// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{box-sizing:border-box}html,body,#root{margin:0;min-height:100%;font-family:var(--pa-font);color:var(--pa-text);background:var(--pa-canvas)}button,input,select{font:inherit}button{cursor:pointer}button:disabled{cursor:not-allowed;opacity:.55}a{color:inherit}.saas-root{min-height:100vh;display:grid;grid-template-columns:240px minmax(0,1fr)}.saas-sidebar{position:fixed;inset:0 auto 0 0;width:240px;background:var(--pa-surface);border-right:1px solid var(--pa-border);display:flex;flex-direction:column;z-index:10}.saas-brand{height:66px;display:flex;align-items:center;gap:11px;padding:0 18px;border-bottom:1px solid var(--pa-border-subtle)}.saas-logo{width:34px;height:34px;border-radius:9px;background:var(--pa-blue);color:#fff;display:grid;place-items:center;font-weight:800;font-size:18px}.saas-logo.large{width:42px;height:42px;border-radius:11px;font-size:22px}.saas-brand-title{font-weight:760;font-size:15px}.saas-brand-sub{font-size:11px;color:var(--pa-text-muted);margin-top:2px}.saas-nav{padding:12px 10px;display:grid;grid-gap:3px;gap:3px}.saas-nav-item{border:0;background:transparent;border-radius:7px;padding:9px 10px;display:flex;gap:10px;align-items:center;text-align:left;color:var(--pa-text-subtle);font-weight:600;font-size:13px}.saas-nav-item:hover{background:var(--pa-surface-muted)}.saas-nav-item.active{background:var(--pa-blue-soft);color:var(--pa-blue)}.saas-nav-icon{width:20px;text-align:center;font-weight:800}.saas-sidebar-foot{margin-top:auto;padding:14px;border-top:1px solid var(--pa-border-subtle)}.saas-env{display:inline-block;font-size:10px;font-weight:700;color:var(--pa-text-muted);background:var(--pa-surface-muted);border:1px solid var(--pa-border);border-radius:999px;padding:4px 7px;margin-bottom:12px}.saas-user{display:flex;align-items:center;gap:9px;margin-bottom:8px}.saas-avatar{width:30px;height:30px;border-radius:50%;display:grid;place-items:center;background:var(--pa-blue-soft);color:var(--pa-blue);font-weight:800}.saas-user-meta{display:grid;min-width:0}.saas-user-meta b{font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.saas-user-meta span{font-size:10px;color:var(--pa-text-muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pa-link-button{border:0;background:transparent;padding:3px 0;color:var(--pa-blue);font-size:11px;font-weight:650}.saas-content{grid-column:2;min-width:0}.saas-topbar{height:58px;position:sticky;top:0;z-index:8;background:rgba(255,255,255,.96);backdrop-filter:blur(8px);border-bottom:1px solid var(--pa-border);display:flex;align-items:center;justify-content:space-between;padding:0 26px;font-size:13px}.saas-topbar>div:first-child{display:flex;align-items:center;gap:9px}.saas-beta{font-size:10px;border:1px solid var(--pa-border);border-radius:999px;padding:3px 7px;color:var(--pa-text-muted);background:var(--pa-surface-muted)}.saas-org{font-size:11px;color:var(--pa-text-muted)}.saas-main{max-width:1240px;margin:0 auto;padding:26px 28px 48px}.page-head{display:flex;align-items:flex-start;justify-content:space-between;gap:20px;margin-bottom:18px}.page-head h1{font-size:24px;letter-spacing:-.01em;margin:0 0 5px}.page-head p,.panel-head p{margin:0;color:var(--pa-text-muted);font-size:12px;line-height:1.5}.pa-primary,.pa-secondary{border-radius:var(--pa-radius);font-weight:700;padding:8px 12px;font-size:12px;display:inline-flex;align-items:center;justify-content:center;text-decoration:none}.pa-primary{border:1px solid var(--pa-blue);background:var(--pa-blue);color:#fff}.pa-primary:hover{background:var(--pa-blue-hover)}.pa-primary.wide{width:100%;padding:10px}.pa-secondary{border:1px solid var(--pa-border);background:#fff;color:var(--pa-text)}.pa-secondary:hover{background:var(--pa-surface-muted)}.pa-secondary.danger{color:var(--pa-danger)}.pa-primary.link{line-height:18px}.panel{background:var(--pa-surface);border:1px solid var(--pa-border);border-radius:var(--pa-radius-lg);box-shadow:var(--pa-shadow);margin-bottom:16px;overflow:hidden}.panel-head{padding:14px 16px;border-bottom:1px solid var(--pa-border-subtle);display:flex;align-items:center;justify-content:space-between;gap:16px}.panel-head h2{margin:0 0 3px;font-size:15px}.panel-body{padding:16px}.metric-grid{display:grid;grid-gap:10px;gap:10px;margin-bottom:16px}.metric-grid.four{grid-template-columns:repeat(4,minmax(0,1fr))}.metric-grid.three{grid-template-columns:repeat(3,minmax(0,1fr))}.metric-grid.compact{margin-top:10px}.metric-card{background:var(--pa-surface);border:1px solid var(--pa-border);border-radius:10px;padding:13px 14px;display:grid;grid-gap:4px;gap:4px}.metric-card span{font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:var(--pa-text-muted);font-weight:700}.metric-card strong{font-size:24px;line-height:1.2}.metric-card strong.metric-word{font-size:18px}.metric-card small{font-size:10px;color:var(--pa-text-muted)}.assessment-list{display:grid}.assessment-row{border:0;border-bottom:1px solid var(--pa-border-subtle);background:#fff;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;text-align:left;color:var(--pa-text)}.assessment-row:last-child{border-bottom:0}.assessment-row:hover{background:var(--pa-surface-muted)}.assessment-row>div:first-child{display:grid;grid-gap:3px;gap:3px}.assessment-row b{font-size:13px}.assessment-row span{font-size:11px;color:var(--pa-text-muted)}.assessment-row-stats{display:flex;align-items:center;gap:14px}.status-pill{display:inline-flex;align-items:center;border-radius:999px;padding:4px 8px;font-size:10px!important;font-weight:750;text-transform:capitalize}.status-pill.success{background:var(--pa-success-soft);color:var(--pa-success)!important}.status-pill.neutral{background:var(--pa-surface-muted);color:var(--pa-text-muted)!important}.status-pill.danger{background:var(--pa-danger-soft);color:var(--pa-danger)!important}.empty-state{text-align:center;padding:42px 20px}.empty-state h3{margin:6px 0;font-size:15px}.empty-state p{margin:0 0 14px;color:var(--pa-text-muted);font-size:12px}.empty-icon{margin:auto;width:38px;height:38px;border-radius:50%;display:grid;place-items:center;background:var(--pa-blue-soft);color:var(--pa-blue);font-size:20px}.assessment-table{font-size:11px}.assessment-table-head,.assessment-table-row{display:grid;grid-template-columns:2fr 1fr .7fr 1.2fr .7fr 36px;align-items:center;grid-gap:12px;gap:12px;padding:10px 14px}.assessment-table-head{background:var(--pa-surface-muted);color:var(--pa-text-muted);font-weight:750;border-bottom:1px solid var(--pa-border)}.assessment-table-row{border-bottom:1px solid var(--pa-border-subtle)}.assessment-table-row:last-child{border-bottom:0}.assessment-name{border:0;background:transparent;text-align:left;display:grid;grid-gap:2px;gap:2px;color:var(--pa-text);padding:0}.assessment-name b{font-size:12px}.assessment-name span{font-size:10px;color:var(--pa-text-muted)}.pa-icon-button{width:26px;height:26px;border:0;border-radius:6px;background:transparent}.pa-icon-button:hover{background:var(--pa-surface-muted)}.pa-icon-button.danger{color:var(--pa-danger)}.source-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));grid-gap:14px;gap:14px}.source-card{position:relative;border:1px solid var(--pa-border);background:#fff;border-radius:var(--pa-radius-lg);padding:20px;text-align:left;min-height:220px;box-shadow:var(--pa-shadow);color:var(--pa-text)}.source-card.active:hover{border-color:var(--pa-blue);box-shadow:0 0 0 2px #CCE0FF}.source-card.disabled{cursor:default;opacity:.72}.source-card h3{font-size:16px;margin:14px 0 6px}.source-card p{font-size:12px;color:var(--pa-text-muted);line-height:1.5;margin:0}.source-icon{width:42px;height:42px;border-radius:10px;display:grid;place-items:center;background:var(--pa-blue-soft);color:var(--pa-blue);font-weight:800}.source-badge{position:absolute;right:14px;top:14px;border-radius:999px;padding:4px 7px;background:var(--pa-success-soft);color:var(--pa-success);font-size:9px;font-weight:800}.source-badge.neutral{background:var(--pa-surface-muted);color:var(--pa-text-muted)}.source-action{position:absolute;left:20px;bottom:18px;font-size:11px;color:var(--pa-blue);font-weight:700}.source-action.muted{color:var(--pa-text-muted)}.wizard-steps{display:flex;gap:0;margin-bottom:16px}.wizard-step{position:relative;display:flex;align-items:center;gap:7px;color:var(--pa-text-muted);font-size:11px;font-weight:700;padding-right:34px}.wizard-step:not(:last-child):after{content:"";position:absolute;width:24px;height:1px;right:5px;top:12px;background:var(--pa-border)}.wizard-step span{width:24px;height:24px;border-radius:50%;display:grid;place-items:center;background:var(--pa-surface);border:1px solid var(--pa-border);font-size:10px}.wizard-step.active{color:var(--pa-blue)}.wizard-step.active span{background:var(--pa-blue-soft);border-color:#85B8FF}.form-grid{display:grid;grid-template-columns:1fr 1fr;grid-gap:12px;gap:12px}.form-grid.two{grid-template-columns:1fr 1fr}.form-grid label{display:grid;grid-gap:5px;gap:5px}.form-grid label>span{font-size:10px;color:var(--pa-text-subtle);font-weight:750}.form-grid input,.form-grid select,.mapping-row select{height:34px;border:1px solid #B3B9C4;border-radius:7px;background:#fff;padding:0 9px;color:var(--pa-text);font-size:12px}.form-grid input:focus,.form-grid select:focus,.mapping-row select:focus{outline:2px solid #CCE0FF;border-color:var(--pa-blue)}.pa-upload{margin-top:14px;border:2px dashed #B3B9C4;border-radius:10px;background:#FAFBFC;padding:22px;display:flex;flex-direction:column;align-items:center;gap:8px}.pa-upload.drag{border-color:var(--pa-blue);background:var(--pa-blue-soft)}.pa-upload b{font-size:13px}.pa-upload span{font-size:11px;color:var(--pa-text-muted)}.file-summary{margin-top:10px;padding:9px 10px;border-radius:7px;background:var(--pa-surface-muted);display:flex;justify-content:space-between;font-size:11px}.file-summary span{color:var(--pa-text-muted)}.subsection-title{font-size:11px;font-weight:800;margin:15px 0 7px;color:var(--pa-text-subtle)}.mapping-grid{border:1px solid var(--pa-border-subtle);border-radius:8px;overflow:hidden;max-height:210px;overflow-y:auto}.mapping-row{display:grid;grid-template-columns:1fr 180px;align-items:center;grid-gap:10px;gap:10px;padding:7px 9px;border-bottom:1px solid var(--pa-border-subtle);font-size:11px}.mapping-row:last-child{border-bottom:0}.button-row{display:flex;gap:8px;align-items:center;margin-top:14px}.button-row.right{justify-content:flex-end}.pa-alert{padding:9px 10px;border-radius:7px;font-size:11px;line-height:1.4;margin-top:8px}.pa-alert.info{background:var(--pa-blue-soft);color:#0747A6}.pa-alert.warning{background:var(--pa-warning-soft);color:var(--pa-warning)}.pa-alert.error{background:var(--pa-danger-soft);color:var(--pa-danger)}.access-banner{margin-top:14px;border-radius:9px;padding:11px 13px;display:flex;align-items:center;justify-content:space-between}.access-banner>div{display:grid;grid-gap:3px;gap:3px}.access-banner b{font-size:12px}.access-banner span{font-size:10px}.access-banner>span{font-size:18px;font-weight:800}.access-banner.ok{background:var(--pa-success-soft);color:var(--pa-success)}.access-banner.blocked{background:var(--pa-warning-soft);color:var(--pa-warning)}.dev-tools{margin-top:14px;border:1px dashed var(--pa-border);border-radius:8px;padding:12px;display:flex;justify-content:space-between;gap:20px;align-items:center}.dev-tools p{margin:3px 0 0;color:var(--pa-text-muted);font-size:11px}.security-list{display:grid}.security-list>div{display:grid;grid-template-columns:180px 1fr;grid-gap:20px;gap:20px;padding:10px 0;border-bottom:1px solid var(--pa-border-subtle);font-size:11px}.security-list>div:last-child{border-bottom:0}.security-list span{color:var(--pa-text-muted)}.danger-zone{border-color:#FFD5D2}.signin-page{min-height:100vh;display:grid;place-items:center;padding:24px;background:linear-gradient(150deg,#F4F5F7 0%,#E9F2FF 100%)}.signin-card{width:410px;background:#fff;border:1px solid var(--pa-border);border-radius:14px;box-shadow:0 8px 28px rgba(9,30,66,.12);padding:28px}.signin-brand{display:flex;align-items:center;gap:12px;margin-bottom:26px}.signin-brand h1{font-size:19px;margin:0}.signin-brand p{font-size:11px;color:var(--pa-text-muted);margin:3px 0 0}.signin-card h2{font-size:18px;margin:0 0 6px}.pa-copy{color:var(--pa-text-muted);font-size:12px;line-height:1.5;margin:0 0 18px}.signin-buttons{display:grid;grid-gap:8px;gap:8px}.provider-button{height:40px;border:1px solid #B3B9C4;background:#fff;border-radius:8px;font-size:12px;font-weight:650;color:var(--pa-text);position:relative}.provider-button:hover{background:var(--pa-surface-muted)}.provider-mark{position:absolute;left:12px;font-weight:800;color:var(--pa-blue)}.signin-separator{height:34px;display:flex;align-items:center;justify-content:center;color:var(--pa-text-muted);font-size:9px;text-transform:uppercase;letter-spacing:.07em}.signin-separator:before,.signin-separator:after{content:"";height:1px;background:var(--pa-border-subtle);flex:1}.signin-separator span{padding:0 10px}.pa-caption{font-size:9px;color:var(--pa-text-muted);line-height:1.5;margin-top:12px}.toast{position:fixed;right:22px;top:72px;z-index:50;background:#172B4D;color:#fff;border-radius:8px;padding:9px 12px;font-size:11px;box-shadow:0 4px 14px rgba(9,30,66,.22)}@media(max-width:980px){.saas-root{grid-template-columns:210px minmax(0,1fr)}.saas-sidebar{width:210px}.metric-grid.four{grid-template-columns:1fr 1fr}.source-grid{grid-template-columns:1fr}.saas-main{padding:20px}.assessment-table-head,.assessment-table-row{grid-template-columns:2fr 1fr .7fr 1fr}.assessment-table-head>*:nth-child(4),.assessment-table-row>*:nth-child(4){display:none}}

/* Full shared Process Advisor runtime. The SaaS shell intentionally steps out of
   the way once an assessment is opened so the Web experience is the same shared
   product UI used by Jira and ServiceNow. */
.web-process-advisor-host {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #fff;
  z-index: 1000;
}
.web-process-advisor-host > * {
  width: 100%;
  height: 100%;
}

/* -------------------------------------------------------------------------
   Sprint 4 — Web Product UX / UI parity
   ------------------------------------------------------------------------- */
:root{--pa-sidebar:232px;--pa-topbar:56px}
html,body,#root{height:100%;min-height:100%;}
body{font-family:var(--pa-font);-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}
body.pa-web-runtime-active{overflow:hidden;background:#fff}

.saas-root{grid-template-columns:232px minmax(0,1fr);grid-template-columns:var(--pa-sidebar) minmax(0,1fr);background:#f7f8fa}
.saas-sidebar{width:232px;width:var(--pa-sidebar);background:#fff;border-right:1px solid #e6e8ec;box-shadow:1px 0 0 rgba(9,30,66,.02)}
.saas-brand{height:72px;padding:0 18px;gap:12px;border-bottom:0}
.saas-brand-logo{width:34px;height:34px;-o-object-fit:contain;object-fit:contain}
.saas-brand-title{font-size:16px;font-weight:760;color:#0b1f44;letter-spacing:-.01em}
.saas-brand-sub{font-size:11px;color:#6b778c;margin-top:2px}
.saas-nav-label{padding:12px 18px 5px;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.09em;color:#8993a4}
.saas-nav{padding:4px 10px 12px;gap:3px}
.saas-nav-item{min-height:40px;padding:0 11px;border-radius:8px;gap:11px;font-size:13px;color:#44546f;transition:background .12s ease,color .12s ease}
.saas-nav-item svg{color:#6b778c}
.saas-nav-item:hover{background:#f5f7fa;color:#172b4d}
.saas-nav-item.active{background:#e9f2ff;color:#0c66e4}
.saas-nav-item.active svg{color:#0c66e4}
.saas-sidebar-foot{padding:12px 14px 16px;border-top:1px solid #eef0f3}
.saas-security-note{display:flex;gap:9px;padding:10px;border:1px solid #e4e8ee;border-radius:9px;background:#fafbfc;color:#44546f;margin-bottom:10px}
.saas-security-note svg{flex:0 0 auto;color:#1f845a;margin-top:1px}
.saas-security-note div{display:grid;grid-gap:2px;gap:2px}
.saas-security-note b{font-size:10px;color:#172b4d}.saas-security-note span{font-size:9px;line-height:1.35;color:#6b778c}
.saas-env{margin:0;font-size:9px;background:transparent;border:0;padding:0;color:#8993a4}

.saas-content{grid-column:2;min-width:0}
.saas-topbar{height:56px;height:var(--pa-topbar);padding:0 28px;background:rgba(255,255,255,.97);border-bottom:1px solid #e6e8ec;box-shadow:0 1px 2px rgba(9,30,66,.025)}
.saas-breadcrumb{display:flex;align-items:center;gap:8px;font-size:12px;color:#6b778c}.saas-breadcrumb b{color:#172b4d}.saas-breadcrumb-sep{color:#c1c7d0}
.saas-topbar-actions{display:flex;align-items:center;gap:7px;font-size:10px;color:#6b778c}.saas-status-dot{width:7px;height:7px;border-radius:50%;background:#22a06b;box-shadow:0 0 0 3px #dcfff1}
.saas-main{max-width:1380px;padding:30px 34px 56px}

.page-head{margin-bottom:22px}.page-head h1{font-size:26px;color:#0b1f44;line-height:1.2;letter-spacing:-.025em}.page-head p{max-width:700px;font-size:12px;color:#6b778c}
.eyebrow{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.09em;color:#0c66e4;margin-bottom:7px}
.hero-head{padding:4px 0 2px;align-items:center}.hero-head h1{max-width:760px;font-size:30px;margin-bottom:8px}.hero-head p{font-size:13px;line-height:1.55}
.pa-primary,.pa-secondary{min-height:34px;gap:7px;border-radius:8px;box-shadow:none}.pa-primary{background:#0c66e4;border-color:#0c66e4}.pa-primary:hover{background:#0055cc}.primary-large{padding:9px 14px;min-height:38px}

.panel{border-color:#e2e6ea;border-radius:12px;box-shadow:0 1px 3px rgba(9,30,66,.06);background:#fff}
.panel-head{padding:16px 18px}.panel-head-strong h2{font-size:16px}.panel-body{padding:18px}
.metric-grid{gap:12px}.overview-metrics{margin-bottom:22px}
.metric-card{border-color:#e2e6ea;border-radius:11px;padding:16px;background:#fff;box-shadow:0 1px 2px rgba(9,30,66,.035)}
.metric-card strong{font-size:26px;color:#0b1f44;letter-spacing:-.025em}.metric-card small{font-size:10px;color:#7a869a}
.metric-card-icon{display:flex;align-items:flex-start;gap:12px}.metric-card-icon>div{display:grid;grid-gap:4px;gap:4px}.metric-icon{width:34px;height:34px;display:grid;place-items:center;border-radius:9px;background:#e9f2ff;color:#0c66e4;flex:0 0 auto}

.assessment-list{background:#fff}.assessment-row-rich{padding:14px 18px;min-height:67px}.assessment-row-main{display:flex!important;align-items:center;gap:12px}.assessment-source-mark,.source-mini{display:inline-grid;place-items:center;background:#e9f2ff;color:#0c66e4;font-weight:800;border-radius:7px}.assessment-source-mark{width:34px;height:34px;font-size:9px}.source-mini{min-width:28px;height:24px;padding:0 6px;font-size:8px;margin-right:7px}
.assessment-row b{font-size:12px}.assessment-row-stats{font-size:10px;color:#6b778c;gap:18px}.assessment-row-stats>span>b{color:#172b4d;font-size:10px}.assessment-row-stats svg{color:#8993a4}
.empty-state-feature{padding:54px 24px}.empty-state-feature h3{font-size:16px}.empty-state-feature p{max-width:520px;margin:0 auto 16px}

.assessment-toolbar{display:flex;align-items:center;gap:10px;padding:12px 14px;border-bottom:1px solid #eef0f3;background:#fbfcfd}.search-field{display:flex;align-items:center;gap:8px;min-width:300px;max-width:440px;flex:1;height:34px;padding:0 10px;background:#fff;border:1px solid #cdd3dc;border-radius:8px;color:#7a869a}.search-field input{border:0;outline:0;min-width:0;flex:1;color:#172b4d;background:transparent;font-size:11px}.toolbar-select{height:34px;border:1px solid #cdd3dc;border-radius:8px;background:#fff;padding:0 28px 0 10px;font-size:11px;color:#44546f}.toolbar-count{font-size:10px;color:#8993a4;margin-left:auto}
.modern-table .assessment-table-head,.modern-table .assessment-table-row{grid-template-columns:2fr 1.45fr .7fr 1.25fr .65fr 76px;padding-left:18px;padding-right:18px}.modern-table .assessment-table-row{min-height:58px}.source-cell{display:flex;align-items:center;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.row-actions{display:flex;justify-content:flex-end;gap:3px}

/* Assessment builder refinements */
.wizard-steps{padding:0 0 4px;margin-bottom:18px}.wizard-step{font-size:10px;padding-right:42px}.wizard-step:not(:last-child):after{width:31px;right:6px}.wizard-step span{width:25px;height:25px}.source-card{border-color:#e0e4e9;box-shadow:0 1px 3px rgba(9,30,66,.05);transition:border-color .12s ease,box-shadow .12s ease,transform .12s ease}.source-card.active:hover{transform:translateY(-1px);box-shadow:0 4px 12px rgba(9,30,66,.08)}
.form-grid input,.form-grid select,.mapping-row select{border-color:#c7cdd7}.pa-upload{background:#fbfcfd;border-color:#c7cdd7}.pa-upload:hover{background:#f7faff;border-color:#85b8ff}

/* Full Process Advisor host ------------------------------------------------ */
.web-process-advisor-host{position:fixed;inset:0;width:100vw;height:100vh;overflow:hidden;background:#fff;z-index:1000;font-family:var(--pa-font)}
.web-process-advisor-host>div{width:100%;height:100%}
.web-process-advisor-host *,body [role="dialog"],body [role="menu"],body [role="listbox"]{font-family:var(--pa-font)}
.web-process-advisor-host [class*="ag-root"],body .ag-popup{font-family:var(--pa-font)}
.web-process-advisor-host button{font-family:var(--pa-font)}

/* Keep legacy print/export render targets mounted for PDF generation but out
   of the live application layout. metricus.tsx also moves these off-screen. */
.web-process-advisor-host #\\#findingDetails,
.web-process-advisor-host #\\#discoveryRuleDetails{max-width:640px}

@media(max-width:1100px){:root{--pa-sidebar:210px}.saas-main{padding:24px}.metric-grid.four{grid-template-columns:repeat(2,minmax(0,1fr))}.modern-table .assessment-table-head,.modern-table .assessment-table-row{grid-template-columns:2fr 1.2fr .7fr 1fr 70px}.modern-table .assessment-table-head>*:nth-child(4),.modern-table .assessment-table-row>*:nth-child(4){display:none}}
.panel-meta{font-size:10px;color:#8993a4;font-weight:650}

/* Sprint 4A — Model workspace ------------------------------------------------ */
.models-page-head{align-items:center}.model-summary-strip{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));grid-gap:10px;gap:10px;margin-bottom:16px}.model-summary-strip>div{background:#fff;border:1px solid #e2e6ea;border-radius:10px;padding:13px 15px;display:flex;align-items:baseline;justify-content:space-between;gap:12px;box-shadow:0 1px 2px rgba(9,30,66,.03)}.model-summary-strip span{font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#7a869a;font-weight:750}.model-summary-strip strong{font-size:20px;color:#0b1f44}.model-grid-panel{overflow:visible}.model-toolbar{display:flex;align-items:center;gap:9px;padding:12px 14px;border-bottom:1px solid #eef0f3;background:#fbfcfd;border-radius:12px 12px 0 0}.model-search{max-width:520px}.pa-secondary.compact{min-height:34px;padding:6px 10px}.model-grid-wrap{height:560px;width:100%;background:#fff;border-radius:0 0 12px 12px;overflow:hidden}.model-grid-wrap .ag-root-wrapper{border:0;border-radius:0 0 12px 12px}.model-grid-wrap .ag-header{background:#f7f8fa;border-bottom-color:#e6e8ec}.model-grid-wrap .ag-header-cell-text{font-size:10px;font-weight:800;color:#5e6c84;text-transform:uppercase;letter-spacing:.035em}.model-grid-wrap .ag-row{border-bottom-color:#eef0f3;cursor:pointer}.model-grid-wrap .ag-row:hover{background:#f7faff}.model-grid-wrap .ag-cell{display:flex;align-items:center;font-size:11px;color:#344563}.grid-model-name{display:grid;grid-gap:2px;gap:2px;line-height:1.25}.grid-model-name b{font-size:12px;color:#172b4d}.grid-model-name span{font-size:9px;color:#7a869a}.model-source-mark{width:31px;height:26px;border-radius:7px;display:grid;place-items:center;font-size:8px;font-weight:850;background:#e9f2ff;color:#0c66e4}.model-source-mark.jira{background:#deebff;color:#0052cc}.model-source-mark.servicenow{background:#dcfff1;color:#1f845a}.model-grid-actions{height:100%;display:flex;align-items:center;justify-content:flex-end;gap:3px}.model-grid-actions button{width:28px;height:28px;border:0;background:transparent;border-radius:6px;color:#5e6c84;display:grid;place-items:center}.model-grid-actions button:hover{background:#edf2f7;color:#172b4d}.model-grid-actions button.danger:hover{background:#ffebe6;color:#ae2a19}.status-pill.info{background:#e9f2ff;color:#0c66e4!important}.model-detail-backdrop{position:fixed;inset:0;background:rgba(9,30,66,.32);z-index:80;display:flex;justify-content:flex-end}.model-detail-backdrop>div{height:100%;width:min(560px,92vw)}.model-detail-panel{height:100%;background:#fff;box-shadow:-10px 0 30px rgba(9,30,66,.16);overflow:auto}.model-detail-head{padding:22px 22px 18px;border-bottom:1px solid #e6e8ec;display:flex;justify-content:space-between;gap:16px;align-items:flex-start}.model-title-block{display:flex;gap:12px;align-items:flex-start}.model-title-block .model-source-mark{margin-top:2px}.model-title-block h2{font-size:20px;line-height:1.2;margin:0 0 4px;color:#0b1f44}.model-title-block p{margin:0;color:#6b778c;font-size:11px}.model-detail-actions{display:flex;gap:8px;padding:14px 22px;border-bottom:1px solid #eef0f3;background:#fbfcfd}.danger-text{color:#ae2a19}.model-detail-section{padding:18px 22px;border-bottom:1px solid #eef0f3}.model-detail-section h3{margin:0 0 12px;font-size:12px;color:#172b4d}.detail-kv-grid{display:grid;grid-template-columns:1fr 1fr;grid-gap:12px;gap:12px}.detail-kv-grid>div{display:grid;grid-gap:5px;gap:5px}.detail-kv-grid span{font-size:9px;text-transform:uppercase;letter-spacing:.045em;color:#8993a4;font-weight:750}.detail-kv-grid b{font-size:11px;color:#344563;font-weight:650}.detail-metrics{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:8px;gap:8px}.detail-metrics>div{background:#f7f8fa;border:1px solid #e6e8ec;border-radius:9px;padding:11px;display:grid;grid-gap:4px;gap:4px}.detail-metrics span{font-size:9px;color:#7a869a}.detail-metrics strong{font-size:18px;color:#0b1f44}.section-title-row{display:flex;justify-content:space-between;align-items:center}.section-title-row>span{font-size:9px;color:#8993a4}.assessment-history-list{display:grid;border:1px solid #e6e8ec;border-radius:9px;overflow:hidden}.assessment-history-row{display:flex;align-items:center;justify-content:space-between;padding:10px 11px;border-bottom:1px solid #eef0f3}.assessment-history-row:last-child{border-bottom:0}.assessment-history-row>div{display:grid;grid-gap:2px;gap:2px}.assessment-history-row b{font-size:10px;color:#344563}.assessment-history-row span{font-size:9px;color:#8993a4}.detail-empty{padding:16px;background:#f7f8fa;border-radius:9px;color:#7a869a;font-size:10px;text-align:center}@media(max-width:900px){.model-summary-strip{grid-template-columns:1fr 1fr}.model-toolbar{flex-wrap:wrap}.model-search{min-width:240px}.toolbar-count{margin-left:0}.detail-kv-grid{grid-template-columns:1fr}.detail-metrics{grid-template-columns:1fr 1fr 1fr}}

/* Sprint 4A — unified collapsible navigation -------------------------------- */
:root{--pa-sidebar-expanded:232px;--pa-sidebar-collapsed:68px;--pa-sidebar:var(--pa-sidebar-expanded)}
.saas-root.sidebar-collapsed{--pa-sidebar:var(--pa-sidebar-collapsed)}
.saas-root{grid-template-columns:232px minmax(0,1fr);grid-template-columns:var(--pa-sidebar) minmax(0,1fr);transition:grid-template-columns .16s ease}
.saas-sidebar{width:232px;width:var(--pa-sidebar);transition:width .16s ease;overflow:hidden}
.saas-brand{height:64px;padding:0 16px;gap:10px;white-space:nowrap}
.saas-brand-logo{width:36px;height:36px;-o-object-fit:contain;object-fit:contain;flex:0 0 auto}
.sidebar-collapsed .saas-brand{padding:0;justify-content:center}
.saas-nav-label{padding:16px 16px 5px;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.11em;color:#8993a4;white-space:nowrap}
.saas-nav{padding:4px 10px;gap:3px}
.saas-nav-item{min-height:40px;padding:0 11px;gap:11px;border-radius:9px;white-space:nowrap;overflow:hidden;flex-shrink:0}
.saas-nav-item svg{flex:0 0 auto}
.saas-nav-item span{overflow:hidden;text-overflow:ellipsis}
.sidebar-collapsed .saas-nav{padding-left:10px;padding-right:10px}
.sidebar-collapsed .saas-nav-item{width:48px;padding:0;justify-content:center;margin:0 auto}
.saas-nav-divider{height:1px;background:#eef0f3;margin:9px 12px}
.saas-nav-divider.push-bottom{margin-top:auto}
.saas-nav-context{display:grid;grid-gap:2px;gap:2px;padding:7px 16px 3px;min-width:0}
.saas-nav-context span{font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:#8993a4;font-weight:750}
.saas-nav-context b{font-size:11px;color:#172b4d;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.saas-model-nav .saas-nav-item.active{background:#e9f2ff;color:#0c66e4;box-shadow:inset 3px 0 0 #0c66e4}
.sidebar-collapsed .saas-model-nav .saas-nav-item.active{box-shadow:inset 3px 0 0 #0c66e4}
.saas-nav-bottom{padding-bottom:10px}
.sidebar-toggle{color:#6b778c}
.saas-sidebar-foot{margin-top:0;padding:11px 12px 14px}
.saas-security-note{display:flex;align-items:flex-start;gap:9px;border:1px solid #e2e6ea;background:#fbfcfd;border-radius:9px;padding:10px;margin-bottom:10px;color:#216e4e}
.saas-security-note>div{display:grid;grid-gap:2px;gap:2px}.saas-security-note b{font-size:10px;color:#172b4d}.saas-security-note span{font-size:9px;line-height:1.35;color:#7a869a}
.saas-env{margin:0;background:transparent;border:0;padding:0;color:#8993a4}
.saas-content{grid-column:2;min-width:0;transition:margin .16s ease}
.saas-topbar{height:58px;padding:0 22px}
.saas-breadcrumb{display:flex;align-items:center;gap:8px;min-width:0}.saas-breadcrumb>span,.saas-breadcrumb>b{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.saas-breadcrumb>b{max-width:360px;color:#172b4d}.saas-breadcrumb-sep{color:#b3b9c4!important}
.saas-topbar-actions{display:flex;align-items:center;gap:8px;color:#6b778c;font-size:10px}.saas-status-dot{width:8px;height:8px;border-radius:50%;background:#22a06b;box-shadow:0 0 0 3px #dcfff1}
.model-back-button{margin-right:8px}
.saas-main-advisor{max-width:none;margin:0;padding:0;height:calc(100vh - 58px);overflow:hidden;background:#fff}

/* The Web shell owns the primary product navigation. The shared Process
   Advisor keeps only its section-specific sub-navigation and action rows. */
.web-process-advisor-host.web-process-advisor-embedded{position:relative;inset:auto;width:100%;height:100%;z-index:1;overflow:hidden;background:#fff;display:flex;flex-direction:column}
.web-process-advisor-embedded>div{min-height:0}
.web-process-advisor-runtime{flex:1 1 auto;height:auto!important;min-height:0;overflow:hidden}
.web-process-advisor-runtime>div{height:100%;min-height:0}
.free-analysis-notice{flex:0 0 auto;display:flex;align-items:center;justify-content:flex-end;gap:10px;padding:5px 16px;border-bottom:1px solid #e7e9ee;background:#fafbfc;color:#626f86;font-size:11.5px;line-height:1.25;min-height:30px}
.free-analysis-notice-copy{display:inline-flex;align-items:center;gap:3px;min-width:0;white-space:nowrap}
.free-analysis-notice-copy b{font-size:11.5px;color:#172b4d}
.free-analysis-dot{margin:0 3px;color:#a5adba}
.free-analysis-link{border:0;background:transparent;color:#0c66e4;padding:2px 4px;font-size:11.5px;font-weight:700;cursor:pointer;white-space:nowrap}
.free-analysis-link:hover{text-decoration:underline}
.free-analysis-link:disabled{opacity:.6;cursor:wait;text-decoration:none}
.web-pa-empty{padding:28px;color:#6b778c;font-size:13px}

@media(max-width:900px){
  :root{--pa-sidebar-expanded:210px}
  .saas-topbar{padding:0 14px}
  .saas-breadcrumb>b{max-width:200px}
}

/* Sprint 4A iteration — streamlined models workspace ------------------------- */
.sidebar-toggle.icon-only{width:40px!important;min-width:40px;padding:0!important;justify-content:center!important;margin:0!important}
.sidebar-collapsed .sidebar-toggle.icon-only{width:48px!important;margin:0 auto!important}
.saas-topbar-actions:empty{display:none}

/* Models is a working list, not a dashboard. */
.model-grid-panel{margin-top:4px}
.model-toolbar{gap:8px;flex-wrap:nowrap}
.model-search{min-width:320px;max-width:620px}
.toolbar-refresh{width:34px;height:34px;flex:0 0 auto}
.model-grid-wrap{height:620px}

.model-grid-actions{gap:2px;overflow:visible}
.model-grid-actions button{width:29px;height:29px}
.model-action-menu{position:fixed;z-index:3000;width:210px;background:#fff;border:1px solid #dfe3e8;border-radius:9px;box-shadow:0 10px 28px rgba(9,30,66,.18);padding:6px;display:grid;grid-gap:2px;gap:2px}
.model-action-menu button{height:34px;border:0;background:#fff;border-radius:6px;padding:0 9px;display:flex;align-items:center;gap:9px;text-align:left;font-size:11px;color:#344563}
.model-action-menu button:hover{background:#f4f5f7;color:#172b4d}.model-action-menu button:disabled{opacity:.45}.model-action-menu button.danger{color:#ae2a19}.model-action-menu button.danger:hover{background:#ffebe6}.model-action-divider{height:1px;background:#eef0f3;margin:3px 2px}

.model-description{font-size:11px;line-height:1.5;color:#5e6c84;margin:14px 0 0;padding-top:12px;border-top:1px solid #eef0f3}
.model-detail-danger{padding:16px 22px;display:flex;gap:18px}.pa-link-danger{border:0;background:transparent;padding:0;display:inline-flex;align-items:center;gap:6px;font-size:10px;font-weight:650;color:#5e6c84}.pa-link-danger:hover{color:#172b4d}.pa-link-danger.danger{color:#ae2a19}

.modal-backdrop{position:fixed;inset:0;z-index:3100;background:rgba(9,30,66,.38);display:grid;place-items:center;padding:24px}
.edit-model-modal{width:min(620px,94vw);background:#fff;border-radius:12px;box-shadow:0 18px 50px rgba(9,30,66,.22);overflow:hidden}
.edit-model-head{padding:19px 20px 15px;border-bottom:1px solid #e6e8ec;display:flex;align-items:flex-start;justify-content:space-between}.edit-model-head h2{margin:0;font-size:19px;color:#0b1f44}
.edit-model-body{padding:18px 20px;display:grid;grid-gap:15px;gap:15px}.edit-model-body label{display:grid;grid-gap:6px;gap:6px}.edit-model-body label>span{font-size:10px;font-weight:700;color:#5e6c84}.edit-model-body input,.edit-model-body textarea{width:100%;border:1px solid #c7cdd7;border-radius:8px;padding:9px 10px;color:#172b4d;background:#fff;outline:0}.edit-model-body input:focus,.edit-model-body textarea:focus{border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.12)}.edit-model-body textarea{resize:vertical;min-height:82px}
.edit-model-foot{padding:13px 20px;border-top:1px solid #eef0f3;background:#fbfcfd;display:flex;justify-content:flex-end;gap:8px}

.form-grid textarea{border:1px solid #c7cdd7;border-radius:7px;padding:8px 9px;color:#172b4d;background:#fff;font:inherit;resize:vertical}.form-grid textarea:focus{outline:0;border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.1)}.form-span-two{grid-column:1/-1}

@media(max-width:1180px){.model-toolbar{flex-wrap:wrap}.model-search{min-width:260px;flex-basis:100%}.toolbar-count{margin-left:auto}}

/* Sprint 4A — Home is an introduction, not a model dashboard ---------------- */
.home-hero{background:linear-gradient(135deg,#fff 0%,#f7faff 68%,#edf5ff 100%);border:1px solid #dfe6ee;border-radius:14px;padding:24px 28px;display:grid;grid-template-columns:minmax(0,1.75fr) minmax(230px,.65fr);grid-gap:28px;gap:28px;align-items:center;margin-bottom:18px;box-shadow:0 1px 2px rgba(9,30,66,.04)}
.home-hero-copy{max-width:820px}.home-hero h1{margin:5px 0 9px;font-size:30px;line-height:1.12;letter-spacing:-.024em;color:#091e42}.home-hero p{margin:0;color:#5e6c84;font-size:13px;line-height:1.52;max-width:790px}.home-hero-actions{display:flex;gap:8px;margin-top:16px}.primary-large{min-height:38px;padding:0 14px}
.home-hero-visual{display:grid;justify-items:center;grid-gap:4px;gap:4px}.home-flow-card{width:188px;min-height:46px;border:1px solid #d9e2ec;border-radius:9px;background:#fff;display:flex;align-items:center;gap:9px;padding:0 13px;color:#344563;font-size:11px;font-weight:700;box-shadow:0 4px 14px rgba(9,30,66,.05)}.home-flow-card svg{color:#0c66e4}.home-flow-card.accent{border-color:#85b8ff;background:#f4f8ff}.home-flow-line{width:1px;height:12px;background:#b6c7dd}
.home-section{margin:18px 0}.home-section-head{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:9px}.home-section-head h2{margin:3px 0 0;font-size:18px;letter-spacing:-.01em;color:#172b4d}.home-steps{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));grid-gap:0;gap:0;background:#fff;border:1px solid #dfe3e8;border-radius:11px;overflow:hidden}.home-step{background:#fff;border:0;border-right:1px solid #e6e9ed;border-radius:0;padding:11px 13px;display:flex;align-items:flex-start;gap:9px;min-height:82px}.home-step:last-child{border-right:0}.home-step-number{width:24px;height:24px;border-radius:7px;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;font-size:10px;font-weight:800;flex:0 0 auto}.home-step h3{margin:1px 0 4px;font-size:12px;color:#172b4d}.home-step p{margin:0;font-size:10px;line-height:1.4;color:#6b778c}
.home-capability-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));grid-gap:9px;gap:9px}.home-capability{background:#fff;border:1px solid #dfe3e8;border-radius:10px;padding:12px 13px;min-height:96px;display:grid;grid-template-columns:30px 1fr;grid-template-rows:auto auto;grid-column-gap:10px;-moz-column-gap:10px;column-gap:10px;align-content:start}.home-capability-icon{width:30px;height:30px;border-radius:8px;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;margin:0;grid-row:1 / span 2}.home-capability h3{margin:1px 0 3px;font-size:13px;color:#172b4d}.home-capability p{margin:0;color:#6b778c;font-size:10px;line-height:1.4}.home-recent-panel{margin-top:18px}.home-empty-state{padding:22px 18px}
@media(max-width:1050px){.home-hero{grid-template-columns:1fr}.home-hero-visual{grid-template-columns:1fr 18px 1fr 18px 1fr;justify-items:stretch;align-items:center}.home-flow-card{width:auto}.home-flow-line{height:1px;width:18px}.home-steps,.home-capability-grid{grid-template-columns:1fr 1fr}}
@media(max-width:700px){.home-hero{padding:20px}.home-hero h1{font-size:26px}.home-hero-visual{display:none}.home-steps,.home-capability-grid{grid-template-columns:1fr}.home-hero-actions{flex-wrap:wrap}}


/* Sprint 4A — viewport-aware desktop Home -----------------------------------
   Process Advisor Web is a desktop-first application. Home uses the available
   shell viewport rather than fixed card heights so typography and whitespace
   grow on larger monitors and compress gracefully on laptop displays. */
.saas-main-home{
  width:100%;
  max-width:1480px;
  height:calc(100vh - 58px);
  min-height:650px;
  padding:clamp(18px,2.2vh,32px) clamp(24px,2.15vw,40px);
  display:grid;
  grid-template-rows:minmax(0,1.32fr) minmax(0,.64fr) minmax(0,.70fr);
  grid-gap:clamp(12px,1.65vh,22px);
  gap:clamp(12px,1.65vh,22px);
  overflow:hidden;
}
.saas-main-home .home-hero,
.saas-main-home .home-section{margin:0;min-height:0}
.saas-main-home .home-hero{
  height:100%;
  padding:clamp(22px,3vh,38px) clamp(26px,2.4vw,46px);
  grid-template-columns:minmax(0,1.75fr) minmax(240px,.62fr);
  gap:clamp(26px,2.7vw,48px);
}
.saas-main-home .home-hero-copy{max-width:900px}
.saas-main-home .eyebrow{font-size:clamp(10px,min(.65vw,1.35vh),12px);letter-spacing:.075em}
.saas-main-home .home-hero h1{
  margin:clamp(5px,.8vh,9px) 0 clamp(9px,1.2vh,14px);
  font-size:clamp(34px,min(2.28vw,4.6vh),46px);
  line-height:1.09;
  letter-spacing:-.027em;
}
.saas-main-home .home-hero p{
  max-width:850px;
  font-size:clamp(14px,min(.92vw,1.9vh),17px);
  line-height:1.5;
}
.saas-main-home .home-hero-actions{margin-top:clamp(14px,1.8vh,22px);gap:10px}
.saas-main-home .primary-large{
  min-height:clamp(38px,4.4vh,46px);
  padding:0 clamp(14px,1vw,19px);
  font-size:clamp(12px,min(.78vw,1.55vh),14px);
}
.saas-main-home .home-hero-visual{gap:clamp(4px,.6vh,8px)}
.saas-main-home .home-flow-card{
  width:clamp(190px,13.2vw,230px);
  min-height:clamp(46px,5.7vh,58px);
  padding:0 clamp(13px,1vw,18px);
  font-size:clamp(11px,min(.75vw,1.5vh),14px);
  border-radius:10px;
}
.saas-main-home .home-flow-line{height:clamp(12px,1.8vh,20px)}
.saas-main-home .home-section{
  display:grid;
  grid-template-rows:auto minmax(0,1fr);
  align-content:stretch;
}
.saas-main-home .home-section-head{margin-bottom:clamp(7px,.85vh,11px)}
.saas-main-home .home-section-head h2{
  margin-top:3px;
  font-size:clamp(18px,min(1.2vw,2.25vh),23px);
  line-height:1.2;
}
.saas-main-home .home-steps{height:100%;min-height:0}
.saas-main-home .home-step{
  height:100%;
  min-height:0;
  padding:clamp(10px,1.25vh,15px) clamp(12px,1vw,17px);
  gap:clamp(8px,.7vw,11px);
  align-items:flex-start;
}
.saas-main-home .home-step-number{
  width:clamp(24px,1.75vw,30px);
  height:clamp(24px,1.75vw,30px);
  font-size:clamp(10px,.68vw,12px);
}
.saas-main-home .home-step h3{
  margin:1px 0 clamp(3px,.45vh,6px);
  font-size:clamp(12px,min(.84vw,1.7vh),15px);
}
.saas-main-home .home-step p{
  font-size:clamp(10px,min(.7vw,1.45vh),13px);
  line-height:1.38;
}
.saas-main-home .home-capability-grid{height:100%;gap:clamp(8px,.8vw,12px)}
.saas-main-home .home-capability{
  height:100%;
  min-height:0;
  padding:clamp(11px,1.3vh,16px) clamp(12px,1vw,17px);
  grid-template-columns:clamp(30px,2.2vw,38px) 1fr;
  -moz-column-gap:clamp(9px,.8vw,13px);
       column-gap:clamp(9px,.8vw,13px);
  border-radius:10px;
}
.saas-main-home .home-capability-icon{
  width:clamp(30px,2.2vw,38px);
  height:clamp(30px,2.2vw,38px);
}
.saas-main-home .home-capability h3{
  margin:1px 0 clamp(3px,.45vh,6px);
  font-size:clamp(13px,min(.92vw,1.8vh),16px);
}
.saas-main-home .home-capability p{
  font-size:clamp(10px,min(.72vw,1.5vh),13px);
  line-height:1.4;
}

/* Short laptop displays compress the same three-section layout rather than
   introducing a long marketing-page scroll. */
@media(min-width:901px) and (max-height:760px){
  .saas-main-home{min-height:0;padding:14px 24px;gap:10px;grid-template-rows:1.2fr .63fr .67fr}
  .saas-main-home .home-hero{padding:18px 24px}
  .saas-main-home .home-hero h1{font-size:32px}
  .saas-main-home .home-hero p{font-size:13px;line-height:1.42}
  .saas-main-home .home-hero-actions{margin-top:12px}
  .saas-main-home .home-flow-card{min-height:42px}
  .saas-main-home .home-section-head{margin-bottom:6px}
  .saas-main-home .home-section-head h2{font-size:17px}
  .saas-main-home .home-step{padding:8px 10px}
  .saas-main-home .home-capability{padding:9px 11px}
}

/* A narrow browser window remains usable, but desktop/laptop is the primary
   target for this product. */
@media(max-width:900px){
  .saas-main-home{
    height:auto;
    min-height:calc(100vh - 58px);
    overflow:visible;
    display:block;
    padding:20px;
  }
  .saas-main-home .home-hero{height:auto;margin-bottom:16px}
  .saas-main-home .home-section{display:block;margin:16px 0}
  .saas-main-home .home-steps,.saas-main-home .home-capability-grid{height:auto}
}


/* Sprint 4A — Home typography refinement -------------------------------------
   The fluid layout already reserves enough card height on desktop. Increase
   text/icon scale to use that space instead of leaving undersized copy in
   oversized cards. */
.saas-main-home .home-step-number{
  width:clamp(30px,2vw,36px);
  height:clamp(30px,2vw,36px);
  border-radius:9px;
  font-size:clamp(12px,.8vw,14px);
}
.saas-main-home .home-step{
  padding:clamp(12px,1.35vh,17px) clamp(14px,1.05vw,19px);
  gap:clamp(10px,.8vw,14px);
  align-items:flex-start;
}
.saas-main-home .home-step h3{
  margin:1px 0 clamp(4px,.5vh,7px);
  font-size:clamp(16px,min(1.02vw,2vh),18px);
  line-height:1.2;
}
.saas-main-home .home-step p{
  max-width:310px;
  font-size:clamp(14px,min(.88vw,1.72vh),16px);
  line-height:1.42;
}
.saas-main-home .home-capability{
  padding:clamp(13px,1.45vh,18px) clamp(15px,1.1vw,20px);
  grid-template-columns:clamp(38px,2.45vw,44px) 1fr;
  -moz-column-gap:clamp(11px,.85vw,15px);
       column-gap:clamp(11px,.85vw,15px);
  align-content:center;
}
.saas-main-home .home-capability-icon{
  width:clamp(38px,2.45vw,44px);
  height:clamp(38px,2.45vw,44px);
  border-radius:10px;
}
.saas-main-home .home-capability-icon svg{
  width:clamp(20px,1.25vw,23px);
  height:clamp(20px,1.25vw,23px);
}
.saas-main-home .home-capability h3{
  margin:0 0 clamp(4px,.48vh,7px);
  font-size:clamp(17px,min(1.08vw,2.05vh),20px);
  line-height:1.2;
}
.saas-main-home .home-capability p{
  max-width:330px;
  font-size:clamp(14px,min(.88vw,1.72vh),16px);
  line-height:1.42;
}
.saas-main-home .home-hero p{
  font-size:clamp(16px,min(1vw,2vh),18px);
  line-height:1.48;
}
.saas-main-home .home-flow-card{
  font-size:clamp(13px,min(.82vw,1.65vh),15px);
}
.saas-main-home .home-flow-card svg{
  width:20px;
  height:20px;
}

/* Keep short laptop screens compact, but don't drop back to tiny typography. */
@media(min-width:901px) and (max-height:760px){
  .saas-main-home .home-hero p{font-size:14px}
  .saas-main-home .home-step-number{width:28px;height:28px;font-size:12px}
  .saas-main-home .home-step h3{font-size:15px}
  .saas-main-home .home-step p{font-size:13px}
  .saas-main-home .home-capability{grid-template-columns:34px 1fr}
  .saas-main-home .home-capability-icon{width:34px;height:34px}
  .saas-main-home .home-capability h3{font-size:16px}
  .saas-main-home .home-capability p{font-size:13px}
}

/* Sprint 5 — database / organization settings */
.settings-status{margin:0 0 14px;padding:10px 12px;border:1px solid #b8c2d1;border-radius:8px;background:#f7faff;color:#172b4d;font-size:12px}
.settings-actions{display:flex;align-items:center;gap:10px;margin-top:16px;flex-wrap:wrap}
.settings-saved-at{font-size:11px;color:#6b778c}
.org-profile-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-gap:14px 16px;gap:14px 16px}
.org-profile-grid label{display:grid;grid-gap:6px;gap:6px;font-size:11px;font-weight:700;color:#44546f}
.org-profile-grid input,.org-profile-grid textarea{width:100%;border:1px solid #cdd3dc;border-radius:8px;background:#fff;color:#172b4d;padding:9px 10px;font:inherit;font-weight:400;outline:none}
.org-profile-grid input:focus,.org-profile-grid textarea:focus{border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.12)}
.org-profile-grid textarea{resize:vertical;line-height:1.45}
.org-profile-grid .wide{grid-column:1/-1}
@media(max-width:900px){.org-profile-grid{grid-template-columns:1fr}}

/* Sprint 5B — Authentication & account */
.boot-screen,.service-error{min-height:100vh;display:grid;place-items:center;background:#f7f8fa;color:#0b1f44;font-family:var(--pa-font)}
.boot-screen>*,.service-error>div{text-align:center}.boot-spinner{width:32px;height:32px;border:3px solid #dfe3e8;border-top-color:#0c66e4;border-radius:50%;animation:pa-spin .8s linear infinite;margin:0 auto 12px}@keyframes pa-spin{to{transform:rotate(360deg)}}
.service-error>div{max-width:520px;padding:32px}.service-error h1{font-size:28px;margin:0 0 10px}.service-error p{color:#6b778c;line-height:1.5}.service-error button{margin-top:14px;background:#0c66e4;color:#fff;border:0;border-radius:8px;padding:10px 18px;font-weight:700;cursor:pointer}

.auth-root{min-height:100vh;display:grid;grid-template-columns:minmax(0,1.08fr) minmax(430px,.92fr);background:#fff;font-family:var(--pa-font);color:#0b1f44}
.auth-brand-panel{background:linear-gradient(135deg,#f8fbff,#eef5ff);padding:clamp(34px,4vw,70px);display:flex;flex-direction:column;min-height:100vh}
.auth-brand{display:flex;align-items:center;gap:12px}.auth-brand img{width:42px;height:42px}.auth-brand b{display:block;font-size:20px}.auth-brand span{display:block;color:#6b778c;font-size:12px;margin-top:3px}
.auth-value{margin:auto 0;max-width:760px}.auth-value h1{font-size:clamp(38px,3.6vw,60px);line-height:1.04;letter-spacing:-.035em;margin:12px 0 20px}.auth-value>p{font-size:18px;line-height:1.55;color:#44546f;max-width:660px}
.auth-value-points{display:grid;grid-gap:12px;gap:12px;margin-top:30px}.auth-value-points>div{display:flex;align-items:center;gap:10px;font-size:14px;font-weight:650;color:#253858}.auth-value-points svg{color:#0c66e4}
.auth-form-panel{display:grid;place-items:center;padding:36px}.auth-card{width:min(440px,100%)}.auth-card-head h2{font-size:32px;letter-spacing:-.025em;margin:0 0 8px}.auth-card-head p{color:#6b778c;font-size:14px;margin:0 0 26px}
.auth-error{padding:10px 12px;border:1px solid #ffbdad;background:#ffebe6;color:#ae2a19;border-radius:8px;font-size:12px;margin-bottom:14px}
.auth-form{display:grid;grid-gap:16px;gap:16px}.auth-form label{display:grid;grid-gap:7px;gap:7px;color:#253858;font-size:12px;font-weight:700}.auth-form small{font-size:10px;color:#7a869a;font-weight:400}.auth-input{height:44px;border:1px solid #cdd3dc;border-radius:8px;display:flex;align-items:center;gap:9px;padding:0 12px;color:#6b778c}.auth-input:focus-within{border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.12)}.auth-input input{border:0;outline:0;flex:1;min-width:0;background:transparent;color:#172b4d;font-size:14px}
.auth-primary{height:44px;border:0;border-radius:8px;background:#0c66e4;color:#fff;font-size:14px;font-weight:750;cursor:pointer}.auth-primary:disabled{opacity:.6}
.auth-divider{display:flex;align-items:center;gap:12px;color:#8993a4;font-size:11px;margin:22px 0}.auth-divider:before,.auth-divider:after{content:"";height:1px;background:#dfe3e8;flex:1}
.auth-social{display:grid;grid-gap:9px;gap:9px}.auth-social a{height:42px;border:1px solid #cdd3dc;border-radius:8px;display:grid;place-items:center;text-decoration:none;color:#172b4d;font-size:13px;font-weight:700;background:#fff}.auth-social a:hover{background:#f7f8fa}
.auth-switch{text-align:center;margin-top:24px;font-size:12px;color:#6b778c}.auth-switch button{border:0;background:transparent;color:#0c66e4;font-weight:750;cursor:pointer;padding:0 3px}
.account-menu{position:relative}.account-menu summary{list-style:none;cursor:pointer;display:flex;align-items:center;gap:9px;padding:4px 7px;border-radius:8px}.account-menu summary::-webkit-details-marker{display:none}.account-menu summary:hover{background:#f4f5f7}.account-avatar{width:32px;height:32px;border-radius:50%;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;font-weight:800}.account-label{display:grid;grid-gap:1px;gap:1px;text-align:left}.account-label b{font-size:11px;color:#172b4d}.account-label small{font-size:9px;color:#7a869a}
.account-popover{position:absolute;right:0;top:44px;width:240px;background:#fff;border:1px solid #dfe3e8;border-radius:10px;box-shadow:0 10px 28px rgba(9,30,66,.18);padding:8px;z-index:100}.account-meta{display:grid;grid-gap:3px;gap:3px;padding:9px 10px 11px;border-bottom:1px solid #eef0f3;margin-bottom:5px}.account-meta b{font-size:12px}.account-meta span{font-size:10px;color:#6b778c}.account-popover button{width:100%;height:34px;border:0;background:transparent;border-radius:7px;text-align:left;padding:0 10px;color:#172b4d;cursor:pointer}.account-popover button:hover{background:#f4f5f7}
@media(max-width:900px){.auth-root{grid-template-columns:1fr}.auth-brand-panel{display:none}.auth-form-panel{min-height:100vh}}

/* Sprint 5B OAuth parity with Billing Portal */
.auth-social-primary{margin:18px 0 0}
.auth-social-primary a{grid-template-columns:30px 1fr;justify-items:start;padding:0 14px;position:relative}
.auth-social-primary a span:last-child{justify-self:center;margin-right:30px}
.auth-social-primary a.disabled{opacity:.45;cursor:not-allowed;background:#f7f8fa}
.provider-mark{width:22px;height:22px;display:grid;place-items:center;flex:0 0 auto}
.provider-mark.google{font-family:Arial,sans-serif;font-weight:800;font-size:17px;color:#4285f4}
.provider-mark.microsoft{grid-template-columns:repeat(2,8px);grid-template-rows:repeat(2,8px);gap:2px}
.provider-mark.microsoft i{display:block;width:8px;height:8px;background:#666}
.provider-mark.microsoft i:nth-child(1){background:#f25022}.provider-mark.microsoft i:nth-child(2){background:#7fba00}.provider-mark.microsoft i:nth-child(3){background:#00a4ef}.provider-mark.microsoft i:nth-child(4){background:#ffb900}
.auth-provider-note{margin:9px 2px 0;font-size:10px;line-height:1.4;color:#8993a4}

/* Sprint 5B — OAuth button layout correction */
.auth-social-primary{
  display:grid;
  grid-gap:10px;
  gap:10px;
  margin:18px 0 0;
}
.auth-social-primary a{
  height:46px;
  display:flex;
  align-items:center;
  justify-content:flex-start;
  gap:12px;
  padding:0 16px;
  border:1px solid #cdd3dc;
  border-radius:8px;
  background:#fff;
  color:#172b4d;
  text-decoration:none;
  font-size:14px;
  font-weight:700;
  white-space:nowrap;
  box-sizing:border-box;
}
.auth-social-primary a:hover{background:#f7f8fa;border-color:#b6bec9}
.auth-social-primary .provider-mark{
  width:24px;
  height:24px;
  flex:0 0 24px;
}
.auth-social-primary .provider-label{
  flex:1 1 auto;
  min-width:0;
  text-align:center;
  padding-right:24px;
}
.auth-social-primary a.disabled{
  opacity:.45;
  pointer-events:none;
}

/* Sprint 5B — Billing Portal OAuth visual parity */
.auth-social-primary{
  display:grid;
  grid-gap:12px;
  gap:12px;
  margin-top:18px;
}
.auth-social-primary a{
  width:100%;
  min-height:46px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:12px;
  padding:0 16px;
  border:1px solid #cbd5e1;
  border-radius:9px;
  background:#fff;
  color:#172b4d;
  font-size:14px;
  font-weight:700;
  text-decoration:none;
  box-sizing:border-box;
}
.auth-social-primary a:hover{background:#f8fafc;border-color:#94a3b8}
.auth-social-primary a.disabled{opacity:.45;pointer-events:none}
.provider-svg{width:20px;height:20px;flex:0 0 20px}
.auth-social-primary .provider-label{
  flex:0 1 auto;
  min-width:0;
  text-align:left;
  padding:0;
  white-space:nowrap;
}

/* Sprint 5C — staged CSV model builder */
.wizard-steps-six{
  grid-template-columns:repeat(6,minmax(0,1fr));
  margin-bottom:18px;
}
.wizard-steps-six .wizard-step{
  -webkit-appearance:none;
     -moz-appearance:none;
          appearance:none;
  border:0;
  background:transparent;
  cursor:pointer;
  text-align:left;
}
.wizard-steps-six .wizard-step.current{
  color:#0c66e4;
  font-weight:800;
}
.field-help-card{
  min-height:42px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#f7f8fa;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding:8px 12px;
  box-sizing:border-box;
}
.field-help-card b{font-size:11px;color:#172b4d}
.field-help-card span{font-size:10px;color:#6b778c;margin-top:2px}
.form-grid label small{
  display:block;
  margin-top:5px;
  color:#7a869a;
  font-size:10px;
  line-height:1.4;
  font-weight:400;
}
.button-row.between{
  justify-content:space-between;
}
.attribute-role-grid{
  display:grid;
  border:1px solid #dfe3e8;
  border-radius:10px;
  overflow:hidden;
}
.attribute-role-row{
  min-height:54px;
  display:grid;
  grid-template-columns:minmax(0,1fr) 210px;
  grid-gap:18px;
  gap:18px;
  align-items:center;
  padding:9px 12px;
  border-bottom:1px solid #eef0f3;
  background:#fff;
}
.attribute-role-row:last-child{border-bottom:0}
.attribute-role-row>div{display:grid;grid-gap:2px;gap:2px;min-width:0}
.attribute-role-row b{font-size:12px;color:#172b4d;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.attribute-role-row span{font-size:10px;color:#7a869a}
.attribute-role-row select{
  height:34px;
  border:1px solid #cdd3dc;
  border-radius:7px;
  background:#fff;
  color:#172b4d;
  padding:0 8px;
}
.run-review-grid{
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  grid-gap:10px;
  gap:10px;
  margin-bottom:16px;
}
.run-review-grid>div{
  display:grid;
  grid-gap:4px;
  gap:4px;
  border:1px solid #dfe3e8;
  background:#f8fafc;
  border-radius:9px;
  padding:11px 12px;
}
.run-review-grid span{font-size:10px;text-transform:uppercase;letter-spacing:.04em;font-weight:700;color:#6b778c}
.run-review-grid b{font-size:12px;color:#172b4d;overflow:hidden;text-overflow:ellipsis}
.storage-consent{
  display:flex;
  align-items:flex-start;
  gap:10px;
  border:1px solid #b8c2d1;
  border-radius:10px;
  padding:13px 14px;
  margin:14px 0;
  background:#fff;
  cursor:pointer;
}
.storage-consent input{margin-top:2px}
.storage-consent>span{display:grid;grid-gap:4px;gap:4px}
.storage-consent b{font-size:12px;color:#172b4d}
.storage-consent small{font-size:10px;line-height:1.45;color:#6b778c}
@media(max-width:1100px){
  .wizard-steps-six{grid-template-columns:repeat(3,1fr);row-gap:8px}
  .run-review-grid{grid-template-columns:repeat(2,1fr)}
}

/* Sprint 5C refinement — help, semantic attributes, typography */
.field-label-with-help{
  display:inline-flex;
  align-items:center;
  gap:5px;
  font-family:var(--pa-font);
  font-weight:700;
}
.field-tip{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  color:#6b778c;
  cursor:help;
  vertical-align:middle;
}
.field-tip:hover{color:#0c66e4}
.attribute-help-strip{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:8px 14px;
  gap:8px 14px;
  padding:12px 14px;
  margin-bottom:12px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  background:#f8fafc;
  font-family:var(--pa-font);
}
.attribute-help-strip span{
  font-family:var(--pa-font);
  font-size:11px;
  line-height:1.45;
  color:#44546f;
}
.attribute-help-strip b{
  font-family:var(--pa-font);
  color:#172b4d;
  font-weight:700;
}
.attribute-role-grid,
.attribute-role-row,
.attribute-role-row *,
.attribute-role-row select,
.attribute-role-row input{
  font-family:var(--pa-font) !important;
}
.attribute-role-row{
  grid-template-columns:minmax(180px,1fr) minmax(220px,1.35fr) 210px;
}
.attribute-role-name{
  display:grid;
  grid-gap:2px;
  gap:2px;
  min-width:0;
}
.attribute-role-name b{
  font-size:12px;
  line-height:1.3;
  color:#172b4d;
  font-weight:700;
}
.attribute-role-name span{
  font-size:10px;
  line-height:1.35;
  color:#6b778c;
}
.attribute-meaning{
  width:100%;
  height:34px;
  box-sizing:border-box;
  border:1px solid #cdd3dc;
  border-radius:7px;
  padding:0 9px;
  color:#172b4d;
  background:#fff;
  font-size:11px;
}
.attribute-meaning:focus{
  outline:none;
  border-color:#579dff;
  box-shadow:0 0 0 2px rgba(12,102,228,.10);
}
.review-span{
  grid-column:1 / -1;
}
.model-objective{
  margin-top:12px;
  padding-top:10px;
  border-top:1px solid #eef0f3;
}
.model-objective span{
  display:block;
  margin-bottom:4px;
  color:#6b778c;
  font-size:10px;
  font-weight:700;
  text-transform:uppercase;
  letter-spacing:.04em;
}
.model-objective p{
  margin:0;
  color:#172b4d;
  font-size:12px;
  line-height:1.5;
}
@media(max-width:1200px){
  .attribute-role-row{grid-template-columns:minmax(160px,1fr) minmax(190px,1fr)}
  .attribute-role-row select{grid-column:2}
}

/* Sprint 5D — Access, billing and entitlement UX */
.billing-portal-link{display:inline-flex;align-items:center;gap:7px;text-decoration:none}
.access-summary-grid{
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  grid-gap:14px;
  gap:14px;
  margin-bottom:18px;
}
.access-summary-card{
  min-height:142px;
  border:1px solid #dfe3e8;
  border-radius:12px;
  background:#fff;
  padding:16px;
  display:grid;
  grid-template-columns:42px 1fr;
  grid-template-rows:auto auto 1fr;
  grid-column-gap:12px;
  -moz-column-gap:12px;
       column-gap:12px;
}
.access-summary-card.available{border-color:#b7e4c7;background:#fbfffc}
.access-summary-card.used{background:#f8fafc}
.access-card-icon{
  grid-row:1/4;
  width:38px;height:38px;border-radius:10px;
  display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;
}
.access-summary-card>span{font-size:10px;text-transform:uppercase;letter-spacing:.045em;font-weight:800;color:#6b778c}
.access-summary-card>strong{font-size:20px;line-height:1.25;color:#172b4d;margin-top:2px}
.access-summary-card>p{font-size:11px;line-height:1.45;color:#6b778c;margin:7px 0 0}
.entitlement-explainer{display:grid;grid-gap:10px;gap:10px}
.entitlement-explainer>div{display:grid;grid-template-columns:170px 1fr;grid-gap:14px;gap:14px;padding:10px 0;border-bottom:1px solid #eef0f3}
.entitlement-explainer>div:last-child{border-bottom:0}
.entitlement-explainer b{font-size:12px;color:#172b4d}
.entitlement-explainer span{font-size:11px;line-height:1.45;color:#6b778c}
.run-access-strip{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:10px;
  gap:10px;
  margin:14px 0;
}
.run-access-strip>span{
  display:grid;grid-gap:3px;gap:3px;padding:10px 12px;border:1px solid #dfe3e8;border-radius:9px;background:#f8fafc;
  color:#6b778c;font-size:10px;
}
.run-access-strip b{font-size:11px;color:#172b4d}
.storage-consent.disabled{opacity:.65;background:#f7f8fa;cursor:not-allowed}
@media(max-width:1050px){
  .access-summary-grid{grid-template-columns:1fr}
  .run-access-strip{grid-template-columns:1fr}
}

.access-topbar-pill{
  height:34px;
  display:inline-flex;
  align-items:center;
  gap:7px;
  border:1px solid #dfe3e8;
  border-radius:18px;
  background:#fff;
  color:#253858;
  padding:0 11px;
  font-size:10px;
  font-weight:750;
  cursor:pointer;
}
.access-topbar-pill:hover{background:#f4f5f7;border-color:#b6bec9}

/* Sprint 6A — AI settings */
.ai-mode-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-gap:12px;gap:12px;margin-bottom:14px}.ai-mode-card{display:flex;gap:10px;align-items:flex-start;border:1px solid #dfe3e8;border-radius:10px;padding:13px;background:#fff;cursor:pointer}.ai-mode-card.active{border-color:#579dff;background:#f4f9ff}.ai-mode-card input{margin-top:3px}.ai-mode-card span{display:grid;grid-gap:4px;gap:4px}.ai-mode-card b{font-size:12px;color:#172b4d}.ai-mode-card small{font-size:10px;line-height:1.45;color:#6b778c}.ai-context-note{display:grid;grid-gap:4px;gap:4px;margin:12px 0;padding:11px 12px;border:1px solid #dfe3e8;border-radius:9px;background:#f8fafc}.ai-context-note b{font-size:11px;color:#172b4d}.ai-context-note span{font-size:10px;line-height:1.5;color:#44546f}@media(max-width:950px){.ai-mode-grid{grid-template-columns:1fr}}

/* Sprint 6A UX refinement */
.settings-tabs{
  display:flex;
  align-items:center;
  gap:4px;
  margin:0 0 16px;
  padding:4px;
  width:-moz-max-content;
  width:max-content;
  max-width:100%;
  border:1px solid #dfe3e8;
  border-radius:10px;
  background:#f7f8fa;
}
.settings-tabs button{
  -webkit-appearance:none;
     -moz-appearance:none;
          appearance:none;
  border:0;
  border-radius:7px;
  background:transparent;
  color:#44546f;
  padding:9px 14px;
  font-family:var(--pa-font);
  font-size:12px;
  font-weight:700;
  cursor:pointer;
}
.settings-tabs button:hover{background:#fff}
.settings-tabs button.active{
  background:#fff;
  color:#0c66e4;
  box-shadow:0 1px 3px rgba(9,30,66,.12);
}
.ai-test-result{
  margin-top:14px;
  display:grid;
  grid-gap:4px;
  gap:4px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  padding:11px 13px;
  font-family:var(--pa-font);
}
.ai-test-result b{font-size:12px;color:#172b4d}
.ai-test-result span{font-size:11px;color:#44546f;line-height:1.45}
.ai-test-result.testing{background:#f4f8ff;border-color:#b3d4ff}
.ai-test-result.success{background:#effcf4;border-color:#b7e4c7}
.ai-test-result.error{background:#fff4f2;border-color:#ffbdad}
.ai-test-result.error b{color:#ae2a19}
@media(max-width:900px){
  .settings-tabs{width:100%;overflow:auto}
  .settings-tabs button{white-space:nowrap}
}

/* Sprint 6B refinement — CSV attribute selector typography */
.attribute-role-row select,
.attribute-role-row select option,
.attribute-role-grid select,
.attribute-role-grid select option {
  font-family: var(--pa-font) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 1.35;
  color: #172b4d;
}
.attribute-role-row select {
  min-height: 36px;
}

/* Sprint 7A — source adaptor / connection foundation */
.connections-panel-body{padding:0}
.connections-settings{font-family:var(--pa-font)}
.connections-toolbar{display:flex;align-items:flex-start;justify-content:space-between;gap:20px;padding:18px 20px;border-bottom:1px solid #eef0f3}
.connections-toolbar h2{margin:0 0 4px;font-size:18px;color:#172b4d}
.connections-toolbar p{margin:0;color:#6b778c;font-size:11px}
.connections-actions{display:flex;gap:8px}
.connections-actions button{display:inline-flex;align-items:center;gap:6px}
.connection-summary{display:flex;gap:22px;padding:12px 20px;border-bottom:1px solid #eef0f3;background:#fafbfc;color:#6b778c;font-size:11px}
.connection-summary b{color:#172b4d;font-size:14px;margin-right:3px}
.empty-connections,.rest-empty{min-height:180px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:8px;padding:28px;color:#6b778c}
.empty-connections b,.rest-empty b{color:#172b4d;font-size:14px}
.empty-connections span,.rest-empty span{max-width:560px;font-size:11px;line-height:1.5}
.connection-list{display:grid}
.connection-row{display:grid;grid-template-columns:42px minmax(0,1fr) auto auto;grid-gap:12px;gap:12px;align-items:center;padding:13px 20px;border-bottom:1px solid #eef0f3}
.connection-mark{width:36px;height:36px;border-radius:9px;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4}
.connection-mark.servicenow-rest{background:#effcf4;color:#087443}
.connection-main{display:grid;grid-gap:3px;gap:3px}
.connection-main b{font-size:12px;color:#172b4d}
.connection-main span{font-size:10px;color:#6b778c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.connection-row-actions{display:flex;gap:5px}
.icon-button{width:32px;height:32px;display:grid;place-items:center;border:1px solid #dfe3e8;border-radius:7px;background:#fff;color:#44546f;cursor:pointer}
.icon-button:hover{background:#f4f5f7}
.icon-button.danger{color:#ae2a19}
.connection-editor{margin:18px 20px;padding:16px;border:1px solid #b3d4ff;border-radius:10px;background:#fbfdff}
.connection-editor-head{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px}
.connection-editor-head h3{margin:0;font-size:15px;color:#172b4d}
.connection-editor-head p{margin:3px 0 0;font-size:10px;color:#6b778c}
.connection-secret{height:40px;display:flex;align-items:center;gap:8px;border:1px solid #cdd3dc;border-radius:7px;padding:0 10px;background:#fff}
.connection-secret input{border:0!important;box-shadow:none!important;padding:0!important;height:auto!important;flex:1}
.connection-choice-grid{display:grid;grid-gap:10px;gap:10px}
.connection-choice{display:grid;grid-template-columns:34px minmax(0,1fr) auto;align-items:center;text-align:left;grid-gap:10px;gap:10px;padding:12px 14px;border:1px solid #dfe3e8;border-radius:9px;background:#fff;cursor:pointer}
.connection-choice:hover{border-color:#85b8ff}
.connection-choice.selected{border-color:#0c66e4;background:#f4f8ff;box-shadow:0 0 0 1px #0c66e4 inset}
.connection-choice span{display:grid;grid-gap:2px;gap:2px}
.connection-choice b{font-size:12px;color:#172b4d}
.connection-choice small{font-size:10px;color:#6b778c}
.connection-choice em{font-style:normal;font-size:10px;color:#087443}
.adapter-foundation-card{margin-top:14px;padding:14px;border:1px solid #dfe3e8;border-radius:9px;background:#f8fafc;display:grid;grid-gap:7px;gap:7px}
.adapter-foundation-card b{font-size:12px;color:#172b4d}
.adapter-foundation-card>span{font-size:10px;line-height:1.5;color:#6b778c}
.adapter-operation-row{display:flex;flex-wrap:wrap;gap:6px;margin-top:3px}
.adapter-operation-row span{padding:5px 8px;border-radius:12px;background:#e9f2ff;color:#0c66e4;font-size:9px;font-weight:700}
@media(max-width:900px){
  .connections-toolbar{flex-direction:column}
  .connection-row{grid-template-columns:36px minmax(0,1fr) auto}
  .connection-row>.status-pill{display:none}
}

/* Sprint 7A — real connection testing */
.connection-test-result{
  margin-top:12px;
  display:grid;
  grid-gap:4px;
  gap:4px;
  padding:10px 12px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#f8fafc;
}
.connection-test-result b{font-size:11px;color:#172b4d}
.connection-test-result span{font-size:10px;color:#44546f;line-height:1.45}
.connection-test-result.testing{background:#f4f8ff;border-color:#b3d4ff}
.connection-test-result.success{background:#effcf4;border-color:#b7e4c7}
.connection-test-result.success b{color:#087443}
.connection-test-result.error{background:#fff4f2;border-color:#ffbdad}
.connection-test-result.error b{color:#ae2a19}

/* Sprint 7B.1 — Jira authentication methods */
.jira-auth-section{margin:16px 0 14px}
.jira-auth-heading{display:grid;grid-gap:3px;gap:3px;margin-bottom:9px}
.jira-auth-heading b{font-size:12px;color:#172b4d}
.jira-auth-heading span{font-size:10px;color:#6b778c}
.jira-auth-methods{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));grid-gap:9px;gap:9px}
.jira-auth-method{position:relative;display:grid;grid-template-columns:34px 1fr;grid-gap:9px;gap:9px;align-items:start;text-align:left;padding:12px;border:1px solid #dfe3e8;border-radius:9px;background:#fff;cursor:pointer}
.jira-auth-method:hover{border-color:#85b8ff}
.jira-auth-method.selected{border-color:#0c66e4;background:#f4f8ff;box-shadow:0 0 0 1px #0c66e4 inset}
.jira-auth-method-icon{width:31px;height:31px;display:grid;place-items:center;border-radius:8px;background:#e9f2ff;color:#0c66e4}
.jira-auth-method>span:nth-child(2){display:grid;grid-gap:4px;gap:4px;padding-right:34px}
.jira-auth-method b{font-size:11px;color:#172b4d}
.jira-auth-method small{font-size:9px;line-height:1.45;color:#6b778c}
.jira-auth-method em{position:absolute;right:9px;top:9px;font-style:normal;font-size:8px;font-weight:700;color:#0c66e4}
.oauth-connect-panel{display:flex;align-items:center;justify-content:space-between;gap:20px;padding:14px;border:1px solid #b3d4ff;border-radius:9px;background:#f4f8ff;margin:12px 0}
.oauth-connect-panel>div{display:grid;grid-gap:4px;gap:4px}
.oauth-connect-panel b{font-size:12px;color:#172b4d}
.oauth-connect-panel span{font-size:10px;color:#44546f;line-height:1.45}
.oauth-connect-panel button{display:inline-flex;align-items:center;gap:7px;white-space:nowrap}
.connection-credential-grid{margin-top:12px}
@media(max-width:1050px){.jira-auth-methods{grid-template-columns:1fr}.oauth-connect-panel{align-items:flex-start;flex-direction:column}}

/* Sprint 7B.2 — Jira REST source discovery and extraction */
.jira-builder{font-family:var(--pa-font)}
.jira-steps{max-width:760px;margin-bottom:18px}
.jira-steps .builder-step{min-width:120px}
.source-context-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 10px;border:1px solid #dfe3e8;border-radius:8px;background:#fff;color:#44546f;font-size:10px;font-weight:700}
.jira-scope-body{display:grid;grid-gap:18px;gap:18px}
.jira-scope-grid{display:grid;grid-template-columns:1fr 1fr;grid-gap:14px;gap:14px}
.jira-choice-panel{border:1px solid #dfe3e8;border-radius:9px;background:#fff;overflow:hidden}
.jira-choice-head{display:flex;align-items:center;justify-content:space-between;padding:10px 12px;background:#fafbfc;border-bottom:1px solid #eef0f3}
.jira-choice-head b{font-size:11px;color:#172b4d}
.jira-choice-head span{font-size:9px;color:#6b778c}
.jira-choice-scroll{max-height:230px;overflow:auto}
.jira-check-row{display:flex;align-items:flex-start;gap:9px;padding:9px 12px;border-bottom:1px solid #f1f2f4;cursor:pointer}
.jira-check-row:last-child{border-bottom:0}
.jira-check-row:hover{background:#f7f9fb}
.jira-check-row input{margin-top:2px}
.jira-check-row>span{display:grid;grid-gap:2px;gap:2px;min-width:0}
.jira-check-row b{font-size:10px;color:#172b4d}
.jira-check-row small{font-size:9px;color:#6b778c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.jira-scope-form{margin-top:0}
.jira-limit-note{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:8px;background:#f4f8ff;border:1px solid #d7e7ff}
.jira-limit-note b{font-size:10px;color:#172b4d}
.jira-limit-note span{font-size:10px;color:#44546f}
.jql-preview{display:grid;grid-gap:7px;gap:7px;margin-top:14px;padding:11px 12px;background:#f8fafc;border:1px solid #dfe3e8;border-radius:8px}
.jql-preview b{font-size:10px;color:#172b4d}
.jql-preview code{white-space:pre-wrap;font-family:ui-monospace,SFMono-Regular,Consolas,monospace;font-size:9px;color:#44546f}
.jira-activity-box{display:grid;grid-template-columns:minmax(280px,.8fr) 1.2fr;grid-gap:16px;gap:16px;align-items:end;padding:14px;border:1px solid #b3d4ff;border-radius:9px;background:#f4f8ff}
.jira-activity-box label{display:grid;grid-gap:6px;gap:6px}
.jira-activity-box label>span{font-size:10px;font-weight:700;color:#172b4d}
.jira-activity-box select{height:40px;border:1px solid #cdd3dc;border-radius:7px;background:#fff;padding:0 10px;font-family:var(--pa-font);font-size:11px}
.jira-activity-box>div{display:grid;grid-gap:4px;gap:4px;padding-bottom:3px}
.jira-activity-box b{font-size:12px;color:#172b4d}
.jira-activity-box div span{font-size:10px;line-height:1.45;color:#44546f}
.jira-attribute-head{display:flex;align-items:flex-end;justify-content:space-between;gap:20px;margin:18px 0 9px}
.jira-attribute-head>div:first-child{display:grid;grid-gap:3px;gap:3px}
.jira-attribute-head b{font-size:12px;color:#172b4d}
.jira-attribute-head span{font-size:10px;color:#6b778c}
.jira-field-search{display:flex;align-items:center;gap:7px;width:300px;height:36px;border:1px solid #cdd3dc;border-radius:7px;padding:0 9px;background:#fff;color:#6b778c}
.jira-field-search input{border:0!important;box-shadow:none!important;padding:0!important;height:auto!important;min-width:0;flex:1;font-family:var(--pa-font);font-size:10px}
.jira-attribute-list{max-height:420px;overflow:auto;border:1px solid #dfe3e8;border-radius:9px}
.jira-attribute-row{display:grid;grid-template-columns:minmax(260px,.8fr) 1.2fr;grid-gap:14px;gap:14px;align-items:center;padding:9px 11px;border-bottom:1px solid #eef0f3}
.jira-attribute-row:last-child{border-bottom:0}
.jira-attribute-row.selected{background:#fbfdff}
.jira-attr-select{display:flex;gap:9px;align-items:flex-start;cursor:pointer}
.jira-attr-select input{margin-top:2px}
.jira-attr-select span{display:grid;grid-gap:2px;gap:2px}
.jira-attr-select b{font-size:10px;color:#172b4d}
.jira-attr-select small{font-size:8px;color:#6b778c}
.jira-attribute-row>input{height:34px;border:1px solid #cdd3dc;border-radius:7px;padding:0 9px;font-family:var(--pa-font);font-size:10px}
.jira-attribute-row>input:disabled{background:#f7f8fa;color:#8993a4}
.jira-preview-table-wrap{overflow:auto;border:1px solid #dfe3e8;border-radius:9px}
.jira-preview-table{width:100%;border-collapse:collapse;font-size:10px}
.jira-preview-table th{text-align:left;padding:9px 10px;background:#fafbfc;border-bottom:1px solid #dfe3e8;color:#44546f;font-size:9px;text-transform:uppercase;letter-spacing:.02em}
.jira-preview-table td{padding:9px 10px;border-bottom:1px solid #eef0f3;color:#44546f;max-width:300px}
.jira-preview-table tr:last-child td{border-bottom:0}
.jira-preview-table td b{color:#0c66e4}
.jira-preview-summary{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:10px;gap:10px;margin-top:14px}
.jira-preview-summary>div{display:grid;grid-gap:3px;gap:3px;padding:11px;border:1px solid #dfe3e8;border-radius:8px;background:#fff}
.jira-preview-summary b{font-size:14px;color:#172b4d}
.jira-preview-summary span{font-size:9px;color:#6b778c}
.jira-run-card{display:grid;grid-gap:16px;gap:16px;padding:18px;border:1px solid #b3d4ff;border-radius:10px;background:#f8fbff}
.jira-run-card>div:first-child{display:flex;align-items:center;gap:10px;color:#0c66e4}
.jira-run-card>div:first-child>span{display:grid;grid-gap:3px;gap:3px}
.jira-run-card b{font-size:13px;color:#172b4d}
.jira-run-card small{font-size:10px;color:#6b778c}
.jira-run-flow{display:flex;align-items:center;flex-wrap:wrap;gap:7px}
.jira-run-flow span{padding:6px 9px;border-radius:14px;background:#fff;border:1px solid #dfe3e8;font-size:9px;font-weight:700;color:#44546f}
.jira-extracting{display:flex;align-items:center;gap:8px;padding:9px 10px;background:#fff;border:1px solid #dfe3e8;border-radius:7px;color:#44546f;font-size:10px}
.rest-loading{min-height:180px;display:flex;align-items:center;justify-content:center;gap:9px;color:#44546f}
.spin{animation:pa-spin 1s linear infinite}
@keyframes pa-spin{to{transform:rotate(360deg)}}
.adapter-card-actions{display:flex;justify-content:flex-end;margin-top:6px}
@media(max-width:1000px){
  .jira-scope-grid,.jira-activity-box{grid-template-columns:1fr}
  .jira-attribute-row{grid-template-columns:1fr}
  .jira-preview-summary{grid-template-columns:1fr 1fr}
  .jira-field-search{width:240px}
}

/* Sprint 7B.2 hotfix — self-contained Jira wizard stepper */
.jira-stage-strip{
  display:flex;
  align-items:center;
  width:min(900px,100%);
  margin:18px 0 22px;
}
.jira-stage{
  display:flex;
  align-items:center;
  gap:7px;
  white-space:nowrap;
  color:#6b778c;
  font-size:10px;
  font-weight:600;
}
.jira-stage>span{
  width:27px;
  height:27px;
  border:1px solid #cdd3dc;
  border-radius:50%;
  display:grid;
  place-items:center;
  background:#fff;
  color:#44546f;
  font-size:10px;
  flex:0 0 auto;
}
.jira-stage>b{font-size:10px;font-weight:700}
.jira-stage.active{color:#0c66e4}
.jira-stage.active>span{
  border-color:#0c66e4;
  color:#0c66e4;
  background:#e9f2ff;
}
.jira-stage.done{color:#0c66e4}
.jira-stage.done>span{
  border-color:#0c66e4;
  background:#0c66e4;
  color:#fff;
}
.jira-stage-line{
  height:1px;
  min-width:24px;
  flex:1 1 50px;
  margin:0 9px;
  background:#dfe3e8;
}
.jira-stage-line.done{background:#0c66e4}

/* Sprint 7B.2 UX refinement — enterprise Jira scope + extraction dialog */
.jira-enterprise-panel{overflow:visible}
.jira-panel-head{align-items:center}
.jira-scope-summary-bar{
  display:grid;
  grid-template-columns:minmax(0,1fr) minmax(0,1fr) auto;
  grid-gap:10px;
  gap:10px;
  padding:12px;
  border:1px solid #dfe3e8;
  border-radius:10px;
  background:#fafbfc;
}
.jira-scope-summary-bar>div{
  display:flex;
  align-items:center;
  gap:9px;
  min-width:0;
}
.jira-scope-summary-bar svg{color:#0c66e4}
.jira-scope-summary-bar span{display:grid;grid-gap:1px;gap:1px}
.jira-scope-summary-bar b{font-size:13px;color:#172b4d}
.jira-scope-summary-bar small{font-size:9px;color:#6b778c}
.jira-scope-summary-bar .jira-scope-limit{
  padding-left:16px;
  border-left:1px solid #dfe3e8;
  justify-content:flex-end;
}
.jira-choice-panel.enterprise{
  min-height:360px;
  display:flex;
  flex-direction:column;
  border-color:#d9dfe7;
  box-shadow:0 1px 2px rgba(9,30,66,.04);
}
.jira-choice-head.enterprise{
  align-items:flex-start;
  gap:12px;
  padding:12px 14px 10px;
}
.jira-choice-head.enterprise>div:first-child{display:grid;grid-gap:3px;gap:3px}
.jira-choice-actions{display:flex;gap:5px;flex-wrap:wrap;justify-content:flex-end}
.jira-choice-actions button{
  border:0;
  background:transparent;
  color:#0c66e4;
  font-family:var(--pa-font);
  font-size:9px;
  font-weight:700;
  cursor:pointer;
  padding:3px 4px;
}
.jira-choice-actions button:hover{text-decoration:underline}
.jira-list-search{
  display:flex;
  align-items:center;
  gap:7px;
  margin:10px 12px 8px;
  height:34px;
  padding:0 9px;
  border:1px solid #cdd3dc;
  border-radius:7px;
  background:#fff;
  color:#6b778c;
}
.jira-list-search:focus-within{border-color:#0c66e4;box-shadow:0 0 0 1px #0c66e4}
.jira-list-search input{
  border:0!important;
  box-shadow:none!important;
  padding:0!important;
  height:auto!important;
  flex:1;
  min-width:0;
  font-family:var(--pa-font);
  font-size:10px;
  background:transparent;
}
.jira-choice-panel.enterprise .jira-choice-scroll{
  max-height:270px;
  flex:1 1 auto;
}
.jira-choice-panel.enterprise .jira-check-row{
  padding:10px 13px;
}
.jira-choice-panel.enterprise .jira-check-row:hover{background:#f4f8ff}
.jira-choice-panel.enterprise .jira-check-row:has(input:checked){background:#f7fbff}
.jira-list-empty{
  padding:28px 14px;
  text-align:center;
  color:#6b778c;
  font-size:10px;
}
.jira-scope-advanced{
  border-top:1px solid #eef0f3;
  padding-top:4px;
}
.jira-section-heading{display:grid;grid-gap:3px;gap:3px;margin-bottom:10px}
.jira-section-heading b{font-size:11px;color:#172b4d}
.jira-section-heading span{font-size:9px;color:#6b778c}
.jira-validation-result{
  display:grid;
  grid-template-columns:auto 1fr;
  grid-gap:10px;
  gap:10px;
  align-items:center;
  padding:12px 14px;
  border-radius:9px;
  border:1px solid #b7e4c7;
  background:#effcf4;
}
.jira-validation-result.error{
  border-color:#ffbdad;
  background:#fff4f2;
}
.jira-validation-icon{color:#087443;display:grid;place-items:center}
.jira-validation-result.error .jira-validation-icon{color:#ae2a19}
.jira-validation-result>div:nth-child(2){display:grid;grid-gap:3px;gap:3px}
.jira-validation-result b{font-size:11px;color:#172b4d}
.jira-validation-result span{font-size:10px;color:#44546f}
.jira-validation-result.compact{
  grid-template-columns:auto 1fr auto;
  margin-bottom:14px;
}
.jira-inline-link{
  border:0;
  background:transparent;
  color:#0c66e4;
  font-family:var(--pa-font);
  font-size:9px;
  font-weight:700;
  cursor:pointer;
}
.jira-panel-footer{
  display:flex!important;
  align-items:center;
  justify-content:space-between!important;
  gap:16px;
  padding:14px 16px!important;
  border-top:1px solid #eef0f3;
  background:#fafbfc;
}
.jira-footer-actions{
  display:flex;
  align-items:center;
  justify-content:flex-end;
  gap:12px;
  margin-left:auto;
}
.jira-footer-actions>span{
  color:#6b778c;
  font-size:9px;
}
.jira-footer-actions .pa-primary{
  min-width:145px;
  display:inline-flex;
  justify-content:center;
  align-items:center;
  gap:6px;
}

/* Extraction progress dialog - mirrors the installed-app extraction experience */
.jira-extraction-overlay{
  position:fixed;
  inset:0;
  z-index:10000;
  background:rgba(9,30,66,.68);
  display:grid;
  place-items:center;
  padding:24px;
  backdrop-filter:blur(1px);
}
.jira-extraction-dialog{
  width:min(660px,calc(100vw - 48px));
  border-radius:16px;
  background:#fff;
  box-shadow:0 22px 70px rgba(9,30,66,.32);
  padding:30px 34px 28px;
}
.jira-extraction-top{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:28px;
}
.jira-extraction-top>div{display:grid;grid-gap:8px;gap:8px}
.jira-extraction-top span{
  font-size:10px;
  font-weight:800;
  letter-spacing:.08em;
  color:#44546f;
}
.jira-extraction-top h2{
  margin:0;
  font-size:25px;
  line-height:1.18;
  color:#172b4d;
}
.jira-extraction-top p{
  margin:0;
  color:#44546f;
  font-size:12px;
  line-height:1.5;
  max-width:470px;
}
.jira-extraction-top strong{
  color:#0c66e4;
  font-size:38px;
  line-height:1;
  font-weight:800;
}
.jira-progress-track{
  height:10px;
  border-radius:999px;
  background:#dfe7f3;
  overflow:hidden;
  margin:24px 0 20px;
}
.jira-progress-fill{
  height:100%;
  border-radius:inherit;
  background:#0c66e4;
  transition:width .35s ease;
}
.jira-extraction-stats{
  display:grid;
  grid-template-columns:1fr 1fr;
  grid-gap:16px;
  gap:16px;
}
.jira-extraction-stats>div{
  min-height:86px;
  display:grid;
  align-content:center;
  grid-gap:7px;
  gap:7px;
  padding:14px 18px;
  border:1px solid #d7e2f0;
  border-radius:12px;
  background:#f8fbff;
}
.jira-extraction-stats span{
  color:#44546f;
  font-size:10px;
  font-weight:800;
  letter-spacing:.04em;
}
.jira-extraction-stats b{
  color:#172b4d;
  font-size:21px;
  line-height:1.15;
}
.jira-extraction-model{
  display:flex;
  align-items:center;
  gap:10px;
  margin-top:18px;
  padding:12px 14px;
  border:1px solid #e1e5eb;
  border-radius:10px;
  color:#0c66e4;
}
.jira-extraction-model>div{display:grid;grid-gap:2px;gap:2px}
.jira-extraction-model b{font-size:11px;color:#172b4d}
.jira-extraction-model span{font-size:9px;color:#6b778c}
.jira-extraction-note{
  margin-top:16px;
  color:#44546f;
  font-size:10px;
  line-height:1.5;
}
@media(max-width:1000px){
  .jira-scope-summary-bar{grid-template-columns:1fr 1fr}
  .jira-scope-summary-bar .jira-scope-limit{grid-column:1 / -1;border-left:0;border-top:1px solid #dfe3e8;padding:10px 0 0}
}
@media(max-width:700px){
  .jira-scope-summary-bar{grid-template-columns:1fr}
  .jira-panel-footer{align-items:flex-start;flex-direction:column}
  .jira-footer-actions{width:100%;flex-direction:column;align-items:stretch}
  .jira-extraction-dialog{padding:24px 20px}
  .jira-extraction-stats{grid-template-columns:1fr}
  .jira-extraction-top strong{font-size:30px}
}

/* Sprint 7B.2 persistence fix — Jira model retention */
.jira-retention-card{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:18px;
  margin-bottom:16px;
  padding:14px 16px;
  border:1px solid #dfe3e8;
  border-radius:10px;
  background:#fff;
}
.jira-retention-card.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}
.jira-retention-card.disabled{
  background:#fafbfc;
}
.jira-retention-card label{
  display:flex;
  align-items:flex-start;
  gap:10px;
  cursor:pointer;
  min-width:0;
}
.jira-retention-card.disabled label{cursor:not-allowed}
.jira-retention-card input{
  margin-top:3px;
  width:15px;
  height:15px;
  accent-color:#0c66e4;
}
.jira-retention-card label>span{
  display:grid;
  grid-gap:4px;
  gap:4px;
}
.jira-retention-card b{
  font-size:11px;
  color:#172b4d;
}
.jira-retention-card small{
  max-width:850px;
  font-size:9px;
  line-height:1.5;
  color:#6b778c;
}
.jira-retention-status{
  flex:0 0 auto;
  border-radius:999px;
  padding:5px 9px;
  font-size:9px;
  font-weight:700;
}
.jira-retention-status.on{
  background:#dcfff1;
  color:#087443;
}
.jira-retention-status.off{
  background:#f1f2f4;
  color:#44546f;
}

/* Sprint 7B.2 — Jira wizard usability redesign */
.jira-builder-v2{
  font-size:13px;
}
.jira-builder-v2 .page-head{
  margin-bottom:10px;
}
.jira-builder-v2 .page-head h1{
  font-size:31px;
  line-height:1.15;
  margin-bottom:4px;
}
.jira-builder-v2 .page-head p{
  font-size:13px;
  line-height:1.45;
}
.jira-builder-v2 .eyebrow{
  font-size:11px;
  letter-spacing:.06em;
}
.jira-builder-v2 .jira-stage-strip{
  margin:10px 0 16px;
  width:min(940px,100%);
}
.jira-builder-v2 .jira-stage{
  gap:8px;
  font-size:12px;
}
.jira-builder-v2 .jira-stage>b{
  font-size:12px;
}
.jira-builder-v2 .jira-stage>span{
  width:31px;
  height:31px;
  font-size:11px;
}
.jira-builder-v2 .jira-stage-line{
  margin:0 10px;
}
.jira-wizard-alert{
  margin-bottom:12px;
  font-size:12px;
}
.jira-wizard-panel{
  overflow:visible;
}
.jira-wizard-panel .panel-head.compact{
  min-height:auto;
  padding:15px 20px;
}
.jira-wizard-panel .panel-head h2{
  margin:0 0 4px;
  font-size:18px;
  line-height:1.25;
}
.jira-wizard-panel .panel-head p{
  margin:0;
  font-size:12px;
  line-height:1.4;
}
.jira-scope-compact-body,
.jira-model-compact-body,
.jira-attributes-compact-body,
.jira-preview-compact-body,
.jira-run-compact-body{
  padding:18px 20px!important;
}
.jira-scope-primary-grid{
  display:grid;
  grid-template-columns:minmax(0,1fr) minmax(0,1fr) 230px;
  grid-gap:14px;
  gap:14px;
  align-items:end;
}
.jira-compact-picker{
  position:relative;
  display:grid;
  grid-gap:7px;
  gap:7px;
}
.jira-compact-picker>label,
.jira-scope-secondary-row label>span,
.jira-model-form label>span,
.jira-activity-row label>span{
  color:#172b4d;
  font-size:12px;
  font-weight:700;
}
.jira-picker-trigger{
  width:100%;
  min-height:50px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  padding:8px 12px;
  border:1px solid #b8c2d1;
  border-radius:8px;
  background:#fff;
  color:#172b4d;
  cursor:pointer;
  text-align:left;
}
.jira-picker-trigger:hover,
.jira-picker-trigger.open{
  border-color:#0c66e4;
  box-shadow:0 0 0 1px #0c66e4;
}
.jira-picker-trigger>span{
  display:grid;
  grid-gap:2px;
  gap:2px;
  min-width:0;
}
.jira-picker-trigger b{
  font-size:13px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.jira-picker-trigger small{
  color:#6b778c;
  font-size:11px;
}
.jira-picker-popover{
  position:absolute;
  z-index:40;
  top:calc(100% + 6px);
  left:0;
  width:max(100%,430px);
  max-width:min(520px,calc(100vw - 80px));
  border:1px solid #cdd4df;
  border-radius:10px;
  background:#fff;
  box-shadow:0 14px 34px rgba(9,30,66,.18);
  overflow:hidden;
}
.jira-picker-toolbar{
  padding:10px;
  border-bottom:1px solid #eef0f3;
  background:#fafbfc;
}
.jira-picker-search{
  height:38px;
  display:flex;
  align-items:center;
  gap:8px;
  padding:0 10px;
  border:1px solid #b8c2d1;
  border-radius:7px;
  background:#fff;
  color:#6b778c;
}
.jira-picker-search input{
  flex:1;
  min-width:0;
  border:0!important;
  box-shadow:none!important;
  padding:0!important;
  font-size:12px!important;
}
.jira-picker-search button{
  display:grid;
  place-items:center;
  width:24px;
  height:24px;
  border:0;
  background:transparent;
  color:#6b778c;
  cursor:pointer;
}
.jira-picker-actions{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  margin-top:8px;
}
.jira-picker-actions button{
  border:0;
  background:transparent;
  color:#0c66e4;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}
.jira-picker-list{
  max-height:280px;
  overflow:auto;
}
.jira-picker-row{
  display:flex;
  align-items:flex-start;
  gap:10px;
  padding:9px 12px;
  border-bottom:1px solid #f0f1f3;
  cursor:pointer;
}
.jira-picker-row:hover{
  background:#f7f9fc;
}
.jira-picker-row.selected{
  background:#f4f8ff;
}
.jira-picker-row input{
  width:16px;
  height:16px;
  margin-top:3px;
  accent-color:#0c66e4;
}
.jira-picker-row>span{
  display:grid;
  grid-gap:2px;
  gap:2px;
  min-width:0;
}
.jira-picker-row b{
  font-size:12px;
  color:#172b4d;
}
.jira-picker-row small{
  font-size:10px;
  color:#6b778c;
  line-height:1.35;
}
.jira-picker-empty{
  padding:24px;
  text-align:center;
  font-size:12px;
  color:#6b778c;
}
.jira-picker-done{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  padding:9px 11px;
  border-top:1px solid #eef0f3;
  background:#fafbfc;
  font-size:11px;
  color:#6b778c;
}
.jira-picker-done button{
  border:1px solid #b8c2d1;
  border-radius:6px;
  padding:6px 12px;
  background:#fff;
  color:#172b4d;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}
.jira-live-estimate{
  height:73px;
  display:grid;
  align-content:center;
  grid-gap:2px;
  gap:2px;
  padding:9px 14px;
  border:1px solid #b8c2d1;
  border-radius:9px;
  background:#f8fafc;
}
.jira-live-estimate>span{
  font-size:10px;
  font-weight:800;
  letter-spacing:.04em;
  text-transform:uppercase;
  color:#6b778c;
}
.jira-live-estimate strong{
  font-size:24px;
  line-height:1.05;
  color:#172b4d;
}
.jira-live-estimate small{
  font-size:10px;
  color:#6b778c;
}
.jira-live-estimate.ok{
  border-color:#b7e4c7;
  background:#f4fff9;
}
.jira-live-estimate.over{
  border-color:#ffbdad;
  background:#fff4f2;
}
.jira-live-estimate.over strong,
.jira-live-estimate.over small{
  color:#ae2a19;
}
.jira-live-estimate.loading strong{
  color:#0c66e4;
}
.jira-scope-secondary-row{
  display:grid;
  grid-template-columns:180px 180px minmax(280px,1fr);
  grid-gap:12px;
  gap:12px;
  align-items:end;
  margin-top:16px;
}
.jira-scope-secondary-row label{
  display:grid;
  grid-gap:6px;
  gap:6px;
}
.jira-scope-secondary-row label>span em{
  color:#6b778c;
  font-style:normal;
  font-weight:500;
}
.jira-scope-secondary-row input{
  height:40px;
  border:1px solid #b8c2d1;
  border-radius:7px;
  padding:0 10px;
  font-family:var(--pa-font);
  font-size:12px;
}
.jira-scope-inline-status{
  min-height:44px;
  display:flex;
  align-items:center;
  gap:22px;
  margin-top:14px;
  padding:8px 12px;
  border:1px solid #e0e4ea;
  border-radius:8px;
  background:#fafbfc;
  color:#44546f;
}
.jira-scope-inline-status>div{
  display:flex;
  align-items:center;
  gap:7px;
}
.jira-scope-inline-status svg{
  color:#0c66e4;
}
.jira-scope-inline-status b,
.jira-scope-inline-status span{
  font-size:11px;
}
.jira-scope-inline-status>span{
  margin-left:auto;
}
.jira-panel-footer.sticky{
  position:sticky;
  bottom:0;
  z-index:20;
  padding:12px 16px!important;
  background:rgba(250,251,252,.96);
  backdrop-filter:blur(4px);
}
.jira-panel-footer .pa-primary,
.jira-panel-footer .pa-secondary{
  min-height:38px;
  font-size:12px;
}
.jira-footer-actions>span{
  font-size:11px!important;
}
.jira-validation-banner{
  display:grid;
  grid-template-columns:auto 1fr auto;
  grid-gap:10px;
  gap:10px;
  align-items:center;
  margin-bottom:14px;
  padding:10px 12px;
  border:1px solid #b7e4c7;
  border-radius:8px;
  background:#f4fff9;
  color:#087443;
}
.jira-validation-banner>div{
  display:grid;
  grid-gap:2px;
  gap:2px;
}
.jira-validation-banner b{
  font-size:12px;
  color:#172b4d;
}
.jira-validation-banner span{
  font-size:11px;
  color:#44546f;
}
.jira-validation-banner button{
  border:0;
  background:transparent;
  color:#0c66e4;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}
.jira-model-form{
  gap:12px 16px!important;
}
.jira-model-form label{
  gap:6px!important;
}
.jira-model-form input,
.jira-model-form textarea{
  font-size:12px!important;
}
.jira-activity-row{
  display:grid;
  grid-template-columns:minmax(300px,.7fr) 1.3fr;
  grid-gap:16px;
  gap:16px;
  align-items:end;
  padding:13px 14px;
  border:1px solid #b3d4ff;
  border-radius:9px;
  background:#f4f8ff;
}
.jira-activity-row label{
  display:grid;
  grid-gap:6px;
  gap:6px;
}
.jira-activity-row select{
  height:42px;
  border:1px solid #b8c2d1;
  border-radius:7px;
  background:#fff;
  padding:0 10px;
  font-family:var(--pa-font);
  font-size:12px;
}
.jira-activity-row>div{
  display:grid;
  grid-gap:3px;
  gap:3px;
  padding-bottom:3px;
}
.jira-activity-row b{
  font-size:13px;
  color:#172b4d;
}
.jira-activity-row span{
  font-size:11px;
  color:#44546f;
}
.jira-selected-characteristics{
  margin-top:14px;
  padding:12px 14px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  background:#fff;
}
.jira-selected-characteristics-head{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:14px;
}
.jira-selected-characteristics-head>div:first-child{
  display:grid;
  grid-gap:2px;
  gap:2px;
}
.jira-selected-characteristics-head b{
  font-size:13px;
  color:#172b4d;
}
.jira-selected-characteristics-head span{
  font-size:11px;
  color:#6b778c;
}
.jira-attribute-view-toggle{
  display:flex;
  padding:3px;
  border:1px solid #dfe3e8;
  border-radius:7px;
  background:#f6f7f9;
}
.jira-attribute-view-toggle button{
  border:0;
  border-radius:5px;
  padding:6px 10px;
  background:transparent;
  color:#44546f;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}
.jira-attribute-view-toggle button.active{
  background:#fff;
  color:#0c66e4;
  box-shadow:0 1px 2px rgba(9,30,66,.12);
}
.jira-selected-chips{
  display:flex;
  align-items:center;
  flex-wrap:wrap;
  gap:6px;
  margin-top:10px;
  min-height:29px;
}
.jira-selected-chips button{
  display:inline-flex;
  align-items:center;
  gap:5px;
  border:1px solid #b3d4ff;
  border-radius:999px;
  padding:5px 8px;
  background:#f4f8ff;
  color:#0c66e4;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}
.jira-selected-chips>span{
  font-size:11px;
  color:#6b778c;
}
.jira-attribute-toolbar{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  margin:12px 0 8px;
}
.jira-field-search.large{
  width:min(460px,100%);
  height:38px;
}
.jira-field-search.large input{
  font-size:12px!important;
}
.jira-attribute-toolbar>span{
  font-size:11px;
  color:#6b778c;
}
.jira-attribute-grid{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:8px;
  gap:8px;
  max-height:310px;
  overflow:auto;
  padding-right:3px;
}
.jira-attribute-tile{
  min-height:56px;
  display:grid;
  grid-gap:7px;
  gap:7px;
  align-content:start;
  padding:10px 11px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fff;
}
.jira-attribute-tile.selected{
  border-color:#85b8ff;
  background:#f8fbff;
}
.jira-attribute-tile>label{
  display:flex;
  align-items:flex-start;
  gap:8px;
  cursor:pointer;
}
.jira-attribute-tile>label input{
  width:15px;
  height:15px;
  margin-top:2px;
  accent-color:#0c66e4;
}
.jira-attribute-tile>label span{
  display:grid;
  grid-gap:1px;
  gap:1px;
}
.jira-attribute-tile b{
  font-size:12px;
  color:#172b4d;
}
.jira-attribute-tile small{
  font-size:10px;
  color:#6b778c;
}
.jira-attribute-tile>input{
  height:34px;
  border:1px solid #c8d0dc;
  border-radius:6px;
  padding:0 8px;
  font-family:var(--pa-font);
  font-size:11px;
}
.jira-attributes-empty{
  grid-column:1/-1;
  padding:28px;
  text-align:center;
  color:#6b778c;
  font-size:12px;
}
.jira-preview-summary.compact{
  margin:0 0 12px;
}
.jira-preview-summary.compact>div{
  padding:9px 11px;
}
.jira-preview-summary.compact b{
  font-size:13px;
}
.jira-preview-summary.compact span{
  font-size:10px;
}
.jira-preview-table{
  font-size:11px!important;
}
.jira-preview-table th{
  font-size:10px!important;
  padding:9px 10px!important;
}
.jira-preview-table td{
  font-size:11px;
  padding:9px 10px!important;
}
.jira-run-compact-body{
  display:grid;
  grid-gap:12px;
  gap:12px;
}
.jira-run-summary{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:20px;
  padding:12px 14px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  background:#fafbfc;
}
.jira-run-summary>div:first-child{
  display:flex;
  align-items:center;
  gap:10px;
  color:#0c66e4;
}
.jira-run-summary>div:first-child span{
  display:grid;
  grid-gap:2px;
  gap:2px;
}
.jira-run-summary b{
  font-size:13px;
  color:#172b4d;
}
.jira-run-summary small{
  font-size:11px;
  color:#6b778c;
}
.jira-data-retention-choice{
  display:grid;
  grid-template-columns:auto 1fr auto;
  grid-gap:11px;
  gap:11px;
  align-items:start;
  padding:13px 14px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  background:#fff;
  cursor:pointer;
}
.jira-data-retention-choice.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}
.jira-data-retention-choice input{
  width:16px;
  height:16px;
  margin-top:3px;
  accent-color:#0c66e4;
}
.jira-data-retention-choice>span{
  display:grid;
  grid-gap:3px;
  gap:3px;
}
.jira-data-retention-choice b{
  font-size:12px;
  color:#172b4d;
}
.jira-data-retention-choice small{
  max-width:900px;
  font-size:11px;
  line-height:1.45;
  color:#6b778c;
}
.jira-data-retention-choice em{
  align-self:center;
  border-radius:999px;
  padding:5px 9px;
  background:#f1f2f4;
  color:#44546f;
  font-size:10px;
  font-style:normal;
  font-weight:700;
}
.jira-data-retention-choice.selected em{
  background:#dcfff1;
  color:#087443;
}
.jira-processing-note{
  padding:9px 11px;
  border-radius:7px;
  background:#f4f5f7;
  color:#44546f;
  font-size:11px;
}

/* keep the complete wizard usable in a 900–1080px-high desktop viewport */
@media(min-width:1100px){
  .jira-builder-v2 .jira-wizard-panel{
    min-height:0;
  }
}
@media(max-width:1100px){
  .jira-scope-primary-grid{
    grid-template-columns:1fr 1fr;
  }
  .jira-live-estimate{
    grid-column:1/-1;
    height:auto;
  }
  .jira-scope-secondary-row{
    grid-template-columns:1fr 1fr;
  }
  .jira-jql-field{
    grid-column:1/-1;
  }
}
@media(max-width:760px){
  .jira-scope-primary-grid,
  .jira-scope-secondary-row,
  .jira-activity-row,
  .jira-attribute-grid{
    grid-template-columns:1fr;
  }
  .jira-picker-popover{
    width:min(520px,calc(100vw - 40px));
  }
  .jira-selected-characteristics-head,
  .jira-run-summary{
    align-items:flex-start;
    flex-direction:column;
  }
}

/* Sprint 7B.2 — Models drawer cleanup */
.model-source-mark.jira{
  background:#e9f2ff;
  color:#0c66e4;
  border-color:#b3d4ff;
}
.model-source-mark.servicenow{
  background:#e9f8f0;
  color:#0b6b3a;
  border-color:#b7e4c7;
}
.model-detail-panel-v2{
  width:min(650px,46vw);
  min-width:560px;
  background:#fff;
}
.model-detail-head.v2{
  padding:22px 26px 18px;
}
.model-detail-head.v2 .model-title-block{
  align-items:flex-start;
}
.model-detail-head.v2 h2{
  margin:2px 0 3px;
  font-size:24px;
  line-height:1.15;
}
.model-detail-head.v2 p{
  margin:0;
  color:#44546f;
  font-size:13px;
}
.model-detail-source-strip{
  display:grid;
  grid-template-columns:1fr 1.25fr 1fr;
  grid-gap:0;
  gap:0;
  border-top:1px solid #eef0f3;
  border-bottom:1px solid #eef0f3;
  background:#fafbfc;
}
.model-detail-source-strip>div{
  display:grid;
  grid-gap:4px;
  gap:4px;
  padding:12px 18px;
  border-right:1px solid #eef0f3;
}
.model-detail-source-strip>div:last-child{
  border-right:0;
}
.model-detail-source-strip span{
  font-size:10px;
  color:#6b778c;
  text-transform:uppercase;
  letter-spacing:.04em;
  font-weight:700;
}
.model-detail-source-strip b{
  font-size:13px;
  color:#172b4d;
}
.model-detail-actions.v2{
  padding:13px 24px;
  gap:8px;
}
.model-detail-actions.v2 button{
  min-height:38px;
  font-size:12px;
}
.model-detail-section.v2{
  padding:18px 24px;
}
.model-detail-section.v2 h3{
  font-size:14px;
  margin:0 0 12px;
}
.model-detail-section.v2 .section-title-row{
  align-items:center;
  margin-bottom:12px;
}
.model-detail-section.v2 .section-title-row h3{
  margin:0;
}
.model-detail-section.v2 .section-title-row>span{
  font-size:11px;
  color:#6b778c;
}
.detail-metrics.v2{
  grid-template-columns:repeat(3,1fr);
  gap:10px;
}
.detail-metrics.v2>div{
  padding:13px 14px;
  min-height:78px;
}
.detail-metrics.v2 span{
  font-size:11px;
}
.detail-metrics.v2 strong{
  font-size:24px;
}
.detail-kv-grid.v2{
  grid-template-columns:repeat(2,minmax(0,1fr));
  row-gap:16px;
  -moz-column-gap:22px;
       column-gap:22px;
}
.detail-kv-grid.v2>div span{
  font-size:10px;
}
.detail-kv-grid.v2>div b{
  font-size:12px;
}
.model-scope-summary{
  display:grid;
  grid-template-columns:1fr 1fr;
  grid-gap:10px 20px;
  gap:10px 20px;
  margin-top:16px;
  padding:14px;
  border:1px solid #e1e5eb;
  border-radius:9px;
  background:#fafbfc;
}
.model-scope-summary>div{
  display:grid;
  grid-gap:3px;
  gap:3px;
  min-width:0;
}
.model-scope-summary span,
.model-copy-block>span{
  color:#6b778c;
  font-size:10px;
  font-weight:700;
  text-transform:uppercase;
  letter-spacing:.03em;
}
.model-scope-summary b{
  color:#172b4d;
  font-size:12px;
  line-height:1.35;
  white-space:normal;
}
.model-copy-block{
  display:grid;
  grid-gap:5px;
  gap:5px;
  margin-top:14px;
}
.model-copy-block p{
  margin:0;
  color:#44546f;
  font-size:12px;
  line-height:1.45;
}
.model-detail-note{
  display:grid;
  grid-gap:5px;
  gap:5px;
  margin:0 24px 18px;
  padding:12px 14px;
  border:1px solid #d7e7ff;
  border-radius:8px;
  background:#f4f8ff;
}
.model-detail-note b{
  font-size:12px;
  color:#172b4d;
}
.model-detail-note span{
  font-size:11px;
  line-height:1.45;
  color:#44546f;
}
.model-detail-danger.v2{
  padding:14px 24px 18px;
}
@media(max-width:1100px){
  .model-detail-panel-v2{
    width:min(650px,70vw);
    min-width:0;
  }
}

/* ==========================================================================
   UI Increment 1 — Models page visual reset
   Desktop-first, data-grade presentation
   ========================================================================== */

/* Navigation: simpler and more legible */
.saas-nav-item{
  font-size:14px;
  min-height:42px;
}
.saas-nav-label{
  font-size:10px;
}
.saas-brand-title{
  font-size:17px;
}
.saas-brand-sub{
  font-size:12px;
}
.saas-breadcrumb{
  font-size:13px;
}
.account-label b{
  font-size:12px;
}
.account-label small{
  font-size:11px;
}

/* Access state should read as an entitlement state, not a generic button */
.access-topbar-pill{
  min-height:34px;
  font-size:12px;
  padding:0 12px;
}
.access-topbar-pill.free{
  border-color:#f0c36d;
  background:#fff9eb;
  color:#7a4d00;
}
.access-topbar-pill.warning{
  border-color:#f3b7ae;
  background:#fff4f2;
  color:#ae2a19;
}
.access-topbar-pill.ok{
  border-color:#b7e4c7;
  background:#f4fff9;
  color:#087443;
}

/* Page heading: one clear title tier; breadcrumb already supplies context */
.models-page-head.ui1{
  margin-bottom:18px;
  align-items:center;
}
.models-page-head.ui1 h1{
  margin:0 0 5px;
  font-size:30px;
  line-height:1.12;
  letter-spacing:-.025em;
  color:#0b1f44;
}
.models-page-head.ui1 p{
  margin:0;
  font-size:14px;
  line-height:1.45;
  color:#5e6c84;
}
.models-page-head.ui1 .primary-large{
  min-height:40px;
  padding:0 15px;
  font-size:13px;
}

/* Models card sizes to its content — no giant empty grid body */
.model-list-card{
  overflow:visible;
  border:1px solid #dfe3e8;
  border-radius:12px;
  background:#fff;
  box-shadow:0 1px 3px rgba(9,30,66,.055);
}

/* Quiet, efficient toolbar */
.model-toolbar.ui1{
  min-height:58px;
  display:flex;
  align-items:center;
  gap:10px;
  padding:10px 12px;
  border-bottom:1px solid #e7eaee;
  background:#fbfcfd;
  border-radius:12px 12px 0 0;
}
.search-field.model-search.ui1{
  min-width:320px;
  max-width:none;
  flex:1 1 520px;
  height:38px;
  border-color:#c8d0dc;
  border-radius:8px;
}
.search-field.model-search.ui1 input{
  font-size:13px;
}
.toolbar-select.ui1{
  height:38px;
  min-width:132px;
  border:1px solid #c8d0dc;
  border-radius:8px;
  background:#fff;
  padding:0 32px 0 11px;
  color:#344563;
  font-size:13px;
  font-family:var(--pa-font);
}
.toolbar-select.ui1:focus{
  outline:2px solid #cce0ff;
  outline-offset:0;
  border-color:#0c66e4;
}
.toolbar-refresh.ui1{
  width:36px;
  height:36px;
  color:#44546f;
}
.toolbar-count.ui1{
  min-width:64px;
  margin-left:4px;
  font-size:12px;
  color:#7a869a;
  text-align:right;
}

/* Plain data table: no AG Grid chrome, no column kebabs, no divider noise */
.model-data-table{
  width:100%;
  overflow-x:auto;
}
.model-data-head,
.model-data-row{
  display:grid;
  grid-template-columns:minmax(240px,1.7fr) minmax(115px,.75fr) minmax(170px,1.05fr) 92px 100px minmax(155px,.95fr) 110px 84px;
  align-items:center;
  grid-column-gap:14px;
  -moz-column-gap:14px;
       column-gap:14px;
  min-width:1120px;
}
.model-data-head{
  min-height:40px;
  padding:0 16px;
  border-bottom:1px solid #dfe3e8;
  background:#f7f8fa;
  color:#5e6c84;
}
.model-data-head>div{
  font-size:12px;
  font-weight:650;
  letter-spacing:.01em;
  text-transform:none;
}
.model-data-head .numeric,
.model-data-row .numeric{
  text-align:right;
  justify-self:stretch;
}
.model-data-head .actions{
  text-align:right;
}
.model-data-row{
  min-height:64px;
  padding:0 16px;
  border-bottom:1px solid #eef0f3;
  background:#fff;
  color:#344563;
  cursor:pointer;
  transition:background .12s ease;
}
.model-data-row:last-child{
  border-bottom:0;
}
.model-data-row:hover{
  background:#f8fbff;
}
.model-data-row:focus{
  outline:2px solid #85b8ff;
  outline-offset:-2px;
}
.model-cell{
  min-width:0;
  font-size:14px;
  line-height:1.3;
}
.model-cell.numeric{
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
  font-weight:650;
  color:#172b4d;
}
.model-name-cell{
  display:grid;
  grid-gap:3px;
  gap:3px;
}
.model-name-cell b{
  overflow:hidden;
  color:#172b4d;
  font-size:14px;
  font-weight:700;
  white-space:nowrap;
  text-overflow:ellipsis;
}
.model-name-cell span{
  overflow:hidden;
  color:#6b778c;
  font-size:12.5px;
  white-space:nowrap;
  text-overflow:ellipsis;
}
.source-text{
  display:grid;
  grid-gap:2px;
  gap:2px;
}
.source-text b{
  overflow:hidden;
  color:#172b4d;
  font-size:13.5px;
  font-weight:650;
  white-space:nowrap;
  text-overflow:ellipsis;
}
.source-text span{
  overflow:hidden;
  color:#6b778c;
  font-size:12px;
  white-space:nowrap;
  text-overflow:ellipsis;
}
.model-cell.last-run{
  color:#44546f;
  font-size:13px;
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}
.model-cell.actions{
  display:flex;
  justify-content:flex-end;
}
.model-grid-actions{
  gap:4px;
}
.model-grid-actions button{
  width:32px;
  height:32px;
  color:#44546f;
}
.model-grid-actions button:hover{
  background:#e9f2ff;
  color:#0c66e4;
}

/* Compact status pill */
.status-pill.compact{
  width:-moz-max-content;
  width:max-content;
  min-height:23px;
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:2px 8px 2px 7px;
  border-radius:999px;
  font-size:12px!important;
  line-height:1;
  font-weight:650;
  text-transform:none;
}
.status-pill.compact i{
  width:6px;
  height:6px;
  border-radius:50%;
  background:currentColor;
  opacity:.85;
}

/* Filtered-empty and low-count state */
.model-filter-empty{
  display:grid;
  place-items:center;
  grid-gap:5px;
  gap:5px;
  padding:34px 20px;
  border-top:1px solid #eef0f3;
  color:#6b778c;
  text-align:center;
}
.model-filter-empty b{
  color:#172b4d;
  font-size:14px;
}
.model-filter-empty span{
  font-size:13px;
}
.empty-state-feature.ui1{
  padding:42px 20px;
}
.empty-state-feature.ui1 h3{
  font-size:17px;
}
.empty-state-feature.ui1 p{
  font-size:13px;
}
.models-page-footnote{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  padding:10px 4px 0;
  color:#7a869a;
  font-size:12px;
}
.models-page-footnote button{
  display:inline-flex;
  align-items:center;
  gap:5px;
  border:0;
  background:transparent;
  color:#0c66e4;
  font-family:var(--pa-font);
  font-size:12px;
  font-weight:650;
  cursor:pointer;
}

/* Drawer: readable, information-dense, no tiny metadata */
.model-detail-panel-v2{
  width:min(620px,44vw);
  min-width:540px;
}
.model-detail-head.v2{
  padding:22px 24px 18px;
}
.model-detail-head.v2 .eyebrow{
  margin-bottom:4px;
  font-size:10px;
}
.model-detail-head.v2 h2{
  font-size:25px;
}
.model-detail-head.v2 p{
  font-size:13px;
}
.model-detail-source-strip span{
  font-size:11px;
}
.model-detail-source-strip b{
  font-size:13px;
}
.model-detail-actions.v2{
  padding:12px 24px;
}
.model-detail-actions.v2 button{
  font-size:12.5px;
}
.model-detail-section.v2{
  padding:18px 24px;
}
.model-detail-section.v2 h3{
  font-size:15px;
}
.model-detail-section.v2 .section-title-row>span{
  font-size:12px;
}
.detail-metrics.v2 span{
  font-size:11.5px;
}
.detail-metrics.v2 strong{
  font-size:23px;
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}
.detail-kv-grid.v2>div span,
.model-scope-summary span,
.model-copy-block>span{
  font-size:11px;
}
.detail-kv-grid.v2>div b,
.model-scope-summary b{
  font-size:13px;
}
.model-copy-block p{
  font-size:13px;
}
.model-detail-note{
  margin:0 24px 18px;
}
.model-detail-note b{
  font-size:13px;
}
.model-detail-note span{
  font-size:12px;
}

/* Keep page broad enough to use desktop real estate properly */
.saas-main:has(.models-page-head.ui1){
  max-width:1480px;
}

/* Focus/accessibility */
.model-grid-actions button:focus-visible,
.models-page-footnote button:focus-visible{
  outline:2px solid #85b8ff;
  outline-offset:1px;
}

@media(max-width:1180px){
  .model-data-head,
  .model-data-row{
    grid-template-columns:minmax(220px,1.5fr) minmax(110px,.7fr) minmax(150px,1fr) 82px 90px minmax(145px,.9fr) 100px 78px;
  }
  .model-detail-panel-v2{
    width:min(620px,62vw);
    min-width:0;
  }
}

/* ==========================================================================
   Scope Screen Redesign — Metricus SaaS controls
   ========================================================================== */

.jira-scope-panel-v3{
  overflow:visible;
  border-radius:12px;
}

.jira-scope-head-v3{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:28px;
  padding:18px 22px;
  border-bottom:1px solid #e6e8ec;
}

.jira-scope-head-v3 h2{
  margin:0 0 4px;
  color:#0b1f44;
  font-size:20px;
  line-height:1.25;
}

.jira-scope-head-v3 p{
  margin:0;
  color:#5e6c84;
  font-size:14px;
  line-height:1.45;
}

.jira-scope-head-right{
  display:flex;
  align-items:center;
  gap:14px;
  flex:0 0 auto;
}

.source-context-chip.v3{
  min-height:38px;
  display:inline-flex;
  align-items:center;
  gap:8px;
  padding:0 12px;
  border:1px solid #d4d9e2;
  border-radius:8px;
  background:#fff;
  color:#172b4d;
  font-size:13px;
  font-weight:650;
}

.jira-scope-count-v3{
  min-width:150px;
  display:grid;
  grid-gap:1px;
  gap:1px;
  padding-left:14px;
  border-left:1px solid #dfe3e8;
}

.jira-scope-count-v3>span{
  color:#6b778c;
  font-size:11px;
  font-weight:700;
  text-transform:uppercase;
  letter-spacing:.035em;
}

.jira-scope-count-v3 strong{
  color:#0b1f44;
  font-size:24px;
  line-height:1.1;
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}

.jira-scope-count-v3 small{
  color:#6b778c;
  font-size:11.5px;
}

.jira-scope-count-v3.over strong,
.jira-scope-count-v3.over small{
  color:#ae2a19;
}

.jira-scope-count-v3.loading strong{
  color:#0c66e4;
}

.jira-scope-body-v3{
  padding:20px 22px 16px;
}

.jira-scope-select-grid-v3{
  display:grid;
  grid-template-columns:1fr 1fr;
  grid-gap:18px;
  gap:18px;
}

.jira-scope-field-v3{
  min-width:0;
  display:grid;
  grid-gap:7px;
  gap:7px;
}

.jira-scope-field-v3>label{
  color:#172b4d;
  font-size:14px;
  font-weight:700;
}

.jira-scope-field-v3>small{
  min-height:18px;
  color:#6b778c;
  font-size:12px;
  line-height:1.4;
}


.jira-advanced-toggle-v3{
  width:100%;
  min-height:42px;
  display:grid;
  grid-template-columns:auto 1fr auto;
  align-items:center;
  grid-gap:10px;
  gap:10px;
  margin-top:16px;
  padding:0 12px;
  border:1px solid #e0e4ea;
  border-radius:8px;
  background:#fafbfc;
  color:#172b4d;
  text-align:left;
  cursor:pointer;
}

.jira-advanced-toggle-v3:hover{
  background:#f4f5f7;
}

.jira-advanced-toggle-v3>span{
  font-size:13px;
  font-weight:700;
}

.jira-advanced-toggle-v3>small{
  color:#7a869a;
  font-size:12px;
}

.jira-advanced-toggle-v3 svg{
  transition:transform .15s ease;
}

.jira-advanced-toggle-v3.open svg{
  transform:rotate(180deg);
}

.jira-advanced-scope-v3{
  display:grid;
  grid-template-columns:180px 180px minmax(260px,1fr);
  grid-gap:12px;
  gap:12px;
  margin-top:10px;
  padding:14px;
  border:1px solid #e0e4ea;
  border-radius:8px;
  background:#fbfcfd;
}

.jira-advanced-scope-v3 label{
  display:grid;
  grid-gap:6px;
  gap:6px;
}

.jira-advanced-scope-v3 label>span{
  color:#44546f;
  font-size:12.5px;
  font-weight:650;
}

.jira-advanced-scope-v3 label>span em{
  color:#8993a4;
  font-style:normal;
  font-weight:500;
}

.jira-advanced-scope-v3 input{
  height:40px;
  border:1px solid #b8c2d1;
  border-radius:7px;
  background:#fff;
  padding:0 10px;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:13px;
}

.jira-advanced-scope-v3 input:focus{
  outline:2px solid #cce0ff;
  border-color:#0c66e4;
}

.jira-scope-footer-v3{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  padding:12px 22px;
  border-top:1px solid #e6e8ec;
  background:#fafbfc;
  border-radius:0 0 12px 12px;
}

.jira-scope-footer-v3 .pa-primary,
.jira-scope-footer-v3 .pa-secondary{
  min-height:40px;
  padding:0 14px;
  font-size:13px;
}

@media(max-width:1000px){
  .jira-scope-head-v3{
    align-items:flex-start;
  }
  .jira-scope-head-right{
    align-items:flex-end;
    flex-direction:column;
  }
  .jira-scope-count-v3{
    padding-left:0;
    border-left:0;
    text-align:right;
  }
  .jira-advanced-scope-v3{
    grid-template-columns:1fr 1fr;
  }
  .jira-advanced-jql-v3{
    grid-column:1/-1;
  }
}

@media(max-width:720px){
  .jira-scope-select-grid-v3,
  .jira-advanced-scope-v3{
    grid-template-columns:1fr;
  }
  .jira-scope-head-v3{
    flex-direction:column;
  }
  .jira-scope-head-right{
    width:100%;
    align-items:flex-start;
  }
  .jira-scope-count-v3{
    text-align:left;
  }
  .jira-advanced-jql-v3{
    grid-column:auto;
  }
}

/* ==========================================================================
   Metricus SaaS component baseline — no Atlaskit dependency
   ========================================================================== */
*,*::before,*::after{box-sizing:border-box}
html,body,#root{min-height:100%;margin:0}
button,input,select,textarea{font:inherit}

.metricus-field{
  min-width:0;
  display:grid;
  grid-gap:7px;
  gap:7px;
}
.metricus-field-label{
  color:#172b4d;
  font-size:14px;
  font-weight:700;
  line-height:1.35;
}
.metricus-field-help{
  min-height:18px;
  color:#6b778c;
  font-size:12px;
  line-height:1.4;
}
.metricus-multiselect .MuiOutlinedInput-root{
  min-height:44px;
  padding:4px 38px 4px 7px!important;
  border-radius:8px;
  background:#fff;
  font-family:var(--pa-font);
}
.metricus-multiselect .MuiOutlinedInput-notchedOutline{
  border-color:#b8c2d1!important;
}
.metricus-multiselect .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{
  border-color:#7a869a!important;
}
.metricus-multiselect .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{
  border-color:#0c66e4!important;
  border-width:2px!important;
}
.metricus-multiselect .MuiAutocomplete-input{
  min-width:90px!important;
  padding:4px 6px!important;
  color:#172b4d;
  font-family:var(--pa-font)!important;
  font-size:14px!important;
}
.metricus-multiselect .MuiInputBase-input::-moz-placeholder{
  color:#44546f;
  opacity:1;
}
.metricus-multiselect .MuiInputBase-input::placeholder{
  color:#44546f;
  opacity:1;
}
.metricus-multiselect .MuiChip-root,
.metricus-multiselect-tag{
  height:28px!important;
  border-radius:6px!important;
  background:#e9f2ff!important;
  color:#0c66e4!important;
  font-family:var(--pa-font)!important;
  font-size:12.5px!important;
  font-weight:650!important;
}
.metricus-multiselect .MuiChip-deleteIcon{
  width:16px!important;
  height:16px!important;
  color:#5e6c84!important;
}
.metricus-multiselect .MuiAutocomplete-popupIndicator,
.metricus-multiselect .MuiAutocomplete-clearIndicator{
  color:#44546f;
}
.metricus-multiselect-paper{
  margin-top:4px!important;
  border:1px solid #d4d9e2!important;
  border-radius:9px!important;
  box-shadow:0 12px 30px rgba(9,30,66,.16)!important;
  font-family:var(--pa-font)!important;
}
.metricus-multiselect-listbox{
  max-height:300px!important;
  padding:5px!important;
}
.metricus-multiselect-option{
  min-height:44px!important;
  display:flex!important;
  align-items:flex-start!important;
  gap:4px!important;
  margin:1px 0!important;
  padding:6px 8px!important;
  border-radius:6px!important;
  color:#172b4d!important;
  font-family:var(--pa-font)!important;
  font-size:14px!important;
}
.metricus-multiselect-option[aria-selected="true"]{
  background:#f4f8ff!important;
}
.metricus-multiselect-option.Mui-focused{
  background:#f1f4f8!important;
}
.metricus-option-checkbox{
  margin:-2px 1px 0 -4px!important;
  padding:6px!important;
}
.metricus-check-box{
  width:16px;
  height:16px;
  display:grid;
  place-items:center;
  border:1.5px solid #8993a4;
  border-radius:3px;
  background:#fff;
}
.metricus-check-box.checked{
  border-color:#0c66e4;
  background:#0c66e4;
  color:#fff;
}
.metricus-option-copy{
  min-width:0;
  display:grid;
  grid-gap:2px;
  gap:2px;
  padding-top:2px;
}
.metricus-option-copy b{
  overflow:hidden;
  color:#172b4d;
  font-size:13.5px;
  line-height:1.3;
  white-space:nowrap;
  text-overflow:ellipsis;
}
.metricus-option-copy small{
  overflow:hidden;
  color:#6b778c;
  font-size:11.5px;
  line-height:1.3;
  white-space:nowrap;
  text-overflow:ellipsis;
}

/* ========================================================================== 
   Jira model wizard consistency pass — shared Metricus component language
   ========================================================================== */
.metricus-wizard-panel{
  overflow:visible;
  border:1px solid #dfe3e8;
  border-radius:12px;
  background:#fff;
}
.metricus-panel-head{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:20px;
  padding:18px 22px;
  border-bottom:1px solid #e6e8ec;
}
.metricus-panel-head h2{
  margin:0 0 4px;
  color:#0b1f44;
  font-size:20px;
  line-height:1.25;
}
.metricus-panel-head p{
  margin:0;
  color:#5e6c84;
  font-size:14px;
  line-height:1.45;
}
.metricus-panel-body{
  padding:20px 22px;
}
.metricus-panel-footer{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:14px;
  min-height:64px;
  padding:12px 22px;
  border-top:1px solid #e6e8ec;
  background:#fafbfc;
  border-radius:0 0 12px 12px;
}
.metricus-panel-footer .pa-primary,
.metricus-panel-footer .pa-secondary{
  min-height:40px;
  padding:0 14px;
  font-size:13px;
}
.metricus-footer-actions{
  display:flex;
  align-items:center;
  justify-content:flex-end;
  gap:14px;
  margin-left:auto;
}
.metricus-footer-actions>span{
  color:#6b778c;
  font-size:12px;
}
.metricus-form-grid{
  display:grid;
  grid-gap:14px 18px;
  gap:14px 18px;
}
.metricus-form-grid.two{
  grid-template-columns:1fr 1fr;
}
.metricus-span-two{
  grid-column:1/-1;
}
.metricus-field{
  min-width:0;
  display:grid;
  grid-gap:7px;
  gap:7px;
}
.metricus-field-label{
  color:#172b4d;
  font-size:14px;
  font-weight:700;
  line-height:1.25;
}
.metricus-input,
.metricus-select{
  width:100%;
  min-height:42px;
  box-sizing:border-box;
  border:1px solid #b8c2d1;
  border-radius:8px;
  background:#fff;
  padding:0 11px;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:14px;
  line-height:1.4;
}
textarea.metricus-input{
  min-height:72px;
  padding:10px 11px;
  resize:vertical;
}
.metricus-input:focus,
.metricus-select:focus{
  outline:2px solid #cce0ff;
  outline-offset:0;
  border-color:#0c66e4;
}
.metricus-field-help{
  color:#6b778c;
  font-size:12px;
  line-height:1.4;
}
.metricus-validation-banner{
  margin-bottom:16px;
  padding:11px 13px;
  border-radius:8px;
}
.metricus-validation-banner b{
  font-size:13px;
}
.metricus-validation-banner span,
.metricus-validation-banner button{
  font-size:12px;
}

/* Activity and attributes */
.metricus-attributes-body{
  display:grid;
  grid-gap:14px;
  gap:14px;
}
.metricus-activity-card{
  display:grid;
  grid-template-columns:minmax(320px, .72fr) 1.28fr;
  align-items:end;
  grid-gap:20px;
  gap:20px;
  padding:15px 16px;
  border:1px solid #cce0ff;
  border-radius:9px;
  background:#f7faff;
}
.metricus-activity-copy{
  display:grid;
  grid-gap:4px;
  gap:4px;
  padding-bottom:3px;
}
.metricus-activity-copy b{
  color:#172b4d;
  font-size:14px;
}
.metricus-activity-copy span{
  color:#5e6c84;
  font-size:13px;
  line-height:1.4;
}
.metricus-characteristics-card{
  padding:14px 16px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  background:#fff;
}
.metricus-characteristics-head{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:16px;
}
.metricus-characteristics-head h3{
  margin:0 0 3px;
  color:#172b4d;
  font-size:15px;
}
.metricus-characteristics-head p{
  margin:0;
  color:#6b778c;
  font-size:12px;
}
.metricus-segmented-control{
  display:flex;
  padding:3px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#f4f5f7;
}
.metricus-segmented-control button{
  min-height:30px;
  border:0;
  border-radius:6px;
  background:transparent;
  padding:0 10px;
  color:#44546f;
  font-family:var(--pa-font);
  font-size:12px;
  font-weight:700;
  cursor:pointer;
}
.metricus-segmented-control button.active{
  background:#fff;
  color:#0c66e4;
  box-shadow:0 1px 2px rgba(9,30,66,.12);
}
.metricus-chip-row{
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  gap:7px;
  margin-top:11px;
  min-height:31px;
}
.metricus-chip-row button{
  display:inline-flex;
  align-items:center;
  gap:5px;
  min-height:28px;
  border:1px solid #b3d4ff;
  border-radius:999px;
  background:#f4f8ff;
  padding:0 9px;
  color:#0c66e4;
  font-family:var(--pa-font);
  font-size:12px;
  font-weight:700;
  cursor:pointer;
}
.metricus-chip-row>span{
  color:#6b778c;
  font-size:12px;
}
.metricus-attribute-toolbar{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
}
.metricus-attribute-toolbar>span{
  color:#6b778c;
  font-size:12px;
}
.metricus-search{
  width:min(480px,100%);
  min-height:40px;
  display:flex;
  align-items:center;
  gap:8px;
  border:1px solid #b8c2d1;
  border-radius:8px;
  background:#fff;
  padding:0 10px;
  color:#6b778c;
}
.metricus-search input{
  flex:1;
  min-width:0;
  border:0;
  outline:0;
  background:transparent;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:14px;
}
.metricus-attribute-grid{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:10px;
  gap:10px;
  max-height:340px;
  overflow:auto;
  padding-right:4px;
}
.metricus-attribute-item{
  min-height:66px;
  display:grid;
  align-content:start;
  grid-gap:9px;
  gap:9px;
  padding:11px 12px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fff;
}
.metricus-attribute-item.selected{
  border-color:#85b8ff;
  background:#f8fbff;
}
.metricus-attribute-check{
  display:flex;
  align-items:flex-start;
  gap:9px;
  cursor:pointer;
}
.metricus-attribute-check input{
  width:16px;
  height:16px;
  margin-top:2px;
  accent-color:#0c66e4;
}
.metricus-attribute-check>span{
  display:grid;
  grid-gap:2px;
  gap:2px;
}
.metricus-attribute-check b{
  color:#172b4d;
  font-size:13px;
}
.metricus-attribute-check small{
  color:#6b778c;
  font-size:11.5px;
}
.metricus-attribute-item .metricus-input{
  min-height:36px;
  font-size:13px;
}

/* Preview */
.metricus-preview-body{
  display:grid;
  grid-gap:14px;
  gap:14px;
}
.metricus-kpi-row{
  display:grid;
  grid-template-columns:repeat(4,minmax(0,1fr));
  grid-gap:10px;
  gap:10px;
}
.metricus-kpi-row>div{
  min-height:64px;
  display:grid;
  align-content:center;
  grid-gap:3px;
  gap:3px;
  padding:10px 13px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fff;
}
.metricus-kpi-row strong{
  overflow:hidden;
  color:#172b4d;
  font-size:17px;
  line-height:1.2;
  white-space:nowrap;
  text-overflow:ellipsis;
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}
.metricus-kpi-row span{
  color:#6b778c;
  font-size:12px;
}
.metricus-data-grid{
  width:100%;
  min-width:0;
  border:1px solid #dfe3e8;
  border-radius:9px;
  overflow:hidden;
  background:#fff;
}
.metricus-data-grid .ag-root-wrapper{
  border:0!important;
  border-radius:0!important;
  font-family:var(--pa-font)!important;
  font-size:14px!important;
}
.metricus-data-grid .ag-header{
  border-bottom:1px solid #dfe3e8!important;
  background:#f7f8fa!important;
}
.metricus-data-grid .ag-header-cell{
  color:#5e6c84!important;
  font-size:12px!important;
  font-weight:650!important;
  text-transform:none!important;
}
.metricus-data-grid .ag-cell{
  display:flex;
  align-items:center;
  color:#344563!important;
  font-size:14px!important;
  border-right:0!important;
}
.metricus-data-grid .ag-row{
  border-bottom:1px solid #eef0f3!important;
}
.metricus-data-grid .ag-row-hover{
  background:#f8fbff!important;
}
.metricus-data-grid .ag-header-cell-menu-button,
.metricus-data-grid .ag-header-cell-filter-button{
  display:none!important;
}
.metricus-data-grid .metricus-grid-key{
  color:#0c66e4!important;
  font-weight:700;
}
.metricus-grid-empty{
  color:#6b778c;
  font-family:var(--pa-font);
  font-size:13px;
}

/* Run */
.metricus-run-body{
  display:grid;
  grid-gap:13px;
  gap:13px;
}
.metricus-run-summary{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:20px;
  padding:14px 16px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  background:#fafbfc;
}
.metricus-run-model{
  display:flex;
  align-items:center;
  gap:11px;
  color:#0c66e4;
}
.metricus-run-model>span{
  display:grid;
  grid-gap:3px;
  gap:3px;
}
.metricus-run-model b{
  color:#172b4d;
  font-size:14px;
}
.metricus-run-model small{
  color:#6b778c;
  font-size:12px;
}
.metricus-run-flow{
  display:flex;
  align-items:center;
  gap:8px;
  color:#44546f;
}
.metricus-run-flow span{
  min-height:28px;
  display:inline-flex;
  align-items:center;
  border:1px solid #dfe3e8;
  border-radius:999px;
  background:#fff;
  padding:0 10px;
  font-size:12px;
  font-weight:650;
}
.metricus-retention-card{
  display:grid;
  grid-template-columns:auto 1fr auto;
  grid-gap:11px;
  gap:11px;
  align-items:start;
  padding:14px 15px;
  border:1px solid #dfe3e8;
  border-radius:9px;
  background:#fff;
  cursor:pointer;
}
.metricus-retention-card.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}
.metricus-retention-card input{
  width:17px;
  height:17px;
  margin-top:3px;
  accent-color:#0c66e4;
}
.metricus-retention-card>span{
  display:grid;
  grid-gap:4px;
  gap:4px;
}
.metricus-retention-card b{
  color:#172b4d;
  font-size:13px;
}
.metricus-retention-card small{
  max-width:920px;
  color:#6b778c;
  font-size:12px;
  line-height:1.45;
}
.metricus-retention-card em{
  align-self:center;
  border-radius:999px;
  background:#f1f2f4;
  padding:5px 9px;
  color:#44546f;
  font-size:11px;
  font-style:normal;
  font-weight:700;
}
.metricus-retention-card.selected em{
  background:#dcfff1;
  color:#087443;
}
.metricus-info-note{
  padding:10px 12px;
  border-radius:8px;
  background:#f4f5f7;
  color:#44546f;
  font-size:12px;
  line-height:1.45;
}

/* Keep the whole wizard visually aligned with the redesigned Scope screen. */
.jira-builder-v2 .jira-stage-strip{
  margin-bottom:16px;
}
.jira-builder-v2 .jira-stage>b{
  font-size:13px!important;
}
.jira-builder-v2 .jira-stage>span{
  font-size:12px!important;
}
.jira-builder-v2 .page-head h1{
  font-size:30px!important;
}
.jira-builder-v2 .page-head p{
  font-size:14px!important;
}
.jira-builder-v2 .eyebrow{
  font-size:11px!important;
}

@media(max-width:1000px){
  .metricus-form-grid.two,
  .metricus-activity-card,
  .metricus-attribute-grid{
    grid-template-columns:1fr;
  }
  .metricus-kpi-row{
    grid-template-columns:repeat(2,minmax(0,1fr));
  }
  .metricus-run-summary{
    align-items:flex-start;
    flex-direction:column;
  }
}

/* ==========================================================================
   Activity & Attributes — layout fix
   Selected attributes and editable AI meanings are separated from field discovery
   ========================================================================== */

.metricus-characteristics-card-v2{
  display:grid;
  grid-gap:12px;
  gap:12px;
}

.metricus-selected-attribute-grid{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:10px;
  gap:10px;
}

.metricus-selected-attribute-row{
  display:grid;
  grid-gap:8px;
  gap:8px;
  padding:11px 12px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fbfcfe;
}

.metricus-selected-attribute-name{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:10px;
}

.metricus-selected-attribute-name>span{
  display:grid;
  grid-gap:2px;
  gap:2px;
  min-width:0;
}

.metricus-selected-attribute-name b{
  color:#172b4d;
  font-size:13.5px;
}

.metricus-selected-attribute-name small{
  color:#6b778c;
  font-size:11.5px;
}

.metricus-selected-attribute-name button{
  width:28px;
  height:28px;
  display:grid;
  place-items:center;
  flex:0 0 auto;
  border:0;
  border-radius:6px;
  background:transparent;
  color:#6b778c;
  cursor:pointer;
}

.metricus-selected-attribute-name button:hover{
  background:#edf2f7;
  color:#172b4d;
}

.metricus-selected-attribute-row .metricus-field{
  display:block;
}

.metricus-selected-attribute-row .metricus-input{
  min-height:38px;
  font-size:13px;
}

.metricus-selected-empty{
  padding:14px;
  border:1px dashed #cdd3dc;
  border-radius:8px;
  color:#6b778c;
  font-size:12.5px;
}

.metricus-available-fields{
  display:grid;
  grid-gap:10px;
  gap:10px;
}

.metricus-available-fields-head{
  display:flex;
  align-items:flex-end;
  justify-content:space-between;
  gap:16px;
}

.metricus-available-fields-head h3{
  margin:0 0 3px;
  color:#172b4d;
  font-size:15px;
}

.metricus-available-fields-head p{
  margin:0;
  color:#6b778c;
  font-size:12px;
}

.metricus-available-fields-head>span{
  color:#6b778c;
  font-size:12px;
}

.metricus-available-field-grid{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:8px;
  gap:8px;
  max-height:300px;
  overflow:auto;
  padding-right:4px;
}

.metricus-available-field{
  min-height:56px;
  display:flex;
  align-items:flex-start;
  gap:9px;
  padding:10px 11px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fff;
  cursor:pointer;
}

.metricus-available-field:hover{
  background:#f7f9fc;
}

.metricus-available-field.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}

.metricus-available-field input{
  width:16px;
  height:16px;
  margin-top:2px;
  accent-color:#0c66e4;
}

.metricus-available-field>span{
  display:grid;
  grid-gap:2px;
  gap:2px;
  min-width:0;
}

.metricus-available-field b{
  color:#172b4d;
  font-size:13px;
  line-height:1.25;
}

.metricus-available-field small{
  color:#6b778c;
  font-size:11.5px;
  line-height:1.3;
}

/* The old all-fields card grid is intentionally not used on this screen anymore. */
@media(max-width:900px){
  .metricus-selected-attribute-grid,
  .metricus-available-field-grid{
    grid-template-columns:1fr;
  }
}

/* Preview data — compact, data-first layout */
.metricus-preview-panel-v2{
  overflow:hidden;
}
.metricus-preview-toolbar-v2{
  min-height:58px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:18px;
  padding:10px 18px;
  border-bottom:1px solid #e6e8ec;
  background:#fff;
}
.metricus-preview-toolbar-v2>div{
  min-width:0;
  display:flex;
  align-items:baseline;
  gap:14px;
  flex-wrap:wrap;
}
.metricus-preview-toolbar-v2 h2{
  margin:0;
  color:#0b1f44;
  font-size:18px;
  line-height:1.2;
}
.metricus-preview-toolbar-v2>div>span{
  color:#5e6c84;
  font-size:12.5px;
  line-height:1.4;
}
.metricus-preview-note-v2{
  flex:0 0 auto;
  color:#7a869a;
  font-size:11.5px;
}
.metricus-preview-grid-v2{
  padding:0;
  background:#fff;
}
.metricus-preview-grid-v2 .metricus-data-grid{
  border:0;
  border-radius:0;
}
.metricus-preview-grid-v2 .ag-header{
  background:#f7f8fa!important;
}
.metricus-preview-grid-v2 .ag-header-cell{
  font-size:12px!important;
}
.metricus-preview-grid-v2 .ag-cell{
  font-size:13.5px!important;
}
.metricus-preview-grid-v2 .ag-pinned-left-header,
.metricus-preview-grid-v2 .ag-pinned-left-cols-container{
  box-shadow:2px 0 4px rgba(9,30,66,.05);
}
@media(max-width:800px){
  .metricus-preview-toolbar-v2{
    align-items:flex-start;
    flex-direction:column;
    gap:4px;
  }
  .metricus-preview-note-v2{display:none;}
}

/* ==========================================================================
   Run screen — processing allowance / retention separation
   ========================================================================== */

.metricus-run-panel-v2{
  overflow:hidden;
}

.metricus-run-head-v2{
  padding:18px 22px;
  border-bottom:1px solid #e6e8ec;
}

.metricus-run-head-v2 h2{
  margin:0 0 4px;
  color:#0b1f44;
  font-size:20px;
  line-height:1.25;
}

.metricus-run-head-v2 p{
  margin:0;
  color:#5e6c84;
  font-size:14px;
  line-height:1.45;
}

.metricus-run-body-v2{
  display:grid;
  grid-gap:14px;
  gap:14px;
  padding:18px 22px;
}

.metricus-run-model-v2{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:20px;
  padding:12px 14px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fbfcfd;
}

.metricus-run-model-title{
  display:flex;
  align-items:center;
  gap:10px;
  color:#0c66e4;
}

.metricus-run-model-title>div{
  display:grid;
  grid-gap:2px;
  gap:2px;
}

.metricus-run-model-title b{
  color:#172b4d;
  font-size:14px;
}

.metricus-run-model-title span{
  color:#6b778c;
  font-size:12.5px;
}

.metricus-run-model-meta{
  display:grid;
  grid-gap:2px;
  gap:2px;
  text-align:right;
}

.metricus-run-model-meta span{
  color:#6b778c;
  font-size:11px;
  font-weight:650;
  text-transform:uppercase;
  letter-spacing:.035em;
}

.metricus-run-model-meta b{
  color:#172b4d;
  font-size:13px;
}

.metricus-processing-summary-v2{
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  border:1px solid #dfe3e8;
  border-radius:8px;
  overflow:hidden;
  background:#fff;
}

.metricus-processing-summary-v2>div{
  display:grid;
  grid-gap:5px;
  gap:5px;
  padding:14px 16px;
  border-right:1px solid #e7eaee;
}

.metricus-processing-summary-v2>div:last-child{
  border-right:0;
}

.metricus-processing-summary-v2 span{
  color:#6b778c;
  font-size:12px;
}

.metricus-processing-summary-v2 strong{
  color:#172b4d;
  font-size:20px;
  line-height:1.15;
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}

.metricus-partial-run-v2{
  padding:12px 14px;
  border:1px solid #f1c46b;
  border-radius:8px;
  background:#fff8e6;
}

.metricus-partial-run-v2>div{
  display:grid;
  grid-gap:4px;
  gap:4px;
}

.metricus-partial-run-v2 b{
  color:#6b4800;
  font-size:13.5px;
}

.metricus-partial-run-v2 span{
  color:#7a5a14;
  font-size:12.5px;
  line-height:1.45;
}

.metricus-full-run-v2{
  display:flex;
  align-items:center;
  gap:9px;
  padding:11px 13px;
  border:1px solid #b7e4c7;
  border-radius:8px;
  background:#f4fff9;
  color:#087443;
  font-size:13px;
  font-weight:600;
}

.metricus-retention-card-v2{
  display:grid;
  grid-template-columns:auto minmax(0,1fr) auto;
  grid-gap:12px;
  gap:12px;
  align-items:start;
  padding:14px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fff;
  cursor:pointer;
}

.metricus-retention-card-v2.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}

.metricus-retention-card-v2 input{
  width:17px;
  height:17px;
  margin-top:2px;
  accent-color:#0c66e4;
}

.metricus-retention-card-v2>span{
  display:grid;
  grid-gap:4px;
  gap:4px;
}

.metricus-retention-card-v2 b{
  color:#172b4d;
  font-size:14px;
}

.metricus-retention-card-v2 small{
  max-width:880px;
  color:#6b778c;
  font-size:12.5px;
  line-height:1.45;
}

.metricus-retention-card-v2 em{
  align-self:center;
  max-width:230px;
  padding:5px 9px;
  border-radius:999px;
  background:#f1f2f4;
  color:#44546f;
  font-size:11.5px;
  font-style:normal;
  font-weight:650;
  text-align:center;
}

.metricus-retention-card-v2.selected em{
  background:#dcfff1;
  color:#087443;
}

.metricus-usage-note-v2{
  display:flex;
  align-items:baseline;
  gap:9px;
  padding:10px 12px;
  border-radius:7px;
  background:#f4f5f7;
}

.metricus-usage-note-v2 b{
  flex:0 0 auto;
  color:#344563;
  font-size:12.5px;
}

.metricus-usage-note-v2 span{
  color:#5e6c84;
  font-size:12px;
  line-height:1.4;
}

@media(max-width:900px){
  .metricus-processing-summary-v2{
    grid-template-columns:1fr;
  }
  .metricus-processing-summary-v2>div{
    border-right:0;
    border-bottom:1px solid #e7eaee;
  }
  .metricus-processing-summary-v2>div:last-child{
    border-bottom:0;
  }
  .metricus-retention-card-v2{
    grid-template-columns:auto 1fr;
  }
  .metricus-retention-card-v2 em{
    grid-column:2;
    justify-self:start;
  }
}

/* ==========================================================================
   Models screen overhaul — Metricus SaaS UI strategy
   ========================================================================== */

.models-page-head-v3{
  margin-bottom:18px;
  align-items:center;
}

.models-page-head-v3 h1{
  margin:0 0 5px;
  color:#0b1f44;
  font-size:30px;
  line-height:1.12;
  letter-spacing:-.02em;
}

.models-page-head-v3 p{
  margin:0;
  color:#5e6c84;
  font-size:14px;
  line-height:1.45;
}

.models-card-v3{
  overflow:visible;
  border:1px solid #dfe3e8;
  border-radius:12px;
  background:#fff;
  box-shadow:0 1px 3px rgba(9,30,66,.05);
}

.models-toolbar-v3{
  min-height:58px;
  display:flex;
  align-items:center;
  gap:10px;
  padding:10px 12px;
  border-bottom:1px solid #e7eaee;
  background:#fbfcfd;
  border-radius:12px 12px 0 0;
}

.models-search-v3{
  min-width:320px;
  height:38px;
  display:flex;
  align-items:center;
  gap:8px;
  flex:1 1 520px;
  padding:0 11px;
  border:1px solid #c8d0dc;
  border-radius:8px;
  background:#fff;
  color:#6b778c;
}

.models-search-v3:focus-within{
  border-color:#0c66e4;
  box-shadow:0 0 0 2px #cce0ff;
}

.models-search-v3 input{
  width:100%;
  min-width:0;
  border:0;
  outline:0;
  background:transparent;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:13.5px;
}

.models-toolbar-v3>select{
  height:38px;
  min-width:138px;
  border:1px solid #c8d0dc;
  border-radius:8px;
  background:#fff;
  padding:0 32px 0 11px;
  color:#344563;
  font-family:var(--pa-font);
  font-size:13px;
}

.models-toolbar-v3>select:focus{
  outline:2px solid #cce0ff;
  border-color:#0c66e4;
}

.models-toolbar-v3>.pa-icon-button{
  width:36px;
  height:36px;
}

.models-toolbar-v3>span{
  min-width:58px;
  color:#7a869a;
  font-size:12px;
  text-align:right;
}

.models-table-v3{
  width:100%;
  overflow-x:auto;
}

.models-table-head-v3,
.models-table-row-v3{
  display:grid;
  grid-template-columns:minmax(260px,1.7fr) minmax(175px,1.05fr) 94px 100px minmax(160px,.9fr) 108px 42px;
  align-items:center;
  grid-column-gap:16px;
  -moz-column-gap:16px;
       column-gap:16px;
  min-width:1040px;
}

.models-table-head-v3{
  min-height:40px;
  padding:0 18px;
  border-bottom:1px solid #dfe3e8;
  background:#f7f8fa;
  color:#5e6c84;
}

.models-table-head-v3>div{
  font-size:12px;
  font-weight:650;
  letter-spacing:.01em;
}

.models-table-head-v3 .numeric{
  text-align:right;
}

.models-table-row-v3{
  min-height:66px;
  padding:0 18px;
  border-bottom:1px solid #eef0f3;
  color:#344563;
  background:#fff;
  cursor:pointer;
  transition:background .12s ease;
}

.models-table-row-v3:last-child{
  border-bottom:0;
}

.models-table-row-v3:hover{
  background:#f8fbff;
}

.models-table-row-v3:focus{
  outline:2px solid #85b8ff;
  outline-offset:-2px;
}

.models-name-v3,
.models-source-v3,
.models-count-v3{
  min-width:0;
  display:grid;
  grid-gap:3px;
  gap:3px;
}

.models-name-v3 b,
.models-source-v3 b,
.models-count-v3 b{
  overflow:hidden;
  color:#172b4d;
  font-size:14px;
  line-height:1.25;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.models-name-v3 span{
  overflow:hidden;
  color:#6b778c;
  font-size:12.5px;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.models-source-v3 b{
  font-size:13.5px;
}

.models-source-v3 span,
.models-count-v3 span{
  overflow:hidden;
  color:#6b778c;
  font-size:12px;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.models-count-v3{
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}

.models-table-row-v3 .numeric{
  text-align:right;
}

.models-date-v3{
  color:#44546f;
  font-size:13px;
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}

.model-row-actions-v3{
  display:flex;
  justify-content:flex-end;
}

.model-row-actions-v3>button{
  width:32px;
  height:32px;
  display:grid;
  place-items:center;
  border:0;
  border-radius:6px;
  background:transparent;
  color:#44546f;
  cursor:pointer;
}

.model-row-actions-v3>button:hover{
  background:#e9f2ff;
  color:#0c66e4;
}

.model-action-menu-v3{
  width:210px;
}

/* Model details drawer */
.model-detail-panel-v3{
  width:min(600px,44vw);
  min-width:540px;
  max-height:100vh;
  overflow:auto;
  background:#fff;
}

.model-detail-head-v3{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:20px;
  padding:22px 26px 18px;
  border-bottom:1px solid #e7eaee;
}

.model-detail-source-label-v3{
  display:flex;
  align-items:center;
  gap:7px;
  margin-bottom:7px;
  color:#0c66e4;
  font-size:12px;
  font-weight:700;
}

.model-detail-head-v3 h2{
  margin:0 0 4px;
  color:#0b1f44;
  font-size:25px;
  line-height:1.15;
  letter-spacing:-.015em;
}

.model-detail-head-v3 p{
  margin:0;
  color:#5e6c84;
  font-size:13.5px;
}

.model-detail-actions-v3{
  display:flex;
  align-items:center;
  gap:8px;
  padding:12px 26px;
  border-bottom:1px solid #e7eaee;
  background:#fbfcfd;
}

.model-detail-actions-v3 button{
  min-height:38px;
  font-size:12.5px;
}

.model-partial-banner-v3{
  display:grid;
  grid-gap:3px;
  gap:3px;
  margin:16px 26px 0;
  padding:11px 13px;
  border:1px solid #f1c46b;
  border-radius:8px;
  background:#fff8e6;
}

.model-partial-banner-v3 b{
  color:#6b4800;
  font-size:13px;
}

.model-partial-banner-v3 span{
  color:#7a5a14;
  font-size:12px;
}

.model-detail-section-v3{
  padding:20px 26px;
  border-bottom:1px solid #eef0f3;
}

.model-detail-section-head-v3{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:16px;
  margin-bottom:12px;
}

.model-detail-section-head-v3 h3{
  margin:0;
  color:#172b4d;
  font-size:15px;
}

.model-detail-section-head-v3>span{
  color:#7a869a;
  font-size:12px;
}

.model-detail-metrics-v3{
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  grid-gap:9px;
  gap:9px;
}

.model-detail-metrics-v3>div{
  display:grid;
  grid-gap:5px;
  gap:5px;
  padding:12px 13px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fafbfc;
}

.model-detail-metrics-v3 span{
  color:#6b778c;
  font-size:11.5px;
}

.model-detail-metrics-v3 strong{
  color:#0b1f44;
  font-size:23px;
  line-height:1.1;
  font-feature-settings:"tnum";
  font-variant-numeric:tabular-nums;
}

.model-definition-grid-v3{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:16px 24px;
  gap:16px 24px;
}

.model-definition-grid-v3>div,
.model-scope-v3>div{
  min-width:0;
  display:grid;
  grid-gap:4px;
  gap:4px;
}

.model-definition-grid-v3 span,
.model-scope-v3 span,
.model-text-detail-v3>span{
  color:#6b778c;
  font-size:10.5px;
  font-weight:700;
  text-transform:uppercase;
  letter-spacing:.035em;
}

.model-definition-grid-v3 b,
.model-scope-v3 b{
  color:#172b4d;
  font-size:13px;
  line-height:1.4;
  word-break:break-word;
}

.model-scope-v3{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  grid-gap:14px 24px;
  gap:14px 24px;
  margin-top:18px;
  padding:14px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fafbfc;
}

.model-text-detail-v3{
  display:grid;
  grid-gap:5px;
  gap:5px;
  margin-top:16px;
}

.model-text-detail-v3 p{
  margin:0;
  color:#44546f;
  font-size:13px;
  line-height:1.5;
}

.model-detail-footer-v3{
  display:flex;
  align-items:center;
  gap:14px;
  padding:14px 26px 20px;
}

.model-detail-footer-v3 button{
  display:inline-flex;
  align-items:center;
  gap:6px;
  border:0;
  background:transparent;
  color:#44546f;
  font-family:var(--pa-font);
  font-size:12px;
  font-weight:650;
  cursor:pointer;
}

.model-detail-footer-v3 button:hover{
  color:#0c66e4;
}

.model-detail-footer-v3 button.danger{
  margin-left:auto;
  color:#ae2a19;
}

/* Comprehensive edit dialog */
.edit-model-modal-v3{
  width:min(760px,calc(100vw - 48px));
  max-height:calc(100vh - 48px);
  overflow:hidden;
  border-radius:12px;
}

.edit-model-head.v3{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:20px;
  padding:20px 24px 17px;
  border-bottom:1px solid #e7eaee;
}

.edit-model-head.v3 h2{
  margin:2px 0 3px;
  color:#0b1f44;
  font-size:23px;
}

.edit-model-head.v3 p{
  margin:0;
  color:#6b778c;
  font-size:12.5px;
}

.edit-model-body.v3{
  max-height:calc(100vh - 190px);
  overflow:auto;
  padding:0;
}

.model-edit-section-v3{
  padding:18px 24px;
  border-bottom:1px solid #eef0f3;
}

.model-edit-section-v3 h3{
  margin:0 0 12px;
  color:#172b4d;
  font-size:14px;
}

.model-edit-grid-v3{
  display:grid;
  grid-template-columns:1fr 1fr;
  grid-gap:12px 14px;
  gap:12px 14px;
}

.model-edit-grid-v3 label{
  display:grid;
  grid-gap:6px;
  gap:6px;
}

.model-edit-grid-v3 label.span-two{
  grid-column:1/-1;
}

.model-edit-grid-v3 label>span{
  color:#344563;
  font-size:12.5px;
  font-weight:650;
}

.model-edit-grid-v3 input,
.model-edit-grid-v3 textarea{
  width:100%;
  border:1px solid #b8c2d1;
  border-radius:8px;
  background:#fff;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:13.5px;
}

.model-edit-grid-v3 input{
  min-height:42px;
  padding:0 11px;
}

.model-edit-grid-v3 textarea{
  min-height:80px;
  padding:10px 11px;
  resize:vertical;
}

.model-edit-grid-v3 input:focus,
.model-edit-grid-v3 textarea:focus{
  outline:2px solid #cce0ff;
  border-color:#0c66e4;
}

.model-retention-edit-v3{
  display:grid;
  grid-template-columns:auto 1fr;
  grid-gap:10px;
  gap:10px;
  align-items:start;
  padding:12px 13px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fff;
  cursor:pointer;
}

.model-retention-edit-v3.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}

.model-retention-edit-v3 input{
  width:17px;
  height:17px;
  margin-top:2px;
  accent-color:#0c66e4;
}

.model-retention-edit-v3>span{
  display:grid;
  grid-gap:3px;
  gap:3px;
}

.model-retention-edit-v3 b{
  color:#172b4d;
  font-size:13.5px;
}

.model-retention-edit-v3 small{
  color:#6b778c;
  font-size:12px;
  line-height:1.45;
}

.model-retention-warning-v3{
  margin-top:8px;
  padding:9px 11px;
  border:1px solid #f1c46b;
  border-radius:7px;
  background:#fff8e6;
  color:#7a5a14;
  font-size:12px;
}

.model-edit-source-v3{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:20px;
  margin:18px 24px;
  padding:13px 14px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fafbfc;
}

.model-edit-source-v3>div{
  display:grid;
  grid-gap:4px;
  gap:4px;
}

.model-edit-source-v3 b{
  color:#172b4d;
  font-size:13px;
}

.model-edit-source-v3 span{
  max-width:500px;
  color:#6b778c;
  font-size:11.5px;
  line-height:1.4;
}

.model-edit-source-v3 button{
  flex:0 0 auto;
  min-height:36px;
  font-size:12px;
}

.edit-model-foot.v3{
  padding:12px 24px;
  border-top:1px solid #e7eaee;
  background:#fbfcfd;
}

@media(max-width:1100px){
  .models-table-head-v3,
  .models-table-row-v3{
    grid-template-columns:minmax(230px,1.5fr) minmax(155px,1fr) 82px 88px minmax(145px,.9fr) 100px 38px;
  }
  .model-detail-panel-v3{
    width:min(600px,65vw);
    min-width:0;
  }
}

@media(max-width:760px){
  .model-edit-grid-v3,
  .model-definition-grid-v3,
  .model-scope-v3,
  .model-detail-metrics-v3{
    grid-template-columns:1fr;
  }
  .model-edit-grid-v3 label.span-two{
    grid-column:auto;
  }
  .model-edit-source-v3{
    align-items:flex-start;
    flex-direction:column;
  }
}

/* ==========================================================================
   Models semantic cleanup — data status / access / explicit actions
   ========================================================================== */

.models-table-head-v3,
.models-table-row-v3{
  grid-template-columns:
    minmax(250px,1.65fr)
    minmax(160px,1fr)
    90px
    96px
    minmax(150px,.9fr)
    118px
    72px;
}

.models-table-head-v3 .actions{
  text-align:right;
}

.models-actions-cell-v4{
  display:flex;
  justify-content:flex-end;
}

.data-status-pill-v4{
  width:-moz-max-content;
  width:max-content;
  min-height:24px;
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:3px 8px;
  border-radius:999px;
  font-size:12px;
  font-weight:650;
  line-height:1;
  white-space:nowrap;
}

.data-status-pill-v4 i{
  width:6px;
  height:6px;
  border-radius:50%;
  background:currentColor;
}

.data-status-pill-v4.success{
  background:#dcfff1;
  color:#087443;
}

.data-status-pill-v4.warning{
  background:#fff0b3;
  color:#7a4d00;
}

.data-status-pill-v4.info{
  background:#e9f2ff;
  color:#0c66e4;
}

.data-status-pill-v4.danger{
  background:#ffeceb;
  color:#ae2a19;
}

.data-status-pill-v4.neutral{
  background:#f1f2f4;
  color:#44546f;
}

.model-access-pill-v4{
  width:-moz-max-content;
  width:max-content;
  display:inline-flex;
  align-items:center;
  min-height:23px;
  padding:3px 8px;
  border-radius:999px;
  font-size:11.5px;
  font-weight:650;
  white-space:nowrap;
}

.model-access-pill-v4.success{
  background:#e9f8f0;
  color:#087443;
}

.model-access-pill-v4.warning{
  background:#fff8e6;
  color:#7a4d00;
}

.model-access-empty-v4{
  color:#8993a4;
  font-size:13px;
}

.model-action-menu-v3{
  width:236px;
}

.model-action-menu-v3 button{
  min-height:38px;
  font-size:12.5px;
}

.model-detail-actions-v3{
  flex-wrap:wrap;
}

@media(max-width:1200px){
  .models-table-head-v3,
  .models-table-row-v3{
    grid-template-columns:
      minmax(225px,1.5fr)
      minmax(145px,1fr)
      80px
      86px
      minmax(140px,.9fr)
      108px
      66px;
  }
}

/* ==========================================================================
   Models edit modal compact pass + data-status correction
   ========================================================================== */

.edit-model-modal-v3{
  width:min(880px,calc(100vw - 48px));
  max-height:calc(100vh - 48px);
}

.edit-model-head.v3{
  padding:17px 22px 14px;
}

.edit-model-head.v3 h2{
  font-size:22px;
}

.edit-model-head.v3 p{
  font-size:12.5px;
}

.edit-model-body.v4{
  padding:18px 22px 16px;
  overflow:auto;
  max-height:calc(100vh - 175px);
}

.model-edit-grid-v4{
  display:grid;
  grid-template-columns:1fr 1fr;
  grid-gap:12px 16px;
  gap:12px 16px;
}

.model-edit-grid-v4 label{
  display:grid;
  grid-gap:6px;
  gap:6px;
}

.model-edit-grid-v4 label.span-two{
  grid-column:1/-1;
}

.model-edit-grid-v4 label>span{
  color:#344563;
  font-size:12.5px;
  font-weight:650;
}

.model-edit-grid-v4 input,
.model-edit-grid-v4 textarea{
  width:100%;
  border:1px solid #b8c2d1;
  border-radius:8px;
  background:#fff;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:13.5px;
  box-sizing:border-box;
}

.model-edit-grid-v4 input{
  height:40px;
  padding:0 11px;
}

.model-edit-grid-v4 textarea{
  min-height:64px;
  max-height:110px;
  padding:9px 11px;
  resize:vertical;
}

.model-edit-grid-v4 input:focus,
.model-edit-grid-v4 textarea:focus{
  outline:2px solid #cce0ff;
  border-color:#0c66e4;
}

.model-edit-lower-v4{
  display:grid;
  grid-template-columns:1.15fr .85fr;
  grid-gap:12px;
  gap:12px;
  margin-top:14px;
}

.model-retention-edit-v4,
.model-config-shortcut-v4{
  min-height:76px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fafbfc;
  padding:12px 13px;
}

.model-retention-edit-v4{
  display:grid;
  grid-template-columns:auto 1fr;
  grid-gap:10px;
  gap:10px;
  align-items:start;
  cursor:pointer;
}

.model-retention-edit-v4.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}

.model-retention-edit-v4 input{
  width:17px;
  height:17px;
  margin-top:2px;
  accent-color:#0c66e4;
}

.model-retention-edit-v4>span{
  display:grid;
  grid-gap:3px;
  gap:3px;
}

.model-retention-edit-v4 b,
.model-config-shortcut-v4 b{
  color:#172b4d;
  font-size:13.5px;
}

.model-retention-edit-v4 small,
.model-config-shortcut-v4 span{
  color:#6b778c;
  font-size:11.5px;
  line-height:1.4;
}

.model-config-shortcut-v4{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
}

.model-config-shortcut-v4>div{
  display:grid;
  grid-gap:4px;
  gap:4px;
}

.model-config-shortcut-v4 button{
  flex:0 0 auto;
  min-height:34px;
  padding:0 10px;
  font-size:12px;
}

.model-retention-warning-v4{
  margin-top:10px;
  padding:8px 10px;
  border:1px solid #f1c46b;
  border-radius:7px;
  background:#fff8e6;
  color:#7a5a14;
  font-size:11.5px;
}

.edit-model-foot.v3{
  padding:11px 22px;
}

@media(max-width:760px){
  .model-edit-grid-v4,
  .model-edit-lower-v4{
    grid-template-columns:1fr;
  }
  .model-edit-grid-v4 label.span-two{
    grid-column:auto;
  }
}

/* ==========================================================================
   Connections settings — compact enterprise layout
   ========================================================================== */

.connections-toolbar.compact{
  align-items:center;
  padding:14px 18px;
}

.connections-title-block{
  display:grid;
  grid-gap:3px;
  gap:3px;
}

.connections-title-line{
  display:flex;
  align-items:baseline;
  gap:12px;
  flex-wrap:wrap;
}

.connections-title-line h2{
  margin:0;
  font-size:17px;
}

.connections-title-line .connections-count{
  color:#6b778c;
  font-size:11px;
  font-weight:500;
}

.connections-toolbar.compact p{
  font-size:10.5px;
}

.settings-status.compact{
  margin:0;
  border-radius:0;
  padding:7px 18px;
  font-size:10.5px;
}

.connection-row{
  padding:10px 18px;
}

.connection-mark{
  width:32px;
  height:32px;
  border-radius:8px;
}

.connection-main b{
  font-size:11.5px;
}

.connection-main span{
  font-size:9.5px;
}

.connection-editor.compact{
  margin:12px 18px 16px;
  padding:14px 16px;
  border-radius:9px;
}

.connection-editor-head.compact{
  align-items:center;
  margin-bottom:12px;
}

.connection-editor-title-line{
  display:flex;
  align-items:baseline;
  gap:10px;
}

.connection-editor-title-line h3{
  margin:0;
  font-size:14.5px;
}

.connection-editor-title-line span{
  color:#6b778c;
  font-size:10px;
}

.connection-core-grid{
  display:grid;
  grid-template-columns:minmax(220px,1fr) 170px minmax(360px,1.7fr);
  grid-gap:12px;
  gap:12px;
  align-items:end;
}

.connection-core-grid label{
  display:grid;
  grid-gap:5px;
  gap:5px;
  min-width:0;
}

.connection-core-grid label>span{
  color:#344563;
  font-size:10.5px;
  font-weight:650;
}

.connection-core-grid input,
.connection-core-grid select{
  width:100%;
  height:38px;
  border:1px solid #cdd3dc;
  border-radius:7px;
  padding:0 10px;
  background:#fff;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:11.5px;
  box-sizing:border-box;
}

.connection-core-grid input:focus,
.connection-core-grid select:focus{
  outline:2px solid #cce0ff;
  border-color:#0c66e4;
}

.jira-auth-section.compact{
  margin:12px 0 10px;
}

.jira-auth-heading.compact{
  display:flex;
  align-items:baseline;
  gap:10px;
  margin-bottom:7px;
}

.jira-auth-heading.compact b{
  font-size:11px;
}

.jira-auth-heading.compact span{
  font-size:9.5px;
}

.jira-auth-methods.compact{
  grid-template-columns:repeat(3,minmax(0,1fr));
  gap:7px;
}

.jira-auth-method.compact{
  min-height:42px;
  display:flex;
  align-items:center;
  gap:8px;
  padding:8px 10px;
  border-radius:7px;
}

.jira-auth-method.compact.selected{
  background:#f4f8ff;
}

.jira-auth-radio{
  width:14px;
  height:14px;
  flex:0 0 14px;
  border:1.5px solid #8c9bab;
  border-radius:50%;
  position:relative;
}

.jira-auth-method.compact.selected .jira-auth-radio{
  border-color:#0c66e4;
}

.jira-auth-method.compact.selected .jira-auth-radio::after{
  content:"";
  position:absolute;
  inset:3px;
  border-radius:50%;
  background:#0c66e4;
}

.jira-auth-compact-label{
  display:flex!important;
  align-items:center;
  justify-content:space-between;
  gap:8px;
  width:100%;
  padding:0!important;
}

.jira-auth-compact-label b{
  font-size:10.5px;
}

.jira-auth-compact-label em{
  position:static!important;
  flex:0 0 auto;
  font-size:8.5px!important;
}

.jira-auth-selected-help{
  margin-top:6px;
  color:#6b778c;
  font-size:9.5px;
  line-height:1.4;
}

.oauth-connect-panel.compact{
  margin:8px 0 0;
  padding:10px 12px;
  border-radius:7px;
}

.oauth-connect-panel.compact b{
  font-size:11px;
}

.oauth-connect-panel.compact span{
  font-size:9.5px;
}

.oauth-connect-panel.compact button{
  min-height:34px;
  padding:0 12px;
  font-size:10.5px;
}

.connection-credential-grid.compact{
  margin-top:9px;
}

.connection-credential-grid.compact label>span{
  font-size:10px;
}

.connection-credential-grid.compact input{
  height:36px;
  font-size:11px;
}

.connection-credential-grid.compact .connection-secret{
  height:36px;
}

.connection-editor-footer{
  display:grid;
  grid-template-columns:minmax(0,1fr) auto;
  grid-gap:12px;
  gap:12px;
  align-items:center;
  margin-top:10px;
  padding-top:10px;
  border-top:1px solid #eef0f3;
}

.settings-actions.compact{
  display:flex;
  align-items:center;
  gap:7px;
  margin:0;
}

.settings-actions.compact button{
  min-height:34px;
  padding:0 12px;
  font-size:10.5px;
}

.connection-test-result.compact{
  margin:0;
  padding:7px 9px;
  grid-template-columns:auto 1fr;
  align-items:center;
  gap:8px;
}

.connection-test-result.compact b{
  font-size:9.5px;
  white-space:nowrap;
}

.connection-test-result.compact span{
  font-size:9.5px;
}

@media(max-width:1150px){
  .connection-core-grid{
    grid-template-columns:1fr 170px;
  }
  .connection-url-field{
    grid-column:1/-1;
  }
}

@media(max-width:850px){
  .connection-core-grid,
  .jira-auth-methods.compact{
    grid-template-columns:1fr;
  }
  .connection-url-field{
    grid-column:auto;
  }
  .connection-editor-footer{
    grid-template-columns:1fr;
  }
  .settings-actions.compact{
    justify-content:flex-end;
  }
}

/* ==========================================================================
   ServiceNow REST model builder
   ========================================================================== */

.sn-builder{
  display:grid;
  grid-gap:14px;
  gap:14px;
}

.compact-model-builder-head{
  margin-bottom:0;
}

.sn-stepper{
  display:flex;
  align-items:center;
  padding:0 4px 2px;
}

.sn-step{
  display:flex;
  align-items:center;
  gap:8px;
  color:#5e6c84;
  white-space:nowrap;
}

.sn-step>span{
  width:30px;
  height:30px;
  display:grid;
  place-items:center;
  border:1px solid #c8d0dc;
  border-radius:50%;
  background:#fff;
  color:#344563;
  font-size:12px;
}

.sn-step b{
  font-size:12.5px;
}

.sn-step.active,
.sn-step.done{
  color:#0c66e4;
}

.sn-step.active>span{
  border-color:#0c66e4;
  color:#0c66e4;
}

.sn-step.done>span{
  border-color:#0c66e4;
  background:#0c66e4;
  color:#fff;
}

.sn-step-line{
  height:1px;
  flex:1 1 70px;
  min-width:30px;
  max-width:115px;
  margin:0 10px;
  background:#dfe3e8;
}

.sn-step-line.done{
  background:#0c66e4;
}

.sn-builder-panel{
  overflow:hidden;
}

.sn-scope-body{
  position:relative;
}

.sn-scope-grid{
  display:grid;
  grid-template-columns:1.25fr .75fr .75fr;
  grid-gap:13px;
  gap:13px;
}

.sn-scope-grid label,
.sn-model-grid label,
.sn-activity-row label{
  display:grid;
  grid-gap:6px;
  gap:6px;
}

.sn-scope-grid label>span,
.sn-model-grid label>span,
.sn-activity-row label>span{
  color:#344563;
  font-size:12px;
  font-weight:650;
}

.sn-scope-grid label>span em{
  color:#7a869a;
  font-style:normal;
  font-weight:400;
}

.sn-scope-grid input,
.sn-scope-grid select,
.sn-model-grid input,
.sn-model-grid textarea,
.sn-activity-row select{
  width:100%;
  min-height:40px;
  box-sizing:border-box;
  border:1px solid #c8d0dc;
  border-radius:8px;
  background:#fff;
  padding:0 11px;
  color:#172b4d;
  font-family:var(--pa-font);
  font-size:13.5px;
}

.sn-model-grid textarea{
  min-height:66px;
  padding:9px 11px;
  resize:vertical;
}

.sn-scope-grid .span-three{
  grid-column:1/-1;
}

.sn-scope-count{
  display:flex;
  align-items:baseline;
  gap:8px;
  margin-top:13px;
  padding:9px 11px;
  width:-moz-max-content;
  width:max-content;
  border:1px solid #b7e4c7;
  border-radius:8px;
  background:#f4fff9;
}

.sn-scope-count b{
  color:#087443;
  font-size:18px;
}

.sn-scope-count span{
  color:#44546f;
  font-size:12px;
}

.sn-model-grid{
  display:grid;
  grid-template-columns:1fr 1fr;
  grid-gap:13px 16px;
  gap:13px 16px;
}

.sn-model-grid .span-two{
  grid-column:1/-1;
}

.sn-activity-row{
  display:grid;
  grid-template-columns:minmax(300px,.8fr) minmax(360px,1.2fr);
  grid-gap:18px;
  gap:18px;
  align-items:center;
  padding:12px 14px;
  border:1px solid #bcd4ff;
  border-radius:8px;
  background:#f4f8ff;
}

.sn-activity-row>div{
  display:grid;
  grid-gap:4px;
  gap:4px;
}

.sn-activity-row>div b{
  color:#172b4d;
  font-size:13px;
}

.sn-activity-row>div span{
  color:#5e6c84;
  font-size:12px;
}

.sn-selected-row{
  display:flex;
  align-items:baseline;
  justify-content:space-between;
  margin-top:14px;
}

.sn-selected-row b{
  color:#172b4d;
  font-size:13px;
}

.sn-selected-row span{
  color:#6b778c;
  font-size:11.5px;
}

.sn-field-search{
  width:min(430px,100%);
  height:38px;
  display:flex;
  align-items:center;
  gap:8px;
  margin:9px 0;
  padding:0 11px;
  border:1px solid #c8d0dc;
  border-radius:8px;
  background:#fff;
  color:#6b778c;
}

.sn-field-search input{
  flex:1;
  border:0;
  outline:0;
  background:transparent;
  font-family:var(--pa-font);
  font-size:13px;
}

.sn-field-grid{
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  grid-gap:7px;
  gap:7px;
  max-height:300px;
  overflow:auto;
  padding-right:4px;
}

.sn-field-grid label{
  min-height:50px;
  display:flex;
  align-items:flex-start;
  gap:8px;
  padding:9px 10px;
  border:1px solid #dfe3e8;
  border-radius:8px;
  background:#fff;
  cursor:pointer;
}

.sn-field-grid label.selected{
  border-color:#85b8ff;
  background:#f4f8ff;
}

.sn-field-grid input{
  width:16px;
  height:16px;
  margin-top:2px;
  accent-color:#0c66e4;
}

.sn-field-grid label>span{
  display:grid;
  grid-gap:2px;
  gap:2px;
  min-width:0;
}

.sn-field-grid b{
  overflow:hidden;
  color:#172b4d;
  font-size:12.5px;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.sn-field-grid small{
  overflow:hidden;
  color:#7a869a;
  font-size:10.5px;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.sn-preview-panel{
  min-height:0;
}

.sn-preview-head{
  display:flex;
  align-items:baseline;
  gap:16px;
  padding:12px 18px;
  border-bottom:1px solid #e7eaee;
}

.sn-preview-head h2{
  margin:0;
  color:#172b4d;
  font-size:17px;
}

.sn-preview-head span{
  color:#5e6c84;
  font-size:12px;
}

.sn-preview-table-wrap{
  max-height:440px;
  overflow:auto;
}

.sn-preview-table{
  width:-moz-max-content;
  width:max-content;
  min-width:100%;
  border-collapse:collapse;
}

.sn-preview-table th{
  position:sticky;
  top:0;
  z-index:1;
  padding:9px 12px;
  border-bottom:1px solid #dfe3e8;
  background:#f7f8fa;
  color:#44546f;
  font-size:11.5px;
  text-align:left;
  white-space:nowrap;
}

.sn-preview-table td{
  padding:10px 12px;
  border-bottom:1px solid #eef0f3;
  color:#344563;
  font-size:12.5px;
  white-space:nowrap;
}

.sn-run-body{
  display:grid;
  grid-gap:13px;
  gap:13px;
}

.source-chip{
  display:inline-flex;
  align-items:center;
  gap:6px;
  min-height:30px;
  padding:0 9px;
  border:1px solid #dfe3e8;
  border-radius:7px;
  color:#344563;
  font-size:11.5px;
  font-weight:650;
}

.count-pill{
  display:inline-flex;
  min-height:25px;
  align-items:center;
  padding:0 8px;
  border-radius:999px;
  background:#dcfff1;
  color:#087443;
  font-size:11.5px;
  font-weight:650;
}

@media(max-width:1000px){
  .sn-scope-grid,
  .sn-model-grid,
  .sn-activity-row{
    grid-template-columns:1fr;
  }
  .sn-scope-grid .span-three,
  .sn-model-grid .span-two{
    grid-column:auto;
  }
  .sn-field-grid{
    grid-template-columns:repeat(2,minmax(0,1fr));
  }
}

@media(max-width:700px){
  .sn-step b{
    display:none;
  }
  .sn-field-grid{
    grid-template-columns:1fr;
  }
}

/* ServiceNow connection methods */
.servicenow-auth-methods.compact{
  display:grid;
  grid-template-columns:repeat(4,minmax(0,1fr));
  grid-gap:7px;
  gap:7px;
}
.connection-credential-grid.one{
  grid-template-columns:1fr;
}
@media(max-width:1180px){
  .servicenow-auth-methods.compact{
    grid-template-columns:repeat(2,minmax(0,1fr));
  }
}
@media(max-width:760px){
  .servicenow-auth-methods.compact{
    grid-template-columns:1fr;
  }
}

/* ServiceNow scope count control */
.sn-scope-count-row{
  display:flex;
  align-items:center;
  gap:10px;
  margin-top:13px;
}
.sn-scope-count-row .pa-secondary{
  min-height:36px;
  padding:0 12px;
}
.sn-scope-count-row .sn-scope-count{
  margin-top:0;
}
.sn-scope-count.over-limit{
  border-color:#f5b7b1;
  background:#fff4f3;
}
.sn-scope-count.over-limit b{
  color:#ae2e24;
}
.sn-count-hint{
  color:#6b778c;
  font-size:11.5px;
}

/* ServiceNow table discovery diagnostics */
.sn-discovery-status{
  display:flex;
  align-items:baseline;
  gap:8px;
  margin-top:10px;
  padding:8px 10px;
  border-radius:7px;
  font-size:11.5px;
}
.sn-discovery-status b{
  white-space:nowrap;
}
.sn-discovery-status span{
  color:#5e6c84;
}
.sn-discovery-status.success{
  border:1px solid #b7e4c7;
  background:#f4fff9;
  color:#087443;
}
.sn-discovery-status.warning{
  border:1px solid #f1c46b;
  background:#fff8e6;
  color:#7a4d00;
}


/* ServiceNow REST working indicator */
.sn-working-overlay{
  position:fixed;
  inset:0;
  z-index:10000;
  display:flex;
  align-items:center;
  justify-content:center;
  background:rgba(244,247,251,.62);
  backdrop-filter:blur(1px);
}
.sn-working-dialog{
  width:min(430px,calc(100vw - 32px));
  display:flex;
  align-items:center;
  gap:14px;
  padding:20px 22px;
  border:1px solid #d8e0ea;
  border-radius:12px;
  background:#fff;
  box-shadow:0 16px 42px rgba(9,30,66,.16);
}
.sn-working-dialog>div:last-child{
  display:flex;
  flex-direction:column;
  gap:4px;
}
.sn-working-dialog b{
  font-size:15px;
  color:#091e42;
}
.sn-working-dialog span{
  font-size:13px;
  line-height:1.4;
  color:#5e6c84;
}
.sn-working-spinner{
  width:28px;
  height:28px;
  flex:0 0 28px;
  border:3px solid #dbe7f7;
  border-top-color:#0c66e4;
  border-radius:50%;
  animation:sn-working-spin .75s linear infinite;
}
@keyframes sn-working-spin{
  to{transform:rotate(360deg);}
}

/* Organization context wizard step */
.organization-context-panel{overflow:hidden}
.organization-context-head{align-items:flex-start;gap:20px}
.organization-ai-button{white-space:nowrap}
.organization-context-body{display:flex;flex-direction:column;gap:18px}
.organization-context-intro{display:flex;align-items:center;justify-content:space-between;gap:18px;padding:14px 16px;border:1px solid #dbe4f0;border-radius:10px;background:#f8fbff}
.organization-context-intro>div{display:flex;flex-direction:column;gap:3px}
.organization-context-intro b{font-size:14px;color:#102a56}
.organization-context-intro span{font-size:13px;color:#526987}
.organization-process-chip{max-width:48%;padding:6px 10px;border-radius:999px;background:#edf4ff;color:#205fc7!important;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.organization-context-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-gap:16px 20px;gap:16px 20px}
.organization-context-grid label{display:flex;flex-direction:column;gap:7px;font-size:13px;font-weight:700;color:#102a56}
.organization-context-grid label.span-two{grid-column:1/-1}
.organization-context-grid input,.organization-context-grid textarea{width:100%;box-sizing:border-box;border:1px solid #cbd7e6;border-radius:9px;background:#fff;color:#0b2854;font:inherit;font-weight:400;padding:11px 13px;outline:none}
.organization-context-grid input:focus,.organization-context-grid textarea:focus{border-color:#0c66e4;box-shadow:0 0 0 2px rgba(12,102,228,.10)}
.organization-context-grid textarea{resize:vertical;min-height:68px}
.organization-default-row{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;padding:13px 15px;border:1px solid #dbe4f0;border-radius:10px;background:#fff}
.organization-default-row label{display:flex;align-items:center;gap:9px;font-size:13px;font-weight:700;color:#102a56}
.organization-default-row small{max-width:48%;color:#64748b;line-height:1.45;text-align:right}
.organization-context-message{padding:10px 12px;border-radius:8px;background:#f3f7fc;color:#3d5879;font-size:13px}
@media(max-width:900px){.organization-context-grid{grid-template-columns:1fr}.organization-context-grid label.span-two{grid-column:auto}.organization-context-intro,.organization-default-row{align-items:flex-start;flex-direction:column}.organization-process-chip,.organization-default-row small{max-width:100%;text-align:left}}

/* Organization context AI assist refinement */
.organization-name-field{grid-column:1/-1!important}
.organization-name-ai-row{display:grid;grid-template-columns:minmax(0,1fr) auto;grid-gap:10px;gap:10px;align-items:stretch}
.organization-name-ai-row input{min-width:0}
.organization-name-ai-row .organization-ai-button{min-width:170px;padding-left:18px;padding-right:18px}
.organization-ai-hint{font-size:12px!important;font-weight:400!important;line-height:1.45;color:#65758b!important}
.organization-ai-hint.ready{color:#245ba7!important}
.organization-ai-hint b{color:#123b78}
.organization-context-grid>.organization-context-message{grid-column:1/-1;margin-top:-4px}
.organization-context-message.success{background:#eefbf4;color:#17633a;border:1px solid #bce8cd}
.organization-context-message.error{background:#fff4f3;color:#ae2e24;border:1px solid #f3b8b3}
.organization-context-message.info{background:#f3f7fc;color:#3d5879;border:1px solid #dbe4f0}
@media(max-width:700px){.organization-name-ai-row{grid-template-columns:1fr}.organization-name-ai-row .organization-ai-button{width:100%}}

/* Integrated billing sprint */
.billing-page-head{align-items:flex-start}
.integrated-billing-summary .access-summary-card strong{font-size:20px}
.billing-offering-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));grid-gap:16px;gap:16px}
.billing-offering-card{border:1px solid #dfe1e6;border-radius:12px;padding:18px;background:#fff;display:flex;flex-direction:column;gap:10px;min-height:270px}
.billing-offering-card.selected{box-shadow:0 0 0 2px rgba(14,99,156,.12);border-color:#0e639c}
.billing-offering-kicker{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#6b778c}
.billing-offering-card h3{margin:0;color:#172b4d;font-size:16px}
.billing-offering-price{font-size:25px;font-weight:800;color:#172b4d;line-height:1.1}
.billing-offering-price small{font-size:11px;font-weight:600;color:#6b778c}
.billing-offering-card p{margin:0 0 3px;color:#5e6c84;font-size:12px;line-height:1.5;min-height:54px}
.billing-offering-feature{display:flex;gap:7px;align-items:flex-start;color:#42526e;font-size:11px;line-height:1.4}
.billing-offering-feature svg{flex:0 0 auto;color:#1f845a;margin-top:1px}
.billing-offering-card button{margin-top:auto;justify-content:center}
.billing-empty{padding:18px;border:1px dashed #c1c7d0;border-radius:10px;color:#6b778c;font-size:12px;text-align:center}
.billing-ledger{display:grid;border:1px solid #dfe1e6;border-radius:10px;overflow:hidden}
.billing-ledger-row{display:grid;grid-template-columns:120px minmax(260px,1fr) 80px 80px;grid-gap:14px;gap:14px;padding:10px 12px;border-top:1px solid #eef0f3;align-items:center;font-size:11px;color:#42526e}
.billing-ledger-row:first-child{border-top:0}
.billing-ledger-head{font-weight:800;color:#5e6c84;background:#fafbfc;text-transform:uppercase;font-size:10px;letter-spacing:.04em}
.billing-ledger-row strong{font-weight:800;color:#ae2a19}
.billing-ledger-row strong.positive{color:#1f845a}
.billing-rule-panel{margin-bottom:30px}
@media(max-width:800px){.billing-ledger-row{grid-template-columns:90px 1fr 60px 60px}.billing-offering-grid{grid-template-columns:1fr}}

/* Billing layout refinement */
.billing-status-strip{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));border:1px solid #dfe3eb;border-radius:14px;background:#fff;overflow:hidden;margin:0 0 18px;box-shadow:0 1px 2px rgba(9,30,66,.04)}
.billing-status-item{display:flex;align-items:center;gap:12px;padding:15px 18px;border-left:1px solid #edf0f5}
.billing-status-item:first-child{border-left:0}
.billing-status-icon{width:36px;height:36px;border-radius:10px;background:#edf4ff;color:#0c66e4;display:grid;place-items:center;flex:0 0 auto}
.billing-status-item span{display:block;font-size:10px;line-height:1.2;text-transform:uppercase;letter-spacing:.05em;color:#6b778c;font-weight:800;margin-bottom:3px}
.billing-status-item strong{display:block;font-size:16px;color:#172b4d;line-height:1.2}
.billing-choice-panel{margin-bottom:18px}
.billing-plan-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-gap:18px;gap:18px}
.billing-plan-card{border:1px solid #dfe3eb;border-radius:14px;padding:22px;background:#fff;display:flex;flex-direction:column;min-height:365px}
.billing-plan-card.assessment{border-top:3px solid #579dff}
.billing-plan-card.subscription{border-top:3px solid #0c66e4}
.billing-plan-top{display:flex;justify-content:space-between;gap:22px;align-items:flex-start;padding-bottom:16px;border-bottom:1px solid #edf0f5}
.billing-plan-card h3{font-size:20px;margin:3px 0 6px;color:#172b4d}
.billing-plan-card p{font-size:12px;color:#5e6c84;line-height:1.5;margin:0;max-width:470px}
.billing-plan-price{text-align:right;white-space:nowrap}
.billing-plan-price strong{display:block;color:#172b4d;font-size:25px;line-height:1.05}
.billing-plan-price span{display:block;color:#6b778c;font-size:10px;margin-top:4px;text-transform:uppercase;font-weight:700;letter-spacing:.04em}
.billing-plan-features{display:grid;grid-gap:9px;gap:9px;padding:17px 0;color:#42526e;font-size:12px}
.billing-plan-features>div{display:flex;align-items:flex-start;gap:8px}
.billing-plan-features svg{color:#1f845a;flex:0 0 auto;margin-top:1px}
.billing-source-picker{display:grid;grid-gap:7px;gap:7px;margin-top:auto;margin-bottom:12px}
.billing-source-picker>span{font-size:11px;font-weight:800;color:#172b4d}
.billing-source-picker select{width:100%;height:42px;border:1px solid #b7c1d1;border-radius:8px;background:#fff;padding:0 11px;color:#172b4d;font:inherit;font-size:12px}
.billing-source-picker select:focus{outline:none;border-color:#0c66e4;box-shadow:0 0 0 2px rgba(12,102,228,.12)}
.billing-plan-action{width:100%;justify-content:center;gap:8px;min-height:42px;margin-top:auto}
.billing-plan-card.subscription .billing-plan-action{margin-top:0}
.billing-empty.compact{padding:12px;min-height:0}
.billing-secondary-grid{display:grid;grid-template-columns:minmax(320px,.72fr) minmax(0,1.28fr);grid-gap:18px;gap:18px;align-items:start}
.billing-compact-panel{margin-bottom:18px}
.billing-partner-row{display:grid;grid-template-columns:auto 1fr auto;grid-gap:14px;gap:14px;align-items:center;padding:18px!important}
.billing-partner-row h3{margin:0 0 3px;color:#172b4d;font-size:15px}
.billing-partner-row p{margin:0;color:#5e6c84;font-size:11px;line-height:1.45}
.billing-partner-icon{width:38px;height:38px;border-radius:10px;background:#f1f2f4;color:#44546f;display:grid;place-items:center}
.billing-ledger.subscriptions .billing-ledger-row{grid-template-columns:minmax(180px,1fr) minmax(280px,1.5fr) 90px 100px}
@media(max-width:1000px){.billing-plan-grid,.billing-secondary-grid{grid-template-columns:1fr}.billing-plan-card{min-height:0}.billing-status-strip{grid-template-columns:1fr}.billing-status-item{border-left:0;border-top:1px solid #edf0f5}.billing-status-item:first-child{border-top:0}.billing-plan-top{flex-direction:column}.billing-plan-price{text-align:left}.billing-partner-row{grid-template-columns:auto 1fr}.billing-partner-row .pa-secondary{grid-column:1/-1;justify-self:start}}

.metricus-access-choice-v2{display:grid;grid-template-columns:1fr 1fr;grid-gap:12px;gap:12px;margin:14px 0}.metricus-access-choice-v2 label{display:flex;align-items:flex-start;gap:10px;border:1px solid #d8e0ec;border-radius:10px;padding:14px 16px;background:#fff;cursor:pointer}.metricus-access-choice-v2 label.selected{border-color:#0c66e4;background:#f3f8ff;box-shadow:0 0 0 1px #0c66e4 inset}.metricus-access-choice-v2 label.disabled{opacity:.55;cursor:not-allowed}.metricus-access-choice-v2 input{margin-top:3px}.metricus-access-choice-v2 span{display:flex;flex-direction:column;gap:3px}.metricus-access-choice-v2 b{font-size:14px;color:#0b1f44}.metricus-access-choice-v2 small{font-size:12px;line-height:1.4;color:#526581}@media(max-width:900px){.metricus-access-choice-v2{grid-template-columns:1fr}}

/* Free-analysis notice must not inherit the legacy full-screen host child height.
   The embedded host is a column: the notice sizes to content and the Process Advisor
   runtime owns the remaining height. */
.web-process-advisor-host.web-process-advisor-embedded > .free-analysis-notice{
  width:100%;
  height:auto!important;
  min-height:30px;
  flex:0 0 auto;
}
.web-process-advisor-host.web-process-advisor-embedded > .web-process-advisor-runtime{
  width:100%;
  height:auto!important;
  min-height:0;
  flex:1 1 0%;
}

.pa-modal-overlay{position:fixed;inset:0;z-index:100;display:grid;place-items:center;padding:24px;background:rgba(9,30,66,.38);backdrop-filter:blur(2px)}
.pa-modal-card{width:min(460px,calc(100vw - 40px));background:#fff;border:1px solid var(--pa-border);border-radius:14px;box-shadow:0 18px 48px rgba(9,30,66,.22);overflow:hidden}
.pa-modal-head{padding:18px 20px 14px;border-bottom:1px solid var(--pa-border-subtle)}
.pa-modal-head span{display:block;font-size:10px;font-weight:800;letter-spacing:.06em;color:var(--pa-blue);margin-bottom:5px}
.pa-modal-head h2{margin:0;font-size:19px}
.pa-modal-body{padding:18px 20px}.pa-modal-body p{margin:0 0 14px;font-size:13px;line-height:1.5}.pa-modal-body small{display:block;margin-top:14px;color:var(--pa-text-muted);font-size:11px;line-height:1.45}
.pa-modal-facts{display:grid;grid-gap:8px;gap:8px;padding:12px 14px;background:var(--pa-surface-muted);border:1px solid var(--pa-border-subtle);border-radius:9px}.pa-modal-facts span{font-size:12px}.pa-modal-facts span:before{content:'✓';color:var(--pa-success);font-weight:800;margin-right:8px}
.pa-modal-actions{display:flex;justify-content:flex-end;gap:8px;padding:14px 20px;background:#FAFBFC;border-top:1px solid var(--pa-border-subtle)}

/* Connections — distinct source systems and scalable source selection */
.connections-add-area{position:relative;flex-shrink:0}
.connections-add-trigger{display:inline-flex;align-items:center;justify-content:center;gap:9px;min-height:38px;padding:0 15px;font-size:12px;font-weight:700}
.connections-source-picker{position:absolute;z-index:20;right:0;top:calc(100% + 8px);width:286px;background:#fff;border:1px solid #dfe3e8;border-radius:10px;box-shadow:0 12px 32px rgba(9,30,66,.16);padding:8px}
.connections-picker-heading{font-size:11px;font-weight:700;color:#44546f;padding:8px 10px 10px}
.connections-source-picker>button{display:flex;align-items:center;text-align:left;width:100%;gap:12px;border:0;border-radius:7px;background:transparent;padding:9px 10px;cursor:pointer;color:#172b4d}
.connections-source-picker>button:hover{background:#f1f5fc}
.connections-source-picker>button>span:last-child{display:grid;grid-gap:3px;gap:3px}
.connections-source-picker b{font-size:12px}
.connections-source-picker small{font-size:10px;color:#6b778c}
.connections-picker-note{border-top:1px solid #eef0f3;margin-top:6px;padding:10px;font-size:10px;line-height:1.5;color:#6b778c}
.connection-table-wrap{width:100%;overflow-x:auto}
.connection-table-head,.connection-detail-row{display:grid;grid-template-columns:minmax(175px,1.4fr) minmax(120px,.9fr) minmax(135px,1fr) minmax(190px,1.5fr) minmax(94px,.7fr) 116px;grid-gap:14px;gap:14px;align-items:center;min-width:900px;padding-left:20px;padding-right:20px}
.connection-table-head{padding-top:11px;padding-bottom:11px;background:#f7f9fc;border-bottom:1px solid #e6ebf2;color:#626f86;text-transform:uppercase;font-size:10px;font-weight:750;letter-spacing:.045em}
.connection-detail-row{padding-top:14px;padding-bottom:14px}
.connection-name-cell{display:flex;align-items:center;gap:11px;min-width:0}
.connection-name-cell b{font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#172b4d}
.connection-name-cell .connection-mark{flex-shrink:0}
.connection-mark.jira-rest{background:#e9f2ff;color:#0c66e4}
.connection-mark.servicenow-rest{background:#e7f7ed;color:#167546}
.connection-source-tag{display:inline-flex;align-items:center;border-radius:5px;padding:5px 9px;font-size:11px;font-weight:750;color:#0c66e4;background:#e9f2ff}
.connection-source-tag.servicenow-rest{color:#167546;background:#e7f7ed}
.connection-auth-cell{display:flex;flex-direction:column;gap:3px;font-size:11.5px;font-weight:650;color:#172b4d}
.connection-auth-cell small{font-size:10px;font-weight:400;color:#6b778c}
.connection-url-cell{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;color:#44546f}
.connection-detail-row>.status-pill{display:inline-flex}
.connection-detail-row>div:has(>.status-pill){display:flex;align-items:center}
.connection-detail-row .connection-row-actions{justify-content:flex-end}
@media(max-width:900px){.connection-detail-row{grid-template-columns:minmax(175px,1.4fr) minmax(120px,.9fr) minmax(135px,1fr) minmax(190px,1.5fr) minmax(94px,.7fr) 116px}.connection-detail-row>div:has(>.status-pill){display:flex}}

/* CSV import appears alongside reusable REST sources in the data-source picker. */
.connection-mark.csv-file{background:#fff3e6;color:#a15c08}

/* Home page refinement — content-driven layout, no viewport-filling empty rows.
   Scoped to the web Home route; does not affect Process Advisor workspaces. */
.saas-main.saas-main-home {
  height: auto;
  min-height: 0;
  max-width: 1480px;
  padding: 20px 26px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: visible;
}
.saas-main-home .home-hero {
  height: auto;
  min-height: 0;
  margin: 0;
  padding: 27px 32px;
  grid-template-columns: minmax(0, 1.9fr) minmax(190px, .55fr);
  gap: 28px;
  align-items: center;
}
.saas-main-home .home-hero h1 {
  font-size: clamp(27px, 2.1vw, 34px);
  line-height: 1.14;
  max-width: 850px;
  margin: 6px 0 10px;
}
.saas-main-home .home-hero p {
  max-width: 760px;
  font-size: 14px;
  line-height: 1.52;
}
.saas-main-home .home-hero-actions { margin-top: 17px; }
.saas-main-home .home-hero-visual { gap: 3px; }
.saas-main-home .home-flow-card {
  min-height: 43px;
  width: min(100%, 198px);
  font-size: 12px;
  box-shadow: 0 2px 7px rgba(9,30,66,.04);
}
.saas-main-home .home-flow-line { height: 11px; }
.saas-main-home .home-section {
  height: auto;
  min-height: 0;
  margin: 0;
  display: block;
}
.saas-main-home .home-section-head { margin-bottom: 9px; }
.saas-main-home .home-section-head h2 { font-size: 19px; }
.saas-main-home .home-steps,
.saas-main-home .home-capability-grid { height: auto; }
.saas-main-home .home-step {
  height: auto;
  min-height: 102px;
  padding: 16px 14px;
}
.saas-main-home .home-step h3 { font-size: 14px; margin-bottom: 5px; }
.saas-main-home .home-step p { font-size: 12px; line-height: 1.45; }
.saas-main-home .home-capability {
  height: auto;
  min-height: 112px;
  padding: 18px 15px;
  align-content: center;
  box-shadow: 0 1px 3px rgba(9,30,66,.03);
}
.saas-main-home .home-capability h3 { font-size: 15px; margin-bottom: 5px; }
.saas-main-home .home-capability p { font-size: 12px; line-height: 1.45; }
@media (max-width: 1050px) {
  .saas-main-home .home-hero { grid-template-columns: 1fr; }
  .saas-main-home .home-hero-visual { display: none; }
}
@media (max-width: 900px) {
  .saas-main.saas-main-home { padding: 18px; gap: 18px; }
  .saas-main-home .home-steps,
  .saas-main-home .home-capability-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }
}
@media (max-width: 620px) {
  .saas-main-home .home-hero { padding: 22px; }
  .saas-main-home .home-hero h1 { font-size: 26px; }
  .saas-main-home .home-steps,
  .saas-main-home .home-capability-grid { grid-template-columns: 1fr; }
}


/* Home & account typography final polish — keep consistent with 14px navigation */
.account-menu .account-label b { font-size: 13px; line-height: 1.35; font-weight: 700; }
.account-menu .account-label small { font-size: 12px; line-height: 1.4; color: #5e6c84; }
.account-popover { width: 276px; padding: 10px; }
.account-popover .account-meta { padding: 12px 12px 13px; gap: 5px; }
.account-popover .account-meta b { font-size: 14px; line-height: 1.4; }
.account-popover .account-meta span { font-size: 12px; line-height: 1.5; overflow-wrap: anywhere; }
.account-popover button { min-height: 42px; height: auto; padding: 10px 12px; font-size: 14px; line-height: 1.35; font-weight: 500; }
.account-popover button:focus-visible, .account-menu summary:focus-visible { outline: 2px solid #0c66e4; outline-offset: 2px; }
.saas-main-home .home-hero h1 { font-size: clamp(27px, 2vw, 33px); line-height: 1.16; max-width: 760px; }

/* Shared popover typography and dismiss affordances */
.account-menu .account-popover,
.connections-source-picker { font-size:14px; color:#172b4d; }
.account-popover { width:276px; max-width:calc(100vw - 24px); }
.account-popover .account-meta b {font-size:14px; line-height:1.45}
.account-popover .account-meta span {font-size:12px; line-height:1.5}
.account-popover button,
.connections-source-picker > button { font-size:14px; line-height:1.4; min-height:42px; }
.connections-source-picker { width:300px; max-width:calc(100vw - 24px); padding:10px; }
.connections-picker-heading { font-size:13px; font-weight:700; padding:8px 10px 10px; }
.connections-source-picker b { font-size:14px; }
.connections-source-picker small { font-size:12px; line-height:1.45; }
.connections-picker-note { font-size:12px; line-height:1.45; }
.connections-source-picker > button:focus-visible { outline:2px solid #0c66e4; outline-offset:-2px; }

/* Process Advisor Web — unified UI scale (v1)
   Shell and web-owned controls only. Avoids global overrides of process-miner,
   AG Grid, Atlaskit, MUI, and third-party dialogs. */
.saas-root {
  --web-ui-text: 14px;
  --web-ui-meta: 12px;
  --web-ui-small: 13px;
  --web-ui-heading: 20px;
  --web-ui-control-height: 38px;
  --web-ui-focus: #0c66e4;
  font-size: 14px;
  font-size: var(--web-ui-text);
  line-height: 1.5;
}
.saas-root :is(.saas-nav-item, .saas-nav-bottom button) {
  font-size: var(--web-ui-text);
  line-height: 1.4;
  min-height: 40px;
  border-radius: 8px;
}
.saas-root .saas-brand-title { font-size: 16px; line-height: 1.3; }
.saas-root :is(.saas-brand-sub, .saas-org, .saas-nav-context span) {
  font-size: var(--web-ui-meta);
  line-height: 1.45;
}
.saas-root :is(.saas-nav-label, .eyebrow) {
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: .065em;
}
.saas-root .saas-topbar { font-size: var(--web-ui-small); }
.saas-root .saas-breadcrumb { font-size: var(--web-ui-small); }
.saas-root .saas-main:not(.saas-main-advisor) { padding-top: 22px; }
.saas-root :is(.page-head h1) { font-size: 25px; line-height: 1.25; }
.saas-root :is(.page-head p, .panel-head p, .empty-state p) {
  font-size: var(--web-ui-small);
  line-height: 1.55;
}
.saas-root .panel-head h2 { font-size: 17px; line-height: 1.3; }
.saas-root :is(.pa-primary, .pa-secondary, .connections-add-trigger) {
  min-height: var(--web-ui-control-height);
  font-size: var(--web-ui-text);
  line-height: 1.35;
  padding: 8px 14px;
  gap: 8px;
}
.saas-root :is(.pa-primary, .pa-secondary):focus-visible,
.saas-root :is(.saas-nav-item, .model-action-menu button):focus-visible,
.saas-root :is(.account-menu summary, .account-popover button, .connections-source-picker button):focus-visible {
  outline: 2px solid var(--web-ui-focus);
  outline-offset: 2px;
}
.saas-root :is(.form-grid label > span, .edit-model-body label > span,
 .metricus-field-label) { font-size: var(--web-ui-small); line-height: 1.4; }
.saas-root :is(.form-grid input, .form-grid select, .mapping-row select,
 .edit-model-body input, .edit-model-body textarea, .metricus-input) {
  font-size: var(--web-ui-text);
  min-height: var(--web-ui-control-height);
  line-height: 1.4;
}
.saas-root :is(.metric-card span, .metric-card small,
 .assessment-name span, .assessment-row span, .file-summary,
 .model-description) { font-size: var(--web-ui-meta); line-height: 1.45; }
.saas-root :is(.assessment-row b, .assessment-name b, .model-name-cell) {
  font-size: var(--web-ui-text);
}
.saas-root :is(.assessment-table, .assessment-table-head,
 .assessment-table-row, .connection-table-head, .connection-name-cell b,
 .connection-url-cell, .connection-auth-cell, .connection-auth-cell small) {
  font-size: var(--web-ui-small);
  line-height: 1.45;
}
.saas-root .connection-table-head { letter-spacing: .015em; }
.saas-root :is(.connections-picker-heading, .connections-source-picker b,
 .account-popover .account-meta b) { font-size: var(--web-ui-text); }
.saas-root :is(.connections-source-picker small, .connections-picker-note,
 .account-popover .account-meta span) { font-size: var(--web-ui-meta); }
.saas-root :is(.connections-source-picker > button, .account-popover button) {
  min-height: 42px;
  font-size: var(--web-ui-text);
  line-height: 1.45;
}
.saas-root .account-popover { width: 290px; max-width: calc(100vw - 24px); }
.saas-root .account-popover .account-meta { padding: 13px 12px; }
.saas-root :is(.home-step p, .home-capability p) {
  font-size: var(--web-ui-small);
  line-height: 1.5;
}
.saas-root :is(.home-step h3, .home-capability h3) { font-size: 15px; line-height: 1.35; }
.saas-root .home-flow-card { font-size: var(--web-ui-small); }
.saas-root .home-section-head h2 { font-size: var(--web-ui-heading); }
.saas-root .pa-modal-head h2 { font-size: var(--web-ui-heading); }
.saas-root :is(.pa-modal-body, .pa-modal-actions, .pa-modal-facts span) {
  font-size: var(--web-ui-text);
  line-height: 1.5;
}
.saas-root .status-pill { font-size: 12px !important; line-height: 1.3; }
.saas-root .wizard-step { font-size: var(--web-ui-small); }
.saas-root .wizard-step span { font-size: var(--web-ui-meta); }
.saas-root .source-card p { font-size: var(--web-ui-small); }
.saas-root :is(.source-action, .source-badge, .file-summary span) {
  font-size: var(--web-ui-meta);
}
@media (max-width: 700px) {
  .saas-root .saas-main:not(.saas-main-advisor) { padding: 16px; }
  .saas-root .page-head h1 { font-size: 22px; }
  .saas-root :is(.pa-primary, .pa-secondary) { min-height: 40px; }
}

/* Process Advisor Web — compact subscription comparison */
.billing-overview-row{display:flex;align-items:center;gap:24px;flex-wrap:wrap;padding:13px 18px;background:#fff;border:1px solid #dfe3eb;border-radius:12px;margin-bottom:18px}
.billing-overview-row>div{display:flex;align-items:center;gap:9px;font-size:13px;min-width:0}
.billing-overview-row svg{color:#0c66e4;flex-shrink:0}
.billing-overview-row span{color:#5e6c84}
.billing-overview-row strong{color:#172b4d;font-size:14px}
.billing-choice-redesign .billing-choice-head{display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;padding:20px 24px}
.billing-choice-redesign .billing-choice-head h2{font-size:21px;margin:0 0 5px}
.billing-choice-redesign .billing-choice-head p{font-size:14px;line-height:1.5;margin:0}
.billing-interval-toggle{display:inline-flex;align-items:center;gap:3px;padding:4px;border:1px solid #dfe3eb;background:#f4f5f7;border-radius:10px;flex-shrink:0}
.billing-interval-toggle button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;border-radius:7px;background:transparent;color:#42526e;padding:9px 13px;font-size:13px;font-weight:700;cursor:pointer}
.billing-interval-toggle button.selected{background:#fff;color:#0c66e4;box-shadow:0 1px 4px rgba(9,30,66,.12)}
.billing-interval-toggle button:focus-visible{outline:2px solid #0c66e4;outline-offset:2px}
.billing-interval-toggle button span{color:#087f5b;font-size:11px;margin-left:4px}
.billing-choice-redesign .billing-plan-grid-two{grid-template-columns:repeat(2,minmax(0,1fr));gap:16px;padding:20px 24px 14px}
.billing-choice-redesign .billing-plan-simple{min-height:0;padding:23px;gap:0;border-top:3px solid #0c66e4}
.billing-plan-simple .billing-plan-identity{display:flex;gap:12px;align-items:flex-start;justify-content:space-between}
.billing-plan-simple .billing-plan-identity h3{font-size:20px;margin:0 0 5px}
.billing-plan-simple .billing-plan-identity p{font-size:13px;line-height:1.5;min-height:40px}
.billing-seat-pill{display:inline-flex;gap:5px;align-items:center;white-space:nowrap;background:#e9f2ff;color:#0c66e4;padding:6px 9px;border-radius:20px;font-size:12px;font-weight:700}
.billing-plan-simple .billing-plan-price{text-align:left;display:flex;align-items:baseline;gap:5px;margin:19px 0 6px}
.billing-plan-simple .billing-plan-price strong{font-size:32px;line-height:1.1}
.billing-plan-simple .billing-plan-price span{font-size:13px;text-transform:none;letter-spacing:0}
.billing-plan-simple .billing-billed-note{font-size:12px;color:#5e6c84;margin:2px 0 0}
.billing-plan-simple .billing-plan-features{font-size:13px;gap:11px;padding:18px 0 22px;margin-top:8px;border-top:1px solid #edf0f5}
.billing-plan-simple .billing-plan-action{margin-top:auto;min-height:42px}
.billing-choice-redesign .billing-footnote{padding:0 24px 18px;font-size:12px;color:#6b778c}
@media(max-width:900px){.billing-choice-redesign .billing-plan-grid-two{grid-template-columns:1fr}.billing-choice-redesign .billing-choice-head{align-items:flex-start}.billing-plan-simple .billing-plan-identity p{min-height:0}}

/* Subscription plan refinement: compact comparison with a clear featured workspace plan. */
.billing-choice-redesign .billing-choice-head { padding:16px 22px; }
.billing-choice-redesign .billing-choice-head h2 { font-size:19px; }
.billing-choice-redesign .billing-choice-head p { font-size:13px; }
.billing-included-line { display:flex;flex-wrap:wrap;align-items:center;gap:10px 22px;padding:13px 22px 2px;color:#344563;font-size:13px; }
.billing-included-label {font-size:11px;font-weight:800;letter-spacing:.045em;text-transform:uppercase;color:#6b778c;}
.billing-included-line>span:not(.billing-included-label){display:inline-flex;align-items:center;gap:6px;}
.billing-included-line svg {color:#16805d;flex-shrink:0;}
.billing-choice-redesign .billing-plan-grid-two {padding:14px 22px 12px;gap:14px;align-items:stretch;}
.billing-choice-redesign .billing-plan-simple {min-height:0!important;padding:20px 22px 18px;border:1px solid #dfe4ef;border-top:3px solid #9eb5d7;gap:0;box-shadow:none;}
.billing-choice-redesign .billing-workspace-featured {background:linear-gradient(145deg,#f5f9ff 0%,#ffffff 70%);border-color:#b9cff9;border-top:3px solid #0c66e4;}
.billing-plan-simple .billing-plan-identity {align-items:center;margin:0 0 7px;}
.billing-plan-eyebrow {font-size:10px;letter-spacing:.09em;font-weight:800;color:#5e6c84;}
.billing-workspace-featured .billing-plan-eyebrow{color:#0c66e4;}
.billing-plan-simple h3 {font-size:22px;margin:0 0 4px;}
.billing-choice-redesign .billing-plan-simple p.billing-plan-intro {font-size:13px;line-height:1.45;min-height:0;margin:0;max-width:none;}
.billing-plan-simple .billing-plan-price {margin:16px 0 0;}
.billing-plan-simple .billing-plan-price strong{font-size:34px;letter-spacing:-.035em;}
.billing-choice-redesign .billing-plan-simple p.billing-price-context{font-size:12px;color:#6b778c;margin:5px 0 13px;}
.billing-plan-difference{display:grid;grid-gap:9px;gap:9px;border-top:1px solid #e8edf5;padding:13px 0 17px;color:#344563;font-size:13px;}
.billing-plan-difference>div{display:flex;align-items:center;gap:8px;}
.billing-plan-difference svg{color:#14835c;flex-shrink:0;}
.billing-choice-redesign .billing-plan-simple .billing-plan-action{margin-top:auto;min-height:40px;width:100%;justify-content:center;}
.billing-choice-redesign .billing-workspace-featured .billing-plan-action:not(:disabled){background:#0c66e4;}
.billing-choice-redesign .billing-plan-simple .billing-plan-action:disabled{opacity:.55;cursor:not-allowed;}
.billing-choice-redesign .billing-plan-simple p.billing-checkout-note{font-size:11px;text-align:center;margin:8px 0 0;color:#6b778c;}
.billing-plan-unavailable{margin-top:auto;padding:10px 12px;border-radius:8px;background:#f1f4f9;color:#53627c;text-align:center;font-size:12px;}
.billing-choice-redesign .billing-footnote{padding:0 22px 14px;font-size:11px;}
@media (max-width:900px){.billing-included-line{gap:8px 14px;}.billing-choice-redesign .billing-plan-grid-two{grid-template-columns:1fr;}}

/* Workspace Management v2 — intentionally scoped to this screen. */
.wm-v2{max-width:1160px;margin:0 auto;color:#172b4d;font-size:14px}
.wm-v2 .page-head{margin-bottom:22px}
.wm-v2 .page-head p{font-size:14px}
.wm-layout{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.12fr);grid-gap:18px;gap:18px;align-items:start}
.wm-card{min-width:0;background:#fff;border:1px solid #dfe4ec;border-radius:12px;box-shadow:0 1px 3px rgba(9,30,66,.06);overflow:hidden}
.wm-card-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:19px 22px;border-bottom:1px solid #edf0f4}
.wm-card-head h2{margin:0 0 5px;font-size:18px;line-height:1.3;color:#10254a}
.wm-card-head p{margin:0;font-size:13px;line-height:1.5;color:#64748b}
.wm-card-content{padding:20px 22px}
.wm-tag{flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid #dce5f0;border-radius:999px;background:#f4f7fb;color:#42526e;font-size:12px;font-weight:750;padding:6px 11px;text-transform:capitalize}
.wm-seat-tag{background:#e9f3ff;border-color:#d6e8ff;color:#0756bd}
.wm-field{display:flex;flex-direction:column;gap:7px;min-width:0}
.wm-field label{font-size:13px;font-weight:700;color:#344563}
.wm-field input,.wm-field select,.wm-v2 select{width:100%;min-width:0;height:40px;border-radius:8px;border:1px solid #c6cfdb;background:white;color:#172b4d;padding:0 12px;font-size:14px}
.wm-field input:focus-visible,.wm-v2 select:focus-visible{outline:2px solid #a1c4fb;outline-offset:1px;border-color:#0c66e4}
.wm-user-meta{font-size:12px;color:#6b778c;margin:10px 0 20px;overflow-wrap:anywhere}
.wm-user-meta strong{color:#344563;font-weight:650}
.wm-form{display:grid;grid-gap:17px;gap:17px}
.wm-form-actions{display:flex;justify-content:flex-start;padding-top:1px}
.wm-v2 .pa-primary,.wm-v2 .pa-secondary{min-height:39px;padding:9px 14px;font-size:13px;border-radius:8px}
.wm-seat-line{display:flex;align-items:center;gap:12px;margin-bottom:12px;color:#64748b;font-size:12px;white-space:nowrap}
.wm-seat-track{flex:1;height:7px;overflow:hidden;background:#edf1f6;border-radius:999px}
.wm-seat-track span{display:block;height:100%;background:#0c66e4;border-radius:999px}
.wm-members{border:1px solid #e9edf2;border-radius:9px;overflow:hidden}
.wm-member{display:flex;align-items:center;gap:11px;padding:12px 13px;min-width:0}
.wm-member+.wm-member{border-top:1px solid #edf0f4}
.wm-member-avatar{display:grid;place-items:center;flex-shrink:0;width:35px;height:35px;border-radius:50%;background:#e9f2ff;color:#0c66e4;font-weight:800}
.wm-member-details{display:grid;grid-gap:3px;gap:3px;flex:1;min-width:0}
.wm-member-details strong{font-size:13px;overflow-wrap:anywhere}
.wm-member-details span{font-size:12px;color:#6b778c;overflow-wrap:anywhere}
.wm-role{text-transform:capitalize;color:#53647c;background:#f3f5f8;border-radius:999px;padding:5px 9px;font-size:11px;font-weight:700}
.wm-invite,.wm-invite-locked,.wm-pending{margin-top:22px;padding-top:18px;border-top:1px solid #edf0f4}
.wm-invite h3,.wm-pending h3{margin:0 0 5px;font-size:15px}
.wm-invite p,.wm-invite-locked p{margin:0 0 15px;font-size:12px;line-height:1.5;color:#64748b}
.wm-invite-locked strong{font-size:14px}
.wm-invite-locked p{margin:6px 0 0}
.wm-inline-form,.wm-join-form{display:flex;align-items:end;gap:10px}
.wm-inline-form .wm-field,.wm-join-form .wm-field{flex:1}
.wm-join{margin-top:18px}
.wm-join .wm-card-head{border-bottom:0;padding-bottom:9px}
.wm-join-form{padding:8px 22px 21px;max-width:760px}
.wm-invite-code{margin-top:15px;padding:14px;border:1px solid #acd0ff;border-radius:9px;background:#f4f9ff}
.wm-invite-code p{margin:7px 0 10px;color:#53647c;font-size:12px}
.wm-code-row{display:flex;gap:10px;align-items:center;flex-wrap:wrap}.wm-code-row code{background:#fff;border:1px solid #d7e3f3;padding:9px;border-radius:6px;font-size:12px;overflow-wrap:anywhere}
.wm-pending-row{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 0;border-bottom:1px solid #edf0f4;font-size:13px}
.wm-notice{padding:12px 14px;border-radius:8px;margin-bottom:15px;font-size:13px}.wm-error{background:#fff1f0;color:#ae2a19;border:1px solid #ffbdad}.wm-success{background:#e3fcef;color:#216e4e;border:1px solid #abf5d1}
.wm-muted{font-size:13px;color:#6b778c}
@media(max-width:950px){.wm-layout{grid-template-columns:1fr}}
@media(max-width:620px){.wm-card-head{padding:16px}.wm-card-content{padding:16px}.wm-inline-form,.wm-join-form{flex-direction:column;align-items:stretch}.wm-join-form{padding:8px 16px 16px}.wm-member{flex-wrap:wrap}.wm-role{margin-left:auto}}

/* Workspace role administration */
.wm-role-control{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:650;color:#53647c;white-space:nowrap}
.wm-role-control select{border:1px solid #d5deea;border-radius:8px;background:white;color:#172b4d;padding:6px 9px;font-size:12px;max-width:115px}

/* Process Advisor Web Home — visual refresh (scoped; no billing/editor changes) */
.saas-main-home .home-hero-refresh{position:relative;isolation:isolate;overflow:hidden;background:linear-gradient(111deg,#102c61 0%,#1552a4 49%,#3c56bb 100%);border:1px solid #2c5bac;box-shadow:0 12px 30px rgba(20,65,137,.13);padding:30px 34px;grid-template-columns:minmax(0,1.5fr) minmax(270px,.7fr);gap:28px}
.saas-main-home .home-hero-refresh:before{content:"";position:absolute;z-index:-1;width:420px;height:420px;border-radius:50%;right:-130px;top:-230px;background:radial-gradient(circle,rgba(139,186,255,.40),rgba(139,186,255,0) 70%)}
.saas-main-home .home-hero-refresh:after{content:"";position:absolute;z-index:-1;width:320px;height:320px;border-radius:50%;left:34%;bottom:-280px;background:radial-gradient(circle,rgba(65,211,213,.24),transparent 70%)}
.saas-main-home .home-hero-refresh h1{color:#fff;font-size:clamp(28px,2.35vw,38px);line-height:1.13;max-width:750px;margin:12px 0 14px;letter-spacing:-.035em}
.saas-main-home .home-headline-accent{color:#b6e6ff}
.saas-main-home .home-hero-refresh p{color:#e0edff;font-size:14px;line-height:1.55;max-width:650px}
.saas-main-home .home-eyebrow{display:inline-flex;gap:7px;align-items:center;color:#cde7ff;letter-spacing:.105em}
.saas-main-home .home-hero-refresh .home-hero-actions{margin-top:22px;gap:10px}
.saas-main-home .home-hero-refresh .pa-primary{background:#fff;color:#124a9f;border-color:#fff;box-shadow:0 6px 15px rgba(0,0,0,.14);font-weight:750}
.saas-main-home .home-hero-refresh .pa-primary:hover{background:#e9f5ff;color:#0f3a83}
.saas-main-home .home-hero-refresh .pa-secondary{background:rgba(255,255,255,.11);border:1px solid rgba(255,255,255,.45);color:#fff}
.saas-main-home .home-hero-refresh .pa-secondary:hover{background:rgba(255,255,255,.2)}
.saas-main-home .home-visual-refresh{background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.21);border-radius:17px;padding:16px 18px;gap:0;box-shadow:0 14px 28px rgba(3,26,70,.12);backdrop-filter:blur(5px)}
.saas-main-home .home-visual-caption{justify-self:start;margin:0 0 12px;color:#dfedff;font-size:10px;font-weight:800;letter-spacing:.10em;display:flex;align-items:center;gap:8px}
.saas-main-home .home-visual-dot{width:7px;height:7px;border-radius:50%;background:#6cf0c5;box-shadow:0 0 0 4px rgba(108,240,197,.15)}
.saas-main-home .home-visual-refresh .home-flow-card{width:100%;max-width:none;min-height:58px;padding:9px 11px;border-radius:11px;background:rgba(255,255,255,.97);border:1px solid rgba(255,255,255,.8);box-shadow:0 5px 13px rgba(9,30,66,.09);font-size:13px;color:#15345e;gap:10px}
.saas-main-home .home-flow-card>span:nth-child(2){display:grid;grid-gap:3px;gap:3px}
.saas-main-home .home-flow-card small{font-size:10px;color:#66758f;font-weight:500}
.saas-main-home .home-visual-refresh .home-flow-card.accent{background:#e7f4ff;border-color:#b2d9ff}
.saas-main-home .home-visual-refresh .home-flow-card.result{background:#e9fff7;border-color:#a9ead2}
.saas-main-home .home-flow-icon{width:34px;height:34px;border-radius:9px;display:grid;place-items:center;flex-shrink:0}
.saas-main-home .home-flow-icon.data{background:#e4f0ff;color:#1b66d9}.saas-main-home .home-flow-icon.model{background:#d9e9ff;color:#2053bf}.saas-main-home .home-flow-icon.advisor{background:#d1f8e9;color:#0b9069}
.saas-main-home .home-visual-refresh .home-flow-line{height:14px;width:2px;background:linear-gradient(#afd7ff,#c6e6ff)}
.saas-main-home .home-result-check{margin-left:auto;color:#0b9069!important}
.saas-main-home .home-section-head h2{font-size:19px;letter-spacing:-.018em}
.saas-main-home .home-steps{gap:9px}
.saas-main-home .home-step{position:relative;background:#fff;border:1px solid #dfe7f2;border-radius:12px;min-height:103px;box-shadow:0 3px 11px rgba(24,68,126,.035);padding:17px 14px;gap:11px}
.saas-main-home .home-step-number{background:#e6f1ff;color:#1760c6;border-radius:10px;font-weight:800}
.saas-main-home .home-step:nth-child(2) .home-step-number{background:#eceaff;color:#6d4cc9}
.saas-main-home .home-step:nth-child(3) .home-step-number{background:#e0f7f6;color:#0e888b}
.saas-main-home .home-step:nth-child(4) .home-step-number{background:#e3f8ec;color:#138356}
.saas-main-home .home-capability-grid{gap:12px}
.saas-main-home .home-capability{position:relative;overflow:hidden;min-height:126px;border:1px solid #dce6f2;border-radius:13px;box-shadow:0 4px 12px rgba(24,68,126,.035);padding:17px;-moz-column-gap:12px;column-gap:12px;grid-template-columns:40px minmax(0,1fr)}
.saas-main-home .home-capability:before{content:"";position:absolute;left:0;top:0;right:0;height:3px;background:#2375d7;background:var(--cap-accent,#2375d7)}
.saas-main-home .home-capability-icon{height:39px;width:39px;border-radius:11px;background:#e7f2ff;background:var(--cap-bg,#e7f2ff);color:#2375d7;color:var(--cap-accent,#2375d7)}
.saas-main-home .home-capability-evidence{--cap-accent:#2469e8;--cap-bg:#e6efff}
.saas-main-home .home-capability-explorer{--cap-accent:#7650c9;--cap-bg:#f0eaff}
.saas-main-home .home-capability-advisor{--cap-accent:#168f9e;--cap-bg:#e0f7f6}
.saas-main-home .home-capability-assessment{--cap-accent:#159562;--cap-bg:#e0f8ec}
.saas-main-home .home-capability h3{font-size:15px;margin:2px 0 5px}
.saas-main-home .home-capability p{font-size:12px;line-height:1.48}
@media(max-width:1100px){.saas-main-home .home-hero-refresh{grid-template-columns:1fr;}.saas-main-home .home-visual-refresh{display:none}}
@media(max-width:650px){.saas-main-home .home-hero-refresh{padding:23px 20px}.saas-main-home .home-hero-refresh h1{font-size:27px}.saas-main-home .home-hero-refresh .home-hero-actions{flex-wrap:wrap}}

/* Connection credential inputs: the global form min-height must not overflow
   the 36px password/secret icon wrapper. Applies to Jira and ServiceNow. */
.saas-root .connection-credential-grid.compact .connection-secret {
  height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.saas-root .connection-credential-grid.compact .connection-secret > svg {
  flex: 0 0 auto;
}
.saas-root .connection-credential-grid.compact .connection-secret > input {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  min-height: 0 !important;
  height: 100% !important;
  max-height: 100%;
  margin: 0;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 0;
  outline: 0;
  box-shadow: none !important;
  background: transparent;
  line-height: normal;
}
.saas-root .connection-credential-grid.compact .connection-secret:focus-within {
  border-color: #0c66e4;
  box-shadow: 0 0 0 2px rgba(12,102,228,.11);
}

/* Multi-currency billing selector */
.billing-choice-controls{display:flex;gap:12px;align-items:center;flex-wrap:wrap}
.billing-currency-label{display:flex;gap:8px;align-items:center;color:#42526e;font-weight:700;font-size:13px}
.billing-currency-label select{border:1px solid #dfe3eb;border-radius:8px;padding:9px 10px;background:#fff;color:#172b4d;font:inherit;cursor:pointer}
.billing-currency-label select:focus-visible{outline:2px solid #0c66e4;outline-offset:2px}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,EAAE,qBAAqB,CAAC,gBAAgB,QAAQ,CAAC,eAAe,CAAC,0BAA0B,CAAC,oBAAoB,CAAC,2BAA2B,CAAC,oBAAoB,YAAY,CAAC,OAAO,cAAc,CAAC,gBAAgB,kBAAkB,CAAC,WAAW,CAAC,EAAE,aAAa,CAAC,WAAW,gBAAgB,CAAC,YAAY,CAAC,yCAAyC,CAAC,cAAc,cAAc,CAAC,gBAAgB,CAAC,WAAW,CAAC,4BAA4B,CAAC,uCAAuC,CAAC,YAAY,CAAC,qBAAqB,CAAC,UAAU,CAAC,YAAY,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,cAAc,CAAC,+CAA+C,CAAC,WAAW,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,yBAAyB,CAAC,UAAU,CAAC,YAAY,CAAC,kBAAkB,CAAC,eAAe,CAAC,cAAc,CAAC,iBAAiB,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,cAAc,CAAC,kBAAkB,eAAe,CAAC,cAAc,CAAC,gBAAgB,cAAc,CAAC,0BAA0B,CAAC,cAAc,CAAC,UAAU,iBAAiB,CAAC,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,eAAe,QAAQ,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,YAAY,CAAC,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,2BAA2B,CAAC,eAAe,CAAC,cAAc,CAAC,qBAAqB,kCAAkC,CAAC,sBAAsB,8BAA8B,CAAC,oBAAoB,CAAC,eAAe,UAAU,CAAC,iBAAiB,CAAC,eAAe,CAAC,mBAAmB,eAAe,CAAC,YAAY,CAAC,4CAA4C,CAAC,UAAU,oBAAoB,CAAC,cAAc,CAAC,eAAe,CAAC,0BAA0B,CAAC,kCAAkC,CAAC,iCAAiC,CAAC,mBAAmB,CAAC,eAAe,CAAC,kBAAkB,CAAC,WAAW,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,iBAAiB,CAAC,aAAa,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,8BAA8B,CAAC,oBAAoB,CAAC,eAAe,CAAC,gBAAgB,YAAY,CAAC,WAAW,CAAC,kBAAkB,cAAc,CAAC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB,CAAC,qBAAqB,cAAc,CAAC,0BAA0B,CAAC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB,CAAC,gBAAgB,QAAQ,CAAC,sBAAsB,CAAC,aAAa,CAAC,oBAAoB,CAAC,cAAc,CAAC,eAAe,CAAC,cAAc,aAAa,CAAC,WAAW,CAAC,aAAa,WAAW,CAAC,eAAe,CAAC,KAAK,CAAC,SAAS,CAAC,gCAAgC,CAAC,yBAAyB,CAAC,wCAAwC,CAAC,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,cAAc,CAAC,cAAc,CAAC,6BAA6B,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,WAAW,cAAc,CAAC,iCAAiC,CAAC,mBAAmB,CAAC,eAAe,CAAC,0BAA0B,CAAC,kCAAkC,CAAC,UAAU,cAAc,CAAC,0BAA0B,CAAC,WAAW,gBAAgB,CAAC,aAAa,CAAC,sBAAsB,CAAC,WAAW,YAAY,CAAC,sBAAsB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,kBAAkB,CAAC,cAAc,cAAc,CAAC,qBAAqB,CAAC,cAAc,CAAC,2BAA2B,QAAQ,CAAC,0BAA0B,CAAC,cAAc,CAAC,eAAe,CAAC,0BAA0B,8BAA8B,CAAC,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,oBAAoB,CAAC,YAAY,+BAA+B,CAAC,yBAAyB,CAAC,UAAU,CAAC,kBAAkB,+BAA+B,CAAC,iBAAiB,UAAU,CAAC,YAAY,CAAC,cAAc,iCAAiC,CAAC,eAAe,CAAC,oBAAoB,CAAC,oBAAoB,kCAAkC,CAAC,qBAAqB,sBAAsB,CAAC,iBAAiB,gBAAgB,CAAC,OAAO,4BAA4B,CAAC,iCAAiC,CAAC,iCAAiC,CAAC,2BAA2B,CAAC,kBAAkB,CAAC,eAAe,CAAC,YAAY,iBAAiB,CAAC,+CAA+C,CAAC,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,eAAe,cAAc,CAAC,cAAc,CAAC,YAAY,YAAY,CAAC,aAAa,YAAY,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,kBAAkB,6CAA6C,CAAC,mBAAmB,6CAA6C,CAAC,qBAAqB,eAAe,CAAC,aAAa,4BAA4B,CAAC,iCAAiC,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,kBAAkB,cAAc,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,0BAA0B,CAAC,eAAe,CAAC,oBAAoB,cAAc,CAAC,eAAe,CAAC,gCAAgC,cAAc,CAAC,mBAAmB,cAAc,CAAC,0BAA0B,CAAC,iBAAiB,YAAY,CAAC,gBAAgB,QAAQ,CAAC,+CAA+C,CAAC,eAAe,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,eAAe,CAAC,oBAAoB,CAAC,2BAA2B,eAAe,CAAC,sBAAsB,kCAAkC,CAAC,gCAAgC,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,kBAAkB,cAAc,CAAC,qBAAqB,cAAc,CAAC,0BAA0B,CAAC,sBAAsB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,aAAa,mBAAmB,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,eAAe,CAAC,wBAAwB,CAAC,eAAe,CAAC,yBAAyB,CAAC,qBAAqB,iCAAiC,CAAC,iCAAiC,CAAC,qBAAqB,kCAAkC,CAAC,oCAAoC,CAAC,oBAAoB,gCAAgC,CAAC,gCAAgC,CAAC,aAAa,iBAAiB,CAAC,iBAAiB,CAAC,gBAAgB,YAAY,CAAC,cAAc,CAAC,eAAe,eAAe,CAAC,0BAA0B,CAAC,cAAc,CAAC,YAAY,WAAW,CAAC,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,8BAA8B,CAAC,oBAAoB,CAAC,cAAc,CAAC,kBAAkB,cAAc,CAAC,6CAA6C,YAAY,CAAC,kDAAkD,CAAC,kBAAkB,CAAC,aAAQ,CAAR,QAAQ,CAAC,iBAAiB,CAAC,uBAAuB,kCAAkC,CAAC,0BAA0B,CAAC,eAAe,CAAC,wCAAwC,CAAC,sBAAsB,+CAA+C,CAAC,iCAAiC,eAAe,CAAC,iBAAiB,QAAQ,CAAC,sBAAsB,CAAC,eAAe,CAAC,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,oBAAoB,CAAC,SAAS,CAAC,mBAAmB,cAAc,CAAC,sBAAsB,cAAc,CAAC,0BAA0B,CAAC,gBAAgB,UAAU,CAAC,WAAW,CAAC,QAAQ,CAAC,iBAAiB,CAAC,sBAAsB,CAAC,sBAAsB,kCAAkC,CAAC,uBAAuB,sBAAsB,CAAC,aAAa,YAAY,CAAC,6CAA6C,CAAC,aAAO,CAAP,QAAQ,CAAC,aAAa,iBAAiB,CAAC,iCAAiC,CAAC,eAAe,CAAC,iCAAiC,CAAC,YAAY,CAAC,eAAe,CAAC,gBAAgB,CAAC,2BAA2B,CAAC,oBAAoB,CAAC,0BAA0B,2BAA2B,CAAC,4BAA4B,CAAC,sBAAsB,cAAc,CAAC,WAAW,CAAC,gBAAgB,cAAc,CAAC,iBAAiB,CAAC,eAAe,cAAc,CAAC,0BAA0B,CAAC,eAAe,CAAC,QAAQ,CAAC,aAAa,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,YAAY,CAAC,kBAAkB,CAAC,8BAA8B,CAAC,oBAAoB,CAAC,eAAe,CAAC,cAAc,iBAAiB,CAAC,UAAU,CAAC,QAAQ,CAAC,mBAAmB,CAAC,eAAe,CAAC,iCAAiC,CAAC,uBAAuB,CAAC,aAAa,CAAC,eAAe,CAAC,sBAAsB,kCAAkC,CAAC,0BAA0B,CAAC,eAAe,iBAAiB,CAAC,SAAS,CAAC,WAAW,CAAC,cAAc,CAAC,oBAAoB,CAAC,eAAe,CAAC,qBAAqB,0BAA0B,CAAC,cAAc,YAAY,CAAC,KAAK,CAAC,kBAAkB,CAAC,aAAa,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,0BAA0B,CAAC,cAAc,CAAC,eAAe,CAAC,kBAAkB,CAAC,oCAAoC,UAAU,CAAC,iBAAiB,CAAC,UAAU,CAAC,UAAU,CAAC,SAAS,CAAC,QAAQ,CAAC,2BAA2B,CAAC,kBAAkB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,4BAA4B,CAAC,iCAAiC,CAAC,cAAc,CAAC,oBAAoB,oBAAoB,CAAC,yBAAyB,8BAA8B,CAAC,oBAAoB,CAAC,WAAW,YAAY,CAAC,6BAA6B,CAAC,aAAO,CAAP,QAAQ,CAAC,eAAe,6BAA6B,CAAC,iBAAiB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,sBAAsB,cAAc,CAAC,2BAA2B,CAAC,eAAe,CAAC,uDAAuD,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,oBAAoB,CAAC,cAAc,CAAC,yEAAyE,yBAAyB,CAAC,2BAA2B,CAAC,WAAW,eAAe,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,YAAY,CAAC,YAAY,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,OAAO,CAAC,gBAAgB,2BAA2B,CAAC,8BAA8B,CAAC,aAAa,cAAc,CAAC,gBAAgB,cAAc,CAAC,0BAA0B,CAAC,cAAc,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,kCAAkC,CAAC,YAAY,CAAC,6BAA6B,CAAC,cAAc,CAAC,mBAAmB,0BAA0B,CAAC,kBAAkB,cAAc,CAAC,eAAe,CAAC,iBAAiB,CAAC,2BAA2B,CAAC,cAAc,wCAAwC,CAAC,iBAAiB,CAAC,eAAe,CAAC,gBAAgB,CAAC,eAAe,CAAC,aAAa,YAAY,CAAC,+BAA+B,CAAC,kBAAkB,CAAC,aAAQ,CAAR,QAAQ,CAAC,eAAe,CAAC,+CAA+C,CAAC,cAAc,CAAC,wBAAwB,eAAe,CAAC,YAAY,YAAY,CAAC,OAAO,CAAC,kBAAkB,CAAC,eAAe,CAAC,kBAAkB,wBAAwB,CAAC,UAAU,gBAAgB,CAAC,iBAAiB,CAAC,cAAc,CAAC,eAAe,CAAC,cAAc,CAAC,eAAe,8BAA8B,CAAC,aAAa,CAAC,kBAAkB,iCAAiC,CAAC,uBAAuB,CAAC,gBAAgB,gCAAgC,CAAC,sBAAsB,CAAC,eAAe,eAAe,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,mBAAmB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,iBAAiB,cAAc,CAAC,oBAAoB,cAAc,CAAC,oBAAoB,cAAc,CAAC,eAAe,CAAC,kBAAkB,iCAAiC,CAAC,uBAAuB,CAAC,uBAAuB,iCAAiC,CAAC,uBAAuB,CAAC,WAAW,eAAe,CAAC,kCAAkC,CAAC,iBAAiB,CAAC,YAAY,CAAC,YAAY,CAAC,6BAA6B,CAAC,QAAQ,CAAC,kBAAkB,CAAC,aAAa,cAAc,CAAC,0BAA0B,CAAC,cAAc,CAAC,eAAe,YAAY,CAAC,mBAAmB,YAAY,CAAC,+BAA+B,CAAC,aAAQ,CAAR,QAAQ,CAAC,cAAc,CAAC,+CAA+C,CAAC,cAAc,CAAC,8BAA8B,eAAe,CAAC,oBAAoB,0BAA0B,CAAC,aAAa,oBAAoB,CAAC,aAAa,gBAAgB,CAAC,YAAY,CAAC,kBAAkB,CAAC,YAAY,CAAC,0DAA0D,CAAC,aAAa,WAAW,CAAC,eAAe,CAAC,iCAAiC,CAAC,kBAAkB,CAAC,uCAAuC,CAAC,YAAY,CAAC,cAAc,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,kBAAkB,CAAC,iBAAiB,cAAc,CAAC,QAAQ,CAAC,gBAAgB,cAAc,CAAC,0BAA0B,CAAC,cAAc,CAAC,gBAAgB,cAAc,CAAC,cAAc,CAAC,SAAS,0BAA0B,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,gBAAgB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,iBAAiB,WAAW,CAAC,wBAAwB,CAAC,eAAe,CAAC,iBAAiB,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,iBAAiB,CAAC,uBAAuB,kCAAkC,CAAC,eAAe,iBAAiB,CAAC,SAAS,CAAC,eAAe,CAAC,oBAAoB,CAAC,kBAAkB,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,0BAA0B,CAAC,aAAa,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,iDAAiD,UAAU,CAAC,UAAU,CAAC,kCAAkC,CAAC,MAAM,CAAC,uBAAuB,cAAc,CAAC,YAAY,aAAa,CAAC,0BAA0B,CAAC,eAAe,CAAC,eAAe,CAAC,OAAO,cAAc,CAAC,UAAU,CAAC,QAAQ,CAAC,UAAU,CAAC,kBAAkB,CAAC,UAAU,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,cAAc,CAAC,uCAAuC,CAAC,wBAAwB,WAAW,yCAAyC,CAAC,cAAc,WAAW,CAAC,kBAAkB,6BAA6B,CAAC,aAAa,yBAAyB,CAAC,WAAW,YAAY,CAAC,6CAA6C,sCAAsC,CAAC,2EAA2E,YAAY,CAAC;;AAE1ra;;4CAE4C;AAC5C;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;8EAE8E;AAC9E,MAAM,kBAAkB,CAAC,gBAAgB;AACzC,gBAAgB,WAAW,CAAC,eAAe,CAAC;AAC5C,KAAK,0BAA0B,CAAC,kCAAkC,CAAC,iCAAiC;AACpG,2BAA2B,eAAe,CAAC,eAAe;;AAE1D,WAAW,yCAAqD,CAArD,qDAAqD,CAAC,kBAAkB;AACnF,cAAc,WAAuB,CAAvB,uBAAuB,CAAC,eAAe,CAAC,8BAA8B,CAAC,oCAAoC;AACzH,YAAY,WAAW,CAAC,cAAc,CAAC,QAAQ,CAAC,eAAe;AAC/D,iBAAiB,UAAU,CAAC,WAAW,CAAC,qBAAiB,CAAjB,kBAAkB;AAC1D,kBAAkB,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,qBAAqB;AACpF,gBAAgB,cAAc,CAAC,aAAa,CAAC,cAAc;AAC3D,gBAAgB,qBAAqB,CAAC,aAAa,CAAC,eAAe,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,aAAa;AAC/H,UAAU,qBAAqB,CAAC,OAAO;AACvC,eAAe,eAAe,CAAC,cAAc,CAAC,iBAAiB,CAAC,QAAQ,CAAC,cAAc,CAAC,aAAa,CAAC,+CAA+C;AACrJ,mBAAmB,aAAa;AAChC,qBAAqB,kBAAkB,CAAC,aAAa;AACrD,sBAAsB,kBAAkB,CAAC,aAAa;AACtD,0BAA0B,aAAa;AACvC,mBAAmB,sBAAsB,CAAC,4BAA4B;AACtE,oBAAoB,YAAY,CAAC,OAAO,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,kBAAkB;AACpJ,wBAAwB,aAAa,CAAC,aAAa,CAAC,cAAc;AAClE,wBAAwB,YAAY,CAAC,YAAM,CAAN,OAAO;AAC5C,sBAAsB,cAAc,CAAC,aAAa,CAAC,yBAAyB,aAAa,CAAC,gBAAgB,CAAC,aAAa;AACxH,UAAU,QAAQ,CAAC,aAAa,CAAC,sBAAsB,CAAC,QAAQ,CAAC,SAAS,CAAC,aAAa;;AAExF,cAAc,aAAa,CAAC,WAAW;AACvC,aAAa,WAAuB,CAAvB,uBAAuB,CAAC,cAAc,CAAC,gCAAgC,CAAC,+BAA+B,CAAC,uCAAuC;AAC5J,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,aAAa,CAAC,mBAAmB,aAAa,CAAC,qBAAqB,aAAa;AACzJ,qBAAqB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,aAAa,CAAC,iBAAiB,SAAS,CAAC,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,4BAA4B;AACjM,WAAW,gBAAgB,CAAC,sBAAsB;;AAElD,WAAW,kBAAkB,CAAC,cAAc,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,aAAa,eAAe,CAAC,cAAc,CAAC,aAAa;AACzK,SAAS,cAAc,CAAC,eAAe,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC,iBAAiB;AACrH,WAAW,iBAAiB,CAAC,kBAAkB,CAAC,cAAc,eAAe,CAAC,cAAc,CAAC,iBAAiB,CAAC,aAAa,cAAc,CAAC,gBAAgB;AAC3J,0BAA0B,eAAe,CAAC,OAAO,CAAC,iBAAiB,CAAC,eAAe,CAAC,YAAY,kBAAkB,CAAC,oBAAoB,CAAC,kBAAkB,kBAAkB,CAAC,eAAe,gBAAgB,CAAC,eAAe;;AAE5N,OAAO,oBAAoB,CAAC,kBAAkB,CAAC,sCAAsC,CAAC,eAAe;AACrG,YAAY,iBAAiB,CAAC,sBAAsB,cAAc,CAAC,YAAY,YAAY;AAC3F,aAAa,QAAQ,CAAC,kBAAkB,kBAAkB;AAC1D,aAAa,oBAAoB,CAAC,kBAAkB,CAAC,YAAY,CAAC,eAAe,CAAC,uCAAuC;AACzH,oBAAoB,cAAc,CAAC,aAAa,CAAC,sBAAsB,CAAC,mBAAmB,cAAc,CAAC,aAAa;AACvH,kBAAkB,YAAY,CAAC,sBAAsB,CAAC,QAAQ,CAAC,sBAAsB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,aAAa,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,aAAa;;AAE9O,iBAAiB,eAAe,CAAC,qBAAqB,iBAAiB,CAAC,eAAe,CAAC,qBAAqB,sBAAsB,CAAC,kBAAkB,CAAC,QAAQ,CAAC,qCAAqC,mBAAmB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,eAAe,CAAC,iBAAiB,CAAC,wBAAwB,UAAU,CAAC,WAAW,CAAC,aAAa,CAAC,aAAa,cAAc,CAAC,WAAW,CAAC,aAAa,CAAC,aAAa,CAAC,gBAAgB;AAChc,kBAAkB,cAAc,CAAC,sBAAsB,cAAc,CAAC,aAAa,CAAC,QAAQ,CAAC,6BAA6B,aAAa,CAAC,cAAc,CAAC,0BAA0B,aAAa;AAC9L,qBAAqB,iBAAiB,CAAC,wBAAwB,cAAc,CAAC,uBAAuB,eAAe,CAAC,kBAAkB;;AAEvI,oBAAoB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,iBAAiB,CAAC,+BAA+B,CAAC,kBAAkB,CAAC,cAAc,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe,CAAC,eAAe,CAAC,MAAM,CAAC,WAAW,CAAC,cAAc,CAAC,eAAe,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,aAAa,CAAC,oBAAoB,QAAQ,CAAC,SAAS,CAAC,WAAW,CAAC,MAAM,CAAC,aAAa,CAAC,sBAAsB,CAAC,cAAc,CAAC,gBAAgB,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,qBAAqB,CAAC,cAAc,CAAC,aAAa,CAAC,eAAe,cAAc,CAAC,aAAa,CAAC,gBAAgB;AACvnB,yEAAyE,uDAAuD,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,oCAAoC,eAAe,CAAC,aAAa,YAAY,CAAC,kBAAkB,CAAC,WAAW,CAAC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB,CAAC,aAAa,YAAY,CAAC,wBAAwB,CAAC,OAAO;;AAEvY,mCAAmC;AACnC,cAAc,eAAe,CAAC,kBAAkB,CAAC,aAAa,cAAc,CAAC,kBAAkB,CAAC,oCAAoC,UAAU,CAAC,SAAS,CAAC,kBAAkB,UAAU,CAAC,WAAW,CAAC,aAAa,oBAAoB,CAAC,sCAAsC,CAAC,0EAA0E,CAAC,0BAA0B,0BAA0B,CAAC,uCAAuC;AAClb,uDAAuD,oBAAoB,CAAC,WAAW,kBAAkB,CAAC,oBAAoB,CAAC,iBAAiB,kBAAkB,CAAC,oBAAoB;;AAEvL,+EAA+E;AAC/E,0BAA0B,cAAc,CAAC,OAAO,CAAC,WAAW,CAAC,YAAY,CAAC,eAAe,CAAC,eAAe,CAAC,YAAY,CAAC,0BAA0B;AACjJ,8BAA8B,UAAU,CAAC,WAAW;AACpD,0FAA0F,0BAA0B;AACpH,4DAA4D,0BAA0B;AACtF,iCAAiC,0BAA0B;;AAE3D;8EAC8E;AAC9E;kDACkD,eAAe;;AAEjE,yBAAyB,MAAM,kBAAkB,CAAC,WAAW,YAAY,CAAC,kBAAkB,6CAA6C,CAAC,yEAAyE,6CAA6C,CAAC,uGAAuG,YAAY,CAAC;AACrX,YAAY,cAAc,CAAC,aAAa,CAAC,eAAe;;AAExD,iFAAiF;AACjF,kBAAkB,kBAAkB,CAAC,qBAAqB,YAAY,CAAC,6CAA6C,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,yBAAyB,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,YAAY,CAAC,oBAAoB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,sCAAsC,CAAC,0BAA0B,cAAc,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC,eAAe,CAAC,4BAA4B,cAAc,CAAC,aAAa,CAAC,kBAAkB,gBAAgB,CAAC,eAAe,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,iBAAiB,CAAC,+BAA+B,CAAC,kBAAkB,CAAC,2BAA2B,CAAC,cAAc,eAAe,CAAC,sBAAsB,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,YAAY,CAAC,UAAU,CAAC,eAAe,CAAC,2BAA2B,CAAC,eAAe,CAAC,kCAAkC,QAAQ,CAAC,2BAA2B,CAAC,4BAA4B,kBAAkB,CAAC,2BAA2B,CAAC,sCAAsC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,yBAAyB,2BAA2B,CAAC,cAAc,CAAC,+BAA+B,kBAAkB,CAAC,0BAA0B,YAAY,CAAC,kBAAkB,CAAC,cAAc,CAAC,aAAa,CAAC,iBAAiB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,gBAAgB,CAAC,mBAAmB,cAAc,CAAC,aAAa,CAAC,sBAAsB,aAAa,CAAC,aAAa,CAAC,mBAAmB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,aAAa,CAAC,eAAe,CAAC,kBAAkB,CAAC,aAAa,CAAC,wBAAwB,kBAAkB,CAAC,aAAa,CAAC,8BAA8B,kBAAkB,CAAC,aAAa,CAAC,oBAAoB,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,OAAO,CAAC,2BAA2B,UAAU,CAAC,WAAW,CAAC,QAAQ,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,aAAa,CAAC,YAAY,CAAC,kBAAkB,CAAC,iCAAiC,kBAAkB,CAAC,aAAa,CAAC,wCAAwC,kBAAkB,CAAC,aAAa,CAAC,kBAAkB,kBAAkB,CAAC,uBAAuB,CAAC,uBAAuB,cAAc,CAAC,OAAO,CAAC,4BAA4B,CAAC,UAAU,CAAC,YAAY,CAAC,wBAAwB,CAAC,2BAA2B,WAAW,CAAC,qBAAqB,CAAC,oBAAoB,WAAW,CAAC,eAAe,CAAC,yCAAyC,CAAC,aAAa,CAAC,mBAAmB,sBAAsB,CAAC,+BAA+B,CAAC,YAAY,CAAC,6BAA6B,CAAC,QAAQ,CAAC,sBAAsB,CAAC,mBAAmB,YAAY,CAAC,QAAQ,CAAC,sBAAsB,CAAC,sCAAsC,cAAc,CAAC,sBAAsB,cAAc,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,qBAAqB,QAAQ,CAAC,aAAa,CAAC,cAAc,CAAC,sBAAsB,YAAY,CAAC,OAAO,CAAC,iBAAiB,CAAC,+BAA+B,CAAC,kBAAkB,CAAC,aAAa,aAAa,CAAC,sBAAsB,iBAAiB,CAAC,+BAA+B,CAAC,yBAAyB,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,gBAAgB,YAAY,CAAC,6BAA6B,CAAC,aAAO,CAAP,QAAQ,CAAC,oBAAoB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,qBAAqB,aAAa,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,aAAa,CAAC,eAAe,CAAC,kBAAkB,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,gBAAgB,YAAY,CAAC,mCAAmC,CAAC,YAAM,CAAN,OAAO,CAAC,oBAAoB,kBAAkB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,YAAY,CAAC,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,qBAAqB,aAAa,CAAC,aAAa,CAAC,uBAAuB,cAAc,CAAC,aAAa,CAAC,mBAAmB,YAAY,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,wBAAwB,aAAa,CAAC,aAAa,CAAC,yBAAyB,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,iBAAiB,CAAC,+BAA+B,CAAC,mCAAmC,eAAe,CAAC,4BAA4B,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,0BAA0B,cAAc,CAAC,aAAa,CAAC,6BAA6B,aAAa,CAAC,aAAa,CAAC,cAAc,YAAY,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,aAAa,CAAC,cAAc,CAAC,iBAAiB,CAAC,wBAAwB,qBAAqB,6BAA6B,CAAC,eAAe,cAAc,CAAC,cAAc,eAAe,CAAC,eAAe,aAAa,CAAC,gBAAgB,yBAAyB,CAAC,gBAAgB,iCAAiC,CAAC;;AAEnpJ,gFAAgF;AAChF,MAAM,2BAA2B,CAAC,2BAA2B,CAAC,uCAAuC;AACrG,6BAA6B,wCAAwC;AACrE,WAAW,yCAAqD,CAArD,qDAAqD,CAAC,0CAA0C;AAC3G,cAAc,WAAuB,CAAvB,uBAAuB,CAAC,0BAA0B,CAAC,eAAe;AAChF,YAAY,WAAW,CAAC,cAAc,CAAC,QAAQ,CAAC,kBAAkB;AAClE,iBAAiB,UAAU,CAAC,WAAW,CAAC,qBAAkB,CAAlB,kBAAkB,CAAC,aAAa;AACxE,+BAA+B,SAAS,CAAC,sBAAsB;AAC/D,gBAAgB,qBAAqB,CAAC,aAAa,CAAC,eAAe,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC,kBAAkB;AAClJ,UAAU,gBAAgB,CAAC,OAAO;AAClC,eAAe,eAAe,CAAC,cAAc,CAAC,QAAQ,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,eAAe,CAAC,aAAa;AACzH,mBAAmB,aAAa;AAChC,oBAAoB,eAAe,CAAC,sBAAsB;AAC1D,6BAA6B,iBAAiB,CAAC,kBAAkB;AACjE,kCAAkC,UAAU,CAAC,SAAS,CAAC,sBAAsB,CAAC,aAAa;AAC3F,kBAAkB,UAAU,CAAC,kBAAkB,CAAC,eAAe;AAC/D,8BAA8B,eAAe;AAC7C,kBAAkB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,oBAAoB,CAAC,WAAW;AACvE,uBAAuB,aAAa,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC,eAAe;AAChH,oBAAoB,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB;AAC1G,sCAAsC,kBAAkB,CAAC,aAAa,CAAC,gCAAgC;AACvG,yDAAyD,gCAAgC;AACzF,iBAAiB,mBAAmB;AACpC,gBAAgB,aAAa;AAC7B,mBAAmB,YAAY,CAAC,sBAAsB;AACtD,oBAAoB,YAAY,CAAC,sBAAsB,CAAC,OAAO,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,aAAa;AAC3K,wBAAwB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,sBAAsB,cAAc,CAAC,aAAa,CAAC,yBAAyB,aAAa,CAAC,gBAAgB,CAAC,aAAa;AACrK,UAAU,QAAQ,CAAC,sBAAsB,CAAC,QAAQ,CAAC,SAAS,CAAC,aAAa;AAC1E,cAAc,aAAa,CAAC,WAAW,CAAC,2BAA2B;AACnE,aAAa,WAAW,CAAC,cAAc;AACvC,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,WAAW,CAAC,yCAAyC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB,CAAC,mBAAmB,eAAe,CAAC,aAAa,CAAC,qBAAqB,uBAAuB;AACrQ,qBAAqB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,aAAa,CAAC,cAAc,CAAC,iBAAiB,SAAS,CAAC,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,4BAA4B;AACjM,mBAAmB,gBAAgB;AACnC,mBAAmB,cAAc,CAAC,QAAQ,CAAC,SAAS,CAAC,yBAAyB,CAAC,eAAe,CAAC,eAAe;;AAE9G;4EAC4E;AAC5E,uDAAuD,iBAAiB,CAAC,UAAU,CAAC,UAAU,CAAC,WAAW,CAAC,SAAS,CAAC,eAAe,CAAC,eAAe,CAAC,YAAY,CAAC,qBAAqB;AACvL,kCAAkC,YAAY;AAC9C,6BAA6B,aAAa,CAAC,qBAAqB,CAAC,YAAY,CAAC,eAAe;AAC7F,iCAAiC,WAAW,CAAC,YAAY;AACzD,sBAAsB,aAAa,CAAC,YAAY,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,QAAQ,CAAC,gBAAgB,CAAC,+BAA+B,CAAC,kBAAkB,CAAC,aAAa,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,eAAe;AACzO,2BAA2B,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,WAAW,CAAC,kBAAkB;AACxG,6BAA6B,gBAAgB,CAAC,aAAa;AAC3D,mBAAmB,YAAY,CAAC,aAAa;AAC7C,oBAAoB,QAAQ,CAAC,sBAAsB,CAAC,aAAa,CAAC,eAAe,CAAC,gBAAgB,CAAC,eAAe,CAAC,cAAc,CAAC,kBAAkB;AACpJ,0BAA0B,yBAAyB;AACnD,6BAA6B,UAAU,CAAC,WAAW,CAAC,oBAAoB;AACxE,cAAc,YAAY,CAAC,aAAa,CAAC,cAAc;;AAEvD;EACE,MAAM,2BAA2B;EACjC,aAAa,cAAc;EAC3B,mBAAmB,eAAe;AACpC;;AAEA,iFAAiF;AACjF,0BAA0B,oBAAoB,CAAC,cAAc,CAAC,mBAAmB,CAAC,gCAAgC,CAAC,kBAAkB;AACrI,6CAA6C,oBAAoB,CAAC,uBAAuB;AACzF,2BAA2B,YAAY;;AAEvC,+CAA+C;AAC/C,kBAAkB,cAAc;AAChC,eAAe,OAAO,CAAC,gBAAgB;AACvC,cAAc,eAAe,CAAC,eAAe;AAC7C,iBAAiB,UAAU,CAAC,WAAW,CAAC,aAAa;AACrD,iBAAiB,YAAY;;AAE7B,oBAAoB,OAAO,CAAC,gBAAgB;AAC5C,2BAA2B,UAAU,CAAC,WAAW;AACjD,mBAAmB,cAAc,CAAC,YAAY,CAAC,WAAW,CAAC,eAAe,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,wCAAwC,CAAC,WAAW,CAAC,YAAY,CAAC,YAAM,CAAN,OAAO;AAC/L,0BAA0B,WAAW,CAAC,QAAQ,CAAC,eAAe,CAAC,iBAAiB,CAAC,aAAa,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa;AACnL,gCAAgC,kBAAkB,CAAC,aAAa,CAAC,mCAAmC,WAAW,CAAC,iCAAiC,aAAa,CAAC,uCAAuC,kBAAkB,CAAC,sBAAsB,UAAU,CAAC,kBAAkB,CAAC,cAAc;;AAE3R,mBAAmB,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,eAAe,CAAC,gBAAgB,CAAC,4BAA4B;AAC7H,qBAAqB,iBAAiB,CAAC,YAAY,CAAC,QAAQ,CAAC,gBAAgB,QAAQ,CAAC,sBAAsB,CAAC,SAAS,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,sBAAsB,aAAa,CAAC,uBAAuB,aAAa;;AAE3R,gBAAgB,cAAc,CAAC,OAAO,CAAC,YAAY,CAAC,4BAA4B,CAAC,YAAY,CAAC,kBAAkB,CAAC,YAAY;AAC7H,kBAAkB,qBAAqB,CAAC,eAAe,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,eAAe;AACnI,iBAAiB,sBAAsB,CAAC,+BAA+B,CAAC,YAAY,CAAC,sBAAsB,CAAC,6BAA6B,CAAC,oBAAoB,QAAQ,CAAC,cAAc,CAAC,aAAa;AACnM,iBAAiB,iBAAiB,CAAC,YAAY,CAAC,aAAO,CAAP,QAAQ,CAAC,uBAAuB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,4BAA4B,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,iDAAiD,UAAU,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,aAAa,CAAC,eAAe,CAAC,SAAS,CAAC,6DAA6D,oBAAoB,CAAC,yCAAyC,CAAC,0BAA0B,eAAe,CAAC,eAAe;AACngB,iBAAiB,iBAAiB,CAAC,4BAA4B,CAAC,kBAAkB,CAAC,YAAY,CAAC,wBAAwB,CAAC,OAAO;;AAEhI,oBAAoB,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,eAAe,CAAC,YAAY,CAAC,eAAe,CAAC,0BAA0B,SAAS,CAAC,oBAAoB,CAAC,wCAAwC,CAAC,eAAe,gBAAgB;;AAE3Q,yBAAyB,eAAe,cAAc,CAAC,cAAc,eAAe,CAAC,eAAe,CAAC,eAAe,gBAAgB,CAAC;;AAErI,gFAAgF;AAChF,WAAW,mEAAmE,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,YAAY,CAAC,0DAA0D,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,sCAAsC;AAC1S,gBAAgB,eAAe,CAAC,cAAc,gBAAgB,CAAC,cAAc,CAAC,gBAAgB,CAAC,sBAAsB,CAAC,aAAa,CAAC,aAAa,QAAQ,CAAC,aAAa,CAAC,cAAc,CAAC,gBAAgB,CAAC,eAAe,CAAC,mBAAmB,YAAY,CAAC,OAAO,CAAC,eAAe,CAAC,eAAe,eAAe,CAAC,cAAc;AAC7T,kBAAkB,YAAY,CAAC,oBAAoB,CAAC,YAAM,CAAN,OAAO,CAAC,gBAAgB,WAAW,CAAC,eAAe,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,uCAAuC,CAAC,oBAAoB,aAAa,CAAC,uBAAuB,oBAAoB,CAAC,kBAAkB,CAAC,gBAAgB,SAAS,CAAC,WAAW,CAAC,kBAAkB;AACxc,cAAc,aAAa,CAAC,mBAAmB,YAAY,CAAC,oBAAoB,CAAC,6BAA6B,CAAC,iBAAiB,CAAC,sBAAsB,cAAc,CAAC,cAAc,CAAC,qBAAqB,CAAC,aAAa,CAAC,YAAY,YAAY,CAAC,6CAA6C,CAAC,UAAK,CAAL,KAAK,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,eAAe,CAAC,WAAW,eAAe,CAAC,QAAQ,CAAC,8BAA8B,CAAC,eAAe,CAAC,iBAAiB,CAAC,YAAY,CAAC,sBAAsB,CAAC,OAAO,CAAC,eAAe,CAAC,sBAAsB,cAAc,CAAC,kBAAkB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,gBAAgB,CAAC,cAAc,CAAC,aAAa,CAAC,aAAa,QAAQ,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AAC/1B,sBAAsB,YAAY,CAAC,6CAA6C,CAAC,YAAM,CAAN,OAAO,CAAC,iBAAiB,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,eAAe,CAAC,YAAY,CAAC,8BAA8B,CAAC,4BAA4B,CAAC,oBAAe,CAAf,oBAAe,CAAf,eAAe,CAAC,mBAAmB,CAAC,sBAAsB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,QAAQ,CAAC,mBAAmB,CAAC,oBAAoB,gBAAgB,CAAC,cAAc,CAAC,aAAa,CAAC,mBAAmB,QAAQ,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,mBAAmB,eAAe,CAAC,kBAAkB,iBAAiB;AACnqB,yBAAyB,WAAW,yBAAyB,CAAC,kBAAkB,2CAA2C,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,gBAAgB,UAAU,CAAC,gBAAgB,UAAU,CAAC,UAAU,CAAC,kCAAkC,6BAA6B,CAAC;AACtS,wBAAwB,WAAW,YAAY,CAAC,cAAc,cAAc,CAAC,kBAAkB,YAAY,CAAC,kCAAkC,yBAAyB,CAAC,mBAAmB,cAAc,CAAC;;;AAG1M;;;wEAGwE;AACxE;EACE,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,sDAAsD;EACtD,YAAY;EACZ,mEAAmE;EACnE,gCAA2B;EAA3B,2BAA2B;EAC3B,eAAe;AACjB;AACA;8BAC8B,QAAQ,CAAC,YAAY;AACnD;EACE,WAAW;EACX,mDAAmD;EACnD,0DAA0D;EAC1D,0BAA0B;AAC5B;AACA,gCAAgC,eAAe;AAC/C,yBAAyB,4CAA4C,CAAC,qBAAqB;AAC3F;EACE,kDAAkD;EAClD,4CAA4C;EAC5C,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,2CAA2C;EAC3C,eAAe;AACjB;AACA,mCAAmC,iCAAiC,CAAC,QAAQ;AAC7E;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA,kCAAkC,uBAAuB;AACzD;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;AACpB;AACA,gCAAgC,6BAA6B;AAC7D;EACE,YAAY;EACZ,qCAAqC;EACrC,qBAAqB;AACvB;AACA,mCAAmC,mCAAmC;AACtE;EACE,cAAc;EACd,4CAA4C;EAC5C,eAAe;AACjB;AACA,4BAA4B,WAAW,CAAC,YAAY;AACpD;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;AACA,sCAAsC,WAAW,CAAC,wBAAwB;AAC1E;EACE,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,gDAAgD;EAChD,oCAA+B;OAA/B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;8CAC8C;AAC9C;EACE,gBAAgB,YAAY,CAAC,iBAAiB,CAAC,QAAQ,CAAC,oCAAoC;EAC5F,2BAA2B,iBAAiB;EAC5C,8BAA8B,cAAc;EAC5C,6BAA6B,cAAc,CAAC,gBAAgB;EAC5D,mCAAmC,eAAe;EAClD,gCAAgC,eAAe;EAC/C,mCAAmC,iBAAiB;EACpD,sCAAsC,cAAc;EACpD,2BAA2B,gBAAgB;EAC3C,iCAAiC,gBAAgB;AACnD;;AAEA;6BAC6B;AAC7B;EACE;IACE,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,YAAY;EACd;EACA,2BAA2B,WAAW,CAAC,kBAAkB;EACzD,8BAA8B,aAAa,CAAC,aAAa;EACzD,kEAAkE,WAAW;AAC/E;;;AAGA;;;qBAGqB;AACrB;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,uDAAuD;EACvD,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,sDAAsD;EACtD,iDAAiD;EACjD,sCAAiC;OAAjC,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,+EAA+E;AAC/E;EACE,6BAA6B,cAAc;EAC3C,kCAAkC,UAAU,CAAC,WAAW,CAAC,cAAc;EACvE,8BAA8B,cAAc;EAC5C,6BAA6B,cAAc;EAC3C,iCAAiC,8BAA8B;EAC/D,sCAAsC,UAAU,CAAC,WAAW;EAC5D,oCAAoC,cAAc;EAClD,mCAAmC,cAAc;AACnD;;AAEA,gDAAgD;AAChD,iBAAiB,eAAe,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc;AAC7I,kBAAkB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,eAAe,CAAC,cAAc;AACzF,mBAAmB,cAAc,CAAC,aAAa;AAC/C,kBAAkB,YAAY,CAAC,6CAA6C,CAAC,kBAAY,CAAZ,aAAa;AAC1F,wBAAwB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AACzF,mDAAmD,UAAU,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,gBAAgB,CAAC,YAAY,CAAC,eAAe,CAAC,YAAY;AACjM,+DAA+D,oBAAoB,CAAC,yCAAyC;AAC7H,2BAA2B,eAAe,CAAC,gBAAgB;AAC3D,wBAAwB,gBAAgB;AACxC,wBAAwB,kBAAkB,yBAAyB,CAAC;;AAEpE,yCAAyC;AACzC,4BAA4B,gBAAgB,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,0BAA0B;AACxI,kCAAkC,iBAAiB,CAAC,cAAc,UAAU,CAAC,WAAW,CAAC,wBAAwB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,qCAAqC,CAAC,kBAAkB,CAAC,mBAAmB,GAAG,wBAAwB,CAAC;AACrQ,mBAAmB,eAAe,CAAC,YAAY,CAAC,kBAAkB,cAAc,CAAC,eAAe,CAAC,iBAAiB,aAAa,CAAC,eAAe,CAAC,sBAAsB,eAAe,CAAC,kBAAkB,CAAC,UAAU,CAAC,QAAQ,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc;;AAE/R,WAAW,gBAAgB,CAAC,YAAY,CAAC,0DAA0D,CAAC,eAAe,CAAC,0BAA0B,CAAC,aAAa;AAC5J,kBAAkB,kDAAkD,CAAC,4BAA4B,CAAC,YAAY,CAAC,qBAAqB,CAAC,gBAAgB;AACrJ,YAAY,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,gBAAgB,UAAU,CAAC,WAAW,CAAC,cAAc,aAAa,CAAC,cAAc,CAAC,iBAAiB,aAAa,CAAC,aAAa,CAAC,cAAc,CAAC,cAAc;AACjN,YAAY,aAAa,CAAC,eAAe,CAAC,eAAe,gCAAgC,CAAC,gBAAgB,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,cAAc,cAAc,CAAC,gBAAgB,CAAC,aAAa,CAAC,eAAe;AAChO,mBAAmB,YAAY,CAAC,aAAQ,CAAR,QAAQ,CAAC,eAAe,CAAC,uBAAuB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,uBAAuB,aAAa;AAC1M,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,YAAY,CAAC,WAAW,qBAAqB,CAAC,mBAAmB,cAAc,CAAC,sBAAsB,CAAC,cAAc,CAAC,kBAAkB,aAAa,CAAC,cAAc,CAAC,eAAe;AACrO,YAAY,iBAAiB,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,CAAC,cAAc,CAAC,kBAAkB;AAC3I,WAAW,YAAY,CAAC,aAAO,CAAP,QAAQ,CAAC,iBAAiB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,iBAAiB,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,YAAY,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,aAAa,CAAC,yBAAyB,oBAAoB,CAAC,yCAAyC,CAAC,kBAAkB,QAAQ,CAAC,SAAS,CAAC,MAAM,CAAC,WAAW,CAAC,sBAAsB,CAAC,aAAa,CAAC,cAAc;AAC7f,cAAc,WAAW,CAAC,QAAQ,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,UAAU,CAAC,cAAc,CAAC,eAAe,CAAC,cAAc,CAAC,uBAAuB,UAAU;AAClK,cAAc,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,aAAa,CAAC,cAAc,CAAC,aAAa,CAAC,yCAAyC,UAAU,CAAC,UAAU,CAAC,kBAAkB,CAAC,MAAM;AAC1L,aAAa,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,eAAe,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,oBAAoB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,qBAAqB,kBAAkB;AACjQ,aAAa,iBAAiB,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,oBAAoB,QAAQ,CAAC,sBAAsB,CAAC,aAAa,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa;AAC1L,cAAc,iBAAiB,CAAC,sBAAsB,eAAe,CAAC,cAAc,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe,CAAC,iBAAiB,CAAC,8CAA8C,YAAY,CAAC,4BAA4B,kBAAkB,CAAC,gBAAgB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,eAAe,CAAC,eAAe,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,eAAe,CAAC,iBAAiB,cAAc,CAAC,aAAa,CAAC,qBAAqB,aAAa,CAAC,aAAa;AACriB,iBAAiB,iBAAiB,CAAC,OAAO,CAAC,QAAQ,CAAC,WAAW,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,WAAW,CAAC,WAAW,CAAC,cAAc,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,qBAAqB,CAAC,+BAA+B,CAAC,iBAAiB,CAAC,gBAAgB,cAAc,CAAC,mBAAmB,cAAc,CAAC,aAAa,CAAC,wBAAwB,UAAU,CAAC,WAAW,CAAC,QAAQ,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,8BAA8B,kBAAkB;AACpkB,wBAAwB,WAAW,yBAAyB,CAAC,kBAAkB,YAAY,CAAC,iBAAiB,gBAAgB,CAAC;;AAE9H,+CAA+C;AAC/C,qBAAqB,eAAe;AACpC,uBAAuB,8BAA8B,CAAC,mBAAmB,CAAC,cAAc,CAAC,iBAAiB;AAC1G,uCAAuC,mBAAmB,CAAC,iBAAiB;AAC5E,gCAAgC,WAAW,CAAC,kBAAkB,CAAC,kBAAkB;AACjF,eAAe,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,aAAa;AACnF,sBAAsB,4BAA4B,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa;AAC/F,yBAAyB,mCAAmC,CAAC,gCAAgC,CAAC,OAAO;AACrG,2BAA2B,aAAa,CAAC,SAAS,CAAC,UAAU,CAAC,eAAe;AAC7E,wCAAwC,kBAAkB,CAAC,wCAAwC,kBAAkB,CAAC,wCAAwC,kBAAkB,CAAC,wCAAwC,kBAAkB;AAC3O,oBAAoB,gBAAgB,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;;AAEjF,+CAA+C;AAC/C;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,QAAQ;EACR,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA,6BAA6B,kBAAkB,CAAC,oBAAoB;AACpE;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;EACR,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;AACA,6BAA6B,kBAAkB,CAAC,oBAAoB;AACpE,gCAAgC,WAAW,CAAC,mBAAmB;AAC/D,cAAc,UAAU,CAAC,WAAW,CAAC,aAAa;AAClD;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,QAAQ;EACR,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;AACA,mBAAmB,cAAc,CAAC,aAAa;AAC/C,sBAAsB,cAAc,CAAC,aAAa,CAAC,cAAc;AACjE;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,aAAQ;EAAR,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;AACA,+BAA+B,eAAe;AAC9C,wBAAwB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,WAAW;AACxD,sBAAsB,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB;AAC5G,yBAAyB,cAAc,CAAC,aAAa;AACrD;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAQ;EAAR,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA,sBAAsB,cAAc,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,eAAe,CAAC,aAAa;AAChH,mBAAmB,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,sBAAsB;AACtF;EACE,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA,uBAAuB,cAAc;AACrC,sBAAsB,YAAY,CAAC,YAAM,CAAN,OAAO;AAC1C,mBAAmB,cAAc,CAAC,aAAa;AAC/C,uBAAuB,cAAc,CAAC,gBAAgB,CAAC,aAAa;AACpE;EACE,kBAAkB,mCAAmC,CAAC,WAAW;EACjE,iBAAiB,mCAAmC;AACtD;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;AACA,iBAAiB,aAAa;AAC9B;EACE,YAAY;EACZ,6CAA6C;EAC7C,iBAAY;EAAZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;AACA;;;;;EAKE,qCAAqC;AACvC;AACA;EACE,kEAAkE;AACpE;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB,yDAAyD;EAC7E,2BAA2B,aAAa;AAC1C;;AAEA,mDAAmD;AACnD,qBAAqB,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,oBAAoB;AACxF;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAQ;EAAR,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAe;EAAf,oBAAe;OAAf,eAAe;AACjB;AACA,+BAA+B,oBAAoB,CAAC,kBAAkB;AACtE,0BAA0B,kBAAkB;AAC5C;EACE,YAAY;EACZ,UAAU,CAAC,WAAW,CAAC,kBAAkB;EACzC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa;AAClE;AACA,0BAA0B,cAAc,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,eAAe,CAAC,aAAa;AACrH,4BAA4B,cAAc,CAAC,gBAAgB,CAAC,aAAa,CAAC,cAAc;AACxF,uBAAuB,cAAc,CAAC,gBAAgB,CAAC,aAAa,CAAC,cAAc;AACnF,uBAAuB,YAAY,CAAC,aAAO,CAAP,QAAQ;AAC5C,2BAA2B,YAAY,CAAC,+BAA+B,CAAC,aAAQ,CAAR,QAAQ,CAAC,cAAc,CAAC,+BAA+B;AAC/H,sCAAsC,eAAe;AACrD,yBAAyB,cAAc,CAAC,aAAa;AACrD,4BAA4B,cAAc,CAAC,gBAAgB,CAAC,aAAa;AACzE;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAQ;EAAR,QAAQ;EACR,aAAa;AACf;AACA;EACE,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB;EACpG,aAAa,CAAC,cAAc;AAC9B;AACA,oBAAoB,cAAc,CAAC,aAAa;AAChD,0BAA0B,WAAW,CAAC,kBAAkB,CAAC,kBAAkB;AAC3E;EACE,qBAAqB,yBAAyB;EAC9C,kBAAkB,yBAAyB;AAC7C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,0BAA0B,kBAAkB,CAAC,oBAAoB;;AAEjE,4BAA4B;AAC5B,cAAc,YAAY,CAAC,6CAA6C,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,cAAc,YAAY,CAAC,QAAQ,CAAC,sBAAsB,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,YAAY,CAAC,eAAe,CAAC,cAAc,CAAC,qBAAqB,oBAAoB,CAAC,kBAAkB,CAAC,oBAAoB,cAAc,CAAC,mBAAmB,YAAY,CAAC,YAAM,CAAN,OAAO,CAAC,gBAAgB,cAAc,CAAC,aAAa,CAAC,oBAAoB,cAAc,CAAC,gBAAgB,CAAC,aAAa,CAAC,iBAAiB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,aAAa,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,mBAAmB,cAAc,CAAC,aAAa,CAAC,sBAAsB,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,wBAAwB,cAAc,yBAAyB,CAAC;;AAEtyB,4BAA4B;AAC5B;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,WAAW;EACX,sBAAiB;EAAjB,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,4BAA4B,eAAe;AAC3C;EACE,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA,kBAAkB,cAAc,CAAC,aAAa;AAC9C,qBAAqB,cAAc,CAAC,aAAa,CAAC,gBAAgB;AAClE,wBAAwB,kBAAkB,CAAC,oBAAoB;AAC/D,wBAAwB,kBAAkB,CAAC,oBAAoB;AAC/D,sBAAsB,kBAAkB,CAAC,oBAAoB;AAC7D,wBAAwB,aAAa;AACrC;EACE,eAAe,UAAU,CAAC,aAAa;EACvC,sBAAsB,kBAAkB;AAC1C;;AAEA,6DAA6D;AAC7D;;;;EAIE,sCAAsC;EACtC,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD,wBAAwB,SAAS;AACjC,sBAAsB,0BAA0B;AAChD,qBAAqB,YAAY,CAAC,sBAAsB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,iBAAiB,CAAC,+BAA+B;AACjJ,wBAAwB,cAAc,CAAC,cAAc,CAAC,aAAa;AACnE,uBAAuB,QAAQ,CAAC,aAAa,CAAC,cAAc;AAC5D,qBAAqB,YAAY,CAAC,OAAO;AACzC,4BAA4B,mBAAmB,CAAC,kBAAkB,CAAC,OAAO;AAC1E,oBAAoB,YAAY,CAAC,QAAQ,CAAC,iBAAiB,CAAC,+BAA+B,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc;AAC3I,sBAAsB,aAAa,CAAC,cAAc,CAAC,gBAAgB;AACnE,+BAA+B,gBAAgB,CAAC,YAAY,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,OAAO,CAAC,YAAY,CAAC,aAAa;AACjL,mCAAmC,aAAa,CAAC,cAAc;AAC/D,yCAAyC,eAAe,CAAC,cAAc,CAAC,eAAe;AACvF,iBAAiB,YAAY;AAC7B,gBAAgB,YAAY,CAAC,kDAAkD,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,+BAA+B;AAC7J,iBAAiB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa;AAC1H,iCAAiC,kBAAkB,CAAC,aAAa;AACjE,iBAAiB,YAAY,CAAC,YAAM,CAAN,OAAO;AACrC,mBAAmB,cAAc,CAAC,aAAa;AAC/C,sBAAsB,cAAc,CAAC,aAAa,CAAC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB;AAC5G,wBAAwB,YAAY,CAAC,OAAO;AAC5C,aAAa,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc;AAC3J,mBAAmB,kBAAkB;AACrC,oBAAoB,aAAa;AACjC,mBAAmB,gBAAgB,CAAC,YAAY,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB;AAC/G,wBAAwB,YAAY,CAAC,6BAA6B,CAAC,sBAAsB,CAAC,kBAAkB;AAC5G,2BAA2B,QAAQ,CAAC,cAAc,CAAC,aAAa;AAChE,0BAA0B,cAAc,CAAC,cAAc,CAAC,aAAa;AACrE,mBAAmB,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,cAAc,CAAC,eAAe;AAChJ,yBAAyB,kBAAkB,CAAC,yBAAyB,CAAC,mBAAmB,CAAC,qBAAqB,CAAC,MAAM;AACtH,wBAAwB,YAAY,CAAC,aAAO,CAAP,QAAQ;AAC7C,mBAAmB,YAAY,CAAC,6CAA6C,CAAC,kBAAkB,CAAC,eAAe,CAAC,aAAQ,CAAR,QAAQ,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc;AACrN,yBAAyB,oBAAoB;AAC7C,4BAA4B,oBAAoB,CAAC,kBAAkB,CAAC,kCAAkC;AACtG,wBAAwB,YAAY,CAAC,YAAM,CAAN,OAAO;AAC5C,qBAAqB,cAAc,CAAC,aAAa;AACjD,yBAAyB,cAAc,CAAC,aAAa;AACrD,sBAAsB,iBAAiB,CAAC,cAAc,CAAC,aAAa;AACpE,yBAAyB,eAAe,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,YAAY,CAAC,YAAM,CAAN,OAAO;AACxI,2BAA2B,cAAc,CAAC,aAAa;AACvD,8BAA8B,cAAc,CAAC,eAAe,CAAC,aAAa;AAC1E,uBAAuB,YAAY,CAAC,cAAc,CAAC,OAAO,CAAC,cAAc;AACzE,4BAA4B,eAAe,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,aAAa,CAAC,eAAe;AAC7H;EACE,qBAAqB,qBAAqB;EAC1C,gBAAgB,6CAA6C;EAC7D,6BAA6B,YAAY;AAC3C;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,0BAA0B,cAAc,CAAC,aAAa;AACtD,6BAA6B,cAAc,CAAC,aAAa,CAAC,gBAAgB;AAC1E,gCAAgC,kBAAkB,CAAC,oBAAoB;AACvE,gCAAgC,kBAAkB,CAAC,oBAAoB;AACvE,kCAAkC,aAAa;AAC/C,8BAA8B,kBAAkB,CAAC,oBAAoB;AACrE,gCAAgC,aAAa;;AAE7C,8CAA8C;AAC9C,mBAAmB,kBAAkB;AACrC,mBAAmB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,iBAAiB;AACzD,qBAAqB,cAAc,CAAC,aAAa;AACjD,wBAAwB,cAAc,CAAC,aAAa;AACpD,mBAAmB,YAAY,CAAC,6CAA6C,CAAC,YAAM,CAAN,OAAO;AACrF,kBAAkB,iBAAiB,CAAC,YAAY,CAAC,8BAA8B,CAAC,YAAO,CAAP,OAAO,CAAC,iBAAiB,CAAC,eAAe,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc;AAChN,wBAAwB,oBAAoB;AAC5C,2BAA2B,oBAAoB,CAAC,kBAAkB,CAAC,kCAAkC;AACrG,uBAAuB,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa;AAChI,oCAAoC,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,kBAAkB;AAC3E,oBAAoB,cAAc,CAAC,aAAa;AAChD,wBAAwB,aAAa,CAAC,gBAAgB,CAAC,aAAa;AACpE,qBAAqB,iBAAiB,CAAC,SAAS,CAAC,OAAO,CAAC,iBAAiB,CAAC,aAAa,CAAC,eAAe,CAAC,aAAa;AACtH,qBAAqB,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa;AACpL,yBAAyB,YAAY,CAAC,YAAM,CAAN,OAAO;AAC7C,uBAAuB,cAAc,CAAC,aAAa;AACnD,0BAA0B,cAAc,CAAC,aAAa,CAAC,gBAAgB;AACvE,4BAA4B,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,kBAAkB;AAC7F,4BAA4B,eAAe;AAC3C,yBAAyB,mBAAmB,yBAAyB,CAAC,qBAAqB,sBAAsB,CAAC,qBAAqB,CAAC;;AAExI,4DAA4D;AAC5D,cAAc,0BAA0B;AACxC,YAAY,eAAe,CAAC,kBAAkB;AAC9C,0BAA0B,eAAe;AACzC,qBAAqB,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe;AAC5L,iBAAiB,YAAY,CAAC,aAAO,CAAP,QAAQ;AACtC,iBAAiB,YAAY,CAAC,6BAA6B,CAAC,aAAO,CAAP,QAAQ;AACpE,mBAAmB,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,eAAe;AAC7F,kBAAkB,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,+BAA+B;AACpJ,oBAAoB,cAAc,CAAC,aAAa;AAChD,uBAAuB,aAAa,CAAC,aAAa;AAClD,oBAAoB,gBAAgB,CAAC,aAAa;AAClD,gBAAgB,YAAY,CAAC,sBAAsB,CAAC,OAAO,CAAC,gBAAgB,CAAC,+BAA+B,CAAC,cAAc;AAC3H,2BAA2B,eAAe;AAC1C,sBAAsB,kBAAkB;AACxC,sBAAsB,cAAc;AACpC,qBAAqB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,WAAW;AACrD,kBAAkB,cAAc,CAAC,aAAa;AAC9C,sBAAsB,aAAa,CAAC,aAAa,CAAC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB;AAC3G,iBAAiB,YAAY;AAC7B,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,wBAAwB;AACzI,mBAAmB,cAAc,CAAC,aAAa;AAC/C,sBAAsB,cAAc,CAAC,aAAa;AAClD,aAAa,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,iBAAiB;AACjI,eAAe,cAAc,CAAC,aAAa;AAC3C,kBAAkB,oBAAoB,CAAC,0DAA0D,CAAC,aAAa,CAAC,aAAa;AAC7H,mBAAmB,YAAY,CAAC,8CAA8C,CAAC,aAAQ,CAAR,QAAQ,CAAC,eAAe,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB;AAClL,yBAAyB,YAAY,CAAC,YAAM,CAAN,OAAO;AAC7C,8BAA8B,cAAc,CAAC,eAAe,CAAC,aAAa;AAC1E,0BAA0B,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc,CAAC,0BAA0B,CAAC,cAAc;AACzJ,uBAAuB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,kBAAkB;AAC9D,qBAAqB,cAAc,CAAC,aAAa;AACjD,4BAA4B,cAAc,CAAC,gBAAgB,CAAC,aAAa;AACzE,qBAAqB,YAAY,CAAC,oBAAoB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,iBAAiB;AAC/G,qCAAqC,YAAY,CAAC,YAAM,CAAN,OAAO;AACzD,uBAAuB,cAAc,CAAC,aAAa;AACnD,0BAA0B,cAAc,CAAC,aAAa;AACtD,mBAAmB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,WAAW,CAAC,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,aAAa,CAAC,eAAe,CAAC,aAAa;AACzK,yBAAyB,kBAAkB,CAAC,yBAAyB,CAAC,mBAAmB,CAAC,qBAAqB,CAAC,WAAW,CAAC,MAAM,CAAC,0BAA0B,CAAC,cAAc;AAC5K,qBAAqB,gBAAgB,CAAC,aAAa,CAAC,wBAAwB,CAAC,iBAAiB;AAC9F,oBAAoB,YAAY,CAAC,8CAA8C,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,+BAA+B;AAC5J,+BAA+B,eAAe;AAC9C,6BAA6B,kBAAkB;AAC/C,kBAAkB,YAAY,CAAC,OAAO,CAAC,sBAAsB,CAAC,cAAc;AAC5E,wBAAwB,cAAc;AACtC,uBAAuB,YAAY,CAAC,YAAM,CAAN,OAAO;AAC3C,oBAAoB,cAAc,CAAC,aAAa;AAChD,wBAAwB,aAAa,CAAC,aAAa;AACnD,0BAA0B,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,aAAa,CAAC,0BAA0B,CAAC,cAAc;AACxI,mCAAmC,kBAAkB,CAAC,aAAa;AACnE,yBAAyB,aAAa,CAAC,wBAAwB,CAAC,iBAAiB;AACjF,oBAAoB,UAAU,CAAC,wBAAwB,CAAC,cAAc;AACtE,uBAAuB,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,+BAA+B,CAAC,aAAa,CAAC,aAAa,CAAC,wBAAwB,CAAC,oBAAoB;AACpL,uBAAuB,gBAAgB,CAAC,+BAA+B,CAAC,aAAa,CAAC,eAAe;AACrG,qCAAqC,eAAe;AACpD,yBAAyB,aAAa;AACtC,sBAAsB,YAAY,CAAC,mCAAmC,CAAC,aAAQ,CAAR,QAAQ,CAAC,eAAe;AAC/F,0BAA0B,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe;AACtH,wBAAwB,cAAc,CAAC,aAAa;AACpD,2BAA2B,aAAa,CAAC,aAAa;AACtD,eAAe,YAAY,CAAC,aAAQ,CAAR,QAAQ,CAAC,YAAY,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB;AAChH,+BAA+B,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,aAAa;AACrF,oCAAoC,YAAY,CAAC,YAAM,CAAN,OAAO;AACxD,iBAAiB,cAAc,CAAC,aAAa;AAC7C,qBAAqB,cAAc,CAAC,aAAa;AACjD,eAAe,YAAY,CAAC,kBAAkB,CAAC,cAAc,CAAC,OAAO;AACrE,oBAAoB,eAAe,CAAC,kBAAkB,CAAC,eAAe,CAAC,wBAAwB,CAAC,aAAa,CAAC,eAAe,CAAC,aAAa;AAC3I,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,gBAAgB,CAAC,eAAe,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,aAAa,CAAC,cAAc;AACjK,cAAc,gBAAgB,CAAC,YAAY,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,OAAO,CAAC,aAAa;AAC3G,MAAM,oCAAoC;AAC1C,mBAAmB,GAAG,wBAAwB,CAAC;AAC/C,sBAAsB,YAAY,CAAC,wBAAwB,CAAC,cAAc;AAC1E;EACE,oCAAoC,yBAAyB;EAC7D,oBAAoB,yBAAyB;EAC7C,sBAAsB,6BAA6B;EACnD,mBAAmB,WAAW;AAChC;;AAEA,4DAA4D;AAC5D;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,cAAc;EACd,aAAa;AACf;AACA,cAAc,cAAc,CAAC,eAAe;AAC5C,mBAAmB,aAAa;AAChC;EACE,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;AACA,iBAAiB,aAAa;AAC9B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA,sBAAsB,kBAAkB;;AAExC,0EAA0E;AAC1E,uBAAuB,gBAAgB;AACvC,iBAAiB,kBAAkB;AACnC;EACE,YAAY;EACZ,sDAAsD;EACtD,aAAQ;EAAR,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;AACA,4BAA4B,aAAa;AACzC,6BAA6B,YAAY,CAAC,YAAM,CAAN,OAAO;AACjD,0BAA0B,cAAc,CAAC,aAAa;AACtD,8BAA8B,aAAa,CAAC,aAAa;AACzD;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;AACA,6CAA6C,YAAY,CAAC,YAAM,CAAN,OAAO;AACjE,qBAAqB,YAAY,CAAC,OAAO,CAAC,cAAc,CAAC,wBAAwB;AACjF;EACE,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA,kCAAkC,yBAAyB;AAC3D;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;AACA,+BAA+B,oBAAoB,CAAC,4BAA4B;AAChF;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,MAAM;EACN,WAAW;EACX,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA,oDAAoD,kBAAkB;AACtE,iEAAiE,kBAAkB;AACnF;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA,sBAAsB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,kBAAkB;AAC7D,wBAAwB,cAAc,CAAC,aAAa;AACpD,2BAA2B,aAAa,CAAC,aAAa;AACtD;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAQ;EAAR,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA,sBAAsB,aAAa,CAAC,YAAY,CAAC,kBAAkB;AACnE,oDAAoD,aAAa;AACjE,yCAAyC,YAAY,CAAC,YAAM,CAAN,OAAO;AAC7D,0BAA0B,cAAc,CAAC,aAAa;AACtD,6BAA6B,cAAc,CAAC,aAAa;AACzD;EACE,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;AACT;;AAEA,iFAAiF;AACjF;EACE,cAAc;EACd,OAAO;EACP,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,QAAQ;AACV;AACA,yBAAyB,YAAY,CAAC,YAAM,CAAN,OAAO;AAC7C;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAQ;EAAR,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;AACA,2BAA2B,YAAY,CAAC,YAAM,CAAN,OAAO;AAC/C,yBAAyB,cAAc,CAAC,aAAa;AACrD,4BAA4B,aAAa,CAAC,aAAa;AACvD;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,wBAAwB,6BAA6B;EACrD,0CAA0C,kBAAkB,CAAC,aAAa,CAAC,4BAA4B,CAAC,gBAAgB;AAC1H;AACA;EACE,wBAAwB,yBAAyB;EACjD,mBAAmB,sBAAsB,CAAC,qBAAqB;EAC/D,qBAAqB,UAAU,CAAC,qBAAqB,CAAC,mBAAmB;EACzE,wBAAwB,iBAAiB;EACzC,uBAAuB,yBAAyB;EAChD,4BAA4B,cAAc;AAC5C;;AAEA,uDAAuD;AACvD;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,WAAW;AACb;AACA,oCAAoC,kBAAkB;AACtD;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,OAAO;EACP,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;;;;;EAKE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,uDAAuD;EACvD,aAAQ;EAAR,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;;;;EAIE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,MAAM;EACN,qBAAqB;EACrB,uCAAuC;EACvC,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;AACA;EACE,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAO;EAAP,OAAO;EACP,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,mDAAmD;EACnD,aAAQ;EAAR,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAQ;EAAR,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,8CAA8C;EAC9C,aAAQ;EAAR,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,YAAO;EAAP,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,OAAO;EACP,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAQ;EAAR,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;;;;IAIE,yBAAyB;EAC3B;EACA;IACE,mCAAmC;EACrC;EACA;;IAEE,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,UAAK;EAAL,KAAK;EACL,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,OAAO;AACT;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,mCAAmC;EACnC,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,6CAA6C;EAC7C,YAAY;EACZ,oBAAe;OAAf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAa;EAAb,aAAa;EACb,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;AACA;;EAEE,aAAa;EACb,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,eAAe;AACjB;AACA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;;;+EAG+E;;AAE/E,yCAAyC;AACzC;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,UAAU;EACV,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,4HAA4H;EAC5H,kBAAkB;EAClB,oBAAe;EAAf,oBAAe;OAAf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAAiC;EAAjC,iCAAiC;EACjC,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;EACd,4BAAiC;EAAjC,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,OAAO;AACT;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,sBAAiB;EAAjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,4BAAiC;EAAjC,iCAAiC;AACnC;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,sHAAsH;EACxH;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,4BAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,aAAQ;EAAR,QAAQ;EACR,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mDAAmD;EACnD,aAAQ;EAAR,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;;+EAE+E;AAC/E,qBAAqB,qBAAqB;AAC1C,gBAAgB,eAAe,CAAC,QAAQ;AACxC,6BAA6B,YAAY;;AAEzC;EACE,WAAW;EACX,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;AACX;AAHA;EACE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,kDAAkD;EAClD,oCAAoC;AACtC;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;;EAEE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAa;EAAb,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;AACA;EACE,YAAY;EACZ,iDAAiD;EACjD,eAAe;EACf,aAAQ;EAAR,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;AACV;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;AACA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;AACV;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAQ;EAAR,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,OAAO;EACP,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAQ;EAAR,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,4BAAiC;EAAjC,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAQ;EAAR,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;;;IAGE,yBAAyB;EAC3B;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;;;+EAG+E;;AAE/E;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,YAAO;EAAP,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mFAAmF;AACnF;EACE;;IAEE,yBAAyB;EAC3B;AACF;;AAEA,8CAA8C;AAC9C;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,QAAQ;EACR,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,OAAO;EACT;EACA,0BAA0B,YAAY,CAAC;AACzC;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,4BAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,aAAQ;EAAR,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,OAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,+BAA+B;EACjC;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,uGAAuG;EACvG,kBAAkB;EAClB,oBAAe;EAAf,oBAAe;OAAf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;;;EAGE,eAAe;EACf,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,4BAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,QAAQ;EACR,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,4BAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,kBAAa;EAAb,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;;;EAGE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,kBAAa;EAAb,aAAa;EACb,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,QAAQ;EACR,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAa;EAAb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAQ;EAAR,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE;;IAEE,mGAAmG;EACrG;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE;;;;IAIE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;;+EAE+E;;AAE/E;;EAEE;;;;;;;QAOM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,sBAAiB;EAAjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAiB;EAAjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE;;;;;;;UAOM;EACR;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAa;EAAb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,aAAQ;EAAR,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAQ;EAAR,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iEAAiE;EACjE,aAAQ;EAAR,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,OAAO;AACT;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,OAAO;EACP,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,aAAQ;EAAR,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,aAAQ;EAAR,QAAQ;AACV;;AAEA;;;EAGE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;;;EAGE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;EAKE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,sBAAiB;EAAjB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAa;EAAb,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,aAAQ;EAAR,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,YAAO;EAAP,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAiB;EAAjB,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,KAAK;EACL,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;;IAGE,yBAAyB;EAC3B;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,6CAA6C;EAC7C,YAAO;EAAP,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,6CAA6C;EAC/C;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,oBAAoB;EACpB,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;;;AAGA,sCAAsC;AACtC;EACE,cAAc;EACd,OAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,OAAO;AACT;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,GAAG,wBAAwB,CAAC;AAC9B;;AAEA,qCAAqC;AACrC,4BAA4B,eAAe;AAC3C,2BAA2B,sBAAsB,CAAC,QAAQ;AAC1D,wBAAwB,kBAAkB;AAC1C,2BAA2B,YAAY,CAAC,qBAAqB,CAAC,QAAQ;AACtE,4BAA4B,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB;AACnL,gCAAgC,YAAY,CAAC,qBAAqB,CAAC,OAAO;AAC1E,8BAA8B,cAAc,CAAC,aAAa;AAC1D,iCAAiC,cAAc,CAAC,aAAa;AAC7D,2BAA2B,aAAa,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,uBAAuB,CAAC,eAAe,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB;AAClM,2BAA2B,YAAY,CAAC,6CAA6C,CAAC,kBAAY,CAAZ,aAAa;AACnG,iCAAiC,YAAY,CAAC,qBAAqB,CAAC,OAAO,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AACxH,0CAA0C,gBAAgB;AAC1D,qEAAqE,UAAU,CAAC,qBAAqB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,aAAa,CAAC,YAAY,CAAC,eAAe,CAAC,iBAAiB,CAAC,YAAY;AAC1O,iFAAiF,oBAAoB,CAAC,yCAAyC;AAC/I,oCAAoC,eAAe,CAAC,eAAe;AACnE,0BAA0B,YAAY,CAAC,sBAAsB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,eAAe;AAClL,gCAAgC,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AACpH,gCAAgC,aAAa,CAAC,aAAa,CAAC,gBAAgB,CAAC,gBAAgB;AAC7F,8BAA8B,iBAAiB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc;AACjH,wBAAwB,2BAA2B,yBAAyB,CAAC,0CAA0C,gBAAgB,CAAC,sDAAsD,sBAAsB,CAAC,qBAAqB,CAAC,2DAA2D,cAAc,CAAC,eAAe,CAAC;;AAErU,8CAA8C;AAC9C,yBAAyB,0BAA0B;AACnD,0BAA0B,YAAY,CAAC,wCAAwC,CAAC,aAAQ,CAAR,QAAQ,CAAC,mBAAmB;AAC5G,gCAAgC,WAAW;AAC3C,kDAAkD,eAAe,CAAC,iBAAiB,CAAC,kBAAkB;AACtG,sBAAsB,wBAAwB,CAAC,yBAAyB,CAAC,gBAAgB,CAAC,uBAAuB;AACjH,4BAA4B,uBAAuB;AACnD,wBAAwB,aAAa;AACrC,yDAAyD,gBAAgB,CAAC,eAAe;AACzF,sCAAsC,kBAAkB,CAAC,aAAa,CAAC,wBAAwB;AAC/F,oCAAoC,kBAAkB,CAAC,aAAa,CAAC,wBAAwB;AAC7F,mCAAmC,kBAAkB,CAAC,aAAa,CAAC,wBAAwB;AAC5F,wBAAwB,0BAA0B,yBAAyB,CAAC,kDAAkD,UAAU,CAAC;;AAEzI,8BAA8B;AAC9B,mBAAmB,sBAAsB;AACzC,wDAAwD,cAAc;AACtE,uBAAuB,YAAY,CAAC,wDAAwD,CAAC,aAAO,CAAP,QAAQ;AACrG,uBAAuB,wBAAwB,CAAC,kBAAkB,CAAC,YAAY,CAAC,eAAe,CAAC,YAAY,CAAC,qBAAqB,CAAC,QAAQ,CAAC,gBAAgB;AAC5J,gCAAgC,wCAAwC,CAAC,oBAAoB;AAC7F,yBAAyB,cAAc,CAAC,eAAe,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,aAAa;AACnH,0BAA0B,QAAQ,CAAC,aAAa,CAAC,cAAc;AAC/D,wBAAwB,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,eAAe;AACpF,8BAA8B,cAAc,CAAC,eAAe,CAAC,aAAa;AAC1E,yBAAyB,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe;AACpG,0BAA0B,YAAY,CAAC,OAAO,CAAC,sBAAsB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe;AAClH,8BAA8B,aAAa,CAAC,aAAa,CAAC,cAAc;AACxE,8BAA8B,eAAe,CAAC,sBAAsB;AACpE,eAAe,YAAY,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,iBAAiB;AACvH,gBAAgB,YAAY,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,eAAe;AACxF,oBAAoB,YAAY,CAAC,uDAAuD,CAAC,aAAQ,CAAR,QAAQ,CAAC,iBAAiB,CAAC,4BAA4B,CAAC,kBAAkB,CAAC,cAAc,CAAC,aAAa;AAChM,gCAAgC,YAAY;AAC5C,qBAAqB,eAAe,CAAC,aAAa,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,cAAc,CAAC,oBAAoB;AAClI,2BAA2B,eAAe,CAAC,aAAa;AACxD,oCAAoC,aAAa;AACjD,oBAAoB,kBAAkB;AACtC,wBAAwB,oBAAoB,wCAAwC,CAAC,uBAAuB,yBAAyB,CAAC;;AAEtI,8BAA8B;AAC9B,sBAAsB,YAAY,CAAC,6CAA6C,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,eAAe,CAAC,eAAe,CAAC,eAAe,CAAC,sCAAsC;AACnN,qBAAqB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,iBAAiB,CAAC,6BAA6B;AAC7G,iCAAiC,aAAa;AAC9C,qBAAqB,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,YAAY,CAAC,kBAAkB,CAAC,aAAa;AAC7I,0BAA0B,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC,eAAe,CAAC,iBAAiB;AACpK,4BAA4B,aAAa,CAAC,cAAc,CAAC,aAAa,CAAC,eAAe;AACtF,sBAAsB,kBAAkB;AACxC,mBAAmB,YAAY,CAAC,6CAA6C,CAAC,aAAO,CAAP,QAAQ;AACtF,mBAAmB,wBAAwB,CAAC,kBAAkB,CAAC,YAAY,CAAC,eAAe,CAAC,YAAY,CAAC,qBAAqB,CAAC,gBAAgB;AAC/I,8BAA8B,4BAA4B;AAC1D,gCAAgC,4BAA4B;AAC5D,kBAAkB,YAAY,CAAC,6BAA6B,CAAC,QAAQ,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,+BAA+B;AAChJ,sBAAsB,cAAc,CAAC,gBAAgB,CAAC,aAAa;AACnE,qBAAqB,cAAc,CAAC,aAAa,CAAC,eAAe,CAAC,QAAQ,CAAC,eAAe;AAC1F,oBAAoB,gBAAgB,CAAC,kBAAkB;AACvD,2BAA2B,aAAa,CAAC,aAAa,CAAC,cAAc,CAAC,gBAAgB;AACtF,yBAAyB,aAAa,CAAC,aAAa,CAAC,cAAc,CAAC,cAAc,CAAC,wBAAwB,CAAC,eAAe,CAAC,oBAAoB;AAChJ,uBAAuB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,cAAc,CAAC,aAAa,CAAC,cAAc;AACvF,2BAA2B,YAAY,CAAC,sBAAsB,CAAC,OAAO;AACtE,2BAA2B,aAAa,CAAC,aAAa,CAAC,cAAc;AACrE,uBAAuB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,eAAe,CAAC,kBAAkB;AAC9E,4BAA4B,cAAc,CAAC,eAAe,CAAC,aAAa;AACxE,8BAA8B,UAAU,CAAC,WAAW,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,YAAY,CAAC,cAAc;AACxK,oCAAoC,YAAY,CAAC,oBAAoB,CAAC,yCAAyC;AAC/G,qBAAqB,UAAU,CAAC,sBAAsB,CAAC,OAAO,CAAC,eAAe,CAAC,eAAe;AAC9F,qDAAqD,YAAY;AACjE,uBAAuB,YAAY,CAAC,YAAY;AAChD,wBAAwB,YAAY,CAAC,0DAA0D,CAAC,aAAQ,CAAR,QAAQ,CAAC,iBAAiB;AAC1H,uBAAuB,kBAAkB;AACzC,qBAAqB,YAAY,CAAC,mCAAmC,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,sBAAsB;AACxH,wBAAwB,cAAc,CAAC,aAAa,CAAC,cAAc;AACnE,uBAAuB,QAAQ,CAAC,aAAa,CAAC,cAAc,CAAC,gBAAgB;AAC7E,sBAAsB,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,YAAY,CAAC,kBAAkB;AAChI,kDAAkD,sEAAsE;AACxH,yBAAyB,2CAA2C,yBAAyB,CAAC,mBAAmB,YAAY,CAAC,sBAAsB,yBAAyB,CAAC,qBAAqB,aAAa,CAAC,4BAA4B,CAAC,iCAAiC,YAAY,CAAC,kBAAkB,qBAAqB,CAAC,oBAAoB,eAAe,CAAC,qBAAqB,8BAA8B,CAAC,mCAAmC,gBAAgB,CAAC,kBAAkB,CAAC;;AAEne,2BAA2B,YAAY,CAAC,6BAA6B,CAAC,aAAQ,CAAR,QAAQ,CAAC,aAAa,CAAC,iCAAiC,YAAY,CAAC,sBAAsB,CAAC,QAAQ,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc,CAAC,0CAA0C,oBAAoB,CAAC,kBAAkB,CAAC,kCAAkC,CAAC,0CAA0C,WAAW,CAAC,kBAAkB,CAAC,iCAAiC,cAAc,CAAC,gCAAgC,YAAY,CAAC,qBAAqB,CAAC,OAAO,CAAC,6BAA6B,cAAc,CAAC,aAAa,CAAC,iCAAiC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,wBAAwB,2BAA2B,yBAAyB,CAAC;;AAEtxB;;uCAEuC;AACvC;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA,kBAAkB,cAAc,CAAC,OAAO,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,YAAY,CAAC,4BAA4B,CAAC,yBAAyB;AACxJ,eAAe,mCAAmC,CAAC,eAAe,CAAC,iCAAiC,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,eAAe;AAChL,eAAe,sBAAsB,CAAC,+CAA+C;AACrF,oBAAoB,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,oBAAoB,CAAC,iBAAiB;AAC5H,kBAAkB,QAAQ,CAAC,cAAc;AACzC,eAAe,iBAAiB,CAAC,iBAAiB,eAAe,CAAC,cAAc,CAAC,eAAe,CAAC,qBAAqB,aAAa,CAAC,eAAe,CAAC,0BAA0B,CAAC,cAAc,CAAC,gBAAgB;AAC9M,gBAAgB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,iBAAiB,CAAC,kCAAkC,CAAC,wCAAwC,CAAC,iBAAiB,CAAC,qBAAqB,cAAc,CAAC,4BAA4B,WAAW,CAAC,uBAAuB,CAAC,eAAe,CAAC,gBAAgB;AACzR,kBAAkB,YAAY,CAAC,wBAAwB,CAAC,OAAO,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,4CAA4C;;AAEjJ,wEAAwE;AACxE,sBAAsB,iBAAiB,CAAC,aAAa;AACrD,yBAAyB,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,OAAO,CAAC,eAAe,CAAC,cAAc,CAAC,cAAc,CAAC,eAAe;AAC5J,2BAA2B,iBAAiB,CAAC,UAAU,CAAC,OAAO,CAAC,oBAAoB,CAAC,WAAW,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,wCAAwC,CAAC,WAAW;AACjN,4BAA4B,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,qBAAqB;AAC9F,kCAAkC,YAAY,CAAC,kBAAkB,CAAC,eAAe,CAAC,UAAU,CAAC,QAAQ,CAAC,QAAQ,CAAC,iBAAiB,CAAC,sBAAsB,CAAC,gBAAgB,CAAC,cAAc,CAAC,aAAa;AACrM,wCAAwC,kBAAkB;AAC1D,kDAAkD,YAAY,CAAC,YAAM,CAAN,OAAO;AACtE,6BAA6B,cAAc;AAC3C,iCAAiC,cAAc,CAAC,aAAa;AAC7D,yBAAyB,4BAA4B,CAAC,cAAc,CAAC,YAAY,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AAC9H,uBAAuB,UAAU,CAAC,eAAe;AACjD,8CAA8C,YAAY,CAAC,0HAA0H,CAAC,aAAQ,CAAR,QAAQ,CAAC,kBAAkB,CAAC,eAAe,CAAC,iBAAiB,CAAC,kBAAkB;AACtQ,uBAAuB,gBAAgB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,+BAA+B,CAAC,aAAa,CAAC,wBAAwB,CAAC,cAAc,CAAC,eAAe,CAAC,qBAAqB;AAC1M,uBAAuB,gBAAgB,CAAC,mBAAmB;AAC3D,sBAAsB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,WAAW;AAC1E,wBAAwB,cAAc,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,aAAa;AAC9G,uCAAuC,aAAa;AACpD,2BAA2B,kBAAkB,CAAC,aAAa;AAC3D,iCAAiC,kBAAkB,CAAC,aAAa;AACjE,uBAAuB,mBAAmB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,kBAAkB;AAC/J,uCAAuC,aAAa,CAAC,kBAAkB;AACvE,sBAAsB,YAAY,CAAC,qBAAqB,CAAC,OAAO,CAAC,gBAAgB,CAAC,eAAe,CAAC,aAAa;AAC/G,4BAA4B,cAAc,CAAC,eAAe,CAAC,aAAa;AACxE,qBAAqB,WAAW,CAAC,eAAe,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,cAAc,CAAC,aAAa;AACvH,oCAAoC,mBAAmB;AACvD,8CAA8C,YAAY,CAAC,kBAAkB;AAC7E,+CAA+C,wBAAwB;AACvE,wBAAwB,uBAAuB,0HAA0H,CAAC,8CAA8C,YAAY,CAAC;;AAErO,kFAAkF;AAClF,0BAA0B,kBAAkB,CAAC,aAAa;;AAE1D;8EAC8E;AAC9E;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA,qCAAqC,gBAAgB,EAAE;AACvD,oCAAoC,QAAQ,EAAE;AAC9C;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,uCAAuC;AACzC;AACA,kCAAkC,YAAY,EAAE;AAChD;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,cAAc;AAChB;AACA,qCAAqC,kBAAkB,EAAE;AACzD,wCAAwC,eAAe,EAAE;AACzD;wCACwC,YAAY,EAAE;AACtD;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA,gCAAgC,eAAe,EAAE,kBAAkB,EAAE;AACrE,+BAA+B,eAAe,EAAE,iBAAiB,EAAE;AACnE;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;AACA,sCAAsC,eAAe,EAAE,kBAAkB,EAAE;AAC3E,qCAAqC,eAAe,EAAE,iBAAiB,EAAE;AACzE;EACE,6BAA6B,0BAA0B,EAAE;EACzD,oCAAoC,aAAa,EAAE;AACrD;AACA;EACE,4BAA4B,aAAa,EAAE,SAAS,EAAE;EACtD;0CACwC,8CAA8C,EAAE;AAC1F;AACA;EACE,6BAA6B,aAAa,EAAE;EAC5C,gCAAgC,eAAe,EAAE;EACjD;0CACwC,0BAA0B,EAAE;AACtE;;;AAGA,kFAAkF;AAClF,iCAAiC,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACvF,qCAAqC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxF,mBAAmB,YAAY,EAAE,aAAa,EAAE;AAChD,iCAAiC,uBAAuB,EAAE,QAAQ,EAAE;AACpE,mCAAmC,eAAe,EAAE,gBAAgB,EAAE;AACtE,sCAAsC,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAClG,0BAA0B,gBAAgB,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACpI,6EAA6E,0BAA0B,EAAE,mBAAmB,EAAE;AAC9H,gCAAgC,iCAAiC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAExG,sDAAsD;AACtD;6BAC6B,cAAc,EAAE,aAAa,EAAE;AAC5D,mBAAmB,WAAW,EAAE,4BAA4B,EAAE;AAC9D,kCAAkC,cAAc,EAAE,gBAAgB;AAClE,qCAAqC,cAAc,EAAE,eAAe;AACpE;sCACsC,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;AACxF,6BAA6B,WAAW,EAAE,4BAA4B,EAAE,YAAY,EAAE;AACtF,8BAA8B,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACtF,+BAA+B,cAAc,EAAE;AAC/C,mCAAmC,cAAc,EAAE,gBAAgB,EAAE;AACrE,2BAA2B,cAAc,EAAE,gBAAgB,EAAE;AAC7D,oDAAoD,yBAAyB,EAAE,mBAAmB,EAAE;;AAEpG;;qDAEqD;AACrD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,eAA6B;EAA7B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,+BAA+B,eAAe,EAAE,gBAAgB,EAAE;AAClE;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA,0BAA0B,8BAA8B,EAAE;AAC1D,8BAA8B,8BAA8B,EAAE;AAC9D,gDAAgD,iBAAiB,EAAE;AACnE,gCAAgC,eAAe,EAAE,iBAAiB,EAAE;AACpE;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA,4BAA4B,eAAe,EAAE,gBAAgB,EAAE;AAC/D;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,QAAQ;AACV;AACA;;;EAGE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;0BAC0B,8BAA8B,EAAE,gBAAgB,EAAE;AAC5E;;EAEE,6BAA6B;EAC7B,wCAAwC;EACxC,gBAAgB;AAClB;AACA;;uBAEuB,6BAA6B,EAAE,iBAAiB,EAAE;AACzE;EACE,6BAA6B;AAC/B;AACA;;;EAGE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA,oCAAoC,sBAAsB,EAAE;AAC5D;qCACqC,6BAA6B,EAAE;AACpE;wCACwC,6BAA6B,EAAE;AACvE;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA,8BAA8B,YAAY,EAAE,6BAA6B,EAAE;AAC3E,4CAA4C,kBAAkB,EAAE;AAChE;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA,qDAAqD,eAAe,EAAE,iBAAiB,EAAE;AACzF,6BAA6B,8BAA8B,EAAE;AAC7D,mCAAmC,gCAAgC,EAAE;AACrE,+BAA+B,gCAAgC,EAAE;AACjE;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA,0BAA0B,0BAA0B,EAAE,gBAAgB,EAAE;AACxE,0BAA0B,8BAA8B,EAAE;AAC1D,+BAA+B,6BAA6B,EAAE;AAC9D,4BAA4B,8BAA8B,EAAE;AAC5D;EACE,6BAA6B;AAC/B;AACA;EACE,gDAAgD,aAAa,EAAE;EAC/D,2BAA2B,eAAe,EAAE;EAC5C,6CAA6C,gBAAgB,EAAE;AACjE;;AAEA,0DAA0D;AAC1D,sBAAsB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,cAAc,CAAC,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB;AAC9K,0BAA0B,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,WAAW;AAC5F,0BAA0B,aAAa,CAAC,aAAa;AACrD,2BAA2B,aAAa;AACxC,6BAA6B,aAAa,CAAC,cAAc;AACzD,8CAA8C,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,cAAc,CAAC,iBAAiB;AACrJ,iDAAiD,cAAc,CAAC,cAAc;AAC9E,gDAAgD,cAAc,CAAC,eAAe,CAAC,QAAQ;AACvF,yBAAyB,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,WAAW,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa;AAChK,gCAAgC,uBAAe,CAAf,oBAAe,CAAf,eAAe,CAAC,QAAQ,CAAC,iBAAiB,CAAC,sBAAsB,CAAC,aAAa,CAAC,gBAAgB,CAAC,cAAc,CAAC,eAAe,CAAC,cAAc;AAC9K,yCAAyC,eAAe,CAAC,aAAa,CAAC,sCAAsC;AAC7G,8CAA8C,yBAAyB,CAAC,kBAAkB;AAC1F,qCAAqC,aAAa,CAAC,cAAc,CAAC,eAAe;AACjF,gDAAgD,6CAA6C,CAAC,QAAQ,CAAC,sBAAsB;AAC7H,8CAA8C,YAAY,CAAC,YAAY,CAAC,KAAK,CAAC,4BAA4B;AAC1G,4CAA4C,YAAY,CAAC,QAAQ,CAAC,sBAAsB,CAAC,6BAA6B;AACtH,+CAA+C,cAAc,CAAC,cAAc;AAC5E,8CAA8C,cAAc,CAAC,eAAe,CAAC,eAAe;AAC5F,mBAAmB,mBAAmB,CAAC,OAAO,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,aAAa,CAAC,eAAe,CAAC,kBAAkB,CAAC,cAAc,CAAC,eAAe;AACvL,yCAAyC,eAAe,CAAC,YAAY,CAAC,oBAAoB,CAAC,OAAO,CAAC,iBAAiB;AACpH,gDAAgD,cAAc,CAAC,eAAe;AAC9E,8CAA8C,cAAc,CAAC,mBAAmB,CAAC,gBAAgB;AACjG,0CAA0C,cAAc,CAAC,aAAa,CAAC,cAAc;AACrF,4CAA4C,cAAc,CAAC,QAAQ,CAAC,mBAAmB,CAAC,cAAc,CAAC,4BAA4B;AACnI,0CAA0C,eAAe,CAAC,eAAe;AACzE,2CAA2C,mBAAmB,CAAC,cAAc,CAAC,aAAa;AAC3F,wBAAwB,gDAAgD,yBAAyB,CAAC,8CAA8C,sBAAsB,CAAC,8CAA8C,YAAY,CAAC;;AAElO,2FAA2F;AAC3F,gDAAgD,iBAAiB,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,kDAAkD,cAAc,EAAE;AAClE,yBAAyB,YAAY,CAAC,cAAc,CAAC,kBAAkB,CAAC,aAAa,CAAC,qBAAqB,CAAC,aAAa,CAAC,cAAc,EAAE;AAC1I,yBAAyB,cAAc,CAAC,eAAe,CAAC,qBAAqB,CAAC,wBAAwB,CAAC,aAAa,CAAC;AACrH,yDAAyD,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC;AACxG,4BAA4B,aAAa,CAAC,aAAa,CAAC;AACxD,iDAAiD,sBAAsB,CAAC,QAAQ,CAAC,mBAAmB,CAAC;AACrG,+CAA+C,sBAAsB,CAAC,sBAAsB,CAAC,wBAAwB,CAAC,4BAA4B,CAAC,KAAK,CAAC,eAAe,CAAC;AACzK,sDAAsD,yDAAyD,CAAC,oBAAoB,CAAC,4BAA4B,CAAC;AAClK,6CAA6C,kBAAkB,CAAC,cAAc,CAAC;AAC/E,uBAAuB,cAAc,CAAC,oBAAoB,CAAC,eAAe,CAAC,aAAa,CAAC;AACzF,kDAAkD,aAAa,CAAC;AAChE,yBAAyB,cAAc,CAAC,cAAc,CAAC;AACvD,oEAAoE,cAAc,CAAC,gBAAgB,CAAC,YAAY,CAAC,QAAQ,CAAC,cAAc,CAAC;AACzI,0CAA0C,eAAe,CAAC;AAC1D,gDAAgD,cAAc,CAAC,sBAAsB,CAAC;AACtF,sEAAsE,cAAc,CAAC,aAAa,CAAC,iBAAiB,CAAC;AACrH,yBAAyB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,4BAA4B,CAAC,mBAAmB,CAAC,aAAa,CAAC,cAAc,CAAC;AAC5H,6BAA6B,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC;AACrE,6BAA6B,aAAa,CAAC,aAAa,CAAC;AACzD,mEAAmE,eAAe,CAAC,eAAe,CAAC,UAAU,CAAC,sBAAsB,CAAC;AACrI,yFAAyF,kBAAkB,CAAC;AAC5G,4EAA4E,WAAW,CAAC,kBAAkB,CAAC;AAC3G,sEAAsE,cAAc,CAAC,iBAAiB,CAAC,cAAc,CAAC,aAAa,CAAC;AACpI,0BAA0B,eAAe,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,iBAAiB,CAAC,cAAc,CAAC;AAChJ,2CAA2C,mBAAmB,CAAC,cAAc,CAAC;AAC9E,yBAAyB,uBAAuB,YAAY,CAAC,CAAC,gDAAgD,yBAAyB,CAAC,CAAC;;AAEzI,mEAAmE;AACnE,OAAO,gBAAgB,CAAC,aAAa,CAAC,aAAa,CAAC,cAAc;AAClE,kBAAkB,kBAAkB;AACpC,oBAAoB,cAAc;AAClC,WAAW,YAAY,CAAC,oDAAoD,CAAC,aAAQ,CAAR,QAAQ,CAAC,iBAAiB;AACvG,SAAS,WAAW,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,sCAAsC,CAAC,eAAe;AACvI,cAAc,YAAY,CAAC,6BAA6B,CAAC,sBAAsB,CAAC,QAAQ,CAAC,iBAAiB,CAAC,+BAA+B;AAC1I,iBAAiB,cAAc,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AAC5E,gBAAgB,QAAQ,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AACrE,iBAAiB,iBAAiB;AAClC,QAAQ,aAAa,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,wBAAwB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,yBAAyB;AAC3O,aAAa,kBAAkB,CAAC,oBAAoB,CAAC,aAAa;AAClE,UAAU,YAAY,CAAC,qBAAqB,CAAC,OAAO,CAAC,WAAW;AAChE,gBAAgB,cAAc,CAAC,eAAe,CAAC,aAAa;AAC5D,+CAA+C,UAAU,CAAC,WAAW,CAAC,WAAW,CAAC,iBAAiB,CAAC,wBAAwB,CAAC,gBAAgB,CAAC,aAAa,CAAC,cAAc,CAAC,cAAc;AACzL,0DAA0D,yBAAyB,CAAC,kBAAkB,CAAC,oBAAoB;AAC3H,cAAc,cAAc,CAAC,aAAa,CAAC,kBAAkB,CAAC,sBAAsB;AACpF,qBAAqB,aAAa,CAAC,eAAe;AAClD,SAAS,YAAY,CAAC,aAAO,CAAP,QAAQ;AAC9B,iBAAiB,YAAY,CAAC,0BAA0B,CAAC,eAAe;AACxE,wCAAwC,eAAe,CAAC,gBAAgB,CAAC,cAAc,CAAC,iBAAiB;AACzG,cAAc,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,kBAAkB;AACzH,eAAe,MAAM,CAAC,UAAU,CAAC,eAAe,CAAC,kBAAkB,CAAC,mBAAmB;AACvF,oBAAoB,aAAa,CAAC,WAAW,CAAC,kBAAkB,CAAC,mBAAmB;AACpF,YAAY,wBAAwB,CAAC,iBAAiB,CAAC,eAAe;AACtE,WAAW,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,iBAAiB,CAAC,WAAW;AACjF,sBAAsB,4BAA4B;AAClD,kBAAkB,YAAY,CAAC,kBAAkB,CAAC,aAAa,CAAC,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,eAAe;AACzJ,mBAAmB,YAAY,CAAC,YAAO,CAAP,OAAO,CAAC,MAAM,CAAC,WAAW;AAC1D,0BAA0B,cAAc,CAAC,sBAAsB;AAC/D,wBAAwB,cAAc,CAAC,aAAa,CAAC,sBAAsB;AAC3E,SAAS,yBAAyB,CAAC,aAAa,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,eAAe,CAAC,cAAc,CAAC,eAAe;AACtI,yCAAyC,eAAe,CAAC,gBAAgB,CAAC,4BAA4B;AACtG,6BAA6B,cAAc,CAAC,cAAc;AAC1D,iCAAiC,eAAe,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa;AAC7F,yBAAyB,cAAc;AACvC,oBAAoB,cAAc;AAClC,8BAA8B,YAAY,CAAC,eAAe,CAAC,QAAQ;AACnE,kDAAkD,MAAM;AACxD,SAAS,eAAe;AACxB,uBAAuB,eAAe,CAAC,kBAAkB;AACzD,cAAc,qBAAqB,CAAC,eAAe;AACnD,gBAAgB,eAAe,CAAC,YAAY,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,kBAAkB;AAC1G,kBAAkB,iBAAiB,CAAC,aAAa,CAAC,cAAc;AAChE,aAAa,YAAY,CAAC,QAAQ,CAAC,kBAAkB,CAAC,cAAc,CAAC,kBAAkB,eAAe,CAAC,wBAAwB,CAAC,WAAW,CAAC,iBAAiB,CAAC,cAAc,CAAC,sBAAsB;AACnM,gBAAgB,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,QAAQ,CAAC,aAAa,CAAC,+BAA+B,CAAC,cAAc;AACnJ,WAAW,iBAAiB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,cAAc,CAAC,UAAU,kBAAkB,CAAC,aAAa,CAAC,wBAAwB,CAAC,YAAY,kBAAkB,CAAC,aAAa,CAAC,wBAAwB;AAC1N,UAAU,cAAc,CAAC,aAAa;AACtC,wBAAwB,WAAW,yBAAyB,CAAC;AAC7D,wBAAwB,cAAc,YAAY,CAAC,iBAAiB,YAAY,CAAC,8BAA8B,qBAAqB,CAAC,mBAAmB,CAAC,cAAc,qBAAqB,CAAC,WAAW,cAAc,CAAC,SAAS,gBAAgB,CAAC;;AAEjP,kCAAkC;AAClC,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,kBAAkB;AACxH,wBAAwB,wBAAwB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,aAAa,CAAC,eAAe,CAAC,cAAc,CAAC,eAAe;;AAEhJ,kFAAkF;AAClF,mCAAmC,iBAAiB,CAAC,iBAAiB,CAAC,eAAe,CAAC,sEAAsE,CAAC,wBAAwB,CAAC,0CAA0C,CAAC,iBAAiB,CAAC,wDAAwD,CAAC,QAAQ;AACrT,0CAA0C,UAAU,CAAC,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC,YAAY,CAAC,UAAU,CAAC,gFAAgF;AACrO,yCAAyC,UAAU,CAAC,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,iBAAiB,CAAC,QAAQ,CAAC,aAAa,CAAC,uEAAuE;AAC1N,sCAAsC,UAAU,CAAC,iCAAiC,CAAC,gBAAgB,CAAC,eAAe,CAAC,kBAAkB,CAAC,sBAAsB;AAC7J,sCAAsC,aAAa;AACnD,qCAAqC,aAAa,CAAC,cAAc,CAAC,gBAAgB,CAAC,eAAe;AAClG,8BAA8B,mBAAmB,CAAC,OAAO,CAAC,kBAAkB,CAAC,aAAa,CAAC,qBAAqB;AAChH,sDAAsD,eAAe,CAAC,QAAQ;AAC9E,+CAA+C,eAAe,CAAC,aAAa,CAAC,iBAAiB,CAAC,qCAAqC,CAAC,eAAe;AACpJ,qDAAqD,kBAAkB,CAAC,aAAa;AACrF,iDAAiD,gCAAgC,CAAC,sCAAsC,CAAC,UAAU;AACnI,uDAAuD,+BAA+B;AACtF,qCAAqC,gCAAgC,CAAC,sCAAsC,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,KAAK,CAAC,wCAAwC,CAAC,yBAAyB;AAC1N,qCAAqC,kBAAkB,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO;AACjL,iCAAiC,SAAS,CAAC,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,0CAA0C;AACrI,qDAAqD,UAAU,CAAC,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,gCAAgC,CAAC,qCAAqC,CAAC,uCAAuC,CAAC,cAAc,CAAC,aAAa,CAAC,QAAQ;AACvR,kDAAkD,YAAY,CAAC,YAAM,CAAN,OAAO;AACtE,sCAAsC,cAAc,CAAC,aAAa,CAAC,eAAe;AAClF,4DAA4D,kBAAkB,CAAC,oBAAoB;AACnG,4DAA4D,kBAAkB,CAAC,oBAAoB;AACnG,gCAAgC,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,aAAa;AACtH,qCAAqC,kBAAkB,CAAC,aAAa,CAAC,sCAAsC,kBAAkB,CAAC,aAAa,CAAC,wCAAwC,kBAAkB,CAAC,aAAa;AACrN,qDAAqD,WAAW,CAAC,SAAS,CAAC,2CAA2C;AACtH,mCAAmC,gBAAgB,CAAC,uBAAuB;AAC3E,sCAAsC,cAAc,CAAC,sBAAsB;AAC3E,4BAA4B,OAAO;AACnC,2BAA2B,iBAAiB,CAAC,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,0CAA0C,CAAC,iBAAiB,CAAC,QAAQ;AAC/L,kCAAkC,kBAAkB,CAAC,aAAa,CAAC,kBAAkB,CAAC,eAAe;AACrG,0DAA0D,kBAAkB,CAAC,aAAa;AAC1F,0DAA0D,kBAAkB,CAAC,aAAa;AAC1F,0DAA0D,kBAAkB,CAAC,aAAa;AAC1F,sCAAsC,QAAQ;AAC9C,iCAAiC,iBAAiB,CAAC,eAAe,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,0CAA0C,CAAC,YAAY,CAAC,oBAAe,CAAf,eAAe,CAAC,wCAAwC;AAChP,wCAAwC,UAAU,CAAC,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC,OAAO,CAAC,UAAU,CAAC,kBAAmC,CAAnC,oCAAoC;AACzI,sCAAsC,WAAW,CAAC,UAAU,CAAC,kBAAkB,CAAC,kBAAgC,CAAhC,gCAAgC,CAAC,aAA8B,CAA9B,+BAA+B;AAChJ,0CAA0C,oBAAoB,CAAC,gBAAgB;AAC/E,0CAA0C,oBAAoB,CAAC,gBAAgB;AAC/E,yCAAyC,oBAAoB,CAAC,gBAAgB;AAC9E,4CAA4C,oBAAoB,CAAC,gBAAgB;AACjF,oCAAoC,cAAc,CAAC,gBAAgB;AACnE,mCAAmC,cAAc,CAAC,gBAAgB;AAClE,yBAAyB,mCAAmC,yBAAyB,CAAC,CAAC,qCAAqC,YAAY,CAAC;AACzI,wBAAwB,mCAAmC,iBAAiB,CAAC,sCAAsC,cAAc,CAAC,sDAAsD,cAAc,CAAC;;AAEvM;2EAC2E;AAC3E;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC,yBAAyB,YAAY,CAAC,QAAQ,CAAC,kBAAkB,CAAC,cAAc;AAChF,wBAAwB,YAAY,CAAC,OAAO,CAAC,kBAAkB,CAAC,aAAa,CAAC,eAAe,CAAC,cAAc;AAC5G,+BAA+B,wBAAwB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,eAAe,CAAC,aAAa,CAAC,YAAY,CAAC,cAAc;AACpJ,6CAA6C,yBAAyB,CAAC,kBAAkB","sourcesContent":["*{box-sizing:border-box}html,body,#root{margin:0;min-height:100%;font-family:var(--pa-font);color:var(--pa-text);background:var(--pa-canvas)}button,input,select{font:inherit}button{cursor:pointer}button:disabled{cursor:not-allowed;opacity:.55}a{color:inherit}.saas-root{min-height:100vh;display:grid;grid-template-columns:240px minmax(0,1fr)}.saas-sidebar{position:fixed;inset:0 auto 0 0;width:240px;background:var(--pa-surface);border-right:1px solid var(--pa-border);display:flex;flex-direction:column;z-index:10}.saas-brand{height:66px;display:flex;align-items:center;gap:11px;padding:0 18px;border-bottom:1px solid var(--pa-border-subtle)}.saas-logo{width:34px;height:34px;border-radius:9px;background:var(--pa-blue);color:#fff;display:grid;place-items:center;font-weight:800;font-size:18px}.saas-logo.large{width:42px;height:42px;border-radius:11px;font-size:22px}.saas-brand-title{font-weight:760;font-size:15px}.saas-brand-sub{font-size:11px;color:var(--pa-text-muted);margin-top:2px}.saas-nav{padding:12px 10px;display:grid;gap:3px}.saas-nav-item{border:0;background:transparent;border-radius:7px;padding:9px 10px;display:flex;gap:10px;align-items:center;text-align:left;color:var(--pa-text-subtle);font-weight:600;font-size:13px}.saas-nav-item:hover{background:var(--pa-surface-muted)}.saas-nav-item.active{background:var(--pa-blue-soft);color:var(--pa-blue)}.saas-nav-icon{width:20px;text-align:center;font-weight:800}.saas-sidebar-foot{margin-top:auto;padding:14px;border-top:1px solid var(--pa-border-subtle)}.saas-env{display:inline-block;font-size:10px;font-weight:700;color:var(--pa-text-muted);background:var(--pa-surface-muted);border:1px solid var(--pa-border);border-radius:999px;padding:4px 7px;margin-bottom:12px}.saas-user{display:flex;align-items:center;gap:9px;margin-bottom:8px}.saas-avatar{width:30px;height:30px;border-radius:50%;display:grid;place-items:center;background:var(--pa-blue-soft);color:var(--pa-blue);font-weight:800}.saas-user-meta{display:grid;min-width:0}.saas-user-meta b{font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.saas-user-meta span{font-size:10px;color:var(--pa-text-muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pa-link-button{border:0;background:transparent;padding:3px 0;color:var(--pa-blue);font-size:11px;font-weight:650}.saas-content{grid-column:2;min-width:0}.saas-topbar{height:58px;position:sticky;top:0;z-index:8;background:rgba(255,255,255,.96);backdrop-filter:blur(8px);border-bottom:1px solid var(--pa-border);display:flex;align-items:center;justify-content:space-between;padding:0 26px;font-size:13px}.saas-topbar>div:first-child{display:flex;align-items:center;gap:9px}.saas-beta{font-size:10px;border:1px solid var(--pa-border);border-radius:999px;padding:3px 7px;color:var(--pa-text-muted);background:var(--pa-surface-muted)}.saas-org{font-size:11px;color:var(--pa-text-muted)}.saas-main{max-width:1240px;margin:0 auto;padding:26px 28px 48px}.page-head{display:flex;align-items:flex-start;justify-content:space-between;gap:20px;margin-bottom:18px}.page-head h1{font-size:24px;letter-spacing:-.01em;margin:0 0 5px}.page-head p,.panel-head p{margin:0;color:var(--pa-text-muted);font-size:12px;line-height:1.5}.pa-primary,.pa-secondary{border-radius:var(--pa-radius);font-weight:700;padding:8px 12px;font-size:12px;display:inline-flex;align-items:center;justify-content:center;text-decoration:none}.pa-primary{border:1px solid var(--pa-blue);background:var(--pa-blue);color:#fff}.pa-primary:hover{background:var(--pa-blue-hover)}.pa-primary.wide{width:100%;padding:10px}.pa-secondary{border:1px solid var(--pa-border);background:#fff;color:var(--pa-text)}.pa-secondary:hover{background:var(--pa-surface-muted)}.pa-secondary.danger{color:var(--pa-danger)}.pa-primary.link{line-height:18px}.panel{background:var(--pa-surface);border:1px solid var(--pa-border);border-radius:var(--pa-radius-lg);box-shadow:var(--pa-shadow);margin-bottom:16px;overflow:hidden}.panel-head{padding:14px 16px;border-bottom:1px solid var(--pa-border-subtle);display:flex;align-items:center;justify-content:space-between;gap:16px}.panel-head h2{margin:0 0 3px;font-size:15px}.panel-body{padding:16px}.metric-grid{display:grid;gap:10px;margin-bottom:16px}.metric-grid.four{grid-template-columns:repeat(4,minmax(0,1fr))}.metric-grid.three{grid-template-columns:repeat(3,minmax(0,1fr))}.metric-grid.compact{margin-top:10px}.metric-card{background:var(--pa-surface);border:1px solid var(--pa-border);border-radius:10px;padding:13px 14px;display:grid;gap:4px}.metric-card span{font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:var(--pa-text-muted);font-weight:700}.metric-card strong{font-size:24px;line-height:1.2}.metric-card strong.metric-word{font-size:18px}.metric-card small{font-size:10px;color:var(--pa-text-muted)}.assessment-list{display:grid}.assessment-row{border:0;border-bottom:1px solid var(--pa-border-subtle);background:#fff;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;text-align:left;color:var(--pa-text)}.assessment-row:last-child{border-bottom:0}.assessment-row:hover{background:var(--pa-surface-muted)}.assessment-row>div:first-child{display:grid;gap:3px}.assessment-row b{font-size:13px}.assessment-row span{font-size:11px;color:var(--pa-text-muted)}.assessment-row-stats{display:flex;align-items:center;gap:14px}.status-pill{display:inline-flex;align-items:center;border-radius:999px;padding:4px 8px;font-size:10px!important;font-weight:750;text-transform:capitalize}.status-pill.success{background:var(--pa-success-soft);color:var(--pa-success)!important}.status-pill.neutral{background:var(--pa-surface-muted);color:var(--pa-text-muted)!important}.status-pill.danger{background:var(--pa-danger-soft);color:var(--pa-danger)!important}.empty-state{text-align:center;padding:42px 20px}.empty-state h3{margin:6px 0;font-size:15px}.empty-state p{margin:0 0 14px;color:var(--pa-text-muted);font-size:12px}.empty-icon{margin:auto;width:38px;height:38px;border-radius:50%;display:grid;place-items:center;background:var(--pa-blue-soft);color:var(--pa-blue);font-size:20px}.assessment-table{font-size:11px}.assessment-table-head,.assessment-table-row{display:grid;grid-template-columns:2fr 1fr .7fr 1.2fr .7fr 36px;align-items:center;gap:12px;padding:10px 14px}.assessment-table-head{background:var(--pa-surface-muted);color:var(--pa-text-muted);font-weight:750;border-bottom:1px solid var(--pa-border)}.assessment-table-row{border-bottom:1px solid var(--pa-border-subtle)}.assessment-table-row:last-child{border-bottom:0}.assessment-name{border:0;background:transparent;text-align:left;display:grid;gap:2px;color:var(--pa-text);padding:0}.assessment-name b{font-size:12px}.assessment-name span{font-size:10px;color:var(--pa-text-muted)}.pa-icon-button{width:26px;height:26px;border:0;border-radius:6px;background:transparent}.pa-icon-button:hover{background:var(--pa-surface-muted)}.pa-icon-button.danger{color:var(--pa-danger)}.source-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px}.source-card{position:relative;border:1px solid var(--pa-border);background:#fff;border-radius:var(--pa-radius-lg);padding:20px;text-align:left;min-height:220px;box-shadow:var(--pa-shadow);color:var(--pa-text)}.source-card.active:hover{border-color:var(--pa-blue);box-shadow:0 0 0 2px #CCE0FF}.source-card.disabled{cursor:default;opacity:.72}.source-card h3{font-size:16px;margin:14px 0 6px}.source-card p{font-size:12px;color:var(--pa-text-muted);line-height:1.5;margin:0}.source-icon{width:42px;height:42px;border-radius:10px;display:grid;place-items:center;background:var(--pa-blue-soft);color:var(--pa-blue);font-weight:800}.source-badge{position:absolute;right:14px;top:14px;border-radius:999px;padding:4px 7px;background:var(--pa-success-soft);color:var(--pa-success);font-size:9px;font-weight:800}.source-badge.neutral{background:var(--pa-surface-muted);color:var(--pa-text-muted)}.source-action{position:absolute;left:20px;bottom:18px;font-size:11px;color:var(--pa-blue);font-weight:700}.source-action.muted{color:var(--pa-text-muted)}.wizard-steps{display:flex;gap:0;margin-bottom:16px}.wizard-step{position:relative;display:flex;align-items:center;gap:7px;color:var(--pa-text-muted);font-size:11px;font-weight:700;padding-right:34px}.wizard-step:not(:last-child):after{content:\"\";position:absolute;width:24px;height:1px;right:5px;top:12px;background:var(--pa-border)}.wizard-step span{width:24px;height:24px;border-radius:50%;display:grid;place-items:center;background:var(--pa-surface);border:1px solid var(--pa-border);font-size:10px}.wizard-step.active{color:var(--pa-blue)}.wizard-step.active span{background:var(--pa-blue-soft);border-color:#85B8FF}.form-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.form-grid.two{grid-template-columns:1fr 1fr}.form-grid label{display:grid;gap:5px}.form-grid label>span{font-size:10px;color:var(--pa-text-subtle);font-weight:750}.form-grid input,.form-grid select,.mapping-row select{height:34px;border:1px solid #B3B9C4;border-radius:7px;background:#fff;padding:0 9px;color:var(--pa-text);font-size:12px}.form-grid input:focus,.form-grid select:focus,.mapping-row select:focus{outline:2px solid #CCE0FF;border-color:var(--pa-blue)}.pa-upload{margin-top:14px;border:2px dashed #B3B9C4;border-radius:10px;background:#FAFBFC;padding:22px;display:flex;flex-direction:column;align-items:center;gap:8px}.pa-upload.drag{border-color:var(--pa-blue);background:var(--pa-blue-soft)}.pa-upload b{font-size:13px}.pa-upload span{font-size:11px;color:var(--pa-text-muted)}.file-summary{margin-top:10px;padding:9px 10px;border-radius:7px;background:var(--pa-surface-muted);display:flex;justify-content:space-between;font-size:11px}.file-summary span{color:var(--pa-text-muted)}.subsection-title{font-size:11px;font-weight:800;margin:15px 0 7px;color:var(--pa-text-subtle)}.mapping-grid{border:1px solid var(--pa-border-subtle);border-radius:8px;overflow:hidden;max-height:210px;overflow-y:auto}.mapping-row{display:grid;grid-template-columns:1fr 180px;align-items:center;gap:10px;padding:7px 9px;border-bottom:1px solid var(--pa-border-subtle);font-size:11px}.mapping-row:last-child{border-bottom:0}.button-row{display:flex;gap:8px;align-items:center;margin-top:14px}.button-row.right{justify-content:flex-end}.pa-alert{padding:9px 10px;border-radius:7px;font-size:11px;line-height:1.4;margin-top:8px}.pa-alert.info{background:var(--pa-blue-soft);color:#0747A6}.pa-alert.warning{background:var(--pa-warning-soft);color:var(--pa-warning)}.pa-alert.error{background:var(--pa-danger-soft);color:var(--pa-danger)}.access-banner{margin-top:14px;border-radius:9px;padding:11px 13px;display:flex;align-items:center;justify-content:space-between}.access-banner>div{display:grid;gap:3px}.access-banner b{font-size:12px}.access-banner span{font-size:10px}.access-banner>span{font-size:18px;font-weight:800}.access-banner.ok{background:var(--pa-success-soft);color:var(--pa-success)}.access-banner.blocked{background:var(--pa-warning-soft);color:var(--pa-warning)}.dev-tools{margin-top:14px;border:1px dashed var(--pa-border);border-radius:8px;padding:12px;display:flex;justify-content:space-between;gap:20px;align-items:center}.dev-tools p{margin:3px 0 0;color:var(--pa-text-muted);font-size:11px}.security-list{display:grid}.security-list>div{display:grid;grid-template-columns:180px 1fr;gap:20px;padding:10px 0;border-bottom:1px solid var(--pa-border-subtle);font-size:11px}.security-list>div:last-child{border-bottom:0}.security-list span{color:var(--pa-text-muted)}.danger-zone{border-color:#FFD5D2}.signin-page{min-height:100vh;display:grid;place-items:center;padding:24px;background:linear-gradient(150deg,#F4F5F7 0%,#E9F2FF 100%)}.signin-card{width:410px;background:#fff;border:1px solid var(--pa-border);border-radius:14px;box-shadow:0 8px 28px rgba(9,30,66,.12);padding:28px}.signin-brand{display:flex;align-items:center;gap:12px;margin-bottom:26px}.signin-brand h1{font-size:19px;margin:0}.signin-brand p{font-size:11px;color:var(--pa-text-muted);margin:3px 0 0}.signin-card h2{font-size:18px;margin:0 0 6px}.pa-copy{color:var(--pa-text-muted);font-size:12px;line-height:1.5;margin:0 0 18px}.signin-buttons{display:grid;gap:8px}.provider-button{height:40px;border:1px solid #B3B9C4;background:#fff;border-radius:8px;font-size:12px;font-weight:650;color:var(--pa-text);position:relative}.provider-button:hover{background:var(--pa-surface-muted)}.provider-mark{position:absolute;left:12px;font-weight:800;color:var(--pa-blue)}.signin-separator{height:34px;display:flex;align-items:center;justify-content:center;color:var(--pa-text-muted);font-size:9px;text-transform:uppercase;letter-spacing:.07em}.signin-separator:before,.signin-separator:after{content:\"\";height:1px;background:var(--pa-border-subtle);flex:1}.signin-separator span{padding:0 10px}.pa-caption{font-size:9px;color:var(--pa-text-muted);line-height:1.5;margin-top:12px}.toast{position:fixed;right:22px;top:72px;z-index:50;background:#172B4D;color:#fff;border-radius:8px;padding:9px 12px;font-size:11px;box-shadow:0 4px 14px rgba(9,30,66,.22)}@media(max-width:980px){.saas-root{grid-template-columns:210px minmax(0,1fr)}.saas-sidebar{width:210px}.metric-grid.four{grid-template-columns:1fr 1fr}.source-grid{grid-template-columns:1fr}.saas-main{padding:20px}.assessment-table-head,.assessment-table-row{grid-template-columns:2fr 1fr .7fr 1fr}.assessment-table-head>*:nth-child(4),.assessment-table-row>*:nth-child(4){display:none}}\n\n/* Full shared Process Advisor runtime. The SaaS shell intentionally steps out of\n   the way once an assessment is opened so the Web experience is the same shared\n   product UI used by Jira and ServiceNow. */\n.web-process-advisor-host {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  background: #fff;\n  z-index: 1000;\n}\n.web-process-advisor-host > * {\n  width: 100%;\n  height: 100%;\n}\n\n/* -------------------------------------------------------------------------\n   Sprint 4 — Web Product UX / UI parity\n   ------------------------------------------------------------------------- */\n:root{--pa-sidebar:232px;--pa-topbar:56px}\nhtml,body,#root{height:100%;min-height:100%;}\nbody{font-family:var(--pa-font);-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}\nbody.pa-web-runtime-active{overflow:hidden;background:#fff}\n\n.saas-root{grid-template-columns:var(--pa-sidebar) minmax(0,1fr);background:#f7f8fa}\n.saas-sidebar{width:var(--pa-sidebar);background:#fff;border-right:1px solid #e6e8ec;box-shadow:1px 0 0 rgba(9,30,66,.02)}\n.saas-brand{height:72px;padding:0 18px;gap:12px;border-bottom:0}\n.saas-brand-logo{width:34px;height:34px;object-fit:contain}\n.saas-brand-title{font-size:16px;font-weight:760;color:#0b1f44;letter-spacing:-.01em}\n.saas-brand-sub{font-size:11px;color:#6b778c;margin-top:2px}\n.saas-nav-label{padding:12px 18px 5px;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.09em;color:#8993a4}\n.saas-nav{padding:4px 10px 12px;gap:3px}\n.saas-nav-item{min-height:40px;padding:0 11px;border-radius:8px;gap:11px;font-size:13px;color:#44546f;transition:background .12s ease,color .12s ease}\n.saas-nav-item svg{color:#6b778c}\n.saas-nav-item:hover{background:#f5f7fa;color:#172b4d}\n.saas-nav-item.active{background:#e9f2ff;color:#0c66e4}\n.saas-nav-item.active svg{color:#0c66e4}\n.saas-sidebar-foot{padding:12px 14px 16px;border-top:1px solid #eef0f3}\n.saas-security-note{display:flex;gap:9px;padding:10px;border:1px solid #e4e8ee;border-radius:9px;background:#fafbfc;color:#44546f;margin-bottom:10px}\n.saas-security-note svg{flex:0 0 auto;color:#1f845a;margin-top:1px}\n.saas-security-note div{display:grid;gap:2px}\n.saas-security-note b{font-size:10px;color:#172b4d}.saas-security-note span{font-size:9px;line-height:1.35;color:#6b778c}\n.saas-env{margin:0;font-size:9px;background:transparent;border:0;padding:0;color:#8993a4}\n\n.saas-content{grid-column:2;min-width:0}\n.saas-topbar{height:var(--pa-topbar);padding:0 28px;background:rgba(255,255,255,.97);border-bottom:1px solid #e6e8ec;box-shadow:0 1px 2px rgba(9,30,66,.025)}\n.saas-breadcrumb{display:flex;align-items:center;gap:8px;font-size:12px;color:#6b778c}.saas-breadcrumb b{color:#172b4d}.saas-breadcrumb-sep{color:#c1c7d0}\n.saas-topbar-actions{display:flex;align-items:center;gap:7px;font-size:10px;color:#6b778c}.saas-status-dot{width:7px;height:7px;border-radius:50%;background:#22a06b;box-shadow:0 0 0 3px #dcfff1}\n.saas-main{max-width:1380px;padding:30px 34px 56px}\n\n.page-head{margin-bottom:22px}.page-head h1{font-size:26px;color:#0b1f44;line-height:1.2;letter-spacing:-.025em}.page-head p{max-width:700px;font-size:12px;color:#6b778c}\n.eyebrow{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.09em;color:#0c66e4;margin-bottom:7px}\n.hero-head{padding:4px 0 2px;align-items:center}.hero-head h1{max-width:760px;font-size:30px;margin-bottom:8px}.hero-head p{font-size:13px;line-height:1.55}\n.pa-primary,.pa-secondary{min-height:34px;gap:7px;border-radius:8px;box-shadow:none}.pa-primary{background:#0c66e4;border-color:#0c66e4}.pa-primary:hover{background:#0055cc}.primary-large{padding:9px 14px;min-height:38px}\n\n.panel{border-color:#e2e6ea;border-radius:12px;box-shadow:0 1px 3px rgba(9,30,66,.06);background:#fff}\n.panel-head{padding:16px 18px}.panel-head-strong h2{font-size:16px}.panel-body{padding:18px}\n.metric-grid{gap:12px}.overview-metrics{margin-bottom:22px}\n.metric-card{border-color:#e2e6ea;border-radius:11px;padding:16px;background:#fff;box-shadow:0 1px 2px rgba(9,30,66,.035)}\n.metric-card strong{font-size:26px;color:#0b1f44;letter-spacing:-.025em}.metric-card small{font-size:10px;color:#7a869a}\n.metric-card-icon{display:flex;align-items:flex-start;gap:12px}.metric-card-icon>div{display:grid;gap:4px}.metric-icon{width:34px;height:34px;display:grid;place-items:center;border-radius:9px;background:#e9f2ff;color:#0c66e4;flex:0 0 auto}\n\n.assessment-list{background:#fff}.assessment-row-rich{padding:14px 18px;min-height:67px}.assessment-row-main{display:flex!important;align-items:center;gap:12px}.assessment-source-mark,.source-mini{display:inline-grid;place-items:center;background:#e9f2ff;color:#0c66e4;font-weight:800;border-radius:7px}.assessment-source-mark{width:34px;height:34px;font-size:9px}.source-mini{min-width:28px;height:24px;padding:0 6px;font-size:8px;margin-right:7px}\n.assessment-row b{font-size:12px}.assessment-row-stats{font-size:10px;color:#6b778c;gap:18px}.assessment-row-stats>span>b{color:#172b4d;font-size:10px}.assessment-row-stats svg{color:#8993a4}\n.empty-state-feature{padding:54px 24px}.empty-state-feature h3{font-size:16px}.empty-state-feature p{max-width:520px;margin:0 auto 16px}\n\n.assessment-toolbar{display:flex;align-items:center;gap:10px;padding:12px 14px;border-bottom:1px solid #eef0f3;background:#fbfcfd}.search-field{display:flex;align-items:center;gap:8px;min-width:300px;max-width:440px;flex:1;height:34px;padding:0 10px;background:#fff;border:1px solid #cdd3dc;border-radius:8px;color:#7a869a}.search-field input{border:0;outline:0;min-width:0;flex:1;color:#172b4d;background:transparent;font-size:11px}.toolbar-select{height:34px;border:1px solid #cdd3dc;border-radius:8px;background:#fff;padding:0 28px 0 10px;font-size:11px;color:#44546f}.toolbar-count{font-size:10px;color:#8993a4;margin-left:auto}\n.modern-table .assessment-table-head,.modern-table .assessment-table-row{grid-template-columns:2fr 1.45fr .7fr 1.25fr .65fr 76px;padding-left:18px;padding-right:18px}.modern-table .assessment-table-row{min-height:58px}.source-cell{display:flex;align-items:center;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.row-actions{display:flex;justify-content:flex-end;gap:3px}\n\n/* Assessment builder refinements */\n.wizard-steps{padding:0 0 4px;margin-bottom:18px}.wizard-step{font-size:10px;padding-right:42px}.wizard-step:not(:last-child):after{width:31px;right:6px}.wizard-step span{width:25px;height:25px}.source-card{border-color:#e0e4e9;box-shadow:0 1px 3px rgba(9,30,66,.05);transition:border-color .12s ease,box-shadow .12s ease,transform .12s ease}.source-card.active:hover{transform:translateY(-1px);box-shadow:0 4px 12px rgba(9,30,66,.08)}\n.form-grid input,.form-grid select,.mapping-row select{border-color:#c7cdd7}.pa-upload{background:#fbfcfd;border-color:#c7cdd7}.pa-upload:hover{background:#f7faff;border-color:#85b8ff}\n\n/* Full Process Advisor host ------------------------------------------------ */\n.web-process-advisor-host{position:fixed;inset:0;width:100vw;height:100vh;overflow:hidden;background:#fff;z-index:1000;font-family:var(--pa-font)}\n.web-process-advisor-host>div{width:100%;height:100%}\n.web-process-advisor-host *,body [role=\"dialog\"],body [role=\"menu\"],body [role=\"listbox\"]{font-family:var(--pa-font)}\n.web-process-advisor-host [class*=\"ag-root\"],body .ag-popup{font-family:var(--pa-font)}\n.web-process-advisor-host button{font-family:var(--pa-font)}\n\n/* Keep legacy print/export render targets mounted for PDF generation but out\n   of the live application layout. metricus.tsx also moves these off-screen. */\n.web-process-advisor-host #\\#findingDetails,\n.web-process-advisor-host #\\#discoveryRuleDetails{max-width:640px}\n\n@media(max-width:1100px){:root{--pa-sidebar:210px}.saas-main{padding:24px}.metric-grid.four{grid-template-columns:repeat(2,minmax(0,1fr))}.modern-table .assessment-table-head,.modern-table .assessment-table-row{grid-template-columns:2fr 1.2fr .7fr 1fr 70px}.modern-table .assessment-table-head>*:nth-child(4),.modern-table .assessment-table-row>*:nth-child(4){display:none}}\n.panel-meta{font-size:10px;color:#8993a4;font-weight:650}\n\n/* Sprint 4A — Model workspace ------------------------------------------------ */\n.models-page-head{align-items:center}.model-summary-strip{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;margin-bottom:16px}.model-summary-strip>div{background:#fff;border:1px solid #e2e6ea;border-radius:10px;padding:13px 15px;display:flex;align-items:baseline;justify-content:space-between;gap:12px;box-shadow:0 1px 2px rgba(9,30,66,.03)}.model-summary-strip span{font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#7a869a;font-weight:750}.model-summary-strip strong{font-size:20px;color:#0b1f44}.model-grid-panel{overflow:visible}.model-toolbar{display:flex;align-items:center;gap:9px;padding:12px 14px;border-bottom:1px solid #eef0f3;background:#fbfcfd;border-radius:12px 12px 0 0}.model-search{max-width:520px}.pa-secondary.compact{min-height:34px;padding:6px 10px}.model-grid-wrap{height:560px;width:100%;background:#fff;border-radius:0 0 12px 12px;overflow:hidden}.model-grid-wrap .ag-root-wrapper{border:0;border-radius:0 0 12px 12px}.model-grid-wrap .ag-header{background:#f7f8fa;border-bottom-color:#e6e8ec}.model-grid-wrap .ag-header-cell-text{font-size:10px;font-weight:800;color:#5e6c84;text-transform:uppercase;letter-spacing:.035em}.model-grid-wrap .ag-row{border-bottom-color:#eef0f3;cursor:pointer}.model-grid-wrap .ag-row:hover{background:#f7faff}.model-grid-wrap .ag-cell{display:flex;align-items:center;font-size:11px;color:#344563}.grid-model-name{display:grid;gap:2px;line-height:1.25}.grid-model-name b{font-size:12px;color:#172b4d}.grid-model-name span{font-size:9px;color:#7a869a}.model-source-mark{width:31px;height:26px;border-radius:7px;display:grid;place-items:center;font-size:8px;font-weight:850;background:#e9f2ff;color:#0c66e4}.model-source-mark.jira{background:#deebff;color:#0052cc}.model-source-mark.servicenow{background:#dcfff1;color:#1f845a}.model-grid-actions{height:100%;display:flex;align-items:center;justify-content:flex-end;gap:3px}.model-grid-actions button{width:28px;height:28px;border:0;background:transparent;border-radius:6px;color:#5e6c84;display:grid;place-items:center}.model-grid-actions button:hover{background:#edf2f7;color:#172b4d}.model-grid-actions button.danger:hover{background:#ffebe6;color:#ae2a19}.status-pill.info{background:#e9f2ff;color:#0c66e4!important}.model-detail-backdrop{position:fixed;inset:0;background:rgba(9,30,66,.32);z-index:80;display:flex;justify-content:flex-end}.model-detail-backdrop>div{height:100%;width:min(560px,92vw)}.model-detail-panel{height:100%;background:#fff;box-shadow:-10px 0 30px rgba(9,30,66,.16);overflow:auto}.model-detail-head{padding:22px 22px 18px;border-bottom:1px solid #e6e8ec;display:flex;justify-content:space-between;gap:16px;align-items:flex-start}.model-title-block{display:flex;gap:12px;align-items:flex-start}.model-title-block .model-source-mark{margin-top:2px}.model-title-block h2{font-size:20px;line-height:1.2;margin:0 0 4px;color:#0b1f44}.model-title-block p{margin:0;color:#6b778c;font-size:11px}.model-detail-actions{display:flex;gap:8px;padding:14px 22px;border-bottom:1px solid #eef0f3;background:#fbfcfd}.danger-text{color:#ae2a19}.model-detail-section{padding:18px 22px;border-bottom:1px solid #eef0f3}.model-detail-section h3{margin:0 0 12px;font-size:12px;color:#172b4d}.detail-kv-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.detail-kv-grid>div{display:grid;gap:5px}.detail-kv-grid span{font-size:9px;text-transform:uppercase;letter-spacing:.045em;color:#8993a4;font-weight:750}.detail-kv-grid b{font-size:11px;color:#344563;font-weight:650}.detail-metrics{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}.detail-metrics>div{background:#f7f8fa;border:1px solid #e6e8ec;border-radius:9px;padding:11px;display:grid;gap:4px}.detail-metrics span{font-size:9px;color:#7a869a}.detail-metrics strong{font-size:18px;color:#0b1f44}.section-title-row{display:flex;justify-content:space-between;align-items:center}.section-title-row>span{font-size:9px;color:#8993a4}.assessment-history-list{display:grid;border:1px solid #e6e8ec;border-radius:9px;overflow:hidden}.assessment-history-row{display:flex;align-items:center;justify-content:space-between;padding:10px 11px;border-bottom:1px solid #eef0f3}.assessment-history-row:last-child{border-bottom:0}.assessment-history-row>div{display:grid;gap:2px}.assessment-history-row b{font-size:10px;color:#344563}.assessment-history-row span{font-size:9px;color:#8993a4}.detail-empty{padding:16px;background:#f7f8fa;border-radius:9px;color:#7a869a;font-size:10px;text-align:center}@media(max-width:900px){.model-summary-strip{grid-template-columns:1fr 1fr}.model-toolbar{flex-wrap:wrap}.model-search{min-width:240px}.toolbar-count{margin-left:0}.detail-kv-grid{grid-template-columns:1fr}.detail-metrics{grid-template-columns:1fr 1fr 1fr}}\n\n/* Sprint 4A — unified collapsible navigation -------------------------------- */\n:root{--pa-sidebar-expanded:232px;--pa-sidebar-collapsed:68px;--pa-sidebar:var(--pa-sidebar-expanded)}\n.saas-root.sidebar-collapsed{--pa-sidebar:var(--pa-sidebar-collapsed)}\n.saas-root{grid-template-columns:var(--pa-sidebar) minmax(0,1fr);transition:grid-template-columns .16s ease}\n.saas-sidebar{width:var(--pa-sidebar);transition:width .16s ease;overflow:hidden}\n.saas-brand{height:64px;padding:0 16px;gap:10px;white-space:nowrap}\n.saas-brand-logo{width:36px;height:36px;object-fit:contain;flex:0 0 auto}\n.sidebar-collapsed .saas-brand{padding:0;justify-content:center}\n.saas-nav-label{padding:16px 16px 5px;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.11em;color:#8993a4;white-space:nowrap}\n.saas-nav{padding:4px 10px;gap:3px}\n.saas-nav-item{min-height:40px;padding:0 11px;gap:11px;border-radius:9px;white-space:nowrap;overflow:hidden;flex-shrink:0}\n.saas-nav-item svg{flex:0 0 auto}\n.saas-nav-item span{overflow:hidden;text-overflow:ellipsis}\n.sidebar-collapsed .saas-nav{padding-left:10px;padding-right:10px}\n.sidebar-collapsed .saas-nav-item{width:48px;padding:0;justify-content:center;margin:0 auto}\n.saas-nav-divider{height:1px;background:#eef0f3;margin:9px 12px}\n.saas-nav-divider.push-bottom{margin-top:auto}\n.saas-nav-context{display:grid;gap:2px;padding:7px 16px 3px;min-width:0}\n.saas-nav-context span{font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:#8993a4;font-weight:750}\n.saas-nav-context b{font-size:11px;color:#172b4d;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n.saas-model-nav .saas-nav-item.active{background:#e9f2ff;color:#0c66e4;box-shadow:inset 3px 0 0 #0c66e4}\n.sidebar-collapsed .saas-model-nav .saas-nav-item.active{box-shadow:inset 3px 0 0 #0c66e4}\n.saas-nav-bottom{padding-bottom:10px}\n.sidebar-toggle{color:#6b778c}\n.saas-sidebar-foot{margin-top:0;padding:11px 12px 14px}\n.saas-security-note{display:flex;align-items:flex-start;gap:9px;border:1px solid #e2e6ea;background:#fbfcfd;border-radius:9px;padding:10px;margin-bottom:10px;color:#216e4e}\n.saas-security-note>div{display:grid;gap:2px}.saas-security-note b{font-size:10px;color:#172b4d}.saas-security-note span{font-size:9px;line-height:1.35;color:#7a869a}\n.saas-env{margin:0;background:transparent;border:0;padding:0;color:#8993a4}\n.saas-content{grid-column:2;min-width:0;transition:margin .16s ease}\n.saas-topbar{height:58px;padding:0 22px}\n.saas-breadcrumb{display:flex;align-items:center;gap:8px;min-width:0}.saas-breadcrumb>span,.saas-breadcrumb>b{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.saas-breadcrumb>b{max-width:360px;color:#172b4d}.saas-breadcrumb-sep{color:#b3b9c4!important}\n.saas-topbar-actions{display:flex;align-items:center;gap:8px;color:#6b778c;font-size:10px}.saas-status-dot{width:8px;height:8px;border-radius:50%;background:#22a06b;box-shadow:0 0 0 3px #dcfff1}\n.model-back-button{margin-right:8px}\n.saas-main-advisor{max-width:none;margin:0;padding:0;height:calc(100vh - 58px);overflow:hidden;background:#fff}\n\n/* The Web shell owns the primary product navigation. The shared Process\n   Advisor keeps only its section-specific sub-navigation and action rows. */\n.web-process-advisor-host.web-process-advisor-embedded{position:relative;inset:auto;width:100%;height:100%;z-index:1;overflow:hidden;background:#fff;display:flex;flex-direction:column}\n.web-process-advisor-embedded>div{min-height:0}\n.web-process-advisor-runtime{flex:1 1 auto;height:auto!important;min-height:0;overflow:hidden}\n.web-process-advisor-runtime>div{height:100%;min-height:0}\n.free-analysis-notice{flex:0 0 auto;display:flex;align-items:center;justify-content:flex-end;gap:10px;padding:5px 16px;border-bottom:1px solid #e7e9ee;background:#fafbfc;color:#626f86;font-size:11.5px;line-height:1.25;min-height:30px}\n.free-analysis-notice-copy{display:inline-flex;align-items:center;gap:3px;min-width:0;white-space:nowrap}\n.free-analysis-notice-copy b{font-size:11.5px;color:#172b4d}\n.free-analysis-dot{margin:0 3px;color:#a5adba}\n.free-analysis-link{border:0;background:transparent;color:#0c66e4;padding:2px 4px;font-size:11.5px;font-weight:700;cursor:pointer;white-space:nowrap}\n.free-analysis-link:hover{text-decoration:underline}\n.free-analysis-link:disabled{opacity:.6;cursor:wait;text-decoration:none}\n.web-pa-empty{padding:28px;color:#6b778c;font-size:13px}\n\n@media(max-width:900px){\n  :root{--pa-sidebar-expanded:210px}\n  .saas-topbar{padding:0 14px}\n  .saas-breadcrumb>b{max-width:200px}\n}\n\n/* Sprint 4A iteration — streamlined models workspace ------------------------- */\n.sidebar-toggle.icon-only{width:40px!important;min-width:40px;padding:0!important;justify-content:center!important;margin:0!important}\n.sidebar-collapsed .sidebar-toggle.icon-only{width:48px!important;margin:0 auto!important}\n.saas-topbar-actions:empty{display:none}\n\n/* Models is a working list, not a dashboard. */\n.model-grid-panel{margin-top:4px}\n.model-toolbar{gap:8px;flex-wrap:nowrap}\n.model-search{min-width:320px;max-width:620px}\n.toolbar-refresh{width:34px;height:34px;flex:0 0 auto}\n.model-grid-wrap{height:620px}\n\n.model-grid-actions{gap:2px;overflow:visible}\n.model-grid-actions button{width:29px;height:29px}\n.model-action-menu{position:fixed;z-index:3000;width:210px;background:#fff;border:1px solid #dfe3e8;border-radius:9px;box-shadow:0 10px 28px rgba(9,30,66,.18);padding:6px;display:grid;gap:2px}\n.model-action-menu button{height:34px;border:0;background:#fff;border-radius:6px;padding:0 9px;display:flex;align-items:center;gap:9px;text-align:left;font-size:11px;color:#344563}\n.model-action-menu button:hover{background:#f4f5f7;color:#172b4d}.model-action-menu button:disabled{opacity:.45}.model-action-menu button.danger{color:#ae2a19}.model-action-menu button.danger:hover{background:#ffebe6}.model-action-divider{height:1px;background:#eef0f3;margin:3px 2px}\n\n.model-description{font-size:11px;line-height:1.5;color:#5e6c84;margin:14px 0 0;padding-top:12px;border-top:1px solid #eef0f3}\n.model-detail-danger{padding:16px 22px;display:flex;gap:18px}.pa-link-danger{border:0;background:transparent;padding:0;display:inline-flex;align-items:center;gap:6px;font-size:10px;font-weight:650;color:#5e6c84}.pa-link-danger:hover{color:#172b4d}.pa-link-danger.danger{color:#ae2a19}\n\n.modal-backdrop{position:fixed;inset:0;z-index:3100;background:rgba(9,30,66,.38);display:grid;place-items:center;padding:24px}\n.edit-model-modal{width:min(620px,94vw);background:#fff;border-radius:12px;box-shadow:0 18px 50px rgba(9,30,66,.22);overflow:hidden}\n.edit-model-head{padding:19px 20px 15px;border-bottom:1px solid #e6e8ec;display:flex;align-items:flex-start;justify-content:space-between}.edit-model-head h2{margin:0;font-size:19px;color:#0b1f44}\n.edit-model-body{padding:18px 20px;display:grid;gap:15px}.edit-model-body label{display:grid;gap:6px}.edit-model-body label>span{font-size:10px;font-weight:700;color:#5e6c84}.edit-model-body input,.edit-model-body textarea{width:100%;border:1px solid #c7cdd7;border-radius:8px;padding:9px 10px;color:#172b4d;background:#fff;outline:0}.edit-model-body input:focus,.edit-model-body textarea:focus{border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.12)}.edit-model-body textarea{resize:vertical;min-height:82px}\n.edit-model-foot{padding:13px 20px;border-top:1px solid #eef0f3;background:#fbfcfd;display:flex;justify-content:flex-end;gap:8px}\n\n.form-grid textarea{border:1px solid #c7cdd7;border-radius:7px;padding:8px 9px;color:#172b4d;background:#fff;font:inherit;resize:vertical}.form-grid textarea:focus{outline:0;border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.1)}.form-span-two{grid-column:1/-1}\n\n@media(max-width:1180px){.model-toolbar{flex-wrap:wrap}.model-search{min-width:260px;flex-basis:100%}.toolbar-count{margin-left:auto}}\n\n/* Sprint 4A — Home is an introduction, not a model dashboard ---------------- */\n.home-hero{background:linear-gradient(135deg,#fff 0%,#f7faff 68%,#edf5ff 100%);border:1px solid #dfe6ee;border-radius:14px;padding:24px 28px;display:grid;grid-template-columns:minmax(0,1.75fr) minmax(230px,.65fr);gap:28px;align-items:center;margin-bottom:18px;box-shadow:0 1px 2px rgba(9,30,66,.04)}\n.home-hero-copy{max-width:820px}.home-hero h1{margin:5px 0 9px;font-size:30px;line-height:1.12;letter-spacing:-.024em;color:#091e42}.home-hero p{margin:0;color:#5e6c84;font-size:13px;line-height:1.52;max-width:790px}.home-hero-actions{display:flex;gap:8px;margin-top:16px}.primary-large{min-height:38px;padding:0 14px}\n.home-hero-visual{display:grid;justify-items:center;gap:4px}.home-flow-card{width:188px;min-height:46px;border:1px solid #d9e2ec;border-radius:9px;background:#fff;display:flex;align-items:center;gap:9px;padding:0 13px;color:#344563;font-size:11px;font-weight:700;box-shadow:0 4px 14px rgba(9,30,66,.05)}.home-flow-card svg{color:#0c66e4}.home-flow-card.accent{border-color:#85b8ff;background:#f4f8ff}.home-flow-line{width:1px;height:12px;background:#b6c7dd}\n.home-section{margin:18px 0}.home-section-head{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:9px}.home-section-head h2{margin:3px 0 0;font-size:18px;letter-spacing:-.01em;color:#172b4d}.home-steps{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:0;background:#fff;border:1px solid #dfe3e8;border-radius:11px;overflow:hidden}.home-step{background:#fff;border:0;border-right:1px solid #e6e9ed;border-radius:0;padding:11px 13px;display:flex;align-items:flex-start;gap:9px;min-height:82px}.home-step:last-child{border-right:0}.home-step-number{width:24px;height:24px;border-radius:7px;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;font-size:10px;font-weight:800;flex:0 0 auto}.home-step h3{margin:1px 0 4px;font-size:12px;color:#172b4d}.home-step p{margin:0;font-size:10px;line-height:1.4;color:#6b778c}\n.home-capability-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:9px}.home-capability{background:#fff;border:1px solid #dfe3e8;border-radius:10px;padding:12px 13px;min-height:96px;display:grid;grid-template-columns:30px 1fr;grid-template-rows:auto auto;column-gap:10px;align-content:start}.home-capability-icon{width:30px;height:30px;border-radius:8px;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;margin:0;grid-row:1 / span 2}.home-capability h3{margin:1px 0 3px;font-size:13px;color:#172b4d}.home-capability p{margin:0;color:#6b778c;font-size:10px;line-height:1.4}.home-recent-panel{margin-top:18px}.home-empty-state{padding:22px 18px}\n@media(max-width:1050px){.home-hero{grid-template-columns:1fr}.home-hero-visual{grid-template-columns:1fr 18px 1fr 18px 1fr;justify-items:stretch;align-items:center}.home-flow-card{width:auto}.home-flow-line{height:1px;width:18px}.home-steps,.home-capability-grid{grid-template-columns:1fr 1fr}}\n@media(max-width:700px){.home-hero{padding:20px}.home-hero h1{font-size:26px}.home-hero-visual{display:none}.home-steps,.home-capability-grid{grid-template-columns:1fr}.home-hero-actions{flex-wrap:wrap}}\n\n\n/* Sprint 4A — viewport-aware desktop Home -----------------------------------\n   Process Advisor Web is a desktop-first application. Home uses the available\n   shell viewport rather than fixed card heights so typography and whitespace\n   grow on larger monitors and compress gracefully on laptop displays. */\n.saas-main-home{\n  width:100%;\n  max-width:1480px;\n  height:calc(100vh - 58px);\n  min-height:650px;\n  padding:clamp(18px,2.2vh,32px) clamp(24px,2.15vw,40px);\n  display:grid;\n  grid-template-rows:minmax(0,1.32fr) minmax(0,.64fr) minmax(0,.70fr);\n  gap:clamp(12px,1.65vh,22px);\n  overflow:hidden;\n}\n.saas-main-home .home-hero,\n.saas-main-home .home-section{margin:0;min-height:0}\n.saas-main-home .home-hero{\n  height:100%;\n  padding:clamp(22px,3vh,38px) clamp(26px,2.4vw,46px);\n  grid-template-columns:minmax(0,1.75fr) minmax(240px,.62fr);\n  gap:clamp(26px,2.7vw,48px);\n}\n.saas-main-home .home-hero-copy{max-width:900px}\n.saas-main-home .eyebrow{font-size:clamp(10px,min(.65vw,1.35vh),12px);letter-spacing:.075em}\n.saas-main-home .home-hero h1{\n  margin:clamp(5px,.8vh,9px) 0 clamp(9px,1.2vh,14px);\n  font-size:clamp(34px,min(2.28vw,4.6vh),46px);\n  line-height:1.09;\n  letter-spacing:-.027em;\n}\n.saas-main-home .home-hero p{\n  max-width:850px;\n  font-size:clamp(14px,min(.92vw,1.9vh),17px);\n  line-height:1.5;\n}\n.saas-main-home .home-hero-actions{margin-top:clamp(14px,1.8vh,22px);gap:10px}\n.saas-main-home .primary-large{\n  min-height:clamp(38px,4.4vh,46px);\n  padding:0 clamp(14px,1vw,19px);\n  font-size:clamp(12px,min(.78vw,1.55vh),14px);\n}\n.saas-main-home .home-hero-visual{gap:clamp(4px,.6vh,8px)}\n.saas-main-home .home-flow-card{\n  width:clamp(190px,13.2vw,230px);\n  min-height:clamp(46px,5.7vh,58px);\n  padding:0 clamp(13px,1vw,18px);\n  font-size:clamp(11px,min(.75vw,1.5vh),14px);\n  border-radius:10px;\n}\n.saas-main-home .home-flow-line{height:clamp(12px,1.8vh,20px)}\n.saas-main-home .home-section{\n  display:grid;\n  grid-template-rows:auto minmax(0,1fr);\n  align-content:stretch;\n}\n.saas-main-home .home-section-head{margin-bottom:clamp(7px,.85vh,11px)}\n.saas-main-home .home-section-head h2{\n  margin-top:3px;\n  font-size:clamp(18px,min(1.2vw,2.25vh),23px);\n  line-height:1.2;\n}\n.saas-main-home .home-steps{height:100%;min-height:0}\n.saas-main-home .home-step{\n  height:100%;\n  min-height:0;\n  padding:clamp(10px,1.25vh,15px) clamp(12px,1vw,17px);\n  gap:clamp(8px,.7vw,11px);\n  align-items:flex-start;\n}\n.saas-main-home .home-step-number{\n  width:clamp(24px,1.75vw,30px);\n  height:clamp(24px,1.75vw,30px);\n  font-size:clamp(10px,.68vw,12px);\n}\n.saas-main-home .home-step h3{\n  margin:1px 0 clamp(3px,.45vh,6px);\n  font-size:clamp(12px,min(.84vw,1.7vh),15px);\n}\n.saas-main-home .home-step p{\n  font-size:clamp(10px,min(.7vw,1.45vh),13px);\n  line-height:1.38;\n}\n.saas-main-home .home-capability-grid{height:100%;gap:clamp(8px,.8vw,12px)}\n.saas-main-home .home-capability{\n  height:100%;\n  min-height:0;\n  padding:clamp(11px,1.3vh,16px) clamp(12px,1vw,17px);\n  grid-template-columns:clamp(30px,2.2vw,38px) 1fr;\n  column-gap:clamp(9px,.8vw,13px);\n  border-radius:10px;\n}\n.saas-main-home .home-capability-icon{\n  width:clamp(30px,2.2vw,38px);\n  height:clamp(30px,2.2vw,38px);\n}\n.saas-main-home .home-capability h3{\n  margin:1px 0 clamp(3px,.45vh,6px);\n  font-size:clamp(13px,min(.92vw,1.8vh),16px);\n}\n.saas-main-home .home-capability p{\n  font-size:clamp(10px,min(.72vw,1.5vh),13px);\n  line-height:1.4;\n}\n\n/* Short laptop displays compress the same three-section layout rather than\n   introducing a long marketing-page scroll. */\n@media(min-width:901px) and (max-height:760px){\n  .saas-main-home{min-height:0;padding:14px 24px;gap:10px;grid-template-rows:1.2fr .63fr .67fr}\n  .saas-main-home .home-hero{padding:18px 24px}\n  .saas-main-home .home-hero h1{font-size:32px}\n  .saas-main-home .home-hero p{font-size:13px;line-height:1.42}\n  .saas-main-home .home-hero-actions{margin-top:12px}\n  .saas-main-home .home-flow-card{min-height:42px}\n  .saas-main-home .home-section-head{margin-bottom:6px}\n  .saas-main-home .home-section-head h2{font-size:17px}\n  .saas-main-home .home-step{padding:8px 10px}\n  .saas-main-home .home-capability{padding:9px 11px}\n}\n\n/* A narrow browser window remains usable, but desktop/laptop is the primary\n   target for this product. */\n@media(max-width:900px){\n  .saas-main-home{\n    height:auto;\n    min-height:calc(100vh - 58px);\n    overflow:visible;\n    display:block;\n    padding:20px;\n  }\n  .saas-main-home .home-hero{height:auto;margin-bottom:16px}\n  .saas-main-home .home-section{display:block;margin:16px 0}\n  .saas-main-home .home-steps,.saas-main-home .home-capability-grid{height:auto}\n}\n\n\n/* Sprint 4A — Home typography refinement -------------------------------------\n   The fluid layout already reserves enough card height on desktop. Increase\n   text/icon scale to use that space instead of leaving undersized copy in\n   oversized cards. */\n.saas-main-home .home-step-number{\n  width:clamp(30px,2vw,36px);\n  height:clamp(30px,2vw,36px);\n  border-radius:9px;\n  font-size:clamp(12px,.8vw,14px);\n}\n.saas-main-home .home-step{\n  padding:clamp(12px,1.35vh,17px) clamp(14px,1.05vw,19px);\n  gap:clamp(10px,.8vw,14px);\n  align-items:flex-start;\n}\n.saas-main-home .home-step h3{\n  margin:1px 0 clamp(4px,.5vh,7px);\n  font-size:clamp(16px,min(1.02vw,2vh),18px);\n  line-height:1.2;\n}\n.saas-main-home .home-step p{\n  max-width:310px;\n  font-size:clamp(14px,min(.88vw,1.72vh),16px);\n  line-height:1.42;\n}\n.saas-main-home .home-capability{\n  padding:clamp(13px,1.45vh,18px) clamp(15px,1.1vw,20px);\n  grid-template-columns:clamp(38px,2.45vw,44px) 1fr;\n  column-gap:clamp(11px,.85vw,15px);\n  align-content:center;\n}\n.saas-main-home .home-capability-icon{\n  width:clamp(38px,2.45vw,44px);\n  height:clamp(38px,2.45vw,44px);\n  border-radius:10px;\n}\n.saas-main-home .home-capability-icon svg{\n  width:clamp(20px,1.25vw,23px);\n  height:clamp(20px,1.25vw,23px);\n}\n.saas-main-home .home-capability h3{\n  margin:0 0 clamp(4px,.48vh,7px);\n  font-size:clamp(17px,min(1.08vw,2.05vh),20px);\n  line-height:1.2;\n}\n.saas-main-home .home-capability p{\n  max-width:330px;\n  font-size:clamp(14px,min(.88vw,1.72vh),16px);\n  line-height:1.42;\n}\n.saas-main-home .home-hero p{\n  font-size:clamp(16px,min(1vw,2vh),18px);\n  line-height:1.48;\n}\n.saas-main-home .home-flow-card{\n  font-size:clamp(13px,min(.82vw,1.65vh),15px);\n}\n.saas-main-home .home-flow-card svg{\n  width:20px;\n  height:20px;\n}\n\n/* Keep short laptop screens compact, but don't drop back to tiny typography. */\n@media(min-width:901px) and (max-height:760px){\n  .saas-main-home .home-hero p{font-size:14px}\n  .saas-main-home .home-step-number{width:28px;height:28px;font-size:12px}\n  .saas-main-home .home-step h3{font-size:15px}\n  .saas-main-home .home-step p{font-size:13px}\n  .saas-main-home .home-capability{grid-template-columns:34px 1fr}\n  .saas-main-home .home-capability-icon{width:34px;height:34px}\n  .saas-main-home .home-capability h3{font-size:16px}\n  .saas-main-home .home-capability p{font-size:13px}\n}\n\n/* Sprint 5 — database / organization settings */\n.settings-status{margin:0 0 14px;padding:10px 12px;border:1px solid #b8c2d1;border-radius:8px;background:#f7faff;color:#172b4d;font-size:12px}\n.settings-actions{display:flex;align-items:center;gap:10px;margin-top:16px;flex-wrap:wrap}\n.settings-saved-at{font-size:11px;color:#6b778c}\n.org-profile-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px 16px}\n.org-profile-grid label{display:grid;gap:6px;font-size:11px;font-weight:700;color:#44546f}\n.org-profile-grid input,.org-profile-grid textarea{width:100%;border:1px solid #cdd3dc;border-radius:8px;background:#fff;color:#172b4d;padding:9px 10px;font:inherit;font-weight:400;outline:none}\n.org-profile-grid input:focus,.org-profile-grid textarea:focus{border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.12)}\n.org-profile-grid textarea{resize:vertical;line-height:1.45}\n.org-profile-grid .wide{grid-column:1/-1}\n@media(max-width:900px){.org-profile-grid{grid-template-columns:1fr}}\n\n/* Sprint 5B — Authentication & account */\n.boot-screen,.service-error{min-height:100vh;display:grid;place-items:center;background:#f7f8fa;color:#0b1f44;font-family:var(--pa-font)}\n.boot-screen>*,.service-error>div{text-align:center}.boot-spinner{width:32px;height:32px;border:3px solid #dfe3e8;border-top-color:#0c66e4;border-radius:50%;animation:pa-spin .8s linear infinite;margin:0 auto 12px}@keyframes pa-spin{to{transform:rotate(360deg)}}\n.service-error>div{max-width:520px;padding:32px}.service-error h1{font-size:28px;margin:0 0 10px}.service-error p{color:#6b778c;line-height:1.5}.service-error button{margin-top:14px;background:#0c66e4;color:#fff;border:0;border-radius:8px;padding:10px 18px;font-weight:700;cursor:pointer}\n\n.auth-root{min-height:100vh;display:grid;grid-template-columns:minmax(0,1.08fr) minmax(430px,.92fr);background:#fff;font-family:var(--pa-font);color:#0b1f44}\n.auth-brand-panel{background:linear-gradient(135deg,#f8fbff,#eef5ff);padding:clamp(34px,4vw,70px);display:flex;flex-direction:column;min-height:100vh}\n.auth-brand{display:flex;align-items:center;gap:12px}.auth-brand img{width:42px;height:42px}.auth-brand b{display:block;font-size:20px}.auth-brand span{display:block;color:#6b778c;font-size:12px;margin-top:3px}\n.auth-value{margin:auto 0;max-width:760px}.auth-value h1{font-size:clamp(38px,3.6vw,60px);line-height:1.04;letter-spacing:-.035em;margin:12px 0 20px}.auth-value>p{font-size:18px;line-height:1.55;color:#44546f;max-width:660px}\n.auth-value-points{display:grid;gap:12px;margin-top:30px}.auth-value-points>div{display:flex;align-items:center;gap:10px;font-size:14px;font-weight:650;color:#253858}.auth-value-points svg{color:#0c66e4}\n.auth-form-panel{display:grid;place-items:center;padding:36px}.auth-card{width:min(440px,100%)}.auth-card-head h2{font-size:32px;letter-spacing:-.025em;margin:0 0 8px}.auth-card-head p{color:#6b778c;font-size:14px;margin:0 0 26px}\n.auth-error{padding:10px 12px;border:1px solid #ffbdad;background:#ffebe6;color:#ae2a19;border-radius:8px;font-size:12px;margin-bottom:14px}\n.auth-form{display:grid;gap:16px}.auth-form label{display:grid;gap:7px;color:#253858;font-size:12px;font-weight:700}.auth-form small{font-size:10px;color:#7a869a;font-weight:400}.auth-input{height:44px;border:1px solid #cdd3dc;border-radius:8px;display:flex;align-items:center;gap:9px;padding:0 12px;color:#6b778c}.auth-input:focus-within{border-color:#579dff;box-shadow:0 0 0 2px rgba(12,102,228,.12)}.auth-input input{border:0;outline:0;flex:1;min-width:0;background:transparent;color:#172b4d;font-size:14px}\n.auth-primary{height:44px;border:0;border-radius:8px;background:#0c66e4;color:#fff;font-size:14px;font-weight:750;cursor:pointer}.auth-primary:disabled{opacity:.6}\n.auth-divider{display:flex;align-items:center;gap:12px;color:#8993a4;font-size:11px;margin:22px 0}.auth-divider:before,.auth-divider:after{content:\"\";height:1px;background:#dfe3e8;flex:1}\n.auth-social{display:grid;gap:9px}.auth-social a{height:42px;border:1px solid #cdd3dc;border-radius:8px;display:grid;place-items:center;text-decoration:none;color:#172b4d;font-size:13px;font-weight:700;background:#fff}.auth-social a:hover{background:#f7f8fa}\n.auth-switch{text-align:center;margin-top:24px;font-size:12px;color:#6b778c}.auth-switch button{border:0;background:transparent;color:#0c66e4;font-weight:750;cursor:pointer;padding:0 3px}\n.account-menu{position:relative}.account-menu summary{list-style:none;cursor:pointer;display:flex;align-items:center;gap:9px;padding:4px 7px;border-radius:8px}.account-menu summary::-webkit-details-marker{display:none}.account-menu summary:hover{background:#f4f5f7}.account-avatar{width:32px;height:32px;border-radius:50%;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;font-weight:800}.account-label{display:grid;gap:1px;text-align:left}.account-label b{font-size:11px;color:#172b4d}.account-label small{font-size:9px;color:#7a869a}\n.account-popover{position:absolute;right:0;top:44px;width:240px;background:#fff;border:1px solid #dfe3e8;border-radius:10px;box-shadow:0 10px 28px rgba(9,30,66,.18);padding:8px;z-index:100}.account-meta{display:grid;gap:3px;padding:9px 10px 11px;border-bottom:1px solid #eef0f3;margin-bottom:5px}.account-meta b{font-size:12px}.account-meta span{font-size:10px;color:#6b778c}.account-popover button{width:100%;height:34px;border:0;background:transparent;border-radius:7px;text-align:left;padding:0 10px;color:#172b4d;cursor:pointer}.account-popover button:hover{background:#f4f5f7}\n@media(max-width:900px){.auth-root{grid-template-columns:1fr}.auth-brand-panel{display:none}.auth-form-panel{min-height:100vh}}\n\n/* Sprint 5B OAuth parity with Billing Portal */\n.auth-social-primary{margin:18px 0 0}\n.auth-social-primary a{grid-template-columns:30px 1fr;justify-items:start;padding:0 14px;position:relative}\n.auth-social-primary a span:last-child{justify-self:center;margin-right:30px}\n.auth-social-primary a.disabled{opacity:.45;cursor:not-allowed;background:#f7f8fa}\n.provider-mark{width:22px;height:22px;display:grid;place-items:center;flex:0 0 auto}\n.provider-mark.google{font-family:Arial,sans-serif;font-weight:800;font-size:17px;color:#4285f4}\n.provider-mark.microsoft{grid-template-columns:repeat(2,8px);grid-template-rows:repeat(2,8px);gap:2px}\n.provider-mark.microsoft i{display:block;width:8px;height:8px;background:#666}\n.provider-mark.microsoft i:nth-child(1){background:#f25022}.provider-mark.microsoft i:nth-child(2){background:#7fba00}.provider-mark.microsoft i:nth-child(3){background:#00a4ef}.provider-mark.microsoft i:nth-child(4){background:#ffb900}\n.auth-provider-note{margin:9px 2px 0;font-size:10px;line-height:1.4;color:#8993a4}\n\n/* Sprint 5B — OAuth button layout correction */\n.auth-social-primary{\n  display:grid;\n  gap:10px;\n  margin:18px 0 0;\n}\n.auth-social-primary a{\n  height:46px;\n  display:flex;\n  align-items:center;\n  justify-content:flex-start;\n  gap:12px;\n  padding:0 16px;\n  border:1px solid #cdd3dc;\n  border-radius:8px;\n  background:#fff;\n  color:#172b4d;\n  text-decoration:none;\n  font-size:14px;\n  font-weight:700;\n  white-space:nowrap;\n  box-sizing:border-box;\n}\n.auth-social-primary a:hover{background:#f7f8fa;border-color:#b6bec9}\n.auth-social-primary .provider-mark{\n  width:24px;\n  height:24px;\n  flex:0 0 24px;\n}\n.auth-social-primary .provider-label{\n  flex:1 1 auto;\n  min-width:0;\n  text-align:center;\n  padding-right:24px;\n}\n.auth-social-primary a.disabled{\n  opacity:.45;\n  pointer-events:none;\n}\n\n/* Sprint 5B — Billing Portal OAuth visual parity */\n.auth-social-primary{\n  display:grid;\n  gap:12px;\n  margin-top:18px;\n}\n.auth-social-primary a{\n  width:100%;\n  min-height:46px;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  gap:12px;\n  padding:0 16px;\n  border:1px solid #cbd5e1;\n  border-radius:9px;\n  background:#fff;\n  color:#172b4d;\n  font-size:14px;\n  font-weight:700;\n  text-decoration:none;\n  box-sizing:border-box;\n}\n.auth-social-primary a:hover{background:#f8fafc;border-color:#94a3b8}\n.auth-social-primary a.disabled{opacity:.45;pointer-events:none}\n.provider-svg{width:20px;height:20px;flex:0 0 20px}\n.auth-social-primary .provider-label{\n  flex:0 1 auto;\n  min-width:0;\n  text-align:left;\n  padding:0;\n  white-space:nowrap;\n}\n\n/* Sprint 5C — staged CSV model builder */\n.wizard-steps-six{\n  grid-template-columns:repeat(6,minmax(0,1fr));\n  margin-bottom:18px;\n}\n.wizard-steps-six .wizard-step{\n  appearance:none;\n  border:0;\n  background:transparent;\n  cursor:pointer;\n  text-align:left;\n}\n.wizard-steps-six .wizard-step.current{\n  color:#0c66e4;\n  font-weight:800;\n}\n.field-help-card{\n  min-height:42px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#f7f8fa;\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  padding:8px 12px;\n  box-sizing:border-box;\n}\n.field-help-card b{font-size:11px;color:#172b4d}\n.field-help-card span{font-size:10px;color:#6b778c;margin-top:2px}\n.form-grid label small{\n  display:block;\n  margin-top:5px;\n  color:#7a869a;\n  font-size:10px;\n  line-height:1.4;\n  font-weight:400;\n}\n.button-row.between{\n  justify-content:space-between;\n}\n.attribute-role-grid{\n  display:grid;\n  border:1px solid #dfe3e8;\n  border-radius:10px;\n  overflow:hidden;\n}\n.attribute-role-row{\n  min-height:54px;\n  display:grid;\n  grid-template-columns:minmax(0,1fr) 210px;\n  gap:18px;\n  align-items:center;\n  padding:9px 12px;\n  border-bottom:1px solid #eef0f3;\n  background:#fff;\n}\n.attribute-role-row:last-child{border-bottom:0}\n.attribute-role-row>div{display:grid;gap:2px;min-width:0}\n.attribute-role-row b{font-size:12px;color:#172b4d;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n.attribute-role-row span{font-size:10px;color:#7a869a}\n.attribute-role-row select{\n  height:34px;\n  border:1px solid #cdd3dc;\n  border-radius:7px;\n  background:#fff;\n  color:#172b4d;\n  padding:0 8px;\n}\n.run-review-grid{\n  display:grid;\n  grid-template-columns:repeat(3,minmax(0,1fr));\n  gap:10px;\n  margin-bottom:16px;\n}\n.run-review-grid>div{\n  display:grid;\n  gap:4px;\n  border:1px solid #dfe3e8;\n  background:#f8fafc;\n  border-radius:9px;\n  padding:11px 12px;\n}\n.run-review-grid span{font-size:10px;text-transform:uppercase;letter-spacing:.04em;font-weight:700;color:#6b778c}\n.run-review-grid b{font-size:12px;color:#172b4d;overflow:hidden;text-overflow:ellipsis}\n.storage-consent{\n  display:flex;\n  align-items:flex-start;\n  gap:10px;\n  border:1px solid #b8c2d1;\n  border-radius:10px;\n  padding:13px 14px;\n  margin:14px 0;\n  background:#fff;\n  cursor:pointer;\n}\n.storage-consent input{margin-top:2px}\n.storage-consent>span{display:grid;gap:4px}\n.storage-consent b{font-size:12px;color:#172b4d}\n.storage-consent small{font-size:10px;line-height:1.45;color:#6b778c}\n@media(max-width:1100px){\n  .wizard-steps-six{grid-template-columns:repeat(3,1fr);row-gap:8px}\n  .run-review-grid{grid-template-columns:repeat(2,1fr)}\n}\n\n/* Sprint 5C refinement — help, semantic attributes, typography */\n.field-label-with-help{\n  display:inline-flex;\n  align-items:center;\n  gap:5px;\n  font-family:var(--pa-font);\n  font-weight:700;\n}\n.field-tip{\n  display:inline-flex;\n  align-items:center;\n  justify-content:center;\n  color:#6b778c;\n  cursor:help;\n  vertical-align:middle;\n}\n.field-tip:hover{color:#0c66e4}\n.attribute-help-strip{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:8px 14px;\n  padding:12px 14px;\n  margin-bottom:12px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  background:#f8fafc;\n  font-family:var(--pa-font);\n}\n.attribute-help-strip span{\n  font-family:var(--pa-font);\n  font-size:11px;\n  line-height:1.45;\n  color:#44546f;\n}\n.attribute-help-strip b{\n  font-family:var(--pa-font);\n  color:#172b4d;\n  font-weight:700;\n}\n.attribute-role-grid,\n.attribute-role-row,\n.attribute-role-row *,\n.attribute-role-row select,\n.attribute-role-row input{\n  font-family:var(--pa-font) !important;\n}\n.attribute-role-row{\n  grid-template-columns:minmax(180px,1fr) minmax(220px,1.35fr) 210px;\n}\n.attribute-role-name{\n  display:grid;\n  gap:2px;\n  min-width:0;\n}\n.attribute-role-name b{\n  font-size:12px;\n  line-height:1.3;\n  color:#172b4d;\n  font-weight:700;\n}\n.attribute-role-name span{\n  font-size:10px;\n  line-height:1.35;\n  color:#6b778c;\n}\n.attribute-meaning{\n  width:100%;\n  height:34px;\n  box-sizing:border-box;\n  border:1px solid #cdd3dc;\n  border-radius:7px;\n  padding:0 9px;\n  color:#172b4d;\n  background:#fff;\n  font-size:11px;\n}\n.attribute-meaning:focus{\n  outline:none;\n  border-color:#579dff;\n  box-shadow:0 0 0 2px rgba(12,102,228,.10);\n}\n.review-span{\n  grid-column:1 / -1;\n}\n.model-objective{\n  margin-top:12px;\n  padding-top:10px;\n  border-top:1px solid #eef0f3;\n}\n.model-objective span{\n  display:block;\n  margin-bottom:4px;\n  color:#6b778c;\n  font-size:10px;\n  font-weight:700;\n  text-transform:uppercase;\n  letter-spacing:.04em;\n}\n.model-objective p{\n  margin:0;\n  color:#172b4d;\n  font-size:12px;\n  line-height:1.5;\n}\n@media(max-width:1200px){\n  .attribute-role-row{grid-template-columns:minmax(160px,1fr) minmax(190px,1fr)}\n  .attribute-role-row select{grid-column:2}\n}\n\n/* Sprint 5D — Access, billing and entitlement UX */\n.billing-portal-link{display:inline-flex;align-items:center;gap:7px;text-decoration:none}\n.access-summary-grid{\n  display:grid;\n  grid-template-columns:repeat(3,minmax(0,1fr));\n  gap:14px;\n  margin-bottom:18px;\n}\n.access-summary-card{\n  min-height:142px;\n  border:1px solid #dfe3e8;\n  border-radius:12px;\n  background:#fff;\n  padding:16px;\n  display:grid;\n  grid-template-columns:42px 1fr;\n  grid-template-rows:auto auto 1fr;\n  column-gap:12px;\n}\n.access-summary-card.available{border-color:#b7e4c7;background:#fbfffc}\n.access-summary-card.used{background:#f8fafc}\n.access-card-icon{\n  grid-row:1/4;\n  width:38px;height:38px;border-radius:10px;\n  display:grid;place-items:center;background:#e9f2ff;color:#0c66e4;\n}\n.access-summary-card>span{font-size:10px;text-transform:uppercase;letter-spacing:.045em;font-weight:800;color:#6b778c}\n.access-summary-card>strong{font-size:20px;line-height:1.25;color:#172b4d;margin-top:2px}\n.access-summary-card>p{font-size:11px;line-height:1.45;color:#6b778c;margin:7px 0 0}\n.entitlement-explainer{display:grid;gap:10px}\n.entitlement-explainer>div{display:grid;grid-template-columns:170px 1fr;gap:14px;padding:10px 0;border-bottom:1px solid #eef0f3}\n.entitlement-explainer>div:last-child{border-bottom:0}\n.entitlement-explainer b{font-size:12px;color:#172b4d}\n.entitlement-explainer span{font-size:11px;line-height:1.45;color:#6b778c}\n.run-access-strip{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:10px;\n  margin:14px 0;\n}\n.run-access-strip>span{\n  display:grid;gap:3px;padding:10px 12px;border:1px solid #dfe3e8;border-radius:9px;background:#f8fafc;\n  color:#6b778c;font-size:10px;\n}\n.run-access-strip b{font-size:11px;color:#172b4d}\n.storage-consent.disabled{opacity:.65;background:#f7f8fa;cursor:not-allowed}\n@media(max-width:1050px){\n  .access-summary-grid{grid-template-columns:1fr}\n  .run-access-strip{grid-template-columns:1fr}\n}\n\n.access-topbar-pill{\n  height:34px;\n  display:inline-flex;\n  align-items:center;\n  gap:7px;\n  border:1px solid #dfe3e8;\n  border-radius:18px;\n  background:#fff;\n  color:#253858;\n  padding:0 11px;\n  font-size:10px;\n  font-weight:750;\n  cursor:pointer;\n}\n.access-topbar-pill:hover{background:#f4f5f7;border-color:#b6bec9}\n\n/* Sprint 6A — AI settings */\n.ai-mode-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;margin-bottom:14px}.ai-mode-card{display:flex;gap:10px;align-items:flex-start;border:1px solid #dfe3e8;border-radius:10px;padding:13px;background:#fff;cursor:pointer}.ai-mode-card.active{border-color:#579dff;background:#f4f9ff}.ai-mode-card input{margin-top:3px}.ai-mode-card span{display:grid;gap:4px}.ai-mode-card b{font-size:12px;color:#172b4d}.ai-mode-card small{font-size:10px;line-height:1.45;color:#6b778c}.ai-context-note{display:grid;gap:4px;margin:12px 0;padding:11px 12px;border:1px solid #dfe3e8;border-radius:9px;background:#f8fafc}.ai-context-note b{font-size:11px;color:#172b4d}.ai-context-note span{font-size:10px;line-height:1.5;color:#44546f}@media(max-width:950px){.ai-mode-grid{grid-template-columns:1fr}}\n\n/* Sprint 6A UX refinement */\n.settings-tabs{\n  display:flex;\n  align-items:center;\n  gap:4px;\n  margin:0 0 16px;\n  padding:4px;\n  width:max-content;\n  max-width:100%;\n  border:1px solid #dfe3e8;\n  border-radius:10px;\n  background:#f7f8fa;\n}\n.settings-tabs button{\n  appearance:none;\n  border:0;\n  border-radius:7px;\n  background:transparent;\n  color:#44546f;\n  padding:9px 14px;\n  font-family:var(--pa-font);\n  font-size:12px;\n  font-weight:700;\n  cursor:pointer;\n}\n.settings-tabs button:hover{background:#fff}\n.settings-tabs button.active{\n  background:#fff;\n  color:#0c66e4;\n  box-shadow:0 1px 3px rgba(9,30,66,.12);\n}\n.ai-test-result{\n  margin-top:14px;\n  display:grid;\n  gap:4px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  padding:11px 13px;\n  font-family:var(--pa-font);\n}\n.ai-test-result b{font-size:12px;color:#172b4d}\n.ai-test-result span{font-size:11px;color:#44546f;line-height:1.45}\n.ai-test-result.testing{background:#f4f8ff;border-color:#b3d4ff}\n.ai-test-result.success{background:#effcf4;border-color:#b7e4c7}\n.ai-test-result.error{background:#fff4f2;border-color:#ffbdad}\n.ai-test-result.error b{color:#ae2a19}\n@media(max-width:900px){\n  .settings-tabs{width:100%;overflow:auto}\n  .settings-tabs button{white-space:nowrap}\n}\n\n/* Sprint 6B refinement — CSV attribute selector typography */\n.attribute-role-row select,\n.attribute-role-row select option,\n.attribute-role-grid select,\n.attribute-role-grid select option {\n  font-family: var(--pa-font) !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 1.35;\n  color: #172b4d;\n}\n.attribute-role-row select {\n  min-height: 36px;\n}\n\n/* Sprint 7A — source adaptor / connection foundation */\n.connections-panel-body{padding:0}\n.connections-settings{font-family:var(--pa-font)}\n.connections-toolbar{display:flex;align-items:flex-start;justify-content:space-between;gap:20px;padding:18px 20px;border-bottom:1px solid #eef0f3}\n.connections-toolbar h2{margin:0 0 4px;font-size:18px;color:#172b4d}\n.connections-toolbar p{margin:0;color:#6b778c;font-size:11px}\n.connections-actions{display:flex;gap:8px}\n.connections-actions button{display:inline-flex;align-items:center;gap:6px}\n.connection-summary{display:flex;gap:22px;padding:12px 20px;border-bottom:1px solid #eef0f3;background:#fafbfc;color:#6b778c;font-size:11px}\n.connection-summary b{color:#172b4d;font-size:14px;margin-right:3px}\n.empty-connections,.rest-empty{min-height:180px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:8px;padding:28px;color:#6b778c}\n.empty-connections b,.rest-empty b{color:#172b4d;font-size:14px}\n.empty-connections span,.rest-empty span{max-width:560px;font-size:11px;line-height:1.5}\n.connection-list{display:grid}\n.connection-row{display:grid;grid-template-columns:42px minmax(0,1fr) auto auto;gap:12px;align-items:center;padding:13px 20px;border-bottom:1px solid #eef0f3}\n.connection-mark{width:36px;height:36px;border-radius:9px;display:grid;place-items:center;background:#e9f2ff;color:#0c66e4}\n.connection-mark.servicenow-rest{background:#effcf4;color:#087443}\n.connection-main{display:grid;gap:3px}\n.connection-main b{font-size:12px;color:#172b4d}\n.connection-main span{font-size:10px;color:#6b778c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n.connection-row-actions{display:flex;gap:5px}\n.icon-button{width:32px;height:32px;display:grid;place-items:center;border:1px solid #dfe3e8;border-radius:7px;background:#fff;color:#44546f;cursor:pointer}\n.icon-button:hover{background:#f4f5f7}\n.icon-button.danger{color:#ae2a19}\n.connection-editor{margin:18px 20px;padding:16px;border:1px solid #b3d4ff;border-radius:10px;background:#fbfdff}\n.connection-editor-head{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px}\n.connection-editor-head h3{margin:0;font-size:15px;color:#172b4d}\n.connection-editor-head p{margin:3px 0 0;font-size:10px;color:#6b778c}\n.connection-secret{height:40px;display:flex;align-items:center;gap:8px;border:1px solid #cdd3dc;border-radius:7px;padding:0 10px;background:#fff}\n.connection-secret input{border:0!important;box-shadow:none!important;padding:0!important;height:auto!important;flex:1}\n.connection-choice-grid{display:grid;gap:10px}\n.connection-choice{display:grid;grid-template-columns:34px minmax(0,1fr) auto;align-items:center;text-align:left;gap:10px;padding:12px 14px;border:1px solid #dfe3e8;border-radius:9px;background:#fff;cursor:pointer}\n.connection-choice:hover{border-color:#85b8ff}\n.connection-choice.selected{border-color:#0c66e4;background:#f4f8ff;box-shadow:0 0 0 1px #0c66e4 inset}\n.connection-choice span{display:grid;gap:2px}\n.connection-choice b{font-size:12px;color:#172b4d}\n.connection-choice small{font-size:10px;color:#6b778c}\n.connection-choice em{font-style:normal;font-size:10px;color:#087443}\n.adapter-foundation-card{margin-top:14px;padding:14px;border:1px solid #dfe3e8;border-radius:9px;background:#f8fafc;display:grid;gap:7px}\n.adapter-foundation-card b{font-size:12px;color:#172b4d}\n.adapter-foundation-card>span{font-size:10px;line-height:1.5;color:#6b778c}\n.adapter-operation-row{display:flex;flex-wrap:wrap;gap:6px;margin-top:3px}\n.adapter-operation-row span{padding:5px 8px;border-radius:12px;background:#e9f2ff;color:#0c66e4;font-size:9px;font-weight:700}\n@media(max-width:900px){\n  .connections-toolbar{flex-direction:column}\n  .connection-row{grid-template-columns:36px minmax(0,1fr) auto}\n  .connection-row>.status-pill{display:none}\n}\n\n/* Sprint 7A — real connection testing */\n.connection-test-result{\n  margin-top:12px;\n  display:grid;\n  gap:4px;\n  padding:10px 12px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#f8fafc;\n}\n.connection-test-result b{font-size:11px;color:#172b4d}\n.connection-test-result span{font-size:10px;color:#44546f;line-height:1.45}\n.connection-test-result.testing{background:#f4f8ff;border-color:#b3d4ff}\n.connection-test-result.success{background:#effcf4;border-color:#b7e4c7}\n.connection-test-result.success b{color:#087443}\n.connection-test-result.error{background:#fff4f2;border-color:#ffbdad}\n.connection-test-result.error b{color:#ae2a19}\n\n/* Sprint 7B.1 — Jira authentication methods */\n.jira-auth-section{margin:16px 0 14px}\n.jira-auth-heading{display:grid;gap:3px;margin-bottom:9px}\n.jira-auth-heading b{font-size:12px;color:#172b4d}\n.jira-auth-heading span{font-size:10px;color:#6b778c}\n.jira-auth-methods{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:9px}\n.jira-auth-method{position:relative;display:grid;grid-template-columns:34px 1fr;gap:9px;align-items:start;text-align:left;padding:12px;border:1px solid #dfe3e8;border-radius:9px;background:#fff;cursor:pointer}\n.jira-auth-method:hover{border-color:#85b8ff}\n.jira-auth-method.selected{border-color:#0c66e4;background:#f4f8ff;box-shadow:0 0 0 1px #0c66e4 inset}\n.jira-auth-method-icon{width:31px;height:31px;display:grid;place-items:center;border-radius:8px;background:#e9f2ff;color:#0c66e4}\n.jira-auth-method>span:nth-child(2){display:grid;gap:4px;padding-right:34px}\n.jira-auth-method b{font-size:11px;color:#172b4d}\n.jira-auth-method small{font-size:9px;line-height:1.45;color:#6b778c}\n.jira-auth-method em{position:absolute;right:9px;top:9px;font-style:normal;font-size:8px;font-weight:700;color:#0c66e4}\n.oauth-connect-panel{display:flex;align-items:center;justify-content:space-between;gap:20px;padding:14px;border:1px solid #b3d4ff;border-radius:9px;background:#f4f8ff;margin:12px 0}\n.oauth-connect-panel>div{display:grid;gap:4px}\n.oauth-connect-panel b{font-size:12px;color:#172b4d}\n.oauth-connect-panel span{font-size:10px;color:#44546f;line-height:1.45}\n.oauth-connect-panel button{display:inline-flex;align-items:center;gap:7px;white-space:nowrap}\n.connection-credential-grid{margin-top:12px}\n@media(max-width:1050px){.jira-auth-methods{grid-template-columns:1fr}.oauth-connect-panel{align-items:flex-start;flex-direction:column}}\n\n/* Sprint 7B.2 — Jira REST source discovery and extraction */\n.jira-builder{font-family:var(--pa-font)}\n.jira-steps{max-width:760px;margin-bottom:18px}\n.jira-steps .builder-step{min-width:120px}\n.source-context-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 10px;border:1px solid #dfe3e8;border-radius:8px;background:#fff;color:#44546f;font-size:10px;font-weight:700}\n.jira-scope-body{display:grid;gap:18px}\n.jira-scope-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}\n.jira-choice-panel{border:1px solid #dfe3e8;border-radius:9px;background:#fff;overflow:hidden}\n.jira-choice-head{display:flex;align-items:center;justify-content:space-between;padding:10px 12px;background:#fafbfc;border-bottom:1px solid #eef0f3}\n.jira-choice-head b{font-size:11px;color:#172b4d}\n.jira-choice-head span{font-size:9px;color:#6b778c}\n.jira-choice-scroll{max-height:230px;overflow:auto}\n.jira-check-row{display:flex;align-items:flex-start;gap:9px;padding:9px 12px;border-bottom:1px solid #f1f2f4;cursor:pointer}\n.jira-check-row:last-child{border-bottom:0}\n.jira-check-row:hover{background:#f7f9fb}\n.jira-check-row input{margin-top:2px}\n.jira-check-row>span{display:grid;gap:2px;min-width:0}\n.jira-check-row b{font-size:10px;color:#172b4d}\n.jira-check-row small{font-size:9px;color:#6b778c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n.jira-scope-form{margin-top:0}\n.jira-limit-note{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:8px;background:#f4f8ff;border:1px solid #d7e7ff}\n.jira-limit-note b{font-size:10px;color:#172b4d}\n.jira-limit-note span{font-size:10px;color:#44546f}\n.jql-preview{display:grid;gap:7px;margin-top:14px;padding:11px 12px;background:#f8fafc;border:1px solid #dfe3e8;border-radius:8px}\n.jql-preview b{font-size:10px;color:#172b4d}\n.jql-preview code{white-space:pre-wrap;font-family:ui-monospace,SFMono-Regular,Consolas,monospace;font-size:9px;color:#44546f}\n.jira-activity-box{display:grid;grid-template-columns:minmax(280px,.8fr) 1.2fr;gap:16px;align-items:end;padding:14px;border:1px solid #b3d4ff;border-radius:9px;background:#f4f8ff}\n.jira-activity-box label{display:grid;gap:6px}\n.jira-activity-box label>span{font-size:10px;font-weight:700;color:#172b4d}\n.jira-activity-box select{height:40px;border:1px solid #cdd3dc;border-radius:7px;background:#fff;padding:0 10px;font-family:var(--pa-font);font-size:11px}\n.jira-activity-box>div{display:grid;gap:4px;padding-bottom:3px}\n.jira-activity-box b{font-size:12px;color:#172b4d}\n.jira-activity-box div span{font-size:10px;line-height:1.45;color:#44546f}\n.jira-attribute-head{display:flex;align-items:flex-end;justify-content:space-between;gap:20px;margin:18px 0 9px}\n.jira-attribute-head>div:first-child{display:grid;gap:3px}\n.jira-attribute-head b{font-size:12px;color:#172b4d}\n.jira-attribute-head span{font-size:10px;color:#6b778c}\n.jira-field-search{display:flex;align-items:center;gap:7px;width:300px;height:36px;border:1px solid #cdd3dc;border-radius:7px;padding:0 9px;background:#fff;color:#6b778c}\n.jira-field-search input{border:0!important;box-shadow:none!important;padding:0!important;height:auto!important;min-width:0;flex:1;font-family:var(--pa-font);font-size:10px}\n.jira-attribute-list{max-height:420px;overflow:auto;border:1px solid #dfe3e8;border-radius:9px}\n.jira-attribute-row{display:grid;grid-template-columns:minmax(260px,.8fr) 1.2fr;gap:14px;align-items:center;padding:9px 11px;border-bottom:1px solid #eef0f3}\n.jira-attribute-row:last-child{border-bottom:0}\n.jira-attribute-row.selected{background:#fbfdff}\n.jira-attr-select{display:flex;gap:9px;align-items:flex-start;cursor:pointer}\n.jira-attr-select input{margin-top:2px}\n.jira-attr-select span{display:grid;gap:2px}\n.jira-attr-select b{font-size:10px;color:#172b4d}\n.jira-attr-select small{font-size:8px;color:#6b778c}\n.jira-attribute-row>input{height:34px;border:1px solid #cdd3dc;border-radius:7px;padding:0 9px;font-family:var(--pa-font);font-size:10px}\n.jira-attribute-row>input:disabled{background:#f7f8fa;color:#8993a4}\n.jira-preview-table-wrap{overflow:auto;border:1px solid #dfe3e8;border-radius:9px}\n.jira-preview-table{width:100%;border-collapse:collapse;font-size:10px}\n.jira-preview-table th{text-align:left;padding:9px 10px;background:#fafbfc;border-bottom:1px solid #dfe3e8;color:#44546f;font-size:9px;text-transform:uppercase;letter-spacing:.02em}\n.jira-preview-table td{padding:9px 10px;border-bottom:1px solid #eef0f3;color:#44546f;max-width:300px}\n.jira-preview-table tr:last-child td{border-bottom:0}\n.jira-preview-table td b{color:#0c66e4}\n.jira-preview-summary{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-top:14px}\n.jira-preview-summary>div{display:grid;gap:3px;padding:11px;border:1px solid #dfe3e8;border-radius:8px;background:#fff}\n.jira-preview-summary b{font-size:14px;color:#172b4d}\n.jira-preview-summary span{font-size:9px;color:#6b778c}\n.jira-run-card{display:grid;gap:16px;padding:18px;border:1px solid #b3d4ff;border-radius:10px;background:#f8fbff}\n.jira-run-card>div:first-child{display:flex;align-items:center;gap:10px;color:#0c66e4}\n.jira-run-card>div:first-child>span{display:grid;gap:3px}\n.jira-run-card b{font-size:13px;color:#172b4d}\n.jira-run-card small{font-size:10px;color:#6b778c}\n.jira-run-flow{display:flex;align-items:center;flex-wrap:wrap;gap:7px}\n.jira-run-flow span{padding:6px 9px;border-radius:14px;background:#fff;border:1px solid #dfe3e8;font-size:9px;font-weight:700;color:#44546f}\n.jira-extracting{display:flex;align-items:center;gap:8px;padding:9px 10px;background:#fff;border:1px solid #dfe3e8;border-radius:7px;color:#44546f;font-size:10px}\n.rest-loading{min-height:180px;display:flex;align-items:center;justify-content:center;gap:9px;color:#44546f}\n.spin{animation:pa-spin 1s linear infinite}\n@keyframes pa-spin{to{transform:rotate(360deg)}}\n.adapter-card-actions{display:flex;justify-content:flex-end;margin-top:6px}\n@media(max-width:1000px){\n  .jira-scope-grid,.jira-activity-box{grid-template-columns:1fr}\n  .jira-attribute-row{grid-template-columns:1fr}\n  .jira-preview-summary{grid-template-columns:1fr 1fr}\n  .jira-field-search{width:240px}\n}\n\n/* Sprint 7B.2 hotfix — self-contained Jira wizard stepper */\n.jira-stage-strip{\n  display:flex;\n  align-items:center;\n  width:min(900px,100%);\n  margin:18px 0 22px;\n}\n.jira-stage{\n  display:flex;\n  align-items:center;\n  gap:7px;\n  white-space:nowrap;\n  color:#6b778c;\n  font-size:10px;\n  font-weight:600;\n}\n.jira-stage>span{\n  width:27px;\n  height:27px;\n  border:1px solid #cdd3dc;\n  border-radius:50%;\n  display:grid;\n  place-items:center;\n  background:#fff;\n  color:#44546f;\n  font-size:10px;\n  flex:0 0 auto;\n}\n.jira-stage>b{font-size:10px;font-weight:700}\n.jira-stage.active{color:#0c66e4}\n.jira-stage.active>span{\n  border-color:#0c66e4;\n  color:#0c66e4;\n  background:#e9f2ff;\n}\n.jira-stage.done{color:#0c66e4}\n.jira-stage.done>span{\n  border-color:#0c66e4;\n  background:#0c66e4;\n  color:#fff;\n}\n.jira-stage-line{\n  height:1px;\n  min-width:24px;\n  flex:1 1 50px;\n  margin:0 9px;\n  background:#dfe3e8;\n}\n.jira-stage-line.done{background:#0c66e4}\n\n/* Sprint 7B.2 UX refinement — enterprise Jira scope + extraction dialog */\n.jira-enterprise-panel{overflow:visible}\n.jira-panel-head{align-items:center}\n.jira-scope-summary-bar{\n  display:grid;\n  grid-template-columns:minmax(0,1fr) minmax(0,1fr) auto;\n  gap:10px;\n  padding:12px;\n  border:1px solid #dfe3e8;\n  border-radius:10px;\n  background:#fafbfc;\n}\n.jira-scope-summary-bar>div{\n  display:flex;\n  align-items:center;\n  gap:9px;\n  min-width:0;\n}\n.jira-scope-summary-bar svg{color:#0c66e4}\n.jira-scope-summary-bar span{display:grid;gap:1px}\n.jira-scope-summary-bar b{font-size:13px;color:#172b4d}\n.jira-scope-summary-bar small{font-size:9px;color:#6b778c}\n.jira-scope-summary-bar .jira-scope-limit{\n  padding-left:16px;\n  border-left:1px solid #dfe3e8;\n  justify-content:flex-end;\n}\n.jira-choice-panel.enterprise{\n  min-height:360px;\n  display:flex;\n  flex-direction:column;\n  border-color:#d9dfe7;\n  box-shadow:0 1px 2px rgba(9,30,66,.04);\n}\n.jira-choice-head.enterprise{\n  align-items:flex-start;\n  gap:12px;\n  padding:12px 14px 10px;\n}\n.jira-choice-head.enterprise>div:first-child{display:grid;gap:3px}\n.jira-choice-actions{display:flex;gap:5px;flex-wrap:wrap;justify-content:flex-end}\n.jira-choice-actions button{\n  border:0;\n  background:transparent;\n  color:#0c66e4;\n  font-family:var(--pa-font);\n  font-size:9px;\n  font-weight:700;\n  cursor:pointer;\n  padding:3px 4px;\n}\n.jira-choice-actions button:hover{text-decoration:underline}\n.jira-list-search{\n  display:flex;\n  align-items:center;\n  gap:7px;\n  margin:10px 12px 8px;\n  height:34px;\n  padding:0 9px;\n  border:1px solid #cdd3dc;\n  border-radius:7px;\n  background:#fff;\n  color:#6b778c;\n}\n.jira-list-search:focus-within{border-color:#0c66e4;box-shadow:0 0 0 1px #0c66e4}\n.jira-list-search input{\n  border:0!important;\n  box-shadow:none!important;\n  padding:0!important;\n  height:auto!important;\n  flex:1;\n  min-width:0;\n  font-family:var(--pa-font);\n  font-size:10px;\n  background:transparent;\n}\n.jira-choice-panel.enterprise .jira-choice-scroll{\n  max-height:270px;\n  flex:1 1 auto;\n}\n.jira-choice-panel.enterprise .jira-check-row{\n  padding:10px 13px;\n}\n.jira-choice-panel.enterprise .jira-check-row:hover{background:#f4f8ff}\n.jira-choice-panel.enterprise .jira-check-row:has(input:checked){background:#f7fbff}\n.jira-list-empty{\n  padding:28px 14px;\n  text-align:center;\n  color:#6b778c;\n  font-size:10px;\n}\n.jira-scope-advanced{\n  border-top:1px solid #eef0f3;\n  padding-top:4px;\n}\n.jira-section-heading{display:grid;gap:3px;margin-bottom:10px}\n.jira-section-heading b{font-size:11px;color:#172b4d}\n.jira-section-heading span{font-size:9px;color:#6b778c}\n.jira-validation-result{\n  display:grid;\n  grid-template-columns:auto 1fr;\n  gap:10px;\n  align-items:center;\n  padding:12px 14px;\n  border-radius:9px;\n  border:1px solid #b7e4c7;\n  background:#effcf4;\n}\n.jira-validation-result.error{\n  border-color:#ffbdad;\n  background:#fff4f2;\n}\n.jira-validation-icon{color:#087443;display:grid;place-items:center}\n.jira-validation-result.error .jira-validation-icon{color:#ae2a19}\n.jira-validation-result>div:nth-child(2){display:grid;gap:3px}\n.jira-validation-result b{font-size:11px;color:#172b4d}\n.jira-validation-result span{font-size:10px;color:#44546f}\n.jira-validation-result.compact{\n  grid-template-columns:auto 1fr auto;\n  margin-bottom:14px;\n}\n.jira-inline-link{\n  border:0;\n  background:transparent;\n  color:#0c66e4;\n  font-family:var(--pa-font);\n  font-size:9px;\n  font-weight:700;\n  cursor:pointer;\n}\n.jira-panel-footer{\n  display:flex!important;\n  align-items:center;\n  justify-content:space-between!important;\n  gap:16px;\n  padding:14px 16px!important;\n  border-top:1px solid #eef0f3;\n  background:#fafbfc;\n}\n.jira-footer-actions{\n  display:flex;\n  align-items:center;\n  justify-content:flex-end;\n  gap:12px;\n  margin-left:auto;\n}\n.jira-footer-actions>span{\n  color:#6b778c;\n  font-size:9px;\n}\n.jira-footer-actions .pa-primary{\n  min-width:145px;\n  display:inline-flex;\n  justify-content:center;\n  align-items:center;\n  gap:6px;\n}\n\n/* Extraction progress dialog - mirrors the installed-app extraction experience */\n.jira-extraction-overlay{\n  position:fixed;\n  inset:0;\n  z-index:10000;\n  background:rgba(9,30,66,.68);\n  display:grid;\n  place-items:center;\n  padding:24px;\n  backdrop-filter:blur(1px);\n}\n.jira-extraction-dialog{\n  width:min(660px,calc(100vw - 48px));\n  border-radius:16px;\n  background:#fff;\n  box-shadow:0 22px 70px rgba(9,30,66,.32);\n  padding:30px 34px 28px;\n}\n.jira-extraction-top{\n  display:flex;\n  align-items:flex-start;\n  justify-content:space-between;\n  gap:28px;\n}\n.jira-extraction-top>div{display:grid;gap:8px}\n.jira-extraction-top span{\n  font-size:10px;\n  font-weight:800;\n  letter-spacing:.08em;\n  color:#44546f;\n}\n.jira-extraction-top h2{\n  margin:0;\n  font-size:25px;\n  line-height:1.18;\n  color:#172b4d;\n}\n.jira-extraction-top p{\n  margin:0;\n  color:#44546f;\n  font-size:12px;\n  line-height:1.5;\n  max-width:470px;\n}\n.jira-extraction-top strong{\n  color:#0c66e4;\n  font-size:38px;\n  line-height:1;\n  font-weight:800;\n}\n.jira-progress-track{\n  height:10px;\n  border-radius:999px;\n  background:#dfe7f3;\n  overflow:hidden;\n  margin:24px 0 20px;\n}\n.jira-progress-fill{\n  height:100%;\n  border-radius:inherit;\n  background:#0c66e4;\n  transition:width .35s ease;\n}\n.jira-extraction-stats{\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  gap:16px;\n}\n.jira-extraction-stats>div{\n  min-height:86px;\n  display:grid;\n  align-content:center;\n  gap:7px;\n  padding:14px 18px;\n  border:1px solid #d7e2f0;\n  border-radius:12px;\n  background:#f8fbff;\n}\n.jira-extraction-stats span{\n  color:#44546f;\n  font-size:10px;\n  font-weight:800;\n  letter-spacing:.04em;\n}\n.jira-extraction-stats b{\n  color:#172b4d;\n  font-size:21px;\n  line-height:1.15;\n}\n.jira-extraction-model{\n  display:flex;\n  align-items:center;\n  gap:10px;\n  margin-top:18px;\n  padding:12px 14px;\n  border:1px solid #e1e5eb;\n  border-radius:10px;\n  color:#0c66e4;\n}\n.jira-extraction-model>div{display:grid;gap:2px}\n.jira-extraction-model b{font-size:11px;color:#172b4d}\n.jira-extraction-model span{font-size:9px;color:#6b778c}\n.jira-extraction-note{\n  margin-top:16px;\n  color:#44546f;\n  font-size:10px;\n  line-height:1.5;\n}\n@media(max-width:1000px){\n  .jira-scope-summary-bar{grid-template-columns:1fr 1fr}\n  .jira-scope-summary-bar .jira-scope-limit{grid-column:1 / -1;border-left:0;border-top:1px solid #dfe3e8;padding:10px 0 0}\n}\n@media(max-width:700px){\n  .jira-scope-summary-bar{grid-template-columns:1fr}\n  .jira-panel-footer{align-items:flex-start;flex-direction:column}\n  .jira-footer-actions{width:100%;flex-direction:column;align-items:stretch}\n  .jira-extraction-dialog{padding:24px 20px}\n  .jira-extraction-stats{grid-template-columns:1fr}\n  .jira-extraction-top strong{font-size:30px}\n}\n\n/* Sprint 7B.2 persistence fix — Jira model retention */\n.jira-retention-card{\n  display:flex;\n  align-items:flex-start;\n  justify-content:space-between;\n  gap:18px;\n  margin-bottom:16px;\n  padding:14px 16px;\n  border:1px solid #dfe3e8;\n  border-radius:10px;\n  background:#fff;\n}\n.jira-retention-card.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n.jira-retention-card.disabled{\n  background:#fafbfc;\n}\n.jira-retention-card label{\n  display:flex;\n  align-items:flex-start;\n  gap:10px;\n  cursor:pointer;\n  min-width:0;\n}\n.jira-retention-card.disabled label{cursor:not-allowed}\n.jira-retention-card input{\n  margin-top:3px;\n  width:15px;\n  height:15px;\n  accent-color:#0c66e4;\n}\n.jira-retention-card label>span{\n  display:grid;\n  gap:4px;\n}\n.jira-retention-card b{\n  font-size:11px;\n  color:#172b4d;\n}\n.jira-retention-card small{\n  max-width:850px;\n  font-size:9px;\n  line-height:1.5;\n  color:#6b778c;\n}\n.jira-retention-status{\n  flex:0 0 auto;\n  border-radius:999px;\n  padding:5px 9px;\n  font-size:9px;\n  font-weight:700;\n}\n.jira-retention-status.on{\n  background:#dcfff1;\n  color:#087443;\n}\n.jira-retention-status.off{\n  background:#f1f2f4;\n  color:#44546f;\n}\n\n/* Sprint 7B.2 — Jira wizard usability redesign */\n.jira-builder-v2{\n  font-size:13px;\n}\n.jira-builder-v2 .page-head{\n  margin-bottom:10px;\n}\n.jira-builder-v2 .page-head h1{\n  font-size:31px;\n  line-height:1.15;\n  margin-bottom:4px;\n}\n.jira-builder-v2 .page-head p{\n  font-size:13px;\n  line-height:1.45;\n}\n.jira-builder-v2 .eyebrow{\n  font-size:11px;\n  letter-spacing:.06em;\n}\n.jira-builder-v2 .jira-stage-strip{\n  margin:10px 0 16px;\n  width:min(940px,100%);\n}\n.jira-builder-v2 .jira-stage{\n  gap:8px;\n  font-size:12px;\n}\n.jira-builder-v2 .jira-stage>b{\n  font-size:12px;\n}\n.jira-builder-v2 .jira-stage>span{\n  width:31px;\n  height:31px;\n  font-size:11px;\n}\n.jira-builder-v2 .jira-stage-line{\n  margin:0 10px;\n}\n.jira-wizard-alert{\n  margin-bottom:12px;\n  font-size:12px;\n}\n.jira-wizard-panel{\n  overflow:visible;\n}\n.jira-wizard-panel .panel-head.compact{\n  min-height:auto;\n  padding:15px 20px;\n}\n.jira-wizard-panel .panel-head h2{\n  margin:0 0 4px;\n  font-size:18px;\n  line-height:1.25;\n}\n.jira-wizard-panel .panel-head p{\n  margin:0;\n  font-size:12px;\n  line-height:1.4;\n}\n.jira-scope-compact-body,\n.jira-model-compact-body,\n.jira-attributes-compact-body,\n.jira-preview-compact-body,\n.jira-run-compact-body{\n  padding:18px 20px!important;\n}\n.jira-scope-primary-grid{\n  display:grid;\n  grid-template-columns:minmax(0,1fr) minmax(0,1fr) 230px;\n  gap:14px;\n  align-items:end;\n}\n.jira-compact-picker{\n  position:relative;\n  display:grid;\n  gap:7px;\n}\n.jira-compact-picker>label,\n.jira-scope-secondary-row label>span,\n.jira-model-form label>span,\n.jira-activity-row label>span{\n  color:#172b4d;\n  font-size:12px;\n  font-weight:700;\n}\n.jira-picker-trigger{\n  width:100%;\n  min-height:50px;\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n  padding:8px 12px;\n  border:1px solid #b8c2d1;\n  border-radius:8px;\n  background:#fff;\n  color:#172b4d;\n  cursor:pointer;\n  text-align:left;\n}\n.jira-picker-trigger:hover,\n.jira-picker-trigger.open{\n  border-color:#0c66e4;\n  box-shadow:0 0 0 1px #0c66e4;\n}\n.jira-picker-trigger>span{\n  display:grid;\n  gap:2px;\n  min-width:0;\n}\n.jira-picker-trigger b{\n  font-size:13px;\n  white-space:nowrap;\n  overflow:hidden;\n  text-overflow:ellipsis;\n}\n.jira-picker-trigger small{\n  color:#6b778c;\n  font-size:11px;\n}\n.jira-picker-popover{\n  position:absolute;\n  z-index:40;\n  top:calc(100% + 6px);\n  left:0;\n  width:max(100%,430px);\n  max-width:min(520px,calc(100vw - 80px));\n  border:1px solid #cdd4df;\n  border-radius:10px;\n  background:#fff;\n  box-shadow:0 14px 34px rgba(9,30,66,.18);\n  overflow:hidden;\n}\n.jira-picker-toolbar{\n  padding:10px;\n  border-bottom:1px solid #eef0f3;\n  background:#fafbfc;\n}\n.jira-picker-search{\n  height:38px;\n  display:flex;\n  align-items:center;\n  gap:8px;\n  padding:0 10px;\n  border:1px solid #b8c2d1;\n  border-radius:7px;\n  background:#fff;\n  color:#6b778c;\n}\n.jira-picker-search input{\n  flex:1;\n  min-width:0;\n  border:0!important;\n  box-shadow:none!important;\n  padding:0!important;\n  font-size:12px!important;\n}\n.jira-picker-search button{\n  display:grid;\n  place-items:center;\n  width:24px;\n  height:24px;\n  border:0;\n  background:transparent;\n  color:#6b778c;\n  cursor:pointer;\n}\n.jira-picker-actions{\n  display:flex;\n  justify-content:flex-end;\n  gap:10px;\n  margin-top:8px;\n}\n.jira-picker-actions button{\n  border:0;\n  background:transparent;\n  color:#0c66e4;\n  font-size:11px;\n  font-weight:700;\n  cursor:pointer;\n}\n.jira-picker-list{\n  max-height:280px;\n  overflow:auto;\n}\n.jira-picker-row{\n  display:flex;\n  align-items:flex-start;\n  gap:10px;\n  padding:9px 12px;\n  border-bottom:1px solid #f0f1f3;\n  cursor:pointer;\n}\n.jira-picker-row:hover{\n  background:#f7f9fc;\n}\n.jira-picker-row.selected{\n  background:#f4f8ff;\n}\n.jira-picker-row input{\n  width:16px;\n  height:16px;\n  margin-top:3px;\n  accent-color:#0c66e4;\n}\n.jira-picker-row>span{\n  display:grid;\n  gap:2px;\n  min-width:0;\n}\n.jira-picker-row b{\n  font-size:12px;\n  color:#172b4d;\n}\n.jira-picker-row small{\n  font-size:10px;\n  color:#6b778c;\n  line-height:1.35;\n}\n.jira-picker-empty{\n  padding:24px;\n  text-align:center;\n  font-size:12px;\n  color:#6b778c;\n}\n.jira-picker-done{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n  padding:9px 11px;\n  border-top:1px solid #eef0f3;\n  background:#fafbfc;\n  font-size:11px;\n  color:#6b778c;\n}\n.jira-picker-done button{\n  border:1px solid #b8c2d1;\n  border-radius:6px;\n  padding:6px 12px;\n  background:#fff;\n  color:#172b4d;\n  font-size:11px;\n  font-weight:700;\n  cursor:pointer;\n}\n.jira-live-estimate{\n  height:73px;\n  display:grid;\n  align-content:center;\n  gap:2px;\n  padding:9px 14px;\n  border:1px solid #b8c2d1;\n  border-radius:9px;\n  background:#f8fafc;\n}\n.jira-live-estimate>span{\n  font-size:10px;\n  font-weight:800;\n  letter-spacing:.04em;\n  text-transform:uppercase;\n  color:#6b778c;\n}\n.jira-live-estimate strong{\n  font-size:24px;\n  line-height:1.05;\n  color:#172b4d;\n}\n.jira-live-estimate small{\n  font-size:10px;\n  color:#6b778c;\n}\n.jira-live-estimate.ok{\n  border-color:#b7e4c7;\n  background:#f4fff9;\n}\n.jira-live-estimate.over{\n  border-color:#ffbdad;\n  background:#fff4f2;\n}\n.jira-live-estimate.over strong,\n.jira-live-estimate.over small{\n  color:#ae2a19;\n}\n.jira-live-estimate.loading strong{\n  color:#0c66e4;\n}\n.jira-scope-secondary-row{\n  display:grid;\n  grid-template-columns:180px 180px minmax(280px,1fr);\n  gap:12px;\n  align-items:end;\n  margin-top:16px;\n}\n.jira-scope-secondary-row label{\n  display:grid;\n  gap:6px;\n}\n.jira-scope-secondary-row label>span em{\n  color:#6b778c;\n  font-style:normal;\n  font-weight:500;\n}\n.jira-scope-secondary-row input{\n  height:40px;\n  border:1px solid #b8c2d1;\n  border-radius:7px;\n  padding:0 10px;\n  font-family:var(--pa-font);\n  font-size:12px;\n}\n.jira-scope-inline-status{\n  min-height:44px;\n  display:flex;\n  align-items:center;\n  gap:22px;\n  margin-top:14px;\n  padding:8px 12px;\n  border:1px solid #e0e4ea;\n  border-radius:8px;\n  background:#fafbfc;\n  color:#44546f;\n}\n.jira-scope-inline-status>div{\n  display:flex;\n  align-items:center;\n  gap:7px;\n}\n.jira-scope-inline-status svg{\n  color:#0c66e4;\n}\n.jira-scope-inline-status b,\n.jira-scope-inline-status span{\n  font-size:11px;\n}\n.jira-scope-inline-status>span{\n  margin-left:auto;\n}\n.jira-panel-footer.sticky{\n  position:sticky;\n  bottom:0;\n  z-index:20;\n  padding:12px 16px!important;\n  background:rgba(250,251,252,.96);\n  backdrop-filter:blur(4px);\n}\n.jira-panel-footer .pa-primary,\n.jira-panel-footer .pa-secondary{\n  min-height:38px;\n  font-size:12px;\n}\n.jira-footer-actions>span{\n  font-size:11px!important;\n}\n.jira-validation-banner{\n  display:grid;\n  grid-template-columns:auto 1fr auto;\n  gap:10px;\n  align-items:center;\n  margin-bottom:14px;\n  padding:10px 12px;\n  border:1px solid #b7e4c7;\n  border-radius:8px;\n  background:#f4fff9;\n  color:#087443;\n}\n.jira-validation-banner>div{\n  display:grid;\n  gap:2px;\n}\n.jira-validation-banner b{\n  font-size:12px;\n  color:#172b4d;\n}\n.jira-validation-banner span{\n  font-size:11px;\n  color:#44546f;\n}\n.jira-validation-banner button{\n  border:0;\n  background:transparent;\n  color:#0c66e4;\n  font-size:11px;\n  font-weight:700;\n  cursor:pointer;\n}\n.jira-model-form{\n  gap:12px 16px!important;\n}\n.jira-model-form label{\n  gap:6px!important;\n}\n.jira-model-form input,\n.jira-model-form textarea{\n  font-size:12px!important;\n}\n.jira-activity-row{\n  display:grid;\n  grid-template-columns:minmax(300px,.7fr) 1.3fr;\n  gap:16px;\n  align-items:end;\n  padding:13px 14px;\n  border:1px solid #b3d4ff;\n  border-radius:9px;\n  background:#f4f8ff;\n}\n.jira-activity-row label{\n  display:grid;\n  gap:6px;\n}\n.jira-activity-row select{\n  height:42px;\n  border:1px solid #b8c2d1;\n  border-radius:7px;\n  background:#fff;\n  padding:0 10px;\n  font-family:var(--pa-font);\n  font-size:12px;\n}\n.jira-activity-row>div{\n  display:grid;\n  gap:3px;\n  padding-bottom:3px;\n}\n.jira-activity-row b{\n  font-size:13px;\n  color:#172b4d;\n}\n.jira-activity-row span{\n  font-size:11px;\n  color:#44546f;\n}\n.jira-selected-characteristics{\n  margin-top:14px;\n  padding:12px 14px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  background:#fff;\n}\n.jira-selected-characteristics-head{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:14px;\n}\n.jira-selected-characteristics-head>div:first-child{\n  display:grid;\n  gap:2px;\n}\n.jira-selected-characteristics-head b{\n  font-size:13px;\n  color:#172b4d;\n}\n.jira-selected-characteristics-head span{\n  font-size:11px;\n  color:#6b778c;\n}\n.jira-attribute-view-toggle{\n  display:flex;\n  padding:3px;\n  border:1px solid #dfe3e8;\n  border-radius:7px;\n  background:#f6f7f9;\n}\n.jira-attribute-view-toggle button{\n  border:0;\n  border-radius:5px;\n  padding:6px 10px;\n  background:transparent;\n  color:#44546f;\n  font-size:11px;\n  font-weight:700;\n  cursor:pointer;\n}\n.jira-attribute-view-toggle button.active{\n  background:#fff;\n  color:#0c66e4;\n  box-shadow:0 1px 2px rgba(9,30,66,.12);\n}\n.jira-selected-chips{\n  display:flex;\n  align-items:center;\n  flex-wrap:wrap;\n  gap:6px;\n  margin-top:10px;\n  min-height:29px;\n}\n.jira-selected-chips button{\n  display:inline-flex;\n  align-items:center;\n  gap:5px;\n  border:1px solid #b3d4ff;\n  border-radius:999px;\n  padding:5px 8px;\n  background:#f4f8ff;\n  color:#0c66e4;\n  font-size:11px;\n  font-weight:700;\n  cursor:pointer;\n}\n.jira-selected-chips>span{\n  font-size:11px;\n  color:#6b778c;\n}\n.jira-attribute-toolbar{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n  margin:12px 0 8px;\n}\n.jira-field-search.large{\n  width:min(460px,100%);\n  height:38px;\n}\n.jira-field-search.large input{\n  font-size:12px!important;\n}\n.jira-attribute-toolbar>span{\n  font-size:11px;\n  color:#6b778c;\n}\n.jira-attribute-grid{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:8px;\n  max-height:310px;\n  overflow:auto;\n  padding-right:3px;\n}\n.jira-attribute-tile{\n  min-height:56px;\n  display:grid;\n  gap:7px;\n  align-content:start;\n  padding:10px 11px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fff;\n}\n.jira-attribute-tile.selected{\n  border-color:#85b8ff;\n  background:#f8fbff;\n}\n.jira-attribute-tile>label{\n  display:flex;\n  align-items:flex-start;\n  gap:8px;\n  cursor:pointer;\n}\n.jira-attribute-tile>label input{\n  width:15px;\n  height:15px;\n  margin-top:2px;\n  accent-color:#0c66e4;\n}\n.jira-attribute-tile>label span{\n  display:grid;\n  gap:1px;\n}\n.jira-attribute-tile b{\n  font-size:12px;\n  color:#172b4d;\n}\n.jira-attribute-tile small{\n  font-size:10px;\n  color:#6b778c;\n}\n.jira-attribute-tile>input{\n  height:34px;\n  border:1px solid #c8d0dc;\n  border-radius:6px;\n  padding:0 8px;\n  font-family:var(--pa-font);\n  font-size:11px;\n}\n.jira-attributes-empty{\n  grid-column:1/-1;\n  padding:28px;\n  text-align:center;\n  color:#6b778c;\n  font-size:12px;\n}\n.jira-preview-summary.compact{\n  margin:0 0 12px;\n}\n.jira-preview-summary.compact>div{\n  padding:9px 11px;\n}\n.jira-preview-summary.compact b{\n  font-size:13px;\n}\n.jira-preview-summary.compact span{\n  font-size:10px;\n}\n.jira-preview-table{\n  font-size:11px!important;\n}\n.jira-preview-table th{\n  font-size:10px!important;\n  padding:9px 10px!important;\n}\n.jira-preview-table td{\n  font-size:11px;\n  padding:9px 10px!important;\n}\n.jira-run-compact-body{\n  display:grid;\n  gap:12px;\n}\n.jira-run-summary{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:20px;\n  padding:12px 14px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  background:#fafbfc;\n}\n.jira-run-summary>div:first-child{\n  display:flex;\n  align-items:center;\n  gap:10px;\n  color:#0c66e4;\n}\n.jira-run-summary>div:first-child span{\n  display:grid;\n  gap:2px;\n}\n.jira-run-summary b{\n  font-size:13px;\n  color:#172b4d;\n}\n.jira-run-summary small{\n  font-size:11px;\n  color:#6b778c;\n}\n.jira-data-retention-choice{\n  display:grid;\n  grid-template-columns:auto 1fr auto;\n  gap:11px;\n  align-items:start;\n  padding:13px 14px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  background:#fff;\n  cursor:pointer;\n}\n.jira-data-retention-choice.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n.jira-data-retention-choice input{\n  width:16px;\n  height:16px;\n  margin-top:3px;\n  accent-color:#0c66e4;\n}\n.jira-data-retention-choice>span{\n  display:grid;\n  gap:3px;\n}\n.jira-data-retention-choice b{\n  font-size:12px;\n  color:#172b4d;\n}\n.jira-data-retention-choice small{\n  max-width:900px;\n  font-size:11px;\n  line-height:1.45;\n  color:#6b778c;\n}\n.jira-data-retention-choice em{\n  align-self:center;\n  border-radius:999px;\n  padding:5px 9px;\n  background:#f1f2f4;\n  color:#44546f;\n  font-size:10px;\n  font-style:normal;\n  font-weight:700;\n}\n.jira-data-retention-choice.selected em{\n  background:#dcfff1;\n  color:#087443;\n}\n.jira-processing-note{\n  padding:9px 11px;\n  border-radius:7px;\n  background:#f4f5f7;\n  color:#44546f;\n  font-size:11px;\n}\n\n/* keep the complete wizard usable in a 900–1080px-high desktop viewport */\n@media(min-width:1100px){\n  .jira-builder-v2 .jira-wizard-panel{\n    min-height:0;\n  }\n}\n@media(max-width:1100px){\n  .jira-scope-primary-grid{\n    grid-template-columns:1fr 1fr;\n  }\n  .jira-live-estimate{\n    grid-column:1/-1;\n    height:auto;\n  }\n  .jira-scope-secondary-row{\n    grid-template-columns:1fr 1fr;\n  }\n  .jira-jql-field{\n    grid-column:1/-1;\n  }\n}\n@media(max-width:760px){\n  .jira-scope-primary-grid,\n  .jira-scope-secondary-row,\n  .jira-activity-row,\n  .jira-attribute-grid{\n    grid-template-columns:1fr;\n  }\n  .jira-picker-popover{\n    width:min(520px,calc(100vw - 40px));\n  }\n  .jira-selected-characteristics-head,\n  .jira-run-summary{\n    align-items:flex-start;\n    flex-direction:column;\n  }\n}\n\n/* Sprint 7B.2 — Models drawer cleanup */\n.model-source-mark.jira{\n  background:#e9f2ff;\n  color:#0c66e4;\n  border-color:#b3d4ff;\n}\n.model-source-mark.servicenow{\n  background:#e9f8f0;\n  color:#0b6b3a;\n  border-color:#b7e4c7;\n}\n.model-detail-panel-v2{\n  width:min(650px,46vw);\n  min-width:560px;\n  background:#fff;\n}\n.model-detail-head.v2{\n  padding:22px 26px 18px;\n}\n.model-detail-head.v2 .model-title-block{\n  align-items:flex-start;\n}\n.model-detail-head.v2 h2{\n  margin:2px 0 3px;\n  font-size:24px;\n  line-height:1.15;\n}\n.model-detail-head.v2 p{\n  margin:0;\n  color:#44546f;\n  font-size:13px;\n}\n.model-detail-source-strip{\n  display:grid;\n  grid-template-columns:1fr 1.25fr 1fr;\n  gap:0;\n  border-top:1px solid #eef0f3;\n  border-bottom:1px solid #eef0f3;\n  background:#fafbfc;\n}\n.model-detail-source-strip>div{\n  display:grid;\n  gap:4px;\n  padding:12px 18px;\n  border-right:1px solid #eef0f3;\n}\n.model-detail-source-strip>div:last-child{\n  border-right:0;\n}\n.model-detail-source-strip span{\n  font-size:10px;\n  color:#6b778c;\n  text-transform:uppercase;\n  letter-spacing:.04em;\n  font-weight:700;\n}\n.model-detail-source-strip b{\n  font-size:13px;\n  color:#172b4d;\n}\n.model-detail-actions.v2{\n  padding:13px 24px;\n  gap:8px;\n}\n.model-detail-actions.v2 button{\n  min-height:38px;\n  font-size:12px;\n}\n.model-detail-section.v2{\n  padding:18px 24px;\n}\n.model-detail-section.v2 h3{\n  font-size:14px;\n  margin:0 0 12px;\n}\n.model-detail-section.v2 .section-title-row{\n  align-items:center;\n  margin-bottom:12px;\n}\n.model-detail-section.v2 .section-title-row h3{\n  margin:0;\n}\n.model-detail-section.v2 .section-title-row>span{\n  font-size:11px;\n  color:#6b778c;\n}\n.detail-metrics.v2{\n  grid-template-columns:repeat(3,1fr);\n  gap:10px;\n}\n.detail-metrics.v2>div{\n  padding:13px 14px;\n  min-height:78px;\n}\n.detail-metrics.v2 span{\n  font-size:11px;\n}\n.detail-metrics.v2 strong{\n  font-size:24px;\n}\n.detail-kv-grid.v2{\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  row-gap:16px;\n  column-gap:22px;\n}\n.detail-kv-grid.v2>div span{\n  font-size:10px;\n}\n.detail-kv-grid.v2>div b{\n  font-size:12px;\n}\n.model-scope-summary{\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  gap:10px 20px;\n  margin-top:16px;\n  padding:14px;\n  border:1px solid #e1e5eb;\n  border-radius:9px;\n  background:#fafbfc;\n}\n.model-scope-summary>div{\n  display:grid;\n  gap:3px;\n  min-width:0;\n}\n.model-scope-summary span,\n.model-copy-block>span{\n  color:#6b778c;\n  font-size:10px;\n  font-weight:700;\n  text-transform:uppercase;\n  letter-spacing:.03em;\n}\n.model-scope-summary b{\n  color:#172b4d;\n  font-size:12px;\n  line-height:1.35;\n  white-space:normal;\n}\n.model-copy-block{\n  display:grid;\n  gap:5px;\n  margin-top:14px;\n}\n.model-copy-block p{\n  margin:0;\n  color:#44546f;\n  font-size:12px;\n  line-height:1.45;\n}\n.model-detail-note{\n  display:grid;\n  gap:5px;\n  margin:0 24px 18px;\n  padding:12px 14px;\n  border:1px solid #d7e7ff;\n  border-radius:8px;\n  background:#f4f8ff;\n}\n.model-detail-note b{\n  font-size:12px;\n  color:#172b4d;\n}\n.model-detail-note span{\n  font-size:11px;\n  line-height:1.45;\n  color:#44546f;\n}\n.model-detail-danger.v2{\n  padding:14px 24px 18px;\n}\n@media(max-width:1100px){\n  .model-detail-panel-v2{\n    width:min(650px,70vw);\n    min-width:0;\n  }\n}\n\n/* ==========================================================================\n   UI Increment 1 — Models page visual reset\n   Desktop-first, data-grade presentation\n   ========================================================================== */\n\n/* Navigation: simpler and more legible */\n.saas-nav-item{\n  font-size:14px;\n  min-height:42px;\n}\n.saas-nav-label{\n  font-size:10px;\n}\n.saas-brand-title{\n  font-size:17px;\n}\n.saas-brand-sub{\n  font-size:12px;\n}\n.saas-breadcrumb{\n  font-size:13px;\n}\n.account-label b{\n  font-size:12px;\n}\n.account-label small{\n  font-size:11px;\n}\n\n/* Access state should read as an entitlement state, not a generic button */\n.access-topbar-pill{\n  min-height:34px;\n  font-size:12px;\n  padding:0 12px;\n}\n.access-topbar-pill.free{\n  border-color:#f0c36d;\n  background:#fff9eb;\n  color:#7a4d00;\n}\n.access-topbar-pill.warning{\n  border-color:#f3b7ae;\n  background:#fff4f2;\n  color:#ae2a19;\n}\n.access-topbar-pill.ok{\n  border-color:#b7e4c7;\n  background:#f4fff9;\n  color:#087443;\n}\n\n/* Page heading: one clear title tier; breadcrumb already supplies context */\n.models-page-head.ui1{\n  margin-bottom:18px;\n  align-items:center;\n}\n.models-page-head.ui1 h1{\n  margin:0 0 5px;\n  font-size:30px;\n  line-height:1.12;\n  letter-spacing:-.025em;\n  color:#0b1f44;\n}\n.models-page-head.ui1 p{\n  margin:0;\n  font-size:14px;\n  line-height:1.45;\n  color:#5e6c84;\n}\n.models-page-head.ui1 .primary-large{\n  min-height:40px;\n  padding:0 15px;\n  font-size:13px;\n}\n\n/* Models card sizes to its content — no giant empty grid body */\n.model-list-card{\n  overflow:visible;\n  border:1px solid #dfe3e8;\n  border-radius:12px;\n  background:#fff;\n  box-shadow:0 1px 3px rgba(9,30,66,.055);\n}\n\n/* Quiet, efficient toolbar */\n.model-toolbar.ui1{\n  min-height:58px;\n  display:flex;\n  align-items:center;\n  gap:10px;\n  padding:10px 12px;\n  border-bottom:1px solid #e7eaee;\n  background:#fbfcfd;\n  border-radius:12px 12px 0 0;\n}\n.search-field.model-search.ui1{\n  min-width:320px;\n  max-width:none;\n  flex:1 1 520px;\n  height:38px;\n  border-color:#c8d0dc;\n  border-radius:8px;\n}\n.search-field.model-search.ui1 input{\n  font-size:13px;\n}\n.toolbar-select.ui1{\n  height:38px;\n  min-width:132px;\n  border:1px solid #c8d0dc;\n  border-radius:8px;\n  background:#fff;\n  padding:0 32px 0 11px;\n  color:#344563;\n  font-size:13px;\n  font-family:var(--pa-font);\n}\n.toolbar-select.ui1:focus{\n  outline:2px solid #cce0ff;\n  outline-offset:0;\n  border-color:#0c66e4;\n}\n.toolbar-refresh.ui1{\n  width:36px;\n  height:36px;\n  color:#44546f;\n}\n.toolbar-count.ui1{\n  min-width:64px;\n  margin-left:4px;\n  font-size:12px;\n  color:#7a869a;\n  text-align:right;\n}\n\n/* Plain data table: no AG Grid chrome, no column kebabs, no divider noise */\n.model-data-table{\n  width:100%;\n  overflow-x:auto;\n}\n.model-data-head,\n.model-data-row{\n  display:grid;\n  grid-template-columns:minmax(240px,1.7fr) minmax(115px,.75fr) minmax(170px,1.05fr) 92px 100px minmax(155px,.95fr) 110px 84px;\n  align-items:center;\n  column-gap:14px;\n  min-width:1120px;\n}\n.model-data-head{\n  min-height:40px;\n  padding:0 16px;\n  border-bottom:1px solid #dfe3e8;\n  background:#f7f8fa;\n  color:#5e6c84;\n}\n.model-data-head>div{\n  font-size:12px;\n  font-weight:650;\n  letter-spacing:.01em;\n  text-transform:none;\n}\n.model-data-head .numeric,\n.model-data-row .numeric{\n  text-align:right;\n  justify-self:stretch;\n}\n.model-data-head .actions{\n  text-align:right;\n}\n.model-data-row{\n  min-height:64px;\n  padding:0 16px;\n  border-bottom:1px solid #eef0f3;\n  background:#fff;\n  color:#344563;\n  cursor:pointer;\n  transition:background .12s ease;\n}\n.model-data-row:last-child{\n  border-bottom:0;\n}\n.model-data-row:hover{\n  background:#f8fbff;\n}\n.model-data-row:focus{\n  outline:2px solid #85b8ff;\n  outline-offset:-2px;\n}\n.model-cell{\n  min-width:0;\n  font-size:14px;\n  line-height:1.3;\n}\n.model-cell.numeric{\n  font-variant-numeric:tabular-nums;\n  font-weight:650;\n  color:#172b4d;\n}\n.model-name-cell{\n  display:grid;\n  gap:3px;\n}\n.model-name-cell b{\n  overflow:hidden;\n  color:#172b4d;\n  font-size:14px;\n  font-weight:700;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n.model-name-cell span{\n  overflow:hidden;\n  color:#6b778c;\n  font-size:12.5px;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n.source-text{\n  display:grid;\n  gap:2px;\n}\n.source-text b{\n  overflow:hidden;\n  color:#172b4d;\n  font-size:13.5px;\n  font-weight:650;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n.source-text span{\n  overflow:hidden;\n  color:#6b778c;\n  font-size:12px;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n.model-cell.last-run{\n  color:#44546f;\n  font-size:13px;\n  font-variant-numeric:tabular-nums;\n}\n.model-cell.actions{\n  display:flex;\n  justify-content:flex-end;\n}\n.model-grid-actions{\n  gap:4px;\n}\n.model-grid-actions button{\n  width:32px;\n  height:32px;\n  color:#44546f;\n}\n.model-grid-actions button:hover{\n  background:#e9f2ff;\n  color:#0c66e4;\n}\n\n/* Compact status pill */\n.status-pill.compact{\n  width:max-content;\n  min-height:23px;\n  display:inline-flex;\n  align-items:center;\n  gap:6px;\n  padding:2px 8px 2px 7px;\n  border-radius:999px;\n  font-size:12px!important;\n  line-height:1;\n  font-weight:650;\n  text-transform:none;\n}\n.status-pill.compact i{\n  width:6px;\n  height:6px;\n  border-radius:50%;\n  background:currentColor;\n  opacity:.85;\n}\n\n/* Filtered-empty and low-count state */\n.model-filter-empty{\n  display:grid;\n  place-items:center;\n  gap:5px;\n  padding:34px 20px;\n  border-top:1px solid #eef0f3;\n  color:#6b778c;\n  text-align:center;\n}\n.model-filter-empty b{\n  color:#172b4d;\n  font-size:14px;\n}\n.model-filter-empty span{\n  font-size:13px;\n}\n.empty-state-feature.ui1{\n  padding:42px 20px;\n}\n.empty-state-feature.ui1 h3{\n  font-size:17px;\n}\n.empty-state-feature.ui1 p{\n  font-size:13px;\n}\n.models-page-footnote{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n  padding:10px 4px 0;\n  color:#7a869a;\n  font-size:12px;\n}\n.models-page-footnote button{\n  display:inline-flex;\n  align-items:center;\n  gap:5px;\n  border:0;\n  background:transparent;\n  color:#0c66e4;\n  font-family:var(--pa-font);\n  font-size:12px;\n  font-weight:650;\n  cursor:pointer;\n}\n\n/* Drawer: readable, information-dense, no tiny metadata */\n.model-detail-panel-v2{\n  width:min(620px,44vw);\n  min-width:540px;\n}\n.model-detail-head.v2{\n  padding:22px 24px 18px;\n}\n.model-detail-head.v2 .eyebrow{\n  margin-bottom:4px;\n  font-size:10px;\n}\n.model-detail-head.v2 h2{\n  font-size:25px;\n}\n.model-detail-head.v2 p{\n  font-size:13px;\n}\n.model-detail-source-strip span{\n  font-size:11px;\n}\n.model-detail-source-strip b{\n  font-size:13px;\n}\n.model-detail-actions.v2{\n  padding:12px 24px;\n}\n.model-detail-actions.v2 button{\n  font-size:12.5px;\n}\n.model-detail-section.v2{\n  padding:18px 24px;\n}\n.model-detail-section.v2 h3{\n  font-size:15px;\n}\n.model-detail-section.v2 .section-title-row>span{\n  font-size:12px;\n}\n.detail-metrics.v2 span{\n  font-size:11.5px;\n}\n.detail-metrics.v2 strong{\n  font-size:23px;\n  font-variant-numeric:tabular-nums;\n}\n.detail-kv-grid.v2>div span,\n.model-scope-summary span,\n.model-copy-block>span{\n  font-size:11px;\n}\n.detail-kv-grid.v2>div b,\n.model-scope-summary b{\n  font-size:13px;\n}\n.model-copy-block p{\n  font-size:13px;\n}\n.model-detail-note{\n  margin:0 24px 18px;\n}\n.model-detail-note b{\n  font-size:13px;\n}\n.model-detail-note span{\n  font-size:12px;\n}\n\n/* Keep page broad enough to use desktop real estate properly */\n.saas-main:has(.models-page-head.ui1){\n  max-width:1480px;\n}\n\n/* Focus/accessibility */\n.model-grid-actions button:focus-visible,\n.models-page-footnote button:focus-visible{\n  outline:2px solid #85b8ff;\n  outline-offset:1px;\n}\n\n@media(max-width:1180px){\n  .model-data-head,\n  .model-data-row{\n    grid-template-columns:minmax(220px,1.5fr) minmax(110px,.7fr) minmax(150px,1fr) 82px 90px minmax(145px,.9fr) 100px 78px;\n  }\n  .model-detail-panel-v2{\n    width:min(620px,62vw);\n    min-width:0;\n  }\n}\n\n/* ==========================================================================\n   Scope Screen Redesign — Metricus SaaS controls\n   ========================================================================== */\n\n.jira-scope-panel-v3{\n  overflow:visible;\n  border-radius:12px;\n}\n\n.jira-scope-head-v3{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:28px;\n  padding:18px 22px;\n  border-bottom:1px solid #e6e8ec;\n}\n\n.jira-scope-head-v3 h2{\n  margin:0 0 4px;\n  color:#0b1f44;\n  font-size:20px;\n  line-height:1.25;\n}\n\n.jira-scope-head-v3 p{\n  margin:0;\n  color:#5e6c84;\n  font-size:14px;\n  line-height:1.45;\n}\n\n.jira-scope-head-right{\n  display:flex;\n  align-items:center;\n  gap:14px;\n  flex:0 0 auto;\n}\n\n.source-context-chip.v3{\n  min-height:38px;\n  display:inline-flex;\n  align-items:center;\n  gap:8px;\n  padding:0 12px;\n  border:1px solid #d4d9e2;\n  border-radius:8px;\n  background:#fff;\n  color:#172b4d;\n  font-size:13px;\n  font-weight:650;\n}\n\n.jira-scope-count-v3{\n  min-width:150px;\n  display:grid;\n  gap:1px;\n  padding-left:14px;\n  border-left:1px solid #dfe3e8;\n}\n\n.jira-scope-count-v3>span{\n  color:#6b778c;\n  font-size:11px;\n  font-weight:700;\n  text-transform:uppercase;\n  letter-spacing:.035em;\n}\n\n.jira-scope-count-v3 strong{\n  color:#0b1f44;\n  font-size:24px;\n  line-height:1.1;\n  font-variant-numeric:tabular-nums;\n}\n\n.jira-scope-count-v3 small{\n  color:#6b778c;\n  font-size:11.5px;\n}\n\n.jira-scope-count-v3.over strong,\n.jira-scope-count-v3.over small{\n  color:#ae2a19;\n}\n\n.jira-scope-count-v3.loading strong{\n  color:#0c66e4;\n}\n\n.jira-scope-body-v3{\n  padding:20px 22px 16px;\n}\n\n.jira-scope-select-grid-v3{\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  gap:18px;\n}\n\n.jira-scope-field-v3{\n  min-width:0;\n  display:grid;\n  gap:7px;\n}\n\n.jira-scope-field-v3>label{\n  color:#172b4d;\n  font-size:14px;\n  font-weight:700;\n}\n\n.jira-scope-field-v3>small{\n  min-height:18px;\n  color:#6b778c;\n  font-size:12px;\n  line-height:1.4;\n}\n\n\n.jira-advanced-toggle-v3{\n  width:100%;\n  min-height:42px;\n  display:grid;\n  grid-template-columns:auto 1fr auto;\n  align-items:center;\n  gap:10px;\n  margin-top:16px;\n  padding:0 12px;\n  border:1px solid #e0e4ea;\n  border-radius:8px;\n  background:#fafbfc;\n  color:#172b4d;\n  text-align:left;\n  cursor:pointer;\n}\n\n.jira-advanced-toggle-v3:hover{\n  background:#f4f5f7;\n}\n\n.jira-advanced-toggle-v3>span{\n  font-size:13px;\n  font-weight:700;\n}\n\n.jira-advanced-toggle-v3>small{\n  color:#7a869a;\n  font-size:12px;\n}\n\n.jira-advanced-toggle-v3 svg{\n  transition:transform .15s ease;\n}\n\n.jira-advanced-toggle-v3.open svg{\n  transform:rotate(180deg);\n}\n\n.jira-advanced-scope-v3{\n  display:grid;\n  grid-template-columns:180px 180px minmax(260px,1fr);\n  gap:12px;\n  margin-top:10px;\n  padding:14px;\n  border:1px solid #e0e4ea;\n  border-radius:8px;\n  background:#fbfcfd;\n}\n\n.jira-advanced-scope-v3 label{\n  display:grid;\n  gap:6px;\n}\n\n.jira-advanced-scope-v3 label>span{\n  color:#44546f;\n  font-size:12.5px;\n  font-weight:650;\n}\n\n.jira-advanced-scope-v3 label>span em{\n  color:#8993a4;\n  font-style:normal;\n  font-weight:500;\n}\n\n.jira-advanced-scope-v3 input{\n  height:40px;\n  border:1px solid #b8c2d1;\n  border-radius:7px;\n  background:#fff;\n  padding:0 10px;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:13px;\n}\n\n.jira-advanced-scope-v3 input:focus{\n  outline:2px solid #cce0ff;\n  border-color:#0c66e4;\n}\n\n.jira-scope-footer-v3{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n  padding:12px 22px;\n  border-top:1px solid #e6e8ec;\n  background:#fafbfc;\n  border-radius:0 0 12px 12px;\n}\n\n.jira-scope-footer-v3 .pa-primary,\n.jira-scope-footer-v3 .pa-secondary{\n  min-height:40px;\n  padding:0 14px;\n  font-size:13px;\n}\n\n@media(max-width:1000px){\n  .jira-scope-head-v3{\n    align-items:flex-start;\n  }\n  .jira-scope-head-right{\n    align-items:flex-end;\n    flex-direction:column;\n  }\n  .jira-scope-count-v3{\n    padding-left:0;\n    border-left:0;\n    text-align:right;\n  }\n  .jira-advanced-scope-v3{\n    grid-template-columns:1fr 1fr;\n  }\n  .jira-advanced-jql-v3{\n    grid-column:1/-1;\n  }\n}\n\n@media(max-width:720px){\n  .jira-scope-select-grid-v3,\n  .jira-advanced-scope-v3{\n    grid-template-columns:1fr;\n  }\n  .jira-scope-head-v3{\n    flex-direction:column;\n  }\n  .jira-scope-head-right{\n    width:100%;\n    align-items:flex-start;\n  }\n  .jira-scope-count-v3{\n    text-align:left;\n  }\n  .jira-advanced-jql-v3{\n    grid-column:auto;\n  }\n}\n\n/* ==========================================================================\n   Metricus SaaS component baseline — no Atlaskit dependency\n   ========================================================================== */\n*,*::before,*::after{box-sizing:border-box}\nhtml,body,#root{min-height:100%;margin:0}\nbutton,input,select,textarea{font:inherit}\n\n.metricus-field{\n  min-width:0;\n  display:grid;\n  gap:7px;\n}\n.metricus-field-label{\n  color:#172b4d;\n  font-size:14px;\n  font-weight:700;\n  line-height:1.35;\n}\n.metricus-field-help{\n  min-height:18px;\n  color:#6b778c;\n  font-size:12px;\n  line-height:1.4;\n}\n.metricus-multiselect .MuiOutlinedInput-root{\n  min-height:44px;\n  padding:4px 38px 4px 7px!important;\n  border-radius:8px;\n  background:#fff;\n  font-family:var(--pa-font);\n}\n.metricus-multiselect .MuiOutlinedInput-notchedOutline{\n  border-color:#b8c2d1!important;\n}\n.metricus-multiselect .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{\n  border-color:#7a869a!important;\n}\n.metricus-multiselect .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{\n  border-color:#0c66e4!important;\n  border-width:2px!important;\n}\n.metricus-multiselect .MuiAutocomplete-input{\n  min-width:90px!important;\n  padding:4px 6px!important;\n  color:#172b4d;\n  font-family:var(--pa-font)!important;\n  font-size:14px!important;\n}\n.metricus-multiselect .MuiInputBase-input::placeholder{\n  color:#44546f;\n  opacity:1;\n}\n.metricus-multiselect .MuiChip-root,\n.metricus-multiselect-tag{\n  height:28px!important;\n  border-radius:6px!important;\n  background:#e9f2ff!important;\n  color:#0c66e4!important;\n  font-family:var(--pa-font)!important;\n  font-size:12.5px!important;\n  font-weight:650!important;\n}\n.metricus-multiselect .MuiChip-deleteIcon{\n  width:16px!important;\n  height:16px!important;\n  color:#5e6c84!important;\n}\n.metricus-multiselect .MuiAutocomplete-popupIndicator,\n.metricus-multiselect .MuiAutocomplete-clearIndicator{\n  color:#44546f;\n}\n.metricus-multiselect-paper{\n  margin-top:4px!important;\n  border:1px solid #d4d9e2!important;\n  border-radius:9px!important;\n  box-shadow:0 12px 30px rgba(9,30,66,.16)!important;\n  font-family:var(--pa-font)!important;\n}\n.metricus-multiselect-listbox{\n  max-height:300px!important;\n  padding:5px!important;\n}\n.metricus-multiselect-option{\n  min-height:44px!important;\n  display:flex!important;\n  align-items:flex-start!important;\n  gap:4px!important;\n  margin:1px 0!important;\n  padding:6px 8px!important;\n  border-radius:6px!important;\n  color:#172b4d!important;\n  font-family:var(--pa-font)!important;\n  font-size:14px!important;\n}\n.metricus-multiselect-option[aria-selected=\"true\"]{\n  background:#f4f8ff!important;\n}\n.metricus-multiselect-option.Mui-focused{\n  background:#f1f4f8!important;\n}\n.metricus-option-checkbox{\n  margin:-2px 1px 0 -4px!important;\n  padding:6px!important;\n}\n.metricus-check-box{\n  width:16px;\n  height:16px;\n  display:grid;\n  place-items:center;\n  border:1.5px solid #8993a4;\n  border-radius:3px;\n  background:#fff;\n}\n.metricus-check-box.checked{\n  border-color:#0c66e4;\n  background:#0c66e4;\n  color:#fff;\n}\n.metricus-option-copy{\n  min-width:0;\n  display:grid;\n  gap:2px;\n  padding-top:2px;\n}\n.metricus-option-copy b{\n  overflow:hidden;\n  color:#172b4d;\n  font-size:13.5px;\n  line-height:1.3;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n.metricus-option-copy small{\n  overflow:hidden;\n  color:#6b778c;\n  font-size:11.5px;\n  line-height:1.3;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n\n/* ========================================================================== \n   Jira model wizard consistency pass — shared Metricus component language\n   ========================================================================== */\n.metricus-wizard-panel{\n  overflow:visible;\n  border:1px solid #dfe3e8;\n  border-radius:12px;\n  background:#fff;\n}\n.metricus-panel-head{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:20px;\n  padding:18px 22px;\n  border-bottom:1px solid #e6e8ec;\n}\n.metricus-panel-head h2{\n  margin:0 0 4px;\n  color:#0b1f44;\n  font-size:20px;\n  line-height:1.25;\n}\n.metricus-panel-head p{\n  margin:0;\n  color:#5e6c84;\n  font-size:14px;\n  line-height:1.45;\n}\n.metricus-panel-body{\n  padding:20px 22px;\n}\n.metricus-panel-footer{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:14px;\n  min-height:64px;\n  padding:12px 22px;\n  border-top:1px solid #e6e8ec;\n  background:#fafbfc;\n  border-radius:0 0 12px 12px;\n}\n.metricus-panel-footer .pa-primary,\n.metricus-panel-footer .pa-secondary{\n  min-height:40px;\n  padding:0 14px;\n  font-size:13px;\n}\n.metricus-footer-actions{\n  display:flex;\n  align-items:center;\n  justify-content:flex-end;\n  gap:14px;\n  margin-left:auto;\n}\n.metricus-footer-actions>span{\n  color:#6b778c;\n  font-size:12px;\n}\n.metricus-form-grid{\n  display:grid;\n  gap:14px 18px;\n}\n.metricus-form-grid.two{\n  grid-template-columns:1fr 1fr;\n}\n.metricus-span-two{\n  grid-column:1/-1;\n}\n.metricus-field{\n  min-width:0;\n  display:grid;\n  gap:7px;\n}\n.metricus-field-label{\n  color:#172b4d;\n  font-size:14px;\n  font-weight:700;\n  line-height:1.25;\n}\n.metricus-input,\n.metricus-select{\n  width:100%;\n  min-height:42px;\n  box-sizing:border-box;\n  border:1px solid #b8c2d1;\n  border-radius:8px;\n  background:#fff;\n  padding:0 11px;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:14px;\n  line-height:1.4;\n}\ntextarea.metricus-input{\n  min-height:72px;\n  padding:10px 11px;\n  resize:vertical;\n}\n.metricus-input:focus,\n.metricus-select:focus{\n  outline:2px solid #cce0ff;\n  outline-offset:0;\n  border-color:#0c66e4;\n}\n.metricus-field-help{\n  color:#6b778c;\n  font-size:12px;\n  line-height:1.4;\n}\n.metricus-validation-banner{\n  margin-bottom:16px;\n  padding:11px 13px;\n  border-radius:8px;\n}\n.metricus-validation-banner b{\n  font-size:13px;\n}\n.metricus-validation-banner span,\n.metricus-validation-banner button{\n  font-size:12px;\n}\n\n/* Activity and attributes */\n.metricus-attributes-body{\n  display:grid;\n  gap:14px;\n}\n.metricus-activity-card{\n  display:grid;\n  grid-template-columns:minmax(320px, .72fr) 1.28fr;\n  align-items:end;\n  gap:20px;\n  padding:15px 16px;\n  border:1px solid #cce0ff;\n  border-radius:9px;\n  background:#f7faff;\n}\n.metricus-activity-copy{\n  display:grid;\n  gap:4px;\n  padding-bottom:3px;\n}\n.metricus-activity-copy b{\n  color:#172b4d;\n  font-size:14px;\n}\n.metricus-activity-copy span{\n  color:#5e6c84;\n  font-size:13px;\n  line-height:1.4;\n}\n.metricus-characteristics-card{\n  padding:14px 16px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  background:#fff;\n}\n.metricus-characteristics-head{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:16px;\n}\n.metricus-characteristics-head h3{\n  margin:0 0 3px;\n  color:#172b4d;\n  font-size:15px;\n}\n.metricus-characteristics-head p{\n  margin:0;\n  color:#6b778c;\n  font-size:12px;\n}\n.metricus-segmented-control{\n  display:flex;\n  padding:3px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#f4f5f7;\n}\n.metricus-segmented-control button{\n  min-height:30px;\n  border:0;\n  border-radius:6px;\n  background:transparent;\n  padding:0 10px;\n  color:#44546f;\n  font-family:var(--pa-font);\n  font-size:12px;\n  font-weight:700;\n  cursor:pointer;\n}\n.metricus-segmented-control button.active{\n  background:#fff;\n  color:#0c66e4;\n  box-shadow:0 1px 2px rgba(9,30,66,.12);\n}\n.metricus-chip-row{\n  display:flex;\n  flex-wrap:wrap;\n  align-items:center;\n  gap:7px;\n  margin-top:11px;\n  min-height:31px;\n}\n.metricus-chip-row button{\n  display:inline-flex;\n  align-items:center;\n  gap:5px;\n  min-height:28px;\n  border:1px solid #b3d4ff;\n  border-radius:999px;\n  background:#f4f8ff;\n  padding:0 9px;\n  color:#0c66e4;\n  font-family:var(--pa-font);\n  font-size:12px;\n  font-weight:700;\n  cursor:pointer;\n}\n.metricus-chip-row>span{\n  color:#6b778c;\n  font-size:12px;\n}\n.metricus-attribute-toolbar{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n}\n.metricus-attribute-toolbar>span{\n  color:#6b778c;\n  font-size:12px;\n}\n.metricus-search{\n  width:min(480px,100%);\n  min-height:40px;\n  display:flex;\n  align-items:center;\n  gap:8px;\n  border:1px solid #b8c2d1;\n  border-radius:8px;\n  background:#fff;\n  padding:0 10px;\n  color:#6b778c;\n}\n.metricus-search input{\n  flex:1;\n  min-width:0;\n  border:0;\n  outline:0;\n  background:transparent;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:14px;\n}\n.metricus-attribute-grid{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:10px;\n  max-height:340px;\n  overflow:auto;\n  padding-right:4px;\n}\n.metricus-attribute-item{\n  min-height:66px;\n  display:grid;\n  align-content:start;\n  gap:9px;\n  padding:11px 12px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fff;\n}\n.metricus-attribute-item.selected{\n  border-color:#85b8ff;\n  background:#f8fbff;\n}\n.metricus-attribute-check{\n  display:flex;\n  align-items:flex-start;\n  gap:9px;\n  cursor:pointer;\n}\n.metricus-attribute-check input{\n  width:16px;\n  height:16px;\n  margin-top:2px;\n  accent-color:#0c66e4;\n}\n.metricus-attribute-check>span{\n  display:grid;\n  gap:2px;\n}\n.metricus-attribute-check b{\n  color:#172b4d;\n  font-size:13px;\n}\n.metricus-attribute-check small{\n  color:#6b778c;\n  font-size:11.5px;\n}\n.metricus-attribute-item .metricus-input{\n  min-height:36px;\n  font-size:13px;\n}\n\n/* Preview */\n.metricus-preview-body{\n  display:grid;\n  gap:14px;\n}\n.metricus-kpi-row{\n  display:grid;\n  grid-template-columns:repeat(4,minmax(0,1fr));\n  gap:10px;\n}\n.metricus-kpi-row>div{\n  min-height:64px;\n  display:grid;\n  align-content:center;\n  gap:3px;\n  padding:10px 13px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fff;\n}\n.metricus-kpi-row strong{\n  overflow:hidden;\n  color:#172b4d;\n  font-size:17px;\n  line-height:1.2;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n  font-variant-numeric:tabular-nums;\n}\n.metricus-kpi-row span{\n  color:#6b778c;\n  font-size:12px;\n}\n.metricus-data-grid{\n  width:100%;\n  min-width:0;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  overflow:hidden;\n  background:#fff;\n}\n.metricus-data-grid .ag-root-wrapper{\n  border:0!important;\n  border-radius:0!important;\n  font-family:var(--pa-font)!important;\n  font-size:14px!important;\n}\n.metricus-data-grid .ag-header{\n  border-bottom:1px solid #dfe3e8!important;\n  background:#f7f8fa!important;\n}\n.metricus-data-grid .ag-header-cell{\n  color:#5e6c84!important;\n  font-size:12px!important;\n  font-weight:650!important;\n  text-transform:none!important;\n}\n.metricus-data-grid .ag-cell{\n  display:flex;\n  align-items:center;\n  color:#344563!important;\n  font-size:14px!important;\n  border-right:0!important;\n}\n.metricus-data-grid .ag-row{\n  border-bottom:1px solid #eef0f3!important;\n}\n.metricus-data-grid .ag-row-hover{\n  background:#f8fbff!important;\n}\n.metricus-data-grid .ag-header-cell-menu-button,\n.metricus-data-grid .ag-header-cell-filter-button{\n  display:none!important;\n}\n.metricus-data-grid .metricus-grid-key{\n  color:#0c66e4!important;\n  font-weight:700;\n}\n.metricus-grid-empty{\n  color:#6b778c;\n  font-family:var(--pa-font);\n  font-size:13px;\n}\n\n/* Run */\n.metricus-run-body{\n  display:grid;\n  gap:13px;\n}\n.metricus-run-summary{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:20px;\n  padding:14px 16px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  background:#fafbfc;\n}\n.metricus-run-model{\n  display:flex;\n  align-items:center;\n  gap:11px;\n  color:#0c66e4;\n}\n.metricus-run-model>span{\n  display:grid;\n  gap:3px;\n}\n.metricus-run-model b{\n  color:#172b4d;\n  font-size:14px;\n}\n.metricus-run-model small{\n  color:#6b778c;\n  font-size:12px;\n}\n.metricus-run-flow{\n  display:flex;\n  align-items:center;\n  gap:8px;\n  color:#44546f;\n}\n.metricus-run-flow span{\n  min-height:28px;\n  display:inline-flex;\n  align-items:center;\n  border:1px solid #dfe3e8;\n  border-radius:999px;\n  background:#fff;\n  padding:0 10px;\n  font-size:12px;\n  font-weight:650;\n}\n.metricus-retention-card{\n  display:grid;\n  grid-template-columns:auto 1fr auto;\n  gap:11px;\n  align-items:start;\n  padding:14px 15px;\n  border:1px solid #dfe3e8;\n  border-radius:9px;\n  background:#fff;\n  cursor:pointer;\n}\n.metricus-retention-card.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n.metricus-retention-card input{\n  width:17px;\n  height:17px;\n  margin-top:3px;\n  accent-color:#0c66e4;\n}\n.metricus-retention-card>span{\n  display:grid;\n  gap:4px;\n}\n.metricus-retention-card b{\n  color:#172b4d;\n  font-size:13px;\n}\n.metricus-retention-card small{\n  max-width:920px;\n  color:#6b778c;\n  font-size:12px;\n  line-height:1.45;\n}\n.metricus-retention-card em{\n  align-self:center;\n  border-radius:999px;\n  background:#f1f2f4;\n  padding:5px 9px;\n  color:#44546f;\n  font-size:11px;\n  font-style:normal;\n  font-weight:700;\n}\n.metricus-retention-card.selected em{\n  background:#dcfff1;\n  color:#087443;\n}\n.metricus-info-note{\n  padding:10px 12px;\n  border-radius:8px;\n  background:#f4f5f7;\n  color:#44546f;\n  font-size:12px;\n  line-height:1.45;\n}\n\n/* Keep the whole wizard visually aligned with the redesigned Scope screen. */\n.jira-builder-v2 .jira-stage-strip{\n  margin-bottom:16px;\n}\n.jira-builder-v2 .jira-stage>b{\n  font-size:13px!important;\n}\n.jira-builder-v2 .jira-stage>span{\n  font-size:12px!important;\n}\n.jira-builder-v2 .page-head h1{\n  font-size:30px!important;\n}\n.jira-builder-v2 .page-head p{\n  font-size:14px!important;\n}\n.jira-builder-v2 .eyebrow{\n  font-size:11px!important;\n}\n\n@media(max-width:1000px){\n  .metricus-form-grid.two,\n  .metricus-activity-card,\n  .metricus-attribute-grid{\n    grid-template-columns:1fr;\n  }\n  .metricus-kpi-row{\n    grid-template-columns:repeat(2,minmax(0,1fr));\n  }\n  .metricus-run-summary{\n    align-items:flex-start;\n    flex-direction:column;\n  }\n}\n\n/* ==========================================================================\n   Activity & Attributes — layout fix\n   Selected attributes and editable AI meanings are separated from field discovery\n   ========================================================================== */\n\n.metricus-characteristics-card-v2{\n  display:grid;\n  gap:12px;\n}\n\n.metricus-selected-attribute-grid{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:10px;\n}\n\n.metricus-selected-attribute-row{\n  display:grid;\n  gap:8px;\n  padding:11px 12px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fbfcfe;\n}\n\n.metricus-selected-attribute-name{\n  display:flex;\n  align-items:flex-start;\n  justify-content:space-between;\n  gap:10px;\n}\n\n.metricus-selected-attribute-name>span{\n  display:grid;\n  gap:2px;\n  min-width:0;\n}\n\n.metricus-selected-attribute-name b{\n  color:#172b4d;\n  font-size:13.5px;\n}\n\n.metricus-selected-attribute-name small{\n  color:#6b778c;\n  font-size:11.5px;\n}\n\n.metricus-selected-attribute-name button{\n  width:28px;\n  height:28px;\n  display:grid;\n  place-items:center;\n  flex:0 0 auto;\n  border:0;\n  border-radius:6px;\n  background:transparent;\n  color:#6b778c;\n  cursor:pointer;\n}\n\n.metricus-selected-attribute-name button:hover{\n  background:#edf2f7;\n  color:#172b4d;\n}\n\n.metricus-selected-attribute-row .metricus-field{\n  display:block;\n}\n\n.metricus-selected-attribute-row .metricus-input{\n  min-height:38px;\n  font-size:13px;\n}\n\n.metricus-selected-empty{\n  padding:14px;\n  border:1px dashed #cdd3dc;\n  border-radius:8px;\n  color:#6b778c;\n  font-size:12.5px;\n}\n\n.metricus-available-fields{\n  display:grid;\n  gap:10px;\n}\n\n.metricus-available-fields-head{\n  display:flex;\n  align-items:flex-end;\n  justify-content:space-between;\n  gap:16px;\n}\n\n.metricus-available-fields-head h3{\n  margin:0 0 3px;\n  color:#172b4d;\n  font-size:15px;\n}\n\n.metricus-available-fields-head p{\n  margin:0;\n  color:#6b778c;\n  font-size:12px;\n}\n\n.metricus-available-fields-head>span{\n  color:#6b778c;\n  font-size:12px;\n}\n\n.metricus-available-field-grid{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:8px;\n  max-height:300px;\n  overflow:auto;\n  padding-right:4px;\n}\n\n.metricus-available-field{\n  min-height:56px;\n  display:flex;\n  align-items:flex-start;\n  gap:9px;\n  padding:10px 11px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fff;\n  cursor:pointer;\n}\n\n.metricus-available-field:hover{\n  background:#f7f9fc;\n}\n\n.metricus-available-field.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n\n.metricus-available-field input{\n  width:16px;\n  height:16px;\n  margin-top:2px;\n  accent-color:#0c66e4;\n}\n\n.metricus-available-field>span{\n  display:grid;\n  gap:2px;\n  min-width:0;\n}\n\n.metricus-available-field b{\n  color:#172b4d;\n  font-size:13px;\n  line-height:1.25;\n}\n\n.metricus-available-field small{\n  color:#6b778c;\n  font-size:11.5px;\n  line-height:1.3;\n}\n\n/* The old all-fields card grid is intentionally not used on this screen anymore. */\n@media(max-width:900px){\n  .metricus-selected-attribute-grid,\n  .metricus-available-field-grid{\n    grid-template-columns:1fr;\n  }\n}\n\n/* Preview data — compact, data-first layout */\n.metricus-preview-panel-v2{\n  overflow:hidden;\n}\n.metricus-preview-toolbar-v2{\n  min-height:58px;\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:18px;\n  padding:10px 18px;\n  border-bottom:1px solid #e6e8ec;\n  background:#fff;\n}\n.metricus-preview-toolbar-v2>div{\n  min-width:0;\n  display:flex;\n  align-items:baseline;\n  gap:14px;\n  flex-wrap:wrap;\n}\n.metricus-preview-toolbar-v2 h2{\n  margin:0;\n  color:#0b1f44;\n  font-size:18px;\n  line-height:1.2;\n}\n.metricus-preview-toolbar-v2>div>span{\n  color:#5e6c84;\n  font-size:12.5px;\n  line-height:1.4;\n}\n.metricus-preview-note-v2{\n  flex:0 0 auto;\n  color:#7a869a;\n  font-size:11.5px;\n}\n.metricus-preview-grid-v2{\n  padding:0;\n  background:#fff;\n}\n.metricus-preview-grid-v2 .metricus-data-grid{\n  border:0;\n  border-radius:0;\n}\n.metricus-preview-grid-v2 .ag-header{\n  background:#f7f8fa!important;\n}\n.metricus-preview-grid-v2 .ag-header-cell{\n  font-size:12px!important;\n}\n.metricus-preview-grid-v2 .ag-cell{\n  font-size:13.5px!important;\n}\n.metricus-preview-grid-v2 .ag-pinned-left-header,\n.metricus-preview-grid-v2 .ag-pinned-left-cols-container{\n  box-shadow:2px 0 4px rgba(9,30,66,.05);\n}\n@media(max-width:800px){\n  .metricus-preview-toolbar-v2{\n    align-items:flex-start;\n    flex-direction:column;\n    gap:4px;\n  }\n  .metricus-preview-note-v2{display:none;}\n}\n\n/* ==========================================================================\n   Run screen — processing allowance / retention separation\n   ========================================================================== */\n\n.metricus-run-panel-v2{\n  overflow:hidden;\n}\n\n.metricus-run-head-v2{\n  padding:18px 22px;\n  border-bottom:1px solid #e6e8ec;\n}\n\n.metricus-run-head-v2 h2{\n  margin:0 0 4px;\n  color:#0b1f44;\n  font-size:20px;\n  line-height:1.25;\n}\n\n.metricus-run-head-v2 p{\n  margin:0;\n  color:#5e6c84;\n  font-size:14px;\n  line-height:1.45;\n}\n\n.metricus-run-body-v2{\n  display:grid;\n  gap:14px;\n  padding:18px 22px;\n}\n\n.metricus-run-model-v2{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:20px;\n  padding:12px 14px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fbfcfd;\n}\n\n.metricus-run-model-title{\n  display:flex;\n  align-items:center;\n  gap:10px;\n  color:#0c66e4;\n}\n\n.metricus-run-model-title>div{\n  display:grid;\n  gap:2px;\n}\n\n.metricus-run-model-title b{\n  color:#172b4d;\n  font-size:14px;\n}\n\n.metricus-run-model-title span{\n  color:#6b778c;\n  font-size:12.5px;\n}\n\n.metricus-run-model-meta{\n  display:grid;\n  gap:2px;\n  text-align:right;\n}\n\n.metricus-run-model-meta span{\n  color:#6b778c;\n  font-size:11px;\n  font-weight:650;\n  text-transform:uppercase;\n  letter-spacing:.035em;\n}\n\n.metricus-run-model-meta b{\n  color:#172b4d;\n  font-size:13px;\n}\n\n.metricus-processing-summary-v2{\n  display:grid;\n  grid-template-columns:repeat(3,minmax(0,1fr));\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  overflow:hidden;\n  background:#fff;\n}\n\n.metricus-processing-summary-v2>div{\n  display:grid;\n  gap:5px;\n  padding:14px 16px;\n  border-right:1px solid #e7eaee;\n}\n\n.metricus-processing-summary-v2>div:last-child{\n  border-right:0;\n}\n\n.metricus-processing-summary-v2 span{\n  color:#6b778c;\n  font-size:12px;\n}\n\n.metricus-processing-summary-v2 strong{\n  color:#172b4d;\n  font-size:20px;\n  line-height:1.15;\n  font-variant-numeric:tabular-nums;\n}\n\n.metricus-partial-run-v2{\n  padding:12px 14px;\n  border:1px solid #f1c46b;\n  border-radius:8px;\n  background:#fff8e6;\n}\n\n.metricus-partial-run-v2>div{\n  display:grid;\n  gap:4px;\n}\n\n.metricus-partial-run-v2 b{\n  color:#6b4800;\n  font-size:13.5px;\n}\n\n.metricus-partial-run-v2 span{\n  color:#7a5a14;\n  font-size:12.5px;\n  line-height:1.45;\n}\n\n.metricus-full-run-v2{\n  display:flex;\n  align-items:center;\n  gap:9px;\n  padding:11px 13px;\n  border:1px solid #b7e4c7;\n  border-radius:8px;\n  background:#f4fff9;\n  color:#087443;\n  font-size:13px;\n  font-weight:600;\n}\n\n.metricus-retention-card-v2{\n  display:grid;\n  grid-template-columns:auto minmax(0,1fr) auto;\n  gap:12px;\n  align-items:start;\n  padding:14px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fff;\n  cursor:pointer;\n}\n\n.metricus-retention-card-v2.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n\n.metricus-retention-card-v2 input{\n  width:17px;\n  height:17px;\n  margin-top:2px;\n  accent-color:#0c66e4;\n}\n\n.metricus-retention-card-v2>span{\n  display:grid;\n  gap:4px;\n}\n\n.metricus-retention-card-v2 b{\n  color:#172b4d;\n  font-size:14px;\n}\n\n.metricus-retention-card-v2 small{\n  max-width:880px;\n  color:#6b778c;\n  font-size:12.5px;\n  line-height:1.45;\n}\n\n.metricus-retention-card-v2 em{\n  align-self:center;\n  max-width:230px;\n  padding:5px 9px;\n  border-radius:999px;\n  background:#f1f2f4;\n  color:#44546f;\n  font-size:11.5px;\n  font-style:normal;\n  font-weight:650;\n  text-align:center;\n}\n\n.metricus-retention-card-v2.selected em{\n  background:#dcfff1;\n  color:#087443;\n}\n\n.metricus-usage-note-v2{\n  display:flex;\n  align-items:baseline;\n  gap:9px;\n  padding:10px 12px;\n  border-radius:7px;\n  background:#f4f5f7;\n}\n\n.metricus-usage-note-v2 b{\n  flex:0 0 auto;\n  color:#344563;\n  font-size:12.5px;\n}\n\n.metricus-usage-note-v2 span{\n  color:#5e6c84;\n  font-size:12px;\n  line-height:1.4;\n}\n\n@media(max-width:900px){\n  .metricus-processing-summary-v2{\n    grid-template-columns:1fr;\n  }\n  .metricus-processing-summary-v2>div{\n    border-right:0;\n    border-bottom:1px solid #e7eaee;\n  }\n  .metricus-processing-summary-v2>div:last-child{\n    border-bottom:0;\n  }\n  .metricus-retention-card-v2{\n    grid-template-columns:auto 1fr;\n  }\n  .metricus-retention-card-v2 em{\n    grid-column:2;\n    justify-self:start;\n  }\n}\n\n/* ==========================================================================\n   Models screen overhaul — Metricus SaaS UI strategy\n   ========================================================================== */\n\n.models-page-head-v3{\n  margin-bottom:18px;\n  align-items:center;\n}\n\n.models-page-head-v3 h1{\n  margin:0 0 5px;\n  color:#0b1f44;\n  font-size:30px;\n  line-height:1.12;\n  letter-spacing:-.02em;\n}\n\n.models-page-head-v3 p{\n  margin:0;\n  color:#5e6c84;\n  font-size:14px;\n  line-height:1.45;\n}\n\n.models-card-v3{\n  overflow:visible;\n  border:1px solid #dfe3e8;\n  border-radius:12px;\n  background:#fff;\n  box-shadow:0 1px 3px rgba(9,30,66,.05);\n}\n\n.models-toolbar-v3{\n  min-height:58px;\n  display:flex;\n  align-items:center;\n  gap:10px;\n  padding:10px 12px;\n  border-bottom:1px solid #e7eaee;\n  background:#fbfcfd;\n  border-radius:12px 12px 0 0;\n}\n\n.models-search-v3{\n  min-width:320px;\n  height:38px;\n  display:flex;\n  align-items:center;\n  gap:8px;\n  flex:1 1 520px;\n  padding:0 11px;\n  border:1px solid #c8d0dc;\n  border-radius:8px;\n  background:#fff;\n  color:#6b778c;\n}\n\n.models-search-v3:focus-within{\n  border-color:#0c66e4;\n  box-shadow:0 0 0 2px #cce0ff;\n}\n\n.models-search-v3 input{\n  width:100%;\n  min-width:0;\n  border:0;\n  outline:0;\n  background:transparent;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:13.5px;\n}\n\n.models-toolbar-v3>select{\n  height:38px;\n  min-width:138px;\n  border:1px solid #c8d0dc;\n  border-radius:8px;\n  background:#fff;\n  padding:0 32px 0 11px;\n  color:#344563;\n  font-family:var(--pa-font);\n  font-size:13px;\n}\n\n.models-toolbar-v3>select:focus{\n  outline:2px solid #cce0ff;\n  border-color:#0c66e4;\n}\n\n.models-toolbar-v3>.pa-icon-button{\n  width:36px;\n  height:36px;\n}\n\n.models-toolbar-v3>span{\n  min-width:58px;\n  color:#7a869a;\n  font-size:12px;\n  text-align:right;\n}\n\n.models-table-v3{\n  width:100%;\n  overflow-x:auto;\n}\n\n.models-table-head-v3,\n.models-table-row-v3{\n  display:grid;\n  grid-template-columns:minmax(260px,1.7fr) minmax(175px,1.05fr) 94px 100px minmax(160px,.9fr) 108px 42px;\n  align-items:center;\n  column-gap:16px;\n  min-width:1040px;\n}\n\n.models-table-head-v3{\n  min-height:40px;\n  padding:0 18px;\n  border-bottom:1px solid #dfe3e8;\n  background:#f7f8fa;\n  color:#5e6c84;\n}\n\n.models-table-head-v3>div{\n  font-size:12px;\n  font-weight:650;\n  letter-spacing:.01em;\n}\n\n.models-table-head-v3 .numeric{\n  text-align:right;\n}\n\n.models-table-row-v3{\n  min-height:66px;\n  padding:0 18px;\n  border-bottom:1px solid #eef0f3;\n  color:#344563;\n  background:#fff;\n  cursor:pointer;\n  transition:background .12s ease;\n}\n\n.models-table-row-v3:last-child{\n  border-bottom:0;\n}\n\n.models-table-row-v3:hover{\n  background:#f8fbff;\n}\n\n.models-table-row-v3:focus{\n  outline:2px solid #85b8ff;\n  outline-offset:-2px;\n}\n\n.models-name-v3,\n.models-source-v3,\n.models-count-v3{\n  min-width:0;\n  display:grid;\n  gap:3px;\n}\n\n.models-name-v3 b,\n.models-source-v3 b,\n.models-count-v3 b{\n  overflow:hidden;\n  color:#172b4d;\n  font-size:14px;\n  line-height:1.25;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n\n.models-name-v3 span{\n  overflow:hidden;\n  color:#6b778c;\n  font-size:12.5px;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n\n.models-source-v3 b{\n  font-size:13.5px;\n}\n\n.models-source-v3 span,\n.models-count-v3 span{\n  overflow:hidden;\n  color:#6b778c;\n  font-size:12px;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n\n.models-count-v3{\n  font-variant-numeric:tabular-nums;\n}\n\n.models-table-row-v3 .numeric{\n  text-align:right;\n}\n\n.models-date-v3{\n  color:#44546f;\n  font-size:13px;\n  font-variant-numeric:tabular-nums;\n}\n\n.model-row-actions-v3{\n  display:flex;\n  justify-content:flex-end;\n}\n\n.model-row-actions-v3>button{\n  width:32px;\n  height:32px;\n  display:grid;\n  place-items:center;\n  border:0;\n  border-radius:6px;\n  background:transparent;\n  color:#44546f;\n  cursor:pointer;\n}\n\n.model-row-actions-v3>button:hover{\n  background:#e9f2ff;\n  color:#0c66e4;\n}\n\n.model-action-menu-v3{\n  width:210px;\n}\n\n/* Model details drawer */\n.model-detail-panel-v3{\n  width:min(600px,44vw);\n  min-width:540px;\n  max-height:100vh;\n  overflow:auto;\n  background:#fff;\n}\n\n.model-detail-head-v3{\n  display:flex;\n  align-items:flex-start;\n  justify-content:space-between;\n  gap:20px;\n  padding:22px 26px 18px;\n  border-bottom:1px solid #e7eaee;\n}\n\n.model-detail-source-label-v3{\n  display:flex;\n  align-items:center;\n  gap:7px;\n  margin-bottom:7px;\n  color:#0c66e4;\n  font-size:12px;\n  font-weight:700;\n}\n\n.model-detail-head-v3 h2{\n  margin:0 0 4px;\n  color:#0b1f44;\n  font-size:25px;\n  line-height:1.15;\n  letter-spacing:-.015em;\n}\n\n.model-detail-head-v3 p{\n  margin:0;\n  color:#5e6c84;\n  font-size:13.5px;\n}\n\n.model-detail-actions-v3{\n  display:flex;\n  align-items:center;\n  gap:8px;\n  padding:12px 26px;\n  border-bottom:1px solid #e7eaee;\n  background:#fbfcfd;\n}\n\n.model-detail-actions-v3 button{\n  min-height:38px;\n  font-size:12.5px;\n}\n\n.model-partial-banner-v3{\n  display:grid;\n  gap:3px;\n  margin:16px 26px 0;\n  padding:11px 13px;\n  border:1px solid #f1c46b;\n  border-radius:8px;\n  background:#fff8e6;\n}\n\n.model-partial-banner-v3 b{\n  color:#6b4800;\n  font-size:13px;\n}\n\n.model-partial-banner-v3 span{\n  color:#7a5a14;\n  font-size:12px;\n}\n\n.model-detail-section-v3{\n  padding:20px 26px;\n  border-bottom:1px solid #eef0f3;\n}\n\n.model-detail-section-head-v3{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:16px;\n  margin-bottom:12px;\n}\n\n.model-detail-section-head-v3 h3{\n  margin:0;\n  color:#172b4d;\n  font-size:15px;\n}\n\n.model-detail-section-head-v3>span{\n  color:#7a869a;\n  font-size:12px;\n}\n\n.model-detail-metrics-v3{\n  display:grid;\n  grid-template-columns:repeat(3,minmax(0,1fr));\n  gap:9px;\n}\n\n.model-detail-metrics-v3>div{\n  display:grid;\n  gap:5px;\n  padding:12px 13px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fafbfc;\n}\n\n.model-detail-metrics-v3 span{\n  color:#6b778c;\n  font-size:11.5px;\n}\n\n.model-detail-metrics-v3 strong{\n  color:#0b1f44;\n  font-size:23px;\n  line-height:1.1;\n  font-variant-numeric:tabular-nums;\n}\n\n.model-definition-grid-v3{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:16px 24px;\n}\n\n.model-definition-grid-v3>div,\n.model-scope-v3>div{\n  min-width:0;\n  display:grid;\n  gap:4px;\n}\n\n.model-definition-grid-v3 span,\n.model-scope-v3 span,\n.model-text-detail-v3>span{\n  color:#6b778c;\n  font-size:10.5px;\n  font-weight:700;\n  text-transform:uppercase;\n  letter-spacing:.035em;\n}\n\n.model-definition-grid-v3 b,\n.model-scope-v3 b{\n  color:#172b4d;\n  font-size:13px;\n  line-height:1.4;\n  word-break:break-word;\n}\n\n.model-scope-v3{\n  display:grid;\n  grid-template-columns:repeat(2,minmax(0,1fr));\n  gap:14px 24px;\n  margin-top:18px;\n  padding:14px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fafbfc;\n}\n\n.model-text-detail-v3{\n  display:grid;\n  gap:5px;\n  margin-top:16px;\n}\n\n.model-text-detail-v3 p{\n  margin:0;\n  color:#44546f;\n  font-size:13px;\n  line-height:1.5;\n}\n\n.model-detail-footer-v3{\n  display:flex;\n  align-items:center;\n  gap:14px;\n  padding:14px 26px 20px;\n}\n\n.model-detail-footer-v3 button{\n  display:inline-flex;\n  align-items:center;\n  gap:6px;\n  border:0;\n  background:transparent;\n  color:#44546f;\n  font-family:var(--pa-font);\n  font-size:12px;\n  font-weight:650;\n  cursor:pointer;\n}\n\n.model-detail-footer-v3 button:hover{\n  color:#0c66e4;\n}\n\n.model-detail-footer-v3 button.danger{\n  margin-left:auto;\n  color:#ae2a19;\n}\n\n/* Comprehensive edit dialog */\n.edit-model-modal-v3{\n  width:min(760px,calc(100vw - 48px));\n  max-height:calc(100vh - 48px);\n  overflow:hidden;\n  border-radius:12px;\n}\n\n.edit-model-head.v3{\n  display:flex;\n  align-items:flex-start;\n  justify-content:space-between;\n  gap:20px;\n  padding:20px 24px 17px;\n  border-bottom:1px solid #e7eaee;\n}\n\n.edit-model-head.v3 h2{\n  margin:2px 0 3px;\n  color:#0b1f44;\n  font-size:23px;\n}\n\n.edit-model-head.v3 p{\n  margin:0;\n  color:#6b778c;\n  font-size:12.5px;\n}\n\n.edit-model-body.v3{\n  max-height:calc(100vh - 190px);\n  overflow:auto;\n  padding:0;\n}\n\n.model-edit-section-v3{\n  padding:18px 24px;\n  border-bottom:1px solid #eef0f3;\n}\n\n.model-edit-section-v3 h3{\n  margin:0 0 12px;\n  color:#172b4d;\n  font-size:14px;\n}\n\n.model-edit-grid-v3{\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  gap:12px 14px;\n}\n\n.model-edit-grid-v3 label{\n  display:grid;\n  gap:6px;\n}\n\n.model-edit-grid-v3 label.span-two{\n  grid-column:1/-1;\n}\n\n.model-edit-grid-v3 label>span{\n  color:#344563;\n  font-size:12.5px;\n  font-weight:650;\n}\n\n.model-edit-grid-v3 input,\n.model-edit-grid-v3 textarea{\n  width:100%;\n  border:1px solid #b8c2d1;\n  border-radius:8px;\n  background:#fff;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:13.5px;\n}\n\n.model-edit-grid-v3 input{\n  min-height:42px;\n  padding:0 11px;\n}\n\n.model-edit-grid-v3 textarea{\n  min-height:80px;\n  padding:10px 11px;\n  resize:vertical;\n}\n\n.model-edit-grid-v3 input:focus,\n.model-edit-grid-v3 textarea:focus{\n  outline:2px solid #cce0ff;\n  border-color:#0c66e4;\n}\n\n.model-retention-edit-v3{\n  display:grid;\n  grid-template-columns:auto 1fr;\n  gap:10px;\n  align-items:start;\n  padding:12px 13px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fff;\n  cursor:pointer;\n}\n\n.model-retention-edit-v3.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n\n.model-retention-edit-v3 input{\n  width:17px;\n  height:17px;\n  margin-top:2px;\n  accent-color:#0c66e4;\n}\n\n.model-retention-edit-v3>span{\n  display:grid;\n  gap:3px;\n}\n\n.model-retention-edit-v3 b{\n  color:#172b4d;\n  font-size:13.5px;\n}\n\n.model-retention-edit-v3 small{\n  color:#6b778c;\n  font-size:12px;\n  line-height:1.45;\n}\n\n.model-retention-warning-v3{\n  margin-top:8px;\n  padding:9px 11px;\n  border:1px solid #f1c46b;\n  border-radius:7px;\n  background:#fff8e6;\n  color:#7a5a14;\n  font-size:12px;\n}\n\n.model-edit-source-v3{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:20px;\n  margin:18px 24px;\n  padding:13px 14px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fafbfc;\n}\n\n.model-edit-source-v3>div{\n  display:grid;\n  gap:4px;\n}\n\n.model-edit-source-v3 b{\n  color:#172b4d;\n  font-size:13px;\n}\n\n.model-edit-source-v3 span{\n  max-width:500px;\n  color:#6b778c;\n  font-size:11.5px;\n  line-height:1.4;\n}\n\n.model-edit-source-v3 button{\n  flex:0 0 auto;\n  min-height:36px;\n  font-size:12px;\n}\n\n.edit-model-foot.v3{\n  padding:12px 24px;\n  border-top:1px solid #e7eaee;\n  background:#fbfcfd;\n}\n\n@media(max-width:1100px){\n  .models-table-head-v3,\n  .models-table-row-v3{\n    grid-template-columns:minmax(230px,1.5fr) minmax(155px,1fr) 82px 88px minmax(145px,.9fr) 100px 38px;\n  }\n  .model-detail-panel-v3{\n    width:min(600px,65vw);\n    min-width:0;\n  }\n}\n\n@media(max-width:760px){\n  .model-edit-grid-v3,\n  .model-definition-grid-v3,\n  .model-scope-v3,\n  .model-detail-metrics-v3{\n    grid-template-columns:1fr;\n  }\n  .model-edit-grid-v3 label.span-two{\n    grid-column:auto;\n  }\n  .model-edit-source-v3{\n    align-items:flex-start;\n    flex-direction:column;\n  }\n}\n\n/* ==========================================================================\n   Models semantic cleanup — data status / access / explicit actions\n   ========================================================================== */\n\n.models-table-head-v3,\n.models-table-row-v3{\n  grid-template-columns:\n    minmax(250px,1.65fr)\n    minmax(160px,1fr)\n    90px\n    96px\n    minmax(150px,.9fr)\n    118px\n    72px;\n}\n\n.models-table-head-v3 .actions{\n  text-align:right;\n}\n\n.models-actions-cell-v4{\n  display:flex;\n  justify-content:flex-end;\n}\n\n.data-status-pill-v4{\n  width:max-content;\n  min-height:24px;\n  display:inline-flex;\n  align-items:center;\n  gap:6px;\n  padding:3px 8px;\n  border-radius:999px;\n  font-size:12px;\n  font-weight:650;\n  line-height:1;\n  white-space:nowrap;\n}\n\n.data-status-pill-v4 i{\n  width:6px;\n  height:6px;\n  border-radius:50%;\n  background:currentColor;\n}\n\n.data-status-pill-v4.success{\n  background:#dcfff1;\n  color:#087443;\n}\n\n.data-status-pill-v4.warning{\n  background:#fff0b3;\n  color:#7a4d00;\n}\n\n.data-status-pill-v4.info{\n  background:#e9f2ff;\n  color:#0c66e4;\n}\n\n.data-status-pill-v4.danger{\n  background:#ffeceb;\n  color:#ae2a19;\n}\n\n.data-status-pill-v4.neutral{\n  background:#f1f2f4;\n  color:#44546f;\n}\n\n.model-access-pill-v4{\n  width:max-content;\n  display:inline-flex;\n  align-items:center;\n  min-height:23px;\n  padding:3px 8px;\n  border-radius:999px;\n  font-size:11.5px;\n  font-weight:650;\n  white-space:nowrap;\n}\n\n.model-access-pill-v4.success{\n  background:#e9f8f0;\n  color:#087443;\n}\n\n.model-access-pill-v4.warning{\n  background:#fff8e6;\n  color:#7a4d00;\n}\n\n.model-access-empty-v4{\n  color:#8993a4;\n  font-size:13px;\n}\n\n.model-action-menu-v3{\n  width:236px;\n}\n\n.model-action-menu-v3 button{\n  min-height:38px;\n  font-size:12.5px;\n}\n\n.model-detail-actions-v3{\n  flex-wrap:wrap;\n}\n\n@media(max-width:1200px){\n  .models-table-head-v3,\n  .models-table-row-v3{\n    grid-template-columns:\n      minmax(225px,1.5fr)\n      minmax(145px,1fr)\n      80px\n      86px\n      minmax(140px,.9fr)\n      108px\n      66px;\n  }\n}\n\n/* ==========================================================================\n   Models edit modal compact pass + data-status correction\n   ========================================================================== */\n\n.edit-model-modal-v3{\n  width:min(880px,calc(100vw - 48px));\n  max-height:calc(100vh - 48px);\n}\n\n.edit-model-head.v3{\n  padding:17px 22px 14px;\n}\n\n.edit-model-head.v3 h2{\n  font-size:22px;\n}\n\n.edit-model-head.v3 p{\n  font-size:12.5px;\n}\n\n.edit-model-body.v4{\n  padding:18px 22px 16px;\n  overflow:auto;\n  max-height:calc(100vh - 175px);\n}\n\n.model-edit-grid-v4{\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  gap:12px 16px;\n}\n\n.model-edit-grid-v4 label{\n  display:grid;\n  gap:6px;\n}\n\n.model-edit-grid-v4 label.span-two{\n  grid-column:1/-1;\n}\n\n.model-edit-grid-v4 label>span{\n  color:#344563;\n  font-size:12.5px;\n  font-weight:650;\n}\n\n.model-edit-grid-v4 input,\n.model-edit-grid-v4 textarea{\n  width:100%;\n  border:1px solid #b8c2d1;\n  border-radius:8px;\n  background:#fff;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:13.5px;\n  box-sizing:border-box;\n}\n\n.model-edit-grid-v4 input{\n  height:40px;\n  padding:0 11px;\n}\n\n.model-edit-grid-v4 textarea{\n  min-height:64px;\n  max-height:110px;\n  padding:9px 11px;\n  resize:vertical;\n}\n\n.model-edit-grid-v4 input:focus,\n.model-edit-grid-v4 textarea:focus{\n  outline:2px solid #cce0ff;\n  border-color:#0c66e4;\n}\n\n.model-edit-lower-v4{\n  display:grid;\n  grid-template-columns:1.15fr .85fr;\n  gap:12px;\n  margin-top:14px;\n}\n\n.model-retention-edit-v4,\n.model-config-shortcut-v4{\n  min-height:76px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fafbfc;\n  padding:12px 13px;\n}\n\n.model-retention-edit-v4{\n  display:grid;\n  grid-template-columns:auto 1fr;\n  gap:10px;\n  align-items:start;\n  cursor:pointer;\n}\n\n.model-retention-edit-v4.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n\n.model-retention-edit-v4 input{\n  width:17px;\n  height:17px;\n  margin-top:2px;\n  accent-color:#0c66e4;\n}\n\n.model-retention-edit-v4>span{\n  display:grid;\n  gap:3px;\n}\n\n.model-retention-edit-v4 b,\n.model-config-shortcut-v4 b{\n  color:#172b4d;\n  font-size:13.5px;\n}\n\n.model-retention-edit-v4 small,\n.model-config-shortcut-v4 span{\n  color:#6b778c;\n  font-size:11.5px;\n  line-height:1.4;\n}\n\n.model-config-shortcut-v4{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n}\n\n.model-config-shortcut-v4>div{\n  display:grid;\n  gap:4px;\n}\n\n.model-config-shortcut-v4 button{\n  flex:0 0 auto;\n  min-height:34px;\n  padding:0 10px;\n  font-size:12px;\n}\n\n.model-retention-warning-v4{\n  margin-top:10px;\n  padding:8px 10px;\n  border:1px solid #f1c46b;\n  border-radius:7px;\n  background:#fff8e6;\n  color:#7a5a14;\n  font-size:11.5px;\n}\n\n.edit-model-foot.v3{\n  padding:11px 22px;\n}\n\n@media(max-width:760px){\n  .model-edit-grid-v4,\n  .model-edit-lower-v4{\n    grid-template-columns:1fr;\n  }\n  .model-edit-grid-v4 label.span-two{\n    grid-column:auto;\n  }\n}\n\n/* ==========================================================================\n   Connections settings — compact enterprise layout\n   ========================================================================== */\n\n.connections-toolbar.compact{\n  align-items:center;\n  padding:14px 18px;\n}\n\n.connections-title-block{\n  display:grid;\n  gap:3px;\n}\n\n.connections-title-line{\n  display:flex;\n  align-items:baseline;\n  gap:12px;\n  flex-wrap:wrap;\n}\n\n.connections-title-line h2{\n  margin:0;\n  font-size:17px;\n}\n\n.connections-title-line .connections-count{\n  color:#6b778c;\n  font-size:11px;\n  font-weight:500;\n}\n\n.connections-toolbar.compact p{\n  font-size:10.5px;\n}\n\n.settings-status.compact{\n  margin:0;\n  border-radius:0;\n  padding:7px 18px;\n  font-size:10.5px;\n}\n\n.connection-row{\n  padding:10px 18px;\n}\n\n.connection-mark{\n  width:32px;\n  height:32px;\n  border-radius:8px;\n}\n\n.connection-main b{\n  font-size:11.5px;\n}\n\n.connection-main span{\n  font-size:9.5px;\n}\n\n.connection-editor.compact{\n  margin:12px 18px 16px;\n  padding:14px 16px;\n  border-radius:9px;\n}\n\n.connection-editor-head.compact{\n  align-items:center;\n  margin-bottom:12px;\n}\n\n.connection-editor-title-line{\n  display:flex;\n  align-items:baseline;\n  gap:10px;\n}\n\n.connection-editor-title-line h3{\n  margin:0;\n  font-size:14.5px;\n}\n\n.connection-editor-title-line span{\n  color:#6b778c;\n  font-size:10px;\n}\n\n.connection-core-grid{\n  display:grid;\n  grid-template-columns:minmax(220px,1fr) 170px minmax(360px,1.7fr);\n  gap:12px;\n  align-items:end;\n}\n\n.connection-core-grid label{\n  display:grid;\n  gap:5px;\n  min-width:0;\n}\n\n.connection-core-grid label>span{\n  color:#344563;\n  font-size:10.5px;\n  font-weight:650;\n}\n\n.connection-core-grid input,\n.connection-core-grid select{\n  width:100%;\n  height:38px;\n  border:1px solid #cdd3dc;\n  border-radius:7px;\n  padding:0 10px;\n  background:#fff;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:11.5px;\n  box-sizing:border-box;\n}\n\n.connection-core-grid input:focus,\n.connection-core-grid select:focus{\n  outline:2px solid #cce0ff;\n  border-color:#0c66e4;\n}\n\n.jira-auth-section.compact{\n  margin:12px 0 10px;\n}\n\n.jira-auth-heading.compact{\n  display:flex;\n  align-items:baseline;\n  gap:10px;\n  margin-bottom:7px;\n}\n\n.jira-auth-heading.compact b{\n  font-size:11px;\n}\n\n.jira-auth-heading.compact span{\n  font-size:9.5px;\n}\n\n.jira-auth-methods.compact{\n  grid-template-columns:repeat(3,minmax(0,1fr));\n  gap:7px;\n}\n\n.jira-auth-method.compact{\n  min-height:42px;\n  display:flex;\n  align-items:center;\n  gap:8px;\n  padding:8px 10px;\n  border-radius:7px;\n}\n\n.jira-auth-method.compact.selected{\n  background:#f4f8ff;\n}\n\n.jira-auth-radio{\n  width:14px;\n  height:14px;\n  flex:0 0 14px;\n  border:1.5px solid #8c9bab;\n  border-radius:50%;\n  position:relative;\n}\n\n.jira-auth-method.compact.selected .jira-auth-radio{\n  border-color:#0c66e4;\n}\n\n.jira-auth-method.compact.selected .jira-auth-radio::after{\n  content:\"\";\n  position:absolute;\n  inset:3px;\n  border-radius:50%;\n  background:#0c66e4;\n}\n\n.jira-auth-compact-label{\n  display:flex!important;\n  align-items:center;\n  justify-content:space-between;\n  gap:8px;\n  width:100%;\n  padding:0!important;\n}\n\n.jira-auth-compact-label b{\n  font-size:10.5px;\n}\n\n.jira-auth-compact-label em{\n  position:static!important;\n  flex:0 0 auto;\n  font-size:8.5px!important;\n}\n\n.jira-auth-selected-help{\n  margin-top:6px;\n  color:#6b778c;\n  font-size:9.5px;\n  line-height:1.4;\n}\n\n.oauth-connect-panel.compact{\n  margin:8px 0 0;\n  padding:10px 12px;\n  border-radius:7px;\n}\n\n.oauth-connect-panel.compact b{\n  font-size:11px;\n}\n\n.oauth-connect-panel.compact span{\n  font-size:9.5px;\n}\n\n.oauth-connect-panel.compact button{\n  min-height:34px;\n  padding:0 12px;\n  font-size:10.5px;\n}\n\n.connection-credential-grid.compact{\n  margin-top:9px;\n}\n\n.connection-credential-grid.compact label>span{\n  font-size:10px;\n}\n\n.connection-credential-grid.compact input{\n  height:36px;\n  font-size:11px;\n}\n\n.connection-credential-grid.compact .connection-secret{\n  height:36px;\n}\n\n.connection-editor-footer{\n  display:grid;\n  grid-template-columns:minmax(0,1fr) auto;\n  gap:12px;\n  align-items:center;\n  margin-top:10px;\n  padding-top:10px;\n  border-top:1px solid #eef0f3;\n}\n\n.settings-actions.compact{\n  display:flex;\n  align-items:center;\n  gap:7px;\n  margin:0;\n}\n\n.settings-actions.compact button{\n  min-height:34px;\n  padding:0 12px;\n  font-size:10.5px;\n}\n\n.connection-test-result.compact{\n  margin:0;\n  padding:7px 9px;\n  grid-template-columns:auto 1fr;\n  align-items:center;\n  gap:8px;\n}\n\n.connection-test-result.compact b{\n  font-size:9.5px;\n  white-space:nowrap;\n}\n\n.connection-test-result.compact span{\n  font-size:9.5px;\n}\n\n@media(max-width:1150px){\n  .connection-core-grid{\n    grid-template-columns:1fr 170px;\n  }\n  .connection-url-field{\n    grid-column:1/-1;\n  }\n}\n\n@media(max-width:850px){\n  .connection-core-grid,\n  .jira-auth-methods.compact{\n    grid-template-columns:1fr;\n  }\n  .connection-url-field{\n    grid-column:auto;\n  }\n  .connection-editor-footer{\n    grid-template-columns:1fr;\n  }\n  .settings-actions.compact{\n    justify-content:flex-end;\n  }\n}\n\n/* ==========================================================================\n   ServiceNow REST model builder\n   ========================================================================== */\n\n.sn-builder{\n  display:grid;\n  gap:14px;\n}\n\n.compact-model-builder-head{\n  margin-bottom:0;\n}\n\n.sn-stepper{\n  display:flex;\n  align-items:center;\n  padding:0 4px 2px;\n}\n\n.sn-step{\n  display:flex;\n  align-items:center;\n  gap:8px;\n  color:#5e6c84;\n  white-space:nowrap;\n}\n\n.sn-step>span{\n  width:30px;\n  height:30px;\n  display:grid;\n  place-items:center;\n  border:1px solid #c8d0dc;\n  border-radius:50%;\n  background:#fff;\n  color:#344563;\n  font-size:12px;\n}\n\n.sn-step b{\n  font-size:12.5px;\n}\n\n.sn-step.active,\n.sn-step.done{\n  color:#0c66e4;\n}\n\n.sn-step.active>span{\n  border-color:#0c66e4;\n  color:#0c66e4;\n}\n\n.sn-step.done>span{\n  border-color:#0c66e4;\n  background:#0c66e4;\n  color:#fff;\n}\n\n.sn-step-line{\n  height:1px;\n  flex:1 1 70px;\n  min-width:30px;\n  max-width:115px;\n  margin:0 10px;\n  background:#dfe3e8;\n}\n\n.sn-step-line.done{\n  background:#0c66e4;\n}\n\n.sn-builder-panel{\n  overflow:hidden;\n}\n\n.sn-scope-body{\n  position:relative;\n}\n\n.sn-scope-grid{\n  display:grid;\n  grid-template-columns:1.25fr .75fr .75fr;\n  gap:13px;\n}\n\n.sn-scope-grid label,\n.sn-model-grid label,\n.sn-activity-row label{\n  display:grid;\n  gap:6px;\n}\n\n.sn-scope-grid label>span,\n.sn-model-grid label>span,\n.sn-activity-row label>span{\n  color:#344563;\n  font-size:12px;\n  font-weight:650;\n}\n\n.sn-scope-grid label>span em{\n  color:#7a869a;\n  font-style:normal;\n  font-weight:400;\n}\n\n.sn-scope-grid input,\n.sn-scope-grid select,\n.sn-model-grid input,\n.sn-model-grid textarea,\n.sn-activity-row select{\n  width:100%;\n  min-height:40px;\n  box-sizing:border-box;\n  border:1px solid #c8d0dc;\n  border-radius:8px;\n  background:#fff;\n  padding:0 11px;\n  color:#172b4d;\n  font-family:var(--pa-font);\n  font-size:13.5px;\n}\n\n.sn-model-grid textarea{\n  min-height:66px;\n  padding:9px 11px;\n  resize:vertical;\n}\n\n.sn-scope-grid .span-three{\n  grid-column:1/-1;\n}\n\n.sn-scope-count{\n  display:flex;\n  align-items:baseline;\n  gap:8px;\n  margin-top:13px;\n  padding:9px 11px;\n  width:max-content;\n  border:1px solid #b7e4c7;\n  border-radius:8px;\n  background:#f4fff9;\n}\n\n.sn-scope-count b{\n  color:#087443;\n  font-size:18px;\n}\n\n.sn-scope-count span{\n  color:#44546f;\n  font-size:12px;\n}\n\n.sn-model-grid{\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  gap:13px 16px;\n}\n\n.sn-model-grid .span-two{\n  grid-column:1/-1;\n}\n\n.sn-activity-row{\n  display:grid;\n  grid-template-columns:minmax(300px,.8fr) minmax(360px,1.2fr);\n  gap:18px;\n  align-items:center;\n  padding:12px 14px;\n  border:1px solid #bcd4ff;\n  border-radius:8px;\n  background:#f4f8ff;\n}\n\n.sn-activity-row>div{\n  display:grid;\n  gap:4px;\n}\n\n.sn-activity-row>div b{\n  color:#172b4d;\n  font-size:13px;\n}\n\n.sn-activity-row>div span{\n  color:#5e6c84;\n  font-size:12px;\n}\n\n.sn-selected-row{\n  display:flex;\n  align-items:baseline;\n  justify-content:space-between;\n  margin-top:14px;\n}\n\n.sn-selected-row b{\n  color:#172b4d;\n  font-size:13px;\n}\n\n.sn-selected-row span{\n  color:#6b778c;\n  font-size:11.5px;\n}\n\n.sn-field-search{\n  width:min(430px,100%);\n  height:38px;\n  display:flex;\n  align-items:center;\n  gap:8px;\n  margin:9px 0;\n  padding:0 11px;\n  border:1px solid #c8d0dc;\n  border-radius:8px;\n  background:#fff;\n  color:#6b778c;\n}\n\n.sn-field-search input{\n  flex:1;\n  border:0;\n  outline:0;\n  background:transparent;\n  font-family:var(--pa-font);\n  font-size:13px;\n}\n\n.sn-field-grid{\n  display:grid;\n  grid-template-columns:repeat(3,minmax(0,1fr));\n  gap:7px;\n  max-height:300px;\n  overflow:auto;\n  padding-right:4px;\n}\n\n.sn-field-grid label{\n  min-height:50px;\n  display:flex;\n  align-items:flex-start;\n  gap:8px;\n  padding:9px 10px;\n  border:1px solid #dfe3e8;\n  border-radius:8px;\n  background:#fff;\n  cursor:pointer;\n}\n\n.sn-field-grid label.selected{\n  border-color:#85b8ff;\n  background:#f4f8ff;\n}\n\n.sn-field-grid input{\n  width:16px;\n  height:16px;\n  margin-top:2px;\n  accent-color:#0c66e4;\n}\n\n.sn-field-grid label>span{\n  display:grid;\n  gap:2px;\n  min-width:0;\n}\n\n.sn-field-grid b{\n  overflow:hidden;\n  color:#172b4d;\n  font-size:12.5px;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n\n.sn-field-grid small{\n  overflow:hidden;\n  color:#7a869a;\n  font-size:10.5px;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n}\n\n.sn-preview-panel{\n  min-height:0;\n}\n\n.sn-preview-head{\n  display:flex;\n  align-items:baseline;\n  gap:16px;\n  padding:12px 18px;\n  border-bottom:1px solid #e7eaee;\n}\n\n.sn-preview-head h2{\n  margin:0;\n  color:#172b4d;\n  font-size:17px;\n}\n\n.sn-preview-head span{\n  color:#5e6c84;\n  font-size:12px;\n}\n\n.sn-preview-table-wrap{\n  max-height:440px;\n  overflow:auto;\n}\n\n.sn-preview-table{\n  width:max-content;\n  min-width:100%;\n  border-collapse:collapse;\n}\n\n.sn-preview-table th{\n  position:sticky;\n  top:0;\n  z-index:1;\n  padding:9px 12px;\n  border-bottom:1px solid #dfe3e8;\n  background:#f7f8fa;\n  color:#44546f;\n  font-size:11.5px;\n  text-align:left;\n  white-space:nowrap;\n}\n\n.sn-preview-table td{\n  padding:10px 12px;\n  border-bottom:1px solid #eef0f3;\n  color:#344563;\n  font-size:12.5px;\n  white-space:nowrap;\n}\n\n.sn-run-body{\n  display:grid;\n  gap:13px;\n}\n\n.source-chip{\n  display:inline-flex;\n  align-items:center;\n  gap:6px;\n  min-height:30px;\n  padding:0 9px;\n  border:1px solid #dfe3e8;\n  border-radius:7px;\n  color:#344563;\n  font-size:11.5px;\n  font-weight:650;\n}\n\n.count-pill{\n  display:inline-flex;\n  min-height:25px;\n  align-items:center;\n  padding:0 8px;\n  border-radius:999px;\n  background:#dcfff1;\n  color:#087443;\n  font-size:11.5px;\n  font-weight:650;\n}\n\n@media(max-width:1000px){\n  .sn-scope-grid,\n  .sn-model-grid,\n  .sn-activity-row{\n    grid-template-columns:1fr;\n  }\n  .sn-scope-grid .span-three,\n  .sn-model-grid .span-two{\n    grid-column:auto;\n  }\n  .sn-field-grid{\n    grid-template-columns:repeat(2,minmax(0,1fr));\n  }\n}\n\n@media(max-width:700px){\n  .sn-step b{\n    display:none;\n  }\n  .sn-field-grid{\n    grid-template-columns:1fr;\n  }\n}\n\n/* ServiceNow connection methods */\n.servicenow-auth-methods.compact{\n  display:grid;\n  grid-template-columns:repeat(4,minmax(0,1fr));\n  gap:7px;\n}\n.connection-credential-grid.one{\n  grid-template-columns:1fr;\n}\n@media(max-width:1180px){\n  .servicenow-auth-methods.compact{\n    grid-template-columns:repeat(2,minmax(0,1fr));\n  }\n}\n@media(max-width:760px){\n  .servicenow-auth-methods.compact{\n    grid-template-columns:1fr;\n  }\n}\n\n/* ServiceNow scope count control */\n.sn-scope-count-row{\n  display:flex;\n  align-items:center;\n  gap:10px;\n  margin-top:13px;\n}\n.sn-scope-count-row .pa-secondary{\n  min-height:36px;\n  padding:0 12px;\n}\n.sn-scope-count-row .sn-scope-count{\n  margin-top:0;\n}\n.sn-scope-count.over-limit{\n  border-color:#f5b7b1;\n  background:#fff4f3;\n}\n.sn-scope-count.over-limit b{\n  color:#ae2e24;\n}\n.sn-count-hint{\n  color:#6b778c;\n  font-size:11.5px;\n}\n\n/* ServiceNow table discovery diagnostics */\n.sn-discovery-status{\n  display:flex;\n  align-items:baseline;\n  gap:8px;\n  margin-top:10px;\n  padding:8px 10px;\n  border-radius:7px;\n  font-size:11.5px;\n}\n.sn-discovery-status b{\n  white-space:nowrap;\n}\n.sn-discovery-status span{\n  color:#5e6c84;\n}\n.sn-discovery-status.success{\n  border:1px solid #b7e4c7;\n  background:#f4fff9;\n  color:#087443;\n}\n.sn-discovery-status.warning{\n  border:1px solid #f1c46b;\n  background:#fff8e6;\n  color:#7a4d00;\n}\n\n\n/* ServiceNow REST working indicator */\n.sn-working-overlay{\n  position:fixed;\n  inset:0;\n  z-index:10000;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  background:rgba(244,247,251,.62);\n  backdrop-filter:blur(1px);\n}\n.sn-working-dialog{\n  width:min(430px,calc(100vw - 32px));\n  display:flex;\n  align-items:center;\n  gap:14px;\n  padding:20px 22px;\n  border:1px solid #d8e0ea;\n  border-radius:12px;\n  background:#fff;\n  box-shadow:0 16px 42px rgba(9,30,66,.16);\n}\n.sn-working-dialog>div:last-child{\n  display:flex;\n  flex-direction:column;\n  gap:4px;\n}\n.sn-working-dialog b{\n  font-size:15px;\n  color:#091e42;\n}\n.sn-working-dialog span{\n  font-size:13px;\n  line-height:1.4;\n  color:#5e6c84;\n}\n.sn-working-spinner{\n  width:28px;\n  height:28px;\n  flex:0 0 28px;\n  border:3px solid #dbe7f7;\n  border-top-color:#0c66e4;\n  border-radius:50%;\n  animation:sn-working-spin .75s linear infinite;\n}\n@keyframes sn-working-spin{\n  to{transform:rotate(360deg);}\n}\n\n/* Organization context wizard step */\n.organization-context-panel{overflow:hidden}\n.organization-context-head{align-items:flex-start;gap:20px}\n.organization-ai-button{white-space:nowrap}\n.organization-context-body{display:flex;flex-direction:column;gap:18px}\n.organization-context-intro{display:flex;align-items:center;justify-content:space-between;gap:18px;padding:14px 16px;border:1px solid #dbe4f0;border-radius:10px;background:#f8fbff}\n.organization-context-intro>div{display:flex;flex-direction:column;gap:3px}\n.organization-context-intro b{font-size:14px;color:#102a56}\n.organization-context-intro span{font-size:13px;color:#526987}\n.organization-process-chip{max-width:48%;padding:6px 10px;border-radius:999px;background:#edf4ff;color:#205fc7!important;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n.organization-context-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px 20px}\n.organization-context-grid label{display:flex;flex-direction:column;gap:7px;font-size:13px;font-weight:700;color:#102a56}\n.organization-context-grid label.span-two{grid-column:1/-1}\n.organization-context-grid input,.organization-context-grid textarea{width:100%;box-sizing:border-box;border:1px solid #cbd7e6;border-radius:9px;background:#fff;color:#0b2854;font:inherit;font-weight:400;padding:11px 13px;outline:none}\n.organization-context-grid input:focus,.organization-context-grid textarea:focus{border-color:#0c66e4;box-shadow:0 0 0 2px rgba(12,102,228,.10)}\n.organization-context-grid textarea{resize:vertical;min-height:68px}\n.organization-default-row{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;padding:13px 15px;border:1px solid #dbe4f0;border-radius:10px;background:#fff}\n.organization-default-row label{display:flex;align-items:center;gap:9px;font-size:13px;font-weight:700;color:#102a56}\n.organization-default-row small{max-width:48%;color:#64748b;line-height:1.45;text-align:right}\n.organization-context-message{padding:10px 12px;border-radius:8px;background:#f3f7fc;color:#3d5879;font-size:13px}\n@media(max-width:900px){.organization-context-grid{grid-template-columns:1fr}.organization-context-grid label.span-two{grid-column:auto}.organization-context-intro,.organization-default-row{align-items:flex-start;flex-direction:column}.organization-process-chip,.organization-default-row small{max-width:100%;text-align:left}}\n\n/* Organization context AI assist refinement */\n.organization-name-field{grid-column:1/-1!important}\n.organization-name-ai-row{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;align-items:stretch}\n.organization-name-ai-row input{min-width:0}\n.organization-name-ai-row .organization-ai-button{min-width:170px;padding-left:18px;padding-right:18px}\n.organization-ai-hint{font-size:12px!important;font-weight:400!important;line-height:1.45;color:#65758b!important}\n.organization-ai-hint.ready{color:#245ba7!important}\n.organization-ai-hint b{color:#123b78}\n.organization-context-grid>.organization-context-message{grid-column:1/-1;margin-top:-4px}\n.organization-context-message.success{background:#eefbf4;color:#17633a;border:1px solid #bce8cd}\n.organization-context-message.error{background:#fff4f3;color:#ae2e24;border:1px solid #f3b8b3}\n.organization-context-message.info{background:#f3f7fc;color:#3d5879;border:1px solid #dbe4f0}\n@media(max-width:700px){.organization-name-ai-row{grid-template-columns:1fr}.organization-name-ai-row .organization-ai-button{width:100%}}\n\n/* Integrated billing sprint */\n.billing-page-head{align-items:flex-start}\n.integrated-billing-summary .access-summary-card strong{font-size:20px}\n.billing-offering-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:16px}\n.billing-offering-card{border:1px solid #dfe1e6;border-radius:12px;padding:18px;background:#fff;display:flex;flex-direction:column;gap:10px;min-height:270px}\n.billing-offering-card.selected{box-shadow:0 0 0 2px rgba(14,99,156,.12);border-color:#0e639c}\n.billing-offering-kicker{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#6b778c}\n.billing-offering-card h3{margin:0;color:#172b4d;font-size:16px}\n.billing-offering-price{font-size:25px;font-weight:800;color:#172b4d;line-height:1.1}\n.billing-offering-price small{font-size:11px;font-weight:600;color:#6b778c}\n.billing-offering-card p{margin:0 0 3px;color:#5e6c84;font-size:12px;line-height:1.5;min-height:54px}\n.billing-offering-feature{display:flex;gap:7px;align-items:flex-start;color:#42526e;font-size:11px;line-height:1.4}\n.billing-offering-feature svg{flex:0 0 auto;color:#1f845a;margin-top:1px}\n.billing-offering-card button{margin-top:auto;justify-content:center}\n.billing-empty{padding:18px;border:1px dashed #c1c7d0;border-radius:10px;color:#6b778c;font-size:12px;text-align:center}\n.billing-ledger{display:grid;border:1px solid #dfe1e6;border-radius:10px;overflow:hidden}\n.billing-ledger-row{display:grid;grid-template-columns:120px minmax(260px,1fr) 80px 80px;gap:14px;padding:10px 12px;border-top:1px solid #eef0f3;align-items:center;font-size:11px;color:#42526e}\n.billing-ledger-row:first-child{border-top:0}\n.billing-ledger-head{font-weight:800;color:#5e6c84;background:#fafbfc;text-transform:uppercase;font-size:10px;letter-spacing:.04em}\n.billing-ledger-row strong{font-weight:800;color:#ae2a19}\n.billing-ledger-row strong.positive{color:#1f845a}\n.billing-rule-panel{margin-bottom:30px}\n@media(max-width:800px){.billing-ledger-row{grid-template-columns:90px 1fr 60px 60px}.billing-offering-grid{grid-template-columns:1fr}}\n\n/* Billing layout refinement */\n.billing-status-strip{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));border:1px solid #dfe3eb;border-radius:14px;background:#fff;overflow:hidden;margin:0 0 18px;box-shadow:0 1px 2px rgba(9,30,66,.04)}\n.billing-status-item{display:flex;align-items:center;gap:12px;padding:15px 18px;border-left:1px solid #edf0f5}\n.billing-status-item:first-child{border-left:0}\n.billing-status-icon{width:36px;height:36px;border-radius:10px;background:#edf4ff;color:#0c66e4;display:grid;place-items:center;flex:0 0 auto}\n.billing-status-item span{display:block;font-size:10px;line-height:1.2;text-transform:uppercase;letter-spacing:.05em;color:#6b778c;font-weight:800;margin-bottom:3px}\n.billing-status-item strong{display:block;font-size:16px;color:#172b4d;line-height:1.2}\n.billing-choice-panel{margin-bottom:18px}\n.billing-plan-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px}\n.billing-plan-card{border:1px solid #dfe3eb;border-radius:14px;padding:22px;background:#fff;display:flex;flex-direction:column;min-height:365px}\n.billing-plan-card.assessment{border-top:3px solid #579dff}\n.billing-plan-card.subscription{border-top:3px solid #0c66e4}\n.billing-plan-top{display:flex;justify-content:space-between;gap:22px;align-items:flex-start;padding-bottom:16px;border-bottom:1px solid #edf0f5}\n.billing-plan-card h3{font-size:20px;margin:3px 0 6px;color:#172b4d}\n.billing-plan-card p{font-size:12px;color:#5e6c84;line-height:1.5;margin:0;max-width:470px}\n.billing-plan-price{text-align:right;white-space:nowrap}\n.billing-plan-price strong{display:block;color:#172b4d;font-size:25px;line-height:1.05}\n.billing-plan-price span{display:block;color:#6b778c;font-size:10px;margin-top:4px;text-transform:uppercase;font-weight:700;letter-spacing:.04em}\n.billing-plan-features{display:grid;gap:9px;padding:17px 0;color:#42526e;font-size:12px}\n.billing-plan-features>div{display:flex;align-items:flex-start;gap:8px}\n.billing-plan-features svg{color:#1f845a;flex:0 0 auto;margin-top:1px}\n.billing-source-picker{display:grid;gap:7px;margin-top:auto;margin-bottom:12px}\n.billing-source-picker>span{font-size:11px;font-weight:800;color:#172b4d}\n.billing-source-picker select{width:100%;height:42px;border:1px solid #b7c1d1;border-radius:8px;background:#fff;padding:0 11px;color:#172b4d;font:inherit;font-size:12px}\n.billing-source-picker select:focus{outline:none;border-color:#0c66e4;box-shadow:0 0 0 2px rgba(12,102,228,.12)}\n.billing-plan-action{width:100%;justify-content:center;gap:8px;min-height:42px;margin-top:auto}\n.billing-plan-card.subscription .billing-plan-action{margin-top:0}\n.billing-empty.compact{padding:12px;min-height:0}\n.billing-secondary-grid{display:grid;grid-template-columns:minmax(320px,.72fr) minmax(0,1.28fr);gap:18px;align-items:start}\n.billing-compact-panel{margin-bottom:18px}\n.billing-partner-row{display:grid;grid-template-columns:auto 1fr auto;gap:14px;align-items:center;padding:18px!important}\n.billing-partner-row h3{margin:0 0 3px;color:#172b4d;font-size:15px}\n.billing-partner-row p{margin:0;color:#5e6c84;font-size:11px;line-height:1.45}\n.billing-partner-icon{width:38px;height:38px;border-radius:10px;background:#f1f2f4;color:#44546f;display:grid;place-items:center}\n.billing-ledger.subscriptions .billing-ledger-row{grid-template-columns:minmax(180px,1fr) minmax(280px,1.5fr) 90px 100px}\n@media(max-width:1000px){.billing-plan-grid,.billing-secondary-grid{grid-template-columns:1fr}.billing-plan-card{min-height:0}.billing-status-strip{grid-template-columns:1fr}.billing-status-item{border-left:0;border-top:1px solid #edf0f5}.billing-status-item:first-child{border-top:0}.billing-plan-top{flex-direction:column}.billing-plan-price{text-align:left}.billing-partner-row{grid-template-columns:auto 1fr}.billing-partner-row .pa-secondary{grid-column:1/-1;justify-self:start}}\n\n.metricus-access-choice-v2{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:14px 0}.metricus-access-choice-v2 label{display:flex;align-items:flex-start;gap:10px;border:1px solid #d8e0ec;border-radius:10px;padding:14px 16px;background:#fff;cursor:pointer}.metricus-access-choice-v2 label.selected{border-color:#0c66e4;background:#f3f8ff;box-shadow:0 0 0 1px #0c66e4 inset}.metricus-access-choice-v2 label.disabled{opacity:.55;cursor:not-allowed}.metricus-access-choice-v2 input{margin-top:3px}.metricus-access-choice-v2 span{display:flex;flex-direction:column;gap:3px}.metricus-access-choice-v2 b{font-size:14px;color:#0b1f44}.metricus-access-choice-v2 small{font-size:12px;line-height:1.4;color:#526581}@media(max-width:900px){.metricus-access-choice-v2{grid-template-columns:1fr}}\n\n/* Free-analysis notice must not inherit the legacy full-screen host child height.\n   The embedded host is a column: the notice sizes to content and the Process Advisor\n   runtime owns the remaining height. */\n.web-process-advisor-host.web-process-advisor-embedded > .free-analysis-notice{\n  width:100%;\n  height:auto!important;\n  min-height:30px;\n  flex:0 0 auto;\n}\n.web-process-advisor-host.web-process-advisor-embedded > .web-process-advisor-runtime{\n  width:100%;\n  height:auto!important;\n  min-height:0;\n  flex:1 1 0%;\n}\n\n.pa-modal-overlay{position:fixed;inset:0;z-index:100;display:grid;place-items:center;padding:24px;background:rgba(9,30,66,.38);backdrop-filter:blur(2px)}\n.pa-modal-card{width:min(460px,calc(100vw - 40px));background:#fff;border:1px solid var(--pa-border);border-radius:14px;box-shadow:0 18px 48px rgba(9,30,66,.22);overflow:hidden}\n.pa-modal-head{padding:18px 20px 14px;border-bottom:1px solid var(--pa-border-subtle)}\n.pa-modal-head span{display:block;font-size:10px;font-weight:800;letter-spacing:.06em;color:var(--pa-blue);margin-bottom:5px}\n.pa-modal-head h2{margin:0;font-size:19px}\n.pa-modal-body{padding:18px 20px}.pa-modal-body p{margin:0 0 14px;font-size:13px;line-height:1.5}.pa-modal-body small{display:block;margin-top:14px;color:var(--pa-text-muted);font-size:11px;line-height:1.45}\n.pa-modal-facts{display:grid;gap:8px;padding:12px 14px;background:var(--pa-surface-muted);border:1px solid var(--pa-border-subtle);border-radius:9px}.pa-modal-facts span{font-size:12px}.pa-modal-facts span:before{content:'✓';color:var(--pa-success);font-weight:800;margin-right:8px}\n.pa-modal-actions{display:flex;justify-content:flex-end;gap:8px;padding:14px 20px;background:#FAFBFC;border-top:1px solid var(--pa-border-subtle)}\n\n/* Connections — distinct source systems and scalable source selection */\n.connections-add-area{position:relative;flex-shrink:0}\n.connections-add-trigger{display:inline-flex;align-items:center;justify-content:center;gap:9px;min-height:38px;padding:0 15px;font-size:12px;font-weight:700}\n.connections-source-picker{position:absolute;z-index:20;right:0;top:calc(100% + 8px);width:286px;background:#fff;border:1px solid #dfe3e8;border-radius:10px;box-shadow:0 12px 32px rgba(9,30,66,.16);padding:8px}\n.connections-picker-heading{font-size:11px;font-weight:700;color:#44546f;padding:8px 10px 10px}\n.connections-source-picker>button{display:flex;align-items:center;text-align:left;width:100%;gap:12px;border:0;border-radius:7px;background:transparent;padding:9px 10px;cursor:pointer;color:#172b4d}\n.connections-source-picker>button:hover{background:#f1f5fc}\n.connections-source-picker>button>span:last-child{display:grid;gap:3px}\n.connections-source-picker b{font-size:12px}\n.connections-source-picker small{font-size:10px;color:#6b778c}\n.connections-picker-note{border-top:1px solid #eef0f3;margin-top:6px;padding:10px;font-size:10px;line-height:1.5;color:#6b778c}\n.connection-table-wrap{width:100%;overflow-x:auto}\n.connection-table-head,.connection-detail-row{display:grid;grid-template-columns:minmax(175px,1.4fr) minmax(120px,.9fr) minmax(135px,1fr) minmax(190px,1.5fr) minmax(94px,.7fr) 116px;gap:14px;align-items:center;min-width:900px;padding-left:20px;padding-right:20px}\n.connection-table-head{padding-top:11px;padding-bottom:11px;background:#f7f9fc;border-bottom:1px solid #e6ebf2;color:#626f86;text-transform:uppercase;font-size:10px;font-weight:750;letter-spacing:.045em}\n.connection-detail-row{padding-top:14px;padding-bottom:14px}\n.connection-name-cell{display:flex;align-items:center;gap:11px;min-width:0}\n.connection-name-cell b{font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#172b4d}\n.connection-name-cell .connection-mark{flex-shrink:0}\n.connection-mark.jira-rest{background:#e9f2ff;color:#0c66e4}\n.connection-mark.servicenow-rest{background:#e7f7ed;color:#167546}\n.connection-source-tag{display:inline-flex;align-items:center;border-radius:5px;padding:5px 9px;font-size:11px;font-weight:750;color:#0c66e4;background:#e9f2ff}\n.connection-source-tag.servicenow-rest{color:#167546;background:#e7f7ed}\n.connection-auth-cell{display:flex;flex-direction:column;gap:3px;font-size:11.5px;font-weight:650;color:#172b4d}\n.connection-auth-cell small{font-size:10px;font-weight:400;color:#6b778c}\n.connection-url-cell{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;color:#44546f}\n.connection-detail-row>.status-pill{display:inline-flex}\n.connection-detail-row>div:has(>.status-pill){display:flex;align-items:center}\n.connection-detail-row .connection-row-actions{justify-content:flex-end}\n@media(max-width:900px){.connection-detail-row{grid-template-columns:minmax(175px,1.4fr) minmax(120px,.9fr) minmax(135px,1fr) minmax(190px,1.5fr) minmax(94px,.7fr) 116px}.connection-detail-row>div:has(>.status-pill){display:flex}}\n\n/* CSV import appears alongside reusable REST sources in the data-source picker. */\n.connection-mark.csv-file{background:#fff3e6;color:#a15c08}\n\n/* Home page refinement — content-driven layout, no viewport-filling empty rows.\n   Scoped to the web Home route; does not affect Process Advisor workspaces. */\n.saas-main.saas-main-home {\n  height: auto;\n  min-height: 0;\n  max-width: 1480px;\n  padding: 20px 26px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow: visible;\n}\n.saas-main-home .home-hero {\n  height: auto;\n  min-height: 0;\n  margin: 0;\n  padding: 27px 32px;\n  grid-template-columns: minmax(0, 1.9fr) minmax(190px, .55fr);\n  gap: 28px;\n  align-items: center;\n}\n.saas-main-home .home-hero h1 {\n  font-size: clamp(27px, 2.1vw, 34px);\n  line-height: 1.14;\n  max-width: 850px;\n  margin: 6px 0 10px;\n}\n.saas-main-home .home-hero p {\n  max-width: 760px;\n  font-size: 14px;\n  line-height: 1.52;\n}\n.saas-main-home .home-hero-actions { margin-top: 17px; }\n.saas-main-home .home-hero-visual { gap: 3px; }\n.saas-main-home .home-flow-card {\n  min-height: 43px;\n  width: min(100%, 198px);\n  font-size: 12px;\n  box-shadow: 0 2px 7px rgba(9,30,66,.04);\n}\n.saas-main-home .home-flow-line { height: 11px; }\n.saas-main-home .home-section {\n  height: auto;\n  min-height: 0;\n  margin: 0;\n  display: block;\n}\n.saas-main-home .home-section-head { margin-bottom: 9px; }\n.saas-main-home .home-section-head h2 { font-size: 19px; }\n.saas-main-home .home-steps,\n.saas-main-home .home-capability-grid { height: auto; }\n.saas-main-home .home-step {\n  height: auto;\n  min-height: 102px;\n  padding: 16px 14px;\n}\n.saas-main-home .home-step h3 { font-size: 14px; margin-bottom: 5px; }\n.saas-main-home .home-step p { font-size: 12px; line-height: 1.45; }\n.saas-main-home .home-capability {\n  height: auto;\n  min-height: 112px;\n  padding: 18px 15px;\n  align-content: center;\n  box-shadow: 0 1px 3px rgba(9,30,66,.03);\n}\n.saas-main-home .home-capability h3 { font-size: 15px; margin-bottom: 5px; }\n.saas-main-home .home-capability p { font-size: 12px; line-height: 1.45; }\n@media (max-width: 1050px) {\n  .saas-main-home .home-hero { grid-template-columns: 1fr; }\n  .saas-main-home .home-hero-visual { display: none; }\n}\n@media (max-width: 900px) {\n  .saas-main.saas-main-home { padding: 18px; gap: 18px; }\n  .saas-main-home .home-steps,\n  .saas-main-home .home-capability-grid { grid-template-columns: repeat(2,minmax(0,1fr)); }\n}\n@media (max-width: 620px) {\n  .saas-main-home .home-hero { padding: 22px; }\n  .saas-main-home .home-hero h1 { font-size: 26px; }\n  .saas-main-home .home-steps,\n  .saas-main-home .home-capability-grid { grid-template-columns: 1fr; }\n}\n\n\n/* Home & account typography final polish — keep consistent with 14px navigation */\n.account-menu .account-label b { font-size: 13px; line-height: 1.35; font-weight: 700; }\n.account-menu .account-label small { font-size: 12px; line-height: 1.4; color: #5e6c84; }\n.account-popover { width: 276px; padding: 10px; }\n.account-popover .account-meta { padding: 12px 12px 13px; gap: 5px; }\n.account-popover .account-meta b { font-size: 14px; line-height: 1.4; }\n.account-popover .account-meta span { font-size: 12px; line-height: 1.5; overflow-wrap: anywhere; }\n.account-popover button { min-height: 42px; height: auto; padding: 10px 12px; font-size: 14px; line-height: 1.35; font-weight: 500; }\n.account-popover button:focus-visible, .account-menu summary:focus-visible { outline: 2px solid #0c66e4; outline-offset: 2px; }\n.saas-main-home .home-hero h1 { font-size: clamp(27px, 2vw, 33px); line-height: 1.16; max-width: 760px; }\n\n/* Shared popover typography and dismiss affordances */\n.account-menu .account-popover,\n.connections-source-picker { font-size:14px; color:#172b4d; }\n.account-popover { width:276px; max-width:calc(100vw - 24px); }\n.account-popover .account-meta b {font-size:14px; line-height:1.45}\n.account-popover .account-meta span {font-size:12px; line-height:1.5}\n.account-popover button,\n.connections-source-picker > button { font-size:14px; line-height:1.4; min-height:42px; }\n.connections-source-picker { width:300px; max-width:calc(100vw - 24px); padding:10px; }\n.connections-picker-heading { font-size:13px; font-weight:700; padding:8px 10px 10px; }\n.connections-source-picker b { font-size:14px; }\n.connections-source-picker small { font-size:12px; line-height:1.45; }\n.connections-picker-note { font-size:12px; line-height:1.45; }\n.connections-source-picker > button:focus-visible { outline:2px solid #0c66e4; outline-offset:-2px; }\n\n/* Process Advisor Web — unified UI scale (v1)\n   Shell and web-owned controls only. Avoids global overrides of process-miner,\n   AG Grid, Atlaskit, MUI, and third-party dialogs. */\n.saas-root {\n  --web-ui-text: 14px;\n  --web-ui-meta: 12px;\n  --web-ui-small: 13px;\n  --web-ui-heading: 20px;\n  --web-ui-control-height: 38px;\n  --web-ui-focus: #0c66e4;\n  font-size: var(--web-ui-text);\n  line-height: 1.5;\n}\n.saas-root :is(.saas-nav-item, .saas-nav-bottom button) {\n  font-size: var(--web-ui-text);\n  line-height: 1.4;\n  min-height: 40px;\n  border-radius: 8px;\n}\n.saas-root .saas-brand-title { font-size: 16px; line-height: 1.3; }\n.saas-root :is(.saas-brand-sub, .saas-org, .saas-nav-context span) {\n  font-size: var(--web-ui-meta);\n  line-height: 1.45;\n}\n.saas-root :is(.saas-nav-label, .eyebrow) {\n  font-size: 11px;\n  line-height: 1.5;\n  letter-spacing: .065em;\n}\n.saas-root .saas-topbar { font-size: var(--web-ui-small); }\n.saas-root .saas-breadcrumb { font-size: var(--web-ui-small); }\n.saas-root .saas-main:not(.saas-main-advisor) { padding-top: 22px; }\n.saas-root :is(.page-head h1) { font-size: 25px; line-height: 1.25; }\n.saas-root :is(.page-head p, .panel-head p, .empty-state p) {\n  font-size: var(--web-ui-small);\n  line-height: 1.55;\n}\n.saas-root .panel-head h2 { font-size: 17px; line-height: 1.3; }\n.saas-root :is(.pa-primary, .pa-secondary, .connections-add-trigger) {\n  min-height: var(--web-ui-control-height);\n  font-size: var(--web-ui-text);\n  line-height: 1.35;\n  padding: 8px 14px;\n  gap: 8px;\n}\n.saas-root :is(.pa-primary, .pa-secondary):focus-visible,\n.saas-root :is(.saas-nav-item, .model-action-menu button):focus-visible,\n.saas-root :is(.account-menu summary, .account-popover button, .connections-source-picker button):focus-visible {\n  outline: 2px solid var(--web-ui-focus);\n  outline-offset: 2px;\n}\n.saas-root :is(.form-grid label > span, .edit-model-body label > span,\n .metricus-field-label) { font-size: var(--web-ui-small); line-height: 1.4; }\n.saas-root :is(.form-grid input, .form-grid select, .mapping-row select,\n .edit-model-body input, .edit-model-body textarea, .metricus-input) {\n  font-size: var(--web-ui-text);\n  min-height: var(--web-ui-control-height);\n  line-height: 1.4;\n}\n.saas-root :is(.metric-card span, .metric-card small,\n .assessment-name span, .assessment-row span, .file-summary,\n .model-description) { font-size: var(--web-ui-meta); line-height: 1.45; }\n.saas-root :is(.assessment-row b, .assessment-name b, .model-name-cell) {\n  font-size: var(--web-ui-text);\n}\n.saas-root :is(.assessment-table, .assessment-table-head,\n .assessment-table-row, .connection-table-head, .connection-name-cell b,\n .connection-url-cell, .connection-auth-cell, .connection-auth-cell small) {\n  font-size: var(--web-ui-small);\n  line-height: 1.45;\n}\n.saas-root .connection-table-head { letter-spacing: .015em; }\n.saas-root :is(.connections-picker-heading, .connections-source-picker b,\n .account-popover .account-meta b) { font-size: var(--web-ui-text); }\n.saas-root :is(.connections-source-picker small, .connections-picker-note,\n .account-popover .account-meta span) { font-size: var(--web-ui-meta); }\n.saas-root :is(.connections-source-picker > button, .account-popover button) {\n  min-height: 42px;\n  font-size: var(--web-ui-text);\n  line-height: 1.45;\n}\n.saas-root .account-popover { width: 290px; max-width: calc(100vw - 24px); }\n.saas-root .account-popover .account-meta { padding: 13px 12px; }\n.saas-root :is(.home-step p, .home-capability p) {\n  font-size: var(--web-ui-small);\n  line-height: 1.5;\n}\n.saas-root :is(.home-step h3, .home-capability h3) { font-size: 15px; line-height: 1.35; }\n.saas-root .home-flow-card { font-size: var(--web-ui-small); }\n.saas-root .home-section-head h2 { font-size: var(--web-ui-heading); }\n.saas-root .pa-modal-head h2 { font-size: var(--web-ui-heading); }\n.saas-root :is(.pa-modal-body, .pa-modal-actions, .pa-modal-facts span) {\n  font-size: var(--web-ui-text);\n  line-height: 1.5;\n}\n.saas-root .status-pill { font-size: 12px !important; line-height: 1.3; }\n.saas-root .wizard-step { font-size: var(--web-ui-small); }\n.saas-root .wizard-step span { font-size: var(--web-ui-meta); }\n.saas-root .source-card p { font-size: var(--web-ui-small); }\n.saas-root :is(.source-action, .source-badge, .file-summary span) {\n  font-size: var(--web-ui-meta);\n}\n@media (max-width: 700px) {\n  .saas-root .saas-main:not(.saas-main-advisor) { padding: 16px; }\n  .saas-root .page-head h1 { font-size: 22px; }\n  .saas-root :is(.pa-primary, .pa-secondary) { min-height: 40px; }\n}\n\n/* Process Advisor Web — compact subscription comparison */\n.billing-overview-row{display:flex;align-items:center;gap:24px;flex-wrap:wrap;padding:13px 18px;background:#fff;border:1px solid #dfe3eb;border-radius:12px;margin-bottom:18px}\n.billing-overview-row>div{display:flex;align-items:center;gap:9px;font-size:13px;min-width:0}\n.billing-overview-row svg{color:#0c66e4;flex-shrink:0}\n.billing-overview-row span{color:#5e6c84}\n.billing-overview-row strong{color:#172b4d;font-size:14px}\n.billing-choice-redesign .billing-choice-head{display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;padding:20px 24px}\n.billing-choice-redesign .billing-choice-head h2{font-size:21px;margin:0 0 5px}\n.billing-choice-redesign .billing-choice-head p{font-size:14px;line-height:1.5;margin:0}\n.billing-interval-toggle{display:inline-flex;align-items:center;gap:3px;padding:4px;border:1px solid #dfe3eb;background:#f4f5f7;border-radius:10px;flex-shrink:0}\n.billing-interval-toggle button{appearance:none;border:0;border-radius:7px;background:transparent;color:#42526e;padding:9px 13px;font-size:13px;font-weight:700;cursor:pointer}\n.billing-interval-toggle button.selected{background:#fff;color:#0c66e4;box-shadow:0 1px 4px rgba(9,30,66,.12)}\n.billing-interval-toggle button:focus-visible{outline:2px solid #0c66e4;outline-offset:2px}\n.billing-interval-toggle button span{color:#087f5b;font-size:11px;margin-left:4px}\n.billing-choice-redesign .billing-plan-grid-two{grid-template-columns:repeat(2,minmax(0,1fr));gap:16px;padding:20px 24px 14px}\n.billing-choice-redesign .billing-plan-simple{min-height:0;padding:23px;gap:0;border-top:3px solid #0c66e4}\n.billing-plan-simple .billing-plan-identity{display:flex;gap:12px;align-items:flex-start;justify-content:space-between}\n.billing-plan-simple .billing-plan-identity h3{font-size:20px;margin:0 0 5px}\n.billing-plan-simple .billing-plan-identity p{font-size:13px;line-height:1.5;min-height:40px}\n.billing-seat-pill{display:inline-flex;gap:5px;align-items:center;white-space:nowrap;background:#e9f2ff;color:#0c66e4;padding:6px 9px;border-radius:20px;font-size:12px;font-weight:700}\n.billing-plan-simple .billing-plan-price{text-align:left;display:flex;align-items:baseline;gap:5px;margin:19px 0 6px}\n.billing-plan-simple .billing-plan-price strong{font-size:32px;line-height:1.1}\n.billing-plan-simple .billing-plan-price span{font-size:13px;text-transform:none;letter-spacing:0}\n.billing-plan-simple .billing-billed-note{font-size:12px;color:#5e6c84;margin:2px 0 0}\n.billing-plan-simple .billing-plan-features{font-size:13px;gap:11px;padding:18px 0 22px;margin-top:8px;border-top:1px solid #edf0f5}\n.billing-plan-simple .billing-plan-action{margin-top:auto;min-height:42px}\n.billing-choice-redesign .billing-footnote{padding:0 24px 18px;font-size:12px;color:#6b778c}\n@media(max-width:900px){.billing-choice-redesign .billing-plan-grid-two{grid-template-columns:1fr}.billing-choice-redesign .billing-choice-head{align-items:flex-start}.billing-plan-simple .billing-plan-identity p{min-height:0}}\n\n/* Subscription plan refinement: compact comparison with a clear featured workspace plan. */\n.billing-choice-redesign .billing-choice-head { padding:16px 22px; }\n.billing-choice-redesign .billing-choice-head h2 { font-size:19px; }\n.billing-choice-redesign .billing-choice-head p { font-size:13px; }\n.billing-included-line { display:flex;flex-wrap:wrap;align-items:center;gap:10px 22px;padding:13px 22px 2px;color:#344563;font-size:13px; }\n.billing-included-label {font-size:11px;font-weight:800;letter-spacing:.045em;text-transform:uppercase;color:#6b778c;}\n.billing-included-line>span:not(.billing-included-label){display:inline-flex;align-items:center;gap:6px;}\n.billing-included-line svg {color:#16805d;flex-shrink:0;}\n.billing-choice-redesign .billing-plan-grid-two {padding:14px 22px 12px;gap:14px;align-items:stretch;}\n.billing-choice-redesign .billing-plan-simple {min-height:0!important;padding:20px 22px 18px;border:1px solid #dfe4ef;border-top:3px solid #9eb5d7;gap:0;box-shadow:none;}\n.billing-choice-redesign .billing-workspace-featured {background:linear-gradient(145deg,#f5f9ff 0%,#ffffff 70%);border-color:#b9cff9;border-top:3px solid #0c66e4;}\n.billing-plan-simple .billing-plan-identity {align-items:center;margin:0 0 7px;}\n.billing-plan-eyebrow {font-size:10px;letter-spacing:.09em;font-weight:800;color:#5e6c84;}\n.billing-workspace-featured .billing-plan-eyebrow{color:#0c66e4;}\n.billing-plan-simple h3 {font-size:22px;margin:0 0 4px;}\n.billing-choice-redesign .billing-plan-simple p.billing-plan-intro {font-size:13px;line-height:1.45;min-height:0;margin:0;max-width:none;}\n.billing-plan-simple .billing-plan-price {margin:16px 0 0;}\n.billing-plan-simple .billing-plan-price strong{font-size:34px;letter-spacing:-.035em;}\n.billing-choice-redesign .billing-plan-simple p.billing-price-context{font-size:12px;color:#6b778c;margin:5px 0 13px;}\n.billing-plan-difference{display:grid;gap:9px;border-top:1px solid #e8edf5;padding:13px 0 17px;color:#344563;font-size:13px;}\n.billing-plan-difference>div{display:flex;align-items:center;gap:8px;}\n.billing-plan-difference svg{color:#14835c;flex-shrink:0;}\n.billing-choice-redesign .billing-plan-simple .billing-plan-action{margin-top:auto;min-height:40px;width:100%;justify-content:center;}\n.billing-choice-redesign .billing-workspace-featured .billing-plan-action:not(:disabled){background:#0c66e4;}\n.billing-choice-redesign .billing-plan-simple .billing-plan-action:disabled{opacity:.55;cursor:not-allowed;}\n.billing-choice-redesign .billing-plan-simple p.billing-checkout-note{font-size:11px;text-align:center;margin:8px 0 0;color:#6b778c;}\n.billing-plan-unavailable{margin-top:auto;padding:10px 12px;border-radius:8px;background:#f1f4f9;color:#53627c;text-align:center;font-size:12px;}\n.billing-choice-redesign .billing-footnote{padding:0 22px 14px;font-size:11px;}\n@media (max-width:900px){.billing-included-line{gap:8px 14px;}.billing-choice-redesign .billing-plan-grid-two{grid-template-columns:1fr;}}\n\n/* Workspace Management v2 — intentionally scoped to this screen. */\n.wm-v2{max-width:1160px;margin:0 auto;color:#172b4d;font-size:14px}\n.wm-v2 .page-head{margin-bottom:22px}\n.wm-v2 .page-head p{font-size:14px}\n.wm-layout{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.12fr);gap:18px;align-items:start}\n.wm-card{min-width:0;background:#fff;border:1px solid #dfe4ec;border-radius:12px;box-shadow:0 1px 3px rgba(9,30,66,.06);overflow:hidden}\n.wm-card-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:19px 22px;border-bottom:1px solid #edf0f4}\n.wm-card-head h2{margin:0 0 5px;font-size:18px;line-height:1.3;color:#10254a}\n.wm-card-head p{margin:0;font-size:13px;line-height:1.5;color:#64748b}\n.wm-card-content{padding:20px 22px}\n.wm-tag{flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid #dce5f0;border-radius:999px;background:#f4f7fb;color:#42526e;font-size:12px;font-weight:750;padding:6px 11px;text-transform:capitalize}\n.wm-seat-tag{background:#e9f3ff;border-color:#d6e8ff;color:#0756bd}\n.wm-field{display:flex;flex-direction:column;gap:7px;min-width:0}\n.wm-field label{font-size:13px;font-weight:700;color:#344563}\n.wm-field input,.wm-field select,.wm-v2 select{width:100%;min-width:0;height:40px;border-radius:8px;border:1px solid #c6cfdb;background:white;color:#172b4d;padding:0 12px;font-size:14px}\n.wm-field input:focus-visible,.wm-v2 select:focus-visible{outline:2px solid #a1c4fb;outline-offset:1px;border-color:#0c66e4}\n.wm-user-meta{font-size:12px;color:#6b778c;margin:10px 0 20px;overflow-wrap:anywhere}\n.wm-user-meta strong{color:#344563;font-weight:650}\n.wm-form{display:grid;gap:17px}\n.wm-form-actions{display:flex;justify-content:flex-start;padding-top:1px}\n.wm-v2 .pa-primary,.wm-v2 .pa-secondary{min-height:39px;padding:9px 14px;font-size:13px;border-radius:8px}\n.wm-seat-line{display:flex;align-items:center;gap:12px;margin-bottom:12px;color:#64748b;font-size:12px;white-space:nowrap}\n.wm-seat-track{flex:1;height:7px;overflow:hidden;background:#edf1f6;border-radius:999px}\n.wm-seat-track span{display:block;height:100%;background:#0c66e4;border-radius:999px}\n.wm-members{border:1px solid #e9edf2;border-radius:9px;overflow:hidden}\n.wm-member{display:flex;align-items:center;gap:11px;padding:12px 13px;min-width:0}\n.wm-member+.wm-member{border-top:1px solid #edf0f4}\n.wm-member-avatar{display:grid;place-items:center;flex-shrink:0;width:35px;height:35px;border-radius:50%;background:#e9f2ff;color:#0c66e4;font-weight:800}\n.wm-member-details{display:grid;gap:3px;flex:1;min-width:0}\n.wm-member-details strong{font-size:13px;overflow-wrap:anywhere}\n.wm-member-details span{font-size:12px;color:#6b778c;overflow-wrap:anywhere}\n.wm-role{text-transform:capitalize;color:#53647c;background:#f3f5f8;border-radius:999px;padding:5px 9px;font-size:11px;font-weight:700}\n.wm-invite,.wm-invite-locked,.wm-pending{margin-top:22px;padding-top:18px;border-top:1px solid #edf0f4}\n.wm-invite h3,.wm-pending h3{margin:0 0 5px;font-size:15px}\n.wm-invite p,.wm-invite-locked p{margin:0 0 15px;font-size:12px;line-height:1.5;color:#64748b}\n.wm-invite-locked strong{font-size:14px}\n.wm-invite-locked p{margin:6px 0 0}\n.wm-inline-form,.wm-join-form{display:flex;align-items:end;gap:10px}\n.wm-inline-form .wm-field,.wm-join-form .wm-field{flex:1}\n.wm-join{margin-top:18px}\n.wm-join .wm-card-head{border-bottom:0;padding-bottom:9px}\n.wm-join-form{padding:8px 22px 21px;max-width:760px}\n.wm-invite-code{margin-top:15px;padding:14px;border:1px solid #acd0ff;border-radius:9px;background:#f4f9ff}\n.wm-invite-code p{margin:7px 0 10px;color:#53647c;font-size:12px}\n.wm-code-row{display:flex;gap:10px;align-items:center;flex-wrap:wrap}.wm-code-row code{background:#fff;border:1px solid #d7e3f3;padding:9px;border-radius:6px;font-size:12px;overflow-wrap:anywhere}\n.wm-pending-row{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 0;border-bottom:1px solid #edf0f4;font-size:13px}\n.wm-notice{padding:12px 14px;border-radius:8px;margin-bottom:15px;font-size:13px}.wm-error{background:#fff1f0;color:#ae2a19;border:1px solid #ffbdad}.wm-success{background:#e3fcef;color:#216e4e;border:1px solid #abf5d1}\n.wm-muted{font-size:13px;color:#6b778c}\n@media(max-width:950px){.wm-layout{grid-template-columns:1fr}}\n@media(max-width:620px){.wm-card-head{padding:16px}.wm-card-content{padding:16px}.wm-inline-form,.wm-join-form{flex-direction:column;align-items:stretch}.wm-join-form{padding:8px 16px 16px}.wm-member{flex-wrap:wrap}.wm-role{margin-left:auto}}\n\n/* Workspace role administration */\n.wm-role-control{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:650;color:#53647c;white-space:nowrap}\n.wm-role-control select{border:1px solid #d5deea;border-radius:8px;background:white;color:#172b4d;padding:6px 9px;font-size:12px;max-width:115px}\n\n/* Process Advisor Web Home — visual refresh (scoped; no billing/editor changes) */\n.saas-main-home .home-hero-refresh{position:relative;isolation:isolate;overflow:hidden;background:linear-gradient(111deg,#102c61 0%,#1552a4 49%,#3c56bb 100%);border:1px solid #2c5bac;box-shadow:0 12px 30px rgba(20,65,137,.13);padding:30px 34px;grid-template-columns:minmax(0,1.5fr) minmax(270px,.7fr);gap:28px}\n.saas-main-home .home-hero-refresh:before{content:\"\";position:absolute;z-index:-1;width:420px;height:420px;border-radius:50%;right:-130px;top:-230px;background:radial-gradient(circle,rgba(139,186,255,.40),rgba(139,186,255,0) 70%)}\n.saas-main-home .home-hero-refresh:after{content:\"\";position:absolute;z-index:-1;width:320px;height:320px;border-radius:50%;left:34%;bottom:-280px;background:radial-gradient(circle,rgba(65,211,213,.24),transparent 70%)}\n.saas-main-home .home-hero-refresh h1{color:#fff;font-size:clamp(28px,2.35vw,38px);line-height:1.13;max-width:750px;margin:12px 0 14px;letter-spacing:-.035em}\n.saas-main-home .home-headline-accent{color:#b6e6ff}\n.saas-main-home .home-hero-refresh p{color:#e0edff;font-size:14px;line-height:1.55;max-width:650px}\n.saas-main-home .home-eyebrow{display:inline-flex;gap:7px;align-items:center;color:#cde7ff;letter-spacing:.105em}\n.saas-main-home .home-hero-refresh .home-hero-actions{margin-top:22px;gap:10px}\n.saas-main-home .home-hero-refresh .pa-primary{background:#fff;color:#124a9f;border-color:#fff;box-shadow:0 6px 15px rgba(0,0,0,.14);font-weight:750}\n.saas-main-home .home-hero-refresh .pa-primary:hover{background:#e9f5ff;color:#0f3a83}\n.saas-main-home .home-hero-refresh .pa-secondary{background:rgba(255,255,255,.11);border:1px solid rgba(255,255,255,.45);color:#fff}\n.saas-main-home .home-hero-refresh .pa-secondary:hover{background:rgba(255,255,255,.2)}\n.saas-main-home .home-visual-refresh{background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.21);border-radius:17px;padding:16px 18px;gap:0;box-shadow:0 14px 28px rgba(3,26,70,.12);backdrop-filter:blur(5px)}\n.saas-main-home .home-visual-caption{justify-self:start;margin:0 0 12px;color:#dfedff;font-size:10px;font-weight:800;letter-spacing:.10em;display:flex;align-items:center;gap:8px}\n.saas-main-home .home-visual-dot{width:7px;height:7px;border-radius:50%;background:#6cf0c5;box-shadow:0 0 0 4px rgba(108,240,197,.15)}\n.saas-main-home .home-visual-refresh .home-flow-card{width:100%;max-width:none;min-height:58px;padding:9px 11px;border-radius:11px;background:rgba(255,255,255,.97);border:1px solid rgba(255,255,255,.8);box-shadow:0 5px 13px rgba(9,30,66,.09);font-size:13px;color:#15345e;gap:10px}\n.saas-main-home .home-flow-card>span:nth-child(2){display:grid;gap:3px}\n.saas-main-home .home-flow-card small{font-size:10px;color:#66758f;font-weight:500}\n.saas-main-home .home-visual-refresh .home-flow-card.accent{background:#e7f4ff;border-color:#b2d9ff}\n.saas-main-home .home-visual-refresh .home-flow-card.result{background:#e9fff7;border-color:#a9ead2}\n.saas-main-home .home-flow-icon{width:34px;height:34px;border-radius:9px;display:grid;place-items:center;flex-shrink:0}\n.saas-main-home .home-flow-icon.data{background:#e4f0ff;color:#1b66d9}.saas-main-home .home-flow-icon.model{background:#d9e9ff;color:#2053bf}.saas-main-home .home-flow-icon.advisor{background:#d1f8e9;color:#0b9069}\n.saas-main-home .home-visual-refresh .home-flow-line{height:14px;width:2px;background:linear-gradient(#afd7ff,#c6e6ff)}\n.saas-main-home .home-result-check{margin-left:auto;color:#0b9069!important}\n.saas-main-home .home-section-head h2{font-size:19px;letter-spacing:-.018em}\n.saas-main-home .home-steps{gap:9px}\n.saas-main-home .home-step{position:relative;background:#fff;border:1px solid #dfe7f2;border-radius:12px;min-height:103px;box-shadow:0 3px 11px rgba(24,68,126,.035);padding:17px 14px;gap:11px}\n.saas-main-home .home-step-number{background:#e6f1ff;color:#1760c6;border-radius:10px;font-weight:800}\n.saas-main-home .home-step:nth-child(2) .home-step-number{background:#eceaff;color:#6d4cc9}\n.saas-main-home .home-step:nth-child(3) .home-step-number{background:#e0f7f6;color:#0e888b}\n.saas-main-home .home-step:nth-child(4) .home-step-number{background:#e3f8ec;color:#138356}\n.saas-main-home .home-capability-grid{gap:12px}\n.saas-main-home .home-capability{position:relative;overflow:hidden;min-height:126px;border:1px solid #dce6f2;border-radius:13px;box-shadow:0 4px 12px rgba(24,68,126,.035);padding:17px;column-gap:12px;grid-template-columns:40px minmax(0,1fr)}\n.saas-main-home .home-capability:before{content:\"\";position:absolute;left:0;top:0;right:0;height:3px;background:var(--cap-accent,#2375d7)}\n.saas-main-home .home-capability-icon{height:39px;width:39px;border-radius:11px;background:var(--cap-bg,#e7f2ff);color:var(--cap-accent,#2375d7)}\n.saas-main-home .home-capability-evidence{--cap-accent:#2469e8;--cap-bg:#e6efff}\n.saas-main-home .home-capability-explorer{--cap-accent:#7650c9;--cap-bg:#f0eaff}\n.saas-main-home .home-capability-advisor{--cap-accent:#168f9e;--cap-bg:#e0f7f6}\n.saas-main-home .home-capability-assessment{--cap-accent:#159562;--cap-bg:#e0f8ec}\n.saas-main-home .home-capability h3{font-size:15px;margin:2px 0 5px}\n.saas-main-home .home-capability p{font-size:12px;line-height:1.48}\n@media(max-width:1100px){.saas-main-home .home-hero-refresh{grid-template-columns:1fr;}.saas-main-home .home-visual-refresh{display:none}}\n@media(max-width:650px){.saas-main-home .home-hero-refresh{padding:23px 20px}.saas-main-home .home-hero-refresh h1{font-size:27px}.saas-main-home .home-hero-refresh .home-hero-actions{flex-wrap:wrap}}\n\n/* Connection credential inputs: the global form min-height must not overflow\n   the 36px password/secret icon wrapper. Applies to Jira and ServiceNow. */\n.saas-root .connection-credential-grid.compact .connection-secret {\n  height: 40px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n.saas-root .connection-credential-grid.compact .connection-secret > svg {\n  flex: 0 0 auto;\n}\n.saas-root .connection-credential-grid.compact .connection-secret > input {\n  flex: 1 1 auto;\n  width: 100%;\n  min-width: 0;\n  min-height: 0 !important;\n  height: 100% !important;\n  max-height: 100%;\n  margin: 0;\n  padding: 0 !important;\n  border: 0 !important;\n  border-radius: 0;\n  outline: 0;\n  box-shadow: none !important;\n  background: transparent;\n  line-height: normal;\n}\n.saas-root .connection-credential-grid.compact .connection-secret:focus-within {\n  border-color: #0c66e4;\n  box-shadow: 0 0 0 2px rgba(12,102,228,.11);\n}\n\n/* Multi-currency billing selector */\n.billing-choice-controls{display:flex;gap:12px;align-items:center;flex-wrap:wrap}\n.billing-currency-label{display:flex;gap:8px;align-items:center;color:#42526e;font-weight:700;font-size:13px}\n.billing-currency-label select{border:1px solid #dfe3eb;border-radius:8px;padding:9px 10px;background:#fff;color:#172b4d;font:inherit;cursor:pointer}\n.billing-currency-label select:focus-visible{outline:2px solid #0c66e4;outline-offset:2px}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
